import { j as s, $ as ai, a as li, b as ci, c as di, d as hi, e as ui, g as pi, i as mi, n as E, O as gi, k as Bs, l as Os, w as $n, Z as fi, H as bi, m as Rn, o as yt, p as io, r as mr, q as xi, t as Hs, W as yi, u as _i, A as Ci, F as wi, v as gr, x as fr, y as Ws, z as br, B as Bn, C as vi, D as Si, E as Ii, G as Di, I as ki, J as Ti, K as xr, L as ji, M as Ni } from "./vendor-BpMo8ZB8.js";
import f from "classnames";
import { memo as Kn, forwardRef as $, PureComponent as D, useState as V, useCallback as F, useEffect as et, cloneElement as rn, isValidElement as Pt, Component as _t, Children as Rt, createRef as B, createContext as Ot, useRef as Y, useMemo as U, useContext as Gt, Fragment as Xt, useImperativeHandle as je, createElement as Fi, lazy as Pi, Suspense as Ri, useReducer as Ei } from "react";
import { I as N, T as L, w as an, r as Ts, B as it, a as tn, b as Li, E as Ms, e as Ai } from "./emoji-jMLUxSo3.js";
import { c as gT, f as fT, d as bT, i as xT } from "./emoji-jMLUxSo3.js";
import { useKey as yr, useMount as Ne, useUnmount as Qt, useUpdateEffect as Yt, useToggle as $i, useSetState as Bi, useClickAway as _r, useEvent as ln, usePrevious as en, useDebounce as Oi } from "react-use";
import j from "moment-timezone";
import { v4 as nn } from "uuid";
import { noop as Hi } from "ts-essentials";
import { a as _T } from "./svg-Co-VBan4.js";
import Wi from "react-dom";
const Mi = "h-button--button__root", zi = "h-button--button__normal", Vi = "h-button--button__large", Ki = "h-button--button__primary", Ui = "h-button--button__active", qi = "h-button--button__label", Gi = "h-button--button__secondary", Yi = "h-button--button__tertiary", Xi = "h-button--button__danger", Qi = "h-button--button__disabled", Zi = "h-button--button__loading", Ji = "h-button--button__withLabel", ta = "h-button--button__slot", ea = "h-button--button__content", Ct = {
  root: Mi,
  normal: zi,
  large: Vi,
  primary: Ki,
  active: Ui,
  label: qi,
  secondary: Gi,
  tertiary: Yi,
  danger: Xi,
  disabled: Qi,
  loading: Zi,
  withLabel: Ji,
  slot: ta,
  content: ea
}, X = Kn(
  $(function({
    children: t,
    className: e,
    type: n = "button",
    variant: o = "primary",
    size: r = "normal",
    icon: a,
    slotStart: l,
    slotEnd: c,
    active: d = !1,
    isLoading: h = !1,
    loadingIndicator: u = /* @__PURE__ */ s.jsx(L.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: "Loading..." }),
    label: p,
    styleText: m = !0,
    disabled: g = !1,
    onClick: b,
    ...x
  }, v) {
    const y = f(
      {
        [Ct.root]: !0,
        [Ct[o]]: !0,
        [Ct[r]]: !0,
        [Ct.active]: d,
        [Ct.disabled]: g,
        [Ct.loading]: h,
        [Ct.withLabel]: !c && !!p
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...x,
        type: n,
        className: y,
        onClick: g ? void 0 : b,
        disabled: g,
        ref: v,
        children: h ? u : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          (l || a) && /* @__PURE__ */ s.jsx("span", { className: Ct.slot, children: a ? /* @__PURE__ */ s.jsx(N, { name: a }) : l }),
          (m || t) && /* @__PURE__ */ s.jsx("span", { className: Ct.content, children: m ? /* @__PURE__ */ s.jsx(
            L.Paragraph,
            {
              as: "span",
              variant: "3",
              wrap: "nowrap",
              color: "inherit",
              children: t
            }
          ) : t }),
          p && /* @__PURE__ */ s.jsx(
            L.Paragraph,
            {
              as: "span",
              variant: "4",
              wrap: "nowrap",
              color: "inherit",
              className: Ct.label,
              children: p
            }
          ),
          c && /* @__PURE__ */ s.jsx("span", { className: Ct.slot, children: c })
        ] })
      }
    );
  })
), na = "h-button-navigationButton--navigationButton__root", sa = {
  root: na
}, ck = ({
  className: i,
  navigate: t,
  onClick: e,
  ...n
}) => {
  const o = (r) => {
    e?.(r), t();
  };
  return /* @__PURE__ */ s.jsx(
    X,
    {
      ...n,
      variant: n.variant ?? "tertiary",
      onClick: o,
      className: f(i, sa.root)
    }
  );
}, oa = "h-spinner--spinner__root", ra = {
  root: oa
};
class Un extends D {
  render() {
    const { className: t, size: e, color: n, trackColor: o, bgColor: r, ...a } = this.props, l = f(
      {
        [ra.root]: !0
      },
      t
    ), c = typeof e == "number" ? e : 32, d = typeof e == "number" ? `${c}px` : "32px", h = `${Math.max(Math.floor(c / 8), 1)}px`, u = {
      height: d,
      width: d,
      borderWidth: h
    };
    return o && o.length && (u.borderColor = o), n && n.length && (u.borderTopColor = n), r && r.length && (u.backgroundColor = r), /* @__PURE__ */ s.jsx("div", { ...a, style: u, className: l });
  }
}
const ia = "h-iconButton--iconButton__root", aa = {
  root: ia
}, K = Kn(
  $(function({
    children: t,
    className: e,
    icon: n,
    iconProps: o,
    iconSize: r,
    variant: a = "primary",
    ...l
  }, c) {
    return /* @__PURE__ */ s.jsx(
      X,
      {
        ref: c,
        "aria-label": n,
        ...l,
        variant: a,
        className: f(aa.root, e),
        loadingIndicator: /* @__PURE__ */ s.jsx(Un, { size: 16 }),
        styleText: !1,
        slotStart: /* @__PURE__ */ s.jsx(N, { size: r || 16, name: n, ...o })
      }
    );
  })
), la = "h-tooltip--tooltip__content", ca = "h-tooltip--tooltip__contentLight", da = "h-tooltip--tooltip__contentHasHead", ha = "h-tooltip--tooltip__body", ua = "h-tooltip--tooltip__head", pa = "h-tooltip--tooltip__arrow", ce = {
  content: la,
  contentLight: ca,
  contentHasHead: da,
  body: ha,
  head: ua,
  arrow: pa
}, ma = 400;
function gt({
  children: i,
  content: t,
  onOpenChange: e,
  side: n = "top",
  className: o,
  head: r,
  defaultOpen: a,
  alwaysShow: l,
  disabled: c,
  delayDuration: d = ma,
  align: h,
  "aria-label": u,
  wrap: p = "span",
  wrapProps: m,
  requireClick: g,
  light: b,
  ...x
}) {
  const [v, y] = V(
    g ? !1 : void 0
  ), C = F(() => {
    y(!1), window.removeEventListener("click", C);
  }, []);
  et(() => () => {
    window.removeEventListener("click", C);
  }, [C]);
  const _ = ai();
  if (c || !t)
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const w = (S) => {
    S.stopPropagation(), window[v ? "removeEventListener" : "addEventListener"](
      "click",
      C
    ), y(!v);
  }, I = f(
    ce.content,
    {
      [ce.contentHasHead]: !!r,
      [ce.contentLight]: b
    },
    o
  );
  return /* @__PURE__ */ s.jsx(li, { children: /* @__PURE__ */ s.jsxs(
    ci,
    {
      open: v ?? (l ? !0 : void 0),
      defaultOpen: a,
      delayDuration: d,
      "aria-label": u,
      onOpenChange: e,
      children: [
        /* @__PURE__ */ s.jsx(di, { asChild: !0, children: p !== "none" ? /* @__PURE__ */ s.jsx(
          p,
          {
            onClick: g ? w : void 0,
            ...m,
            ...x,
            children: i
          }
        ) : g && Pt(i) ? rn(i, { onClick: w }) : i }),
        /* @__PURE__ */ s.jsx(hi, { children: /* @__PURE__ */ s.jsx(
          ui,
          {
            id: _,
            side: n,
            sideOffset: 4,
            align: h,
            className: I,
            style: { zIndex: 2147483647 },
            children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              r && /* @__PURE__ */ s.jsx("div", { className: ce.head, children: r }),
              /* @__PURE__ */ s.jsx("div", { className: ce.body, children: t }),
              /* @__PURE__ */ s.jsx(pi, { className: ce.arrow })
            ] })
          }
        ) })
      ]
    }
  ) });
}
const ga = "h-attachment--attachment__root", fa = "h-attachment--attachment__icon", ba = "h-attachment--attachment__name", os = {
  root: ga,
  icon: fa,
  name: ba
}, ao = {
  /* images */
  jpg: "file-image",
  jpeg: "file-image",
  bmp: "file-image",
  gif: "file-image",
  tiff: "file-image",
  png: "file-image",
  /* video */
  mp4: "file-video",
  m4v: "file-video",
  mpeg: "file-video",
  mov: "file-video",
  avi: "file-video",
  wmv: "file-video",
  webm: "file-video",
  flv: "file-video",
  /* audio */
  wav: "file-audio",
  mp3: "file-audio",
  aiff: "file-audio",
  acc: "file-audio",
  ogg: "file-audio",
  wma: "file-audio",
  flac: "file-audio",
  alac: "file-audio",
  /* documents */
  pdf: "file-pdf",
  csv: "file-csv",
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  /* archives */
  zip: "file-archive",
  rar: "file-archive",
  arc: "file-archive",
  "7z": "file-archive",
  s7z: "file-archive",
  tar: "file-archive",
  bz2: "file-archive",
  gz: "file-archive"
};
function xa(i) {
  const t = i.split(".").pop()?.toLowerCase();
  return !t || !ao[t] ? "file" : ao[t];
}
class dk extends D {
  render() {
    const {
      className: t,
      fileName: e,
      label: n,
      onDownload: o,
      onPreview: r,
      isPreviewLoading: a,
      isDownloadLoading: l,
      extraButtons: c,
      ...d
    } = this.props, h = f(
      {
        [os.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      /* @__PURE__ */ s.jsx(
        N,
        {
          className: os.icon,
          name: xa(e),
          size: 24,
          color: "neutral.700"
        }
      ),
      /* @__PURE__ */ s.jsx(
        gt,
        {
          content: n || e,
          wrap: "div",
          wrapProps: { className: os.name },
          children: /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "4", color: "secondary", children: n || e })
        }
      ),
      r && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: a,
          variant: "secondary",
          icon: "eye",
          onClick: a ? void 0 : r
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: l,
          variant: "secondary",
          icon: "download",
          onClick: l ? void 0 : o
        }
      ),
      c
    ] });
  }
}
const ya = "h-avatar--avatar__root", En = {
  root: ya,
  "avatar-24": "h-avatar--avatar__avatar-24",
  "avatar-32": "h-avatar--avatar__avatar-32",
  "avatar-40": "h-avatar--avatar__avatar-40"
}, _a = {
  24: 16,
  32: 20,
  40: 24
}, Ca = ({
  icon: i,
  size: t,
  color: e = "inherit"
}) => /* @__PURE__ */ s.jsx(N, { name: i, size: _a[t], color: e }), wa = "h-image--image__image", va = "h-image--image__error", Sa = "h-image--image__complete", rs = {
  image: wa,
  error: va,
  complete: Sa
};
class zs extends _t {
  static defaultProps;
  mounted;
  constructor(t) {
    super(t), this.state = {
      imageSrc: "",
      loadingError: !1,
      loadingComplete: !1
    }, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { src: t } = this.props;
    this.handleSource(t);
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { src: e } = this.props;
    t.src !== e && this.handleSource(t.src);
  }
  componentWillUnmount() {
    this.mounted = !1;
  }
  handleSource(t) {
    typeof t == "string" ? this.setState({
      imageSrc: t
    }) : t().then((e) => {
      this.mounted && typeof e == "string" && this.setState({
        imageSrc: e
      });
    }).catch(() => {
      this.mounted && this.setState({
        loadingError: !0
      });
    });
  }
  onLoad(t) {
    this.setState({
      loadingComplete: !0,
      loadingError: !1
    }), this.props.onLoad?.(t);
  }
  onError(t) {
    this.setState({
      loadingError: !0,
      loadingComplete: !1
    }), this.props.onError?.(t);
  }
  render() {
    const { className: t, src: e, alt: n, ...o } = this.props, { imageSrc: r } = this.state, { loadingError: a, loadingComplete: l } = this.state, c = f(
      {
        [rs.image]: !0,
        [rs.error]: !!a,
        [rs.complete]: !!l
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "img",
      {
        ...o,
        className: c,
        onError: this.onError,
        onLoad: this.onLoad,
        src: r,
        alt: n || ""
      }
    );
  }
}
zs.defaultProps = {
  className: "",
  alt: ""
};
const Ia = "h-avatar--imageAvatar__root", Da = {
  root: Ia
}, ka = ({
  src: i,
  alt: t = "avatar"
}) => /* @__PURE__ */ s.jsx(zs, { src: i, alt: t, className: Da.root }), Ta = "h-avatar--textAvatar__root", Ln = {
  root: Ta,
  "avatar-24": "h-avatar--textAvatar__avatar-24",
  "avatar-32": "h-avatar--textAvatar__avatar-32",
  "avatar-40": "h-avatar--textAvatar__avatar-40"
}, ja = {
  24: Ln["avatar-24"],
  32: Ln["avatar-32"],
  40: Ln["avatar-40"]
}, Na = ({ text: i = "", size: t }) => /* @__PURE__ */ s.jsx("div", { className: f(Ln.root, ja[t]), children: i.trim().split(" ").map(
  (e, n, o) => o.length === 1 ? e : e[0]
).join("").slice(0, 2) }), Fa = [
  {
    contentColor: "var(--dixa-avatar-content-green)",
    backgroundColor: "var(--dixa-avatar-background-green)"
  },
  {
    contentColor: "var(--dixa-avatar-content-purple)",
    backgroundColor: "var(--dixa-avatar-background-purple)"
  },
  {
    contentColor: "var(--dixa-avatar-content-blue)",
    backgroundColor: "var(--dixa-avatar-background-blue)"
  },
  {
    contentColor: "var(--dixa-avatar-content-orange)",
    backgroundColor: "var(--dixa-avatar-background-orange)"
  },
  {
    contentColor: "var(--dixa-avatar-content-red)",
    backgroundColor: "var(--dixa-avatar-background-red)"
  }
];
class Pa {
  constructor(t) {
    this.colors = t, this.colors = t;
  }
  generate(t) {
    const e = this.getRandomIndex(t);
    return this.colors[e];
  }
  getRandomIndex(t) {
    const e = mi(t);
    return Math.floor(e() * this.colors.length);
  }
}
var J = /* @__PURE__ */ ((i) => (i.Icon = "Icon", i.Image = "Image", i.Text = "Text", i))(J || {});
function de(i) {
  return i.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
function wt(i) {
  return !!i && i.trim().length !== 0;
}
function Ra(i) {
  if (i.icon)
    return {
      type: J.Icon,
      icon: i.icon,
      backgroundColor: i.color?.backgroundColor,
      iconColor: i.color?.contentColor
    };
  const { user: t } = i;
  if (!t)
    return {
      type: J.Icon,
      icon: "user-slash"
    };
  if (wt(t.avatar_url))
    return {
      type: J.Image,
      src: t.avatar_url,
      alt: t.name || t.display_name || t.email || t.phone_number || t.given_name || t.family_name || ""
    };
  if (wt(t.name)) {
    const e = de(t.name.trim()).split(" ");
    if (e.length === 1)
      return {
        type: J.Text,
        text: e[0]?.[0] ?? ""
      };
    const n = e[0], o = e[e.length - 1];
    return {
      type: J.Text,
      text: (n?.[0] ?? "") + (o?.[0] ?? "")
    };
  }
  if (wt(t.display_name))
    return {
      type: J.Text,
      text: de(t.display_name.trim())
    };
  if (wt(t.given_name) && wt(t.family_name))
    return {
      type: J.Text,
      text: de(t.given_name.trim())[0] + de(t.family_name.trim())[0]
    };
  if (wt(t.given_name) && !wt(t.family_name))
    return {
      type: J.Text,
      text: de(t.given_name.trim())[0]
    };
  if (!wt(t.given_name) && wt(t.family_name))
    return {
      type: J.Text,
      text: de(t.family_name.trim())[0]
    };
  if (wt(t.email)) {
    const [e] = t.email.split("@");
    return {
      type: J.Text,
      text: e.trim()
    };
  }
  return wt(t.phone_number) ? {
    type: J.Text,
    text: t.phone_number.slice(-2)
  } : t.id ? {
    type: J.Icon,
    icon: "user-secret"
  } : {
    type: J.Icon,
    icon: "user-slash"
  };
}
const vt = {
  backgroundColor: "var(--dixa-color-neutral-200)",
  contentColor: "var(--dixa-color-neutral-700)"
}, lo = {
  shopify: {
    backgroundColor: "rgba(148, 190, 69, 0.1)",
    // this is the same as the content color but has opacity
    contentColor: "#94BE45"
  },
  agillic: {
    ...vt,
    contentColor: "#000"
  },
  magento: {
    backgroundColor: "rgba(193, 72, 0, 0.1)",
    contentColor: "#C14800"
  },
  salesforce: {
    backgroundColor: "rgba(3, 161, 224, 0.1)",
    contentColor: "#03A1E0"
  },
  busylight: {
    backgroundColor: "rgba(27, 190, 246, 0.1)",
    contentColor: "#1BBEF6"
  },
  podio: {
    backgroundColor: "rgba(80, 145, 189, 0.1)",
    contentColor: "#5091BD"
  },
  "user-secret": vt,
  "user-slash": vt,
  "map-pin": vt,
  "web-form": vt,
  code: vt,
  history: vt,
  smile: vt,
  key: vt,
  webhooks: vt,
  plug: vt
}, Ea = {
  24: En["avatar-24"],
  32: En["avatar-32"],
  40: En["avatar-40"]
};
class La extends D {
  static defaultProps = {
    size: "32",
    colorGenerator: new Pa(Fa)
  };
  getAvatarChild(t, e) {
    if (t.type === J.Icon)
      return /* @__PURE__ */ s.jsx(
        Ca,
        {
          size: e,
          icon: t.icon,
          color: t.iconColor
        }
      );
    if (t.type === J.Image)
      return /* @__PURE__ */ s.jsx(ka, { src: t.src, alt: t.alt });
    if (t.type === J.Text)
      return /* @__PURE__ */ s.jsx(Na, { size: e, text: t.text });
  }
  calculateColor(t) {
    if (t.type === J.Icon) {
      if (t.backgroundColor && t.iconColor)
        return {
          backgroundColor: t.backgroundColor,
          contentColor: t.iconColor
        };
      if (lo[t.icon])
        return lo[t.icon];
    }
    return t.type === J.Image ? {
      backgroundColor: "transparent",
      contentColor: "initial"
    } : this.props.user?.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : t.type === J.Text ? this.props.colorGenerator.generate(t.text) : this.props.colorGenerator.generate();
  }
  render() {
    const { className: t, size: e } = this.props, n = Ra(this.props), o = this.getAvatarChild(n, e), r = this.calculateColor(n);
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        style: {
          backgroundColor: r.backgroundColor,
          color: r.contentColor
        },
        className: f(
          En.root,
          Ea[e],
          t
        ),
        children: o
      }
    );
  }
}
const Cr = an(La, {
  fallback: null
}), Aa = "h-badge--badge__badge", $a = "h-badge--badge__badgeSmall", Ba = "h-badge--badge__badgeMedium", Oa = "h-badge--badge__badgePrimary", Ha = "h-badge--badge__badgeSecondary", Wa = "h-badge--badge__badgeSuccess", Ma = "h-badge--badge__badgeInfo", za = "h-badge--badge__badgeWarning", Va = "h-badge--badge__badgeError", Bt = {
  badge: Aa,
  badgeSmall: $a,
  badgeMedium: Ba,
  badgePrimary: Oa,
  badgeSecondary: Ha,
  badgeSuccess: Wa,
  badgeInfo: Ma,
  badgeWarning: za,
  badgeError: Va
}, Ka = {
  small: Bt.badgeSmall,
  medium: Bt.badgeMedium
}, Ua = {
  primary: Bt.badgePrimary,
  secondary: Bt.badgeSecondary,
  success: Bt.badgeSuccess,
  info: Bt.badgeInfo,
  warning: Bt.badgeWarning,
  error: Bt.badgeError
}, qa = "badge";
function hk(i) {
  const { className: t, size: e, variant: n, children: o, ...r } = i, a = f(
    Bt.badge,
    Ka[e],
    Ua[n],
    t
  );
  return /* @__PURE__ */ s.jsx("span", { className: a, ...r, "data-testid": qa, children: o });
}
const O = $(function({
  flexWrap: t,
  flexDirection: e,
  justifyItems: n,
  justifyContent: o,
  alignItems: r,
  alignContent: a,
  gap: l,
  style: c,
  children: d,
  ...h
}, u) {
  const p = {
    ...t && { flexWrap: t },
    ...e && { flexDirection: e },
    ...n && { justifyItems: n },
    ...o && { justifyContent: o },
    ...r && { alignItems: r },
    ...a && { alignContent: a },
    ...l && { gap: Ts(l) },
    display: "flex",
    ...c
  };
  return /* @__PURE__ */ s.jsx(it, { ...h, style: p, ref: u, children: d });
}), Ga = "h-banner--banner__root", Ya = "h-banner--banner__rootWithClose", Xa = "h-banner--banner__iconContainer", Qa = "h-banner--banner__closeIcon", Za = "h-banner--banner__headline", Ja = "h-banner--banner__rootInfo", tl = "h-banner--banner__icon", el = "h-banner--banner__description", nl = "h-banner--banner__rootWarning", sl = "h-banner--banner__rootAnnouncement", ol = "h-banner--banner__rootSuccess", rl = "h-banner--banner__rootFail", bt = {
  root: Ga,
  rootWithClose: Ya,
  iconContainer: Xa,
  closeIcon: Qa,
  headline: Za,
  rootInfo: Ja,
  icon: tl,
  description: el,
  rootWarning: nl,
  rootAnnouncement: sl,
  rootSuccess: ol,
  rootFail: rl
}, il = (i, t) => {
  if (t !== void 0)
    return t;
  switch (i) {
    case "info":
    case "announcement":
      return "info";
    case "warning":
      return "exclamation-triangle-filled";
    case "success":
      return "check-circle-filled";
    default:
      return "close-circle-filled";
  }
}, uk = ({
  actionSlot: i,
  className: t,
  description: e,
  headline: n,
  icon: o,
  variant: r,
  onClose: a
}) => {
  const l = f(bt.root, t, {
    [bt.rootInfo]: r === "info",
    [bt.rootAnnouncement]: r === "announcement",
    [bt.rootWarning]: r === "warning",
    [bt.rootSuccess]: r === "success",
    [bt.rootFail]: r === "fail",
    [bt.rootWithClose]: a
  }), c = il(r, o);
  return /* @__PURE__ */ s.jsxs("div", { className: l, children: [
    /* @__PURE__ */ s.jsxs(O, { justifyContent: "center", children: [
      c && /* @__PURE__ */ s.jsx("span", { className: bt.iconContainer, children: /* @__PURE__ */ s.jsx(N, { name: c, size: 16, className: bt.icon }) }),
      /* @__PURE__ */ s.jsxs(O, { flexDirection: "column", children: [
        n && /* @__PURE__ */ s.jsx(
          L.Heading,
          {
            as: "span",
            variant: "heading-3",
            className: bt.headline,
            children: n
          }
        ),
        rn(e, {
          className: bt.description
        })
      ] })
    ] }),
    i ? /* @__PURE__ */ s.jsx(O, { gap: "250", margin: "0 0 0 250", children: i }) : a && /* @__PURE__ */ s.jsx(
      K,
      {
        icon: "close",
        variant: "tertiary",
        className: bt.closeIcon,
        onClick: a
      }
    )
  ] });
}, al = "h-buttonGroup--buttonGroup__root", ll = "h-buttonGroup--buttonGroup__button", cl = "h-buttonGroup--buttonGroup__buttonWithBorder", dl = "h-buttonGroup--buttonGroup__buttonWithoutBorder", un = {
  root: al,
  button: ll,
  buttonWithBorder: cl,
  buttonWithoutBorder: dl
}, pk = ({
  className: i,
  children: t,
  variant: e,
  size: n,
  disabled: o
}) => {
  const r = f(un.root, i);
  return /* @__PURE__ */ s.jsx("div", { className: r, role: "group", children: Rt.map(t, (a) => {
    if (!Pt(a))
      return null;
    const l = (e ?? a.props.variant) === "secondary", c = f(a.props.className, {
      [un.button]: !0,
      [un.buttonWithBorder]: l,
      [un.buttonWithoutBorder]: !l
    });
    return rn(a, {
      className: c,
      disabled: o ?? a.props.disabled,
      variant: e ?? a.props.variant,
      size: n
    });
  }) });
}, hl = "h-divider--divider__root", ul = "h-divider--divider__withChildren", pl = "h-divider--divider__horizontal", ml = "h-divider--divider__vertical", is = {
  root: hl,
  withChildren: ul,
  horizontal: pl,
  vertical: ml
}, qn = $(function({
  className: t,
  children: e,
  as: n,
  orientation: o = "horizontal",
  color: r,
  margin: a,
  padding: l,
  ...c
}, d) {
  const h = n ?? (e ? "div" : "hr"), u = f(
    is.root,
    is[o],
    {
      [is.withChildren]: !!e
    },
    t
  ), p = {
    ...c.style,
    ...r ? { "--divider-color": tn(r) } : {},
    ...a ? { margin: Ts(a) } : {},
    ...l ? { padding: Ts(l) } : {}
  };
  return /* @__PURE__ */ s.jsx(
    h,
    {
      ...c,
      ref: d,
      className: u,
      style: p,
      children: typeof e == "string" ? /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: e }) : e
    }
  );
}), gl = "h-buttonList--buttonList__buttonList", fl = "h-buttonList--buttonList__inner", co = {
  buttonList: gl,
  inner: fl
};
let bl = class extends D {
  render() {
    const { children: t, className: e, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(qn, { as: "li", color: "tertiary", padding: "200 250", ...n, children: t });
  }
};
const xl = "h-buttonList--item__item", yl = "h-buttonList--item__icon", _l = "h-buttonList--item__button", Cl = "h-buttonList--item__buttonDisabled", wl = "h-buttonList--item__buttonCentered", vl = "h-buttonList--item__checkmark", Sl = "h-buttonList--item__buttonLoading", Il = "h-buttonList--item__buttonContent", Ht = {
  item: xl,
  icon: yl,
  button: _l,
  buttonDisabled: Cl,
  buttonCentered: wl,
  checkmark: vl,
  buttonLoading: Sl,
  buttonContent: Il
}, Dl = function({
  icon: t,
  children: e,
  className: n,
  isSelected: o,
  isCentered: r,
  isLoading: a,
  isDisabled: l,
  buttonClassName: c,
  buttonProps: d,
  onClick: h,
  ...u
}, p) {
  const m = f(
    {
      [Ht.item]: !0
    },
    n
  ), g = f(
    Ht.button,
    {
      [Ht.buttonCentered]: r,
      [Ht.buttonLoading]: a,
      [Ht.buttonDisabled]: l
    },
    c
  ), b = l ? { tabIndex: -1 } : {};
  return /* @__PURE__ */ s.jsx("li", { ref: p, ...u, className: m, children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      ...b,
      ...d,
      className: g,
      onClick: h,
      children: [
        /* @__PURE__ */ s.jsxs("span", { className: Ht.buttonContent, children: [
          t && /* @__PURE__ */ s.jsx(N, { className: Ht.icon, name: t }),
          /* @__PURE__ */ s.jsx(L.Paragraph, { variant: o ? "1" : "2", children: e })
        ] }),
        o && /* @__PURE__ */ s.jsx(
          N,
          {
            name: "done",
            size: 20,
            color: "neutral.700",
            className: Ht.checkmark
          }
        )
      ]
    }
  ) });
}, kl = $(Dl);
class ho extends D {
  static get Item() {
    return kl;
  }
  static get Header() {
    return bl;
  }
  static get Divider() {
    return Tl;
  }
  render() {
    const { children: t, className: e, ...n } = this.props, o = f(
      {
        [co.buttonList]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: /* @__PURE__ */ s.jsx("ul", { className: co.inner, children: t }) });
  }
}
const Tl = () => /* @__PURE__ */ s.jsx(qn, { as: "li", margin: "100 0" }), jl = "h-checkbox--checkbox__root", Nl = "h-checkbox--checkbox__rootDisabled", Fl = "h-checkbox--checkbox__rootChecked", Pl = "h-checkbox--checkbox__rootIndeterminate", Rl = "h-checkbox--checkbox__checkbox", El = "h-checkbox--checkbox__input", he = {
  root: jl,
  rootDisabled: Nl,
  rootChecked: Fl,
  rootIndeterminate: Pl,
  checkbox: Rl,
  input: El
};
class cn extends D {
  inputRef;
  constructor(t) {
    super(t), this.inputRef = B();
  }
  componentDidMount() {
    const t = this.inputRef.current;
    t && (t.indeterminate = !!this.props.indeterminate);
  }
  componentDidUpdate(t) {
    const e = this.inputRef.current;
    e && t.indeterminate !== this.props.indeterminate && (e.indeterminate = !!this.props.indeterminate);
  }
  render() {
    const {
      className: t,
      onChange: e,
      id: n,
      name: o,
      checked: r,
      indeterminate: a,
      disabled: l,
      tabIndex: c,
      ...d
    } = this.props, h = f(
      {
        [he.root]: !0,
        [he.rootDisabled]: l,
        [he.rootChecked]: r,
        [he.rootIndeterminate]: a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("span", { className: h, "data-testid": "habla-checkbox", ...d, children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          role: "checkbox",
          "aria-checked": a ? "mixed" : r,
          className: he.checkbox
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          id: n,
          type: "checkbox",
          "aria-hidden": "true",
          name: o,
          className: he.input,
          onChange: e || E,
          checked: r,
          disabled: l,
          ref: this.inputRef,
          tabIndex: c
        }
      )
    ] });
  }
}
const Ll = "h-collapseCard--collapseCard__card", Al = {
  card: Ll
}, Vs = Ot({
  isOpen: !1,
  onToggle: E
}), $l = "h-collapseCard--content__content", Bl = "h-collapseCard--content__contentIsOpen", uo = {
  content: $l,
  contentIsOpen: Bl
};
class Ol extends D {
  static displayName = "CollapseCard.Content";
  getRootClassName(t) {
    return f(uo.content, this.props.className, {
      [uo.contentIsOpen]: t
    });
  }
  render() {
    const { children: t, className: e, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Vs.Consumer, { children: ({ isOpen: o }) => o ? /* @__PURE__ */ s.jsx(
      "ul",
      {
        ...n,
        className: this.getRootClassName(o),
        "data-testid": "content",
        children: t
      }
    ) : null });
  }
}
function Gn(i) {
  return {
    role: "button",
    onClick: i,
    onKeyDown: (t) => {
      t.key === "Enter" && i(t);
    }
  };
}
const Hl = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  " "
], Wl = ["Escape", "Esc"], Yn = (i) => Hl.includes(i), Fe = (i) => Wl.includes(i), Ml = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  '[tabindex]:not([tabindex="-1"]):not([disabled])'
], po = Ml.join(
  ':not([hidden]):not([tabindex="-1"]),'
), wr = Kn(function({
  containerRef: t,
  children: e,
  isActive: n,
  autoFocus: o,
  restoreFocus: r,
  onActiveStateChange: a,
  bringInFocusOnTab: l
}) {
  const c = n !== void 0, d = n === void 0 || n, h = Y(null), u = Y(
    // type null is needed to make ref mutable.
    d ? document.activeElement : null
  ), p = t || h;
  yr(
    "Tab",
    (b) => {
      if (!d)
        return;
      const x = p.current?.querySelectorAll(po), v = !p.current?.contains(
        b.target instanceof Element ? b.target : null
      );
      if (!x)
        return;
      const y = x[0], C = x[x.length - 1];
      if (!b.shiftKey && document.activeElement === C || !b.shiftKey && l && v)
        return y?.focus(), b.preventDefault();
      (b.shiftKey && document.activeElement === y || b.shiftKey && l && v) && (C?.focus(), b.preventDefault());
    },
    void 0,
    [d]
  );
  const m = () => {
    setTimeout(() => {
      o && (o === !0 ? p.current?.querySelector(po)?.focus() : o.current && o.current.focus());
    });
  }, g = () => {
    document.activeElement !== document.body && !p.current?.contains(document.activeElement) || setTimeout(() => {
      r && (r === !0 ? u.current?.focus() : r.current && r.current.focus());
    });
  };
  return Ne(() => {
    c || (m(), a?.(!0));
  }), Qt(() => {
    c || (g(), a?.(!1));
  }), Yt(() => {
    n === !0 ? (u.current = document.activeElement, m()) : n === !1 && g(), a?.(!!n);
  }, [n]), t ? /* @__PURE__ */ s.jsx(s.Fragment, { children: e }) : /* @__PURE__ */ s.jsx("div", { ref: h, children: e });
}), zl = "h-dropdown--dropdown__dropdown", Vl = "h-dropdown--dropdown__dropdownOpen", Kl = "h-dropdown--dropdown__dropdownFromRight", Ul = "h-dropdown--dropdown__dropdownFromBottom", ql = "h-dropdown--dropdown__dropdownAnimating", Gl = "h-dropdown--dropdown__dropdownFixed", Yl = "h-dropdown--dropdown__loader", Xl = "h-dropdown--dropdown__error", Ql = "h-dropdown--dropdown__errorIcon", Lt = {
  dropdown: zl,
  dropdownOpen: Vl,
  dropdownFromRight: Kl,
  dropdownFromBottom: Ul,
  dropdownAnimating: ql,
  dropdownFixed: Gl,
  loader: Yl,
  error: Xl,
  errorIcon: Ql
};
class Zt extends D {
  dropdownRef;
  timeoutAnimationStart;
  timeoutAnimationEnd;
  static defaultProps = {
    onClose: () => {
    },
    closeOnBlur: !0
  };
  constructor(t) {
    super(t), this.state = {
      fromRight: !1,
      fromBottom: !1,
      fromTop: !1,
      width: null,
      height: null,
      animating: !1
    }, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = B(), this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }
  componentDidMount() {
    this.calculatePosition();
  }
  getSnapshotBeforeUpdate() {
    if (this.dropdownRef.current) {
      const t = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: t.width,
        oldHeight: t.height
      };
    }
    return null;
  }
  componentDidUpdate(t, e, n) {
    const { isOpen: o, isLoading: r, errorMessage: a, fixed: l, closeOnBlur: c } = this.props;
    if (n && (r !== t.isLoading || a !== t.errorMessage)) {
      const d = r !== t.isLoading && r;
      this.animate(n.oldWidth, n.oldHeight, d);
    }
    o && this.calculatePosition(), o !== t.isOpen && (window[o ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutsideDropdown
    ), c && window[o ? "addEventListener" : "removeEventListener"](
      "blur",
      this.handleOnClose
    ), l && window[o ? "addEventListener" : "removeEventListener"](
      "scroll",
      this.handleFixedScroll,
      !0
    ));
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleClickOutsideDropdown), window.removeEventListener("scroll", this.handleFixedScroll), window.removeEventListener("blur", this.handleOnClose), window.clearInterval(this.timeoutAnimationStart), window.clearInterval(this.timeoutAnimationEnd);
  }
  handleOnClose() {
    const { onClose: t } = this.props;
    t();
  }
  animate(t, e, n) {
    if (this.dropdownRef.current) {
      const o = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: t,
        height: e,
        animating: !n
      }), this.timeoutAnimationStart = window.setTimeout(() => {
        this.setState({
          width: o.width,
          height: o.height
        }), this.timeoutAnimationEnd = window.setTimeout(() => {
          this.setState({
            width: null,
            height: null,
            animating: !1
          });
        }, 200);
      });
    }
  }
  handleClickOutsideDropdown(t) {
    if (!this.dropdownRef || !(t.target instanceof Node)) return;
    const { onClose: e } = this.props;
    this.dropdownRef.current && t.target !== this.dropdownRef.current && !this.dropdownRef.current.contains(t.target) && e();
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  handleFixedScroll() {
    this.forceUpdate();
  }
  calculatePosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const t = this.dropdownRef.current.parentElement.getBoundingClientRect(), e = t.left + t.width / 2, n = t.top + t.height / 2, o = window.innerWidth / 2, r = window.innerHeight / 2;
      this.setState({
        fromRight: e > o,
        fromBottom: n > r,
        fromTop: n <= r
      });
    }
  }
  getFixedPosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const { fromRight: t, fromBottom: e, fromTop: n } = this.state, o = this.dropdownRef.current.parentElement.getBoundingClientRect(), r = {};
      return t ? r.right = `${window.innerWidth - o.right}px` : r.left = `${o.left}px`, e && (r.bottom = `${window.innerHeight - o.top}px`), n && (r.top = `${o.top + o.height}px`), r;
    }
    return {};
  }
  render() {
    const {
      className: t,
      children: e,
      onClose: n,
      isOpen: o,
      isLoading: r,
      closeOnBlur: a,
      errorMessage: l,
      fixed: c,
      style: d,
      autoFocus: h,
      restoreFocus: u,
      bringInFocusOnTab: p,
      ...m
    } = this.props, { fromRight: g, fromBottom: b, animating: x, width: v, height: y } = this.state, C = f(
      {
        [Lt.dropdown]: !0,
        [Lt.dropdownOpen]: o,
        [Lt.dropdownFromRight]: g,
        [Lt.dropdownFromBottom]: b,
        [Lt.dropdownAnimating]: x,
        [Lt.dropdownFixed]: c
      },
      t
    );
    let _ = { ...d };
    v && y && (_.width = `${v}px`, _.height = `${y}px`), c && (_ = { ..._, ...this.getFixedPosition() });
    const w = !r && !l;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...m,
        className: C,
        ref: this.dropdownRef,
        style: _,
        onClick: this.handleDropdownClick,
        role: "menu",
        "aria-expanded": o,
        children: [
          r && /* @__PURE__ */ s.jsx("div", { className: Lt.loader }),
          !!l && !r && /* @__PURE__ */ s.jsxs("div", { className: Lt.error, children: [
            /* @__PURE__ */ s.jsx(N, { className: Lt.errorIcon, name: "exclamation" }),
            /* @__PURE__ */ s.jsx("span", { children: l })
          ] }),
          w && /* @__PURE__ */ s.jsx(
            wr,
            {
              containerRef: this.dropdownRef,
              isActive: o,
              autoFocus: h,
              restoreFocus: u,
              bringInFocusOnTab: p,
              children: e
            }
          )
        ]
      }
    );
  }
}
const Zl = "h-dropdownButton--dropdownButton__root", Jl = "h-dropdownButton--dropdownButton__wrapper", as = {
  root: Zl,
  wrapper: Jl
}, dn = Ot({
  toggleDropdown: E,
  openDropdown: E,
  closeDropdown: E,
  dropdownOpen: !1
});
class ae extends _t {
  buttonWrapperRef;
  buttonRef;
  contextState;
  timeoutId;
  static defaultProps = {
    allowEscClose: !0
  };
  constructor(t) {
    super(t);
    const e = t.show ?? !1;
    this.state = {
      dropdownOpen: e,
      pristine: !0,
      fromBottom: !1
    }, this.timeoutId = null, this.buttonWrapperRef = B(), this.buttonRef = B(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
      toggleDropdown: this.toggle,
      openDropdown: this.open,
      closeDropdown: this.close,
      dropdownOpen: e
    };
  }
  componentDidMount() {
    this.props.allowEscClose && this.props.show && window.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
  }
  componentDidUpdate(t) {
    this.toggleDropdownIfNeeded(t);
  }
  componentWillUnmount() {
    this.props.allowEscClose && window.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && window.clearTimeout(this.timeoutId);
  }
  shouldToggleDropdown(t) {
    return t.show !== this.props.show;
  }
  handleKeyDown(t) {
    Fe(t.key) && this.state.dropdownOpen && (t.stopPropagation(), this.close());
  }
  toggleDropdownIfNeeded(t) {
    this.shouldToggleDropdown(t) && (this.props.show ? this.open() : this.close());
  }
  /**
   * HACK: To get around node and dom types not being compatible and both
   * overloading setTimeout
   *
   * @param callback
   * @param delay
   * @returns
   */
  setTimeout(t, e = 0) {
    return window.setTimeout(t, e);
  }
  handleDropdownToggle() {
    const { dropdownOpen: t } = this.state, e = () => {
      this.timeoutId = this.setTimeout(() => {
        this.toggle(!t);
      });
    }, n = this.shouldDropdownBeAboveButton();
    t ? e() : this.setState(
      { fromBottom: n },
      e
    );
  }
  close() {
    this.toggle(!1);
  }
  open() {
    this.toggle(!0);
  }
  toggle(t) {
    const { allowEscClose: e, onToggle: n } = this.props, { pristine: o, dropdownOpen: r } = this.state, a = t ?? !r;
    this.contextState = { ...this.contextState, dropdownOpen: a }, this.setState({ dropdownOpen: a, pristine: !1 }), e && (a ? window.addEventListener : window.removeEventListener)("keydown", this.handleKeyDown, !0), n?.(a, o);
  }
  shouldDropdownBeAboveButton() {
    const t = this.buttonWrapperRef.current?.getBoundingClientRect();
    return t ? t.bottom > window.innerHeight / 2 : !1;
  }
  renderTheTriggerButton() {
    const {
      icon: t,
      buttonProps: e,
      children: n,
      noArrow: o,
      noStyle: r,
      onMouseEnter: a,
      onMouseLeave: l
    } = this.props, { fromBottom: c } = this.state;
    return r ? /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: this.buttonRef,
        className: e?.className,
        ...e,
        onMouseEnter: a,
        onMouseLeave: l,
        ...Gn(this.handleDropdownToggle),
        children: n
      }
    ) : t && !n ? /* @__PURE__ */ s.jsx(
      K,
      {
        ref: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...e,
        onClick: this.handleDropdownToggle
      }
    ) : /* @__PURE__ */ s.jsx(
      X,
      {
        ref: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...e,
        onClick: this.handleDropdownToggle,
        slotEnd: o ? void 0 : /* @__PURE__ */ s.jsx(N, { name: c ? "angle-up" : "angle-down" }),
        children: n
      }
    );
  }
  render() {
    const {
      className: t,
      children: e,
      icon: n,
      dropdown: o,
      buttonProps: r,
      dropdownProps: a,
      noArrow: l,
      noStyle: c,
      show: d,
      onToggle: h,
      isLoading: u,
      errorMessage: p,
      fixed: m,
      onMouseEnter: g,
      onMouseLeave: b,
      allowEscClose: x,
      ...v
    } = this.props, { dropdownOpen: y, pristine: C } = this.state, _ = f({ [as.root]: as.root }, t);
    return /* @__PURE__ */ s.jsx(dn.Provider, { value: this.contextState, children: /* @__PURE__ */ s.jsx("div", { ...v, className: _, ref: this.buttonWrapperRef, children: /* @__PURE__ */ s.jsxs("div", { className: as.wrapper, children: [
      this.renderTheTriggerButton(),
      /* @__PURE__ */ s.jsx(
        Zt,
        {
          restoreFocus: this.buttonRef,
          ...a,
          isOpen: y,
          onClose: this.close,
          isLoading: u,
          errorMessage: p,
          fixed: m,
          children: (y || !C) && o
        }
      )
    ] }) }) });
  }
}
const tc = "h-collapseCard--header__header", ec = "h-collapseCard--header__headerOpen", nc = "h-collapseCard--header__headerHasDropdown", sc = "h-collapseCard--header__title", pn = {
  header: tc,
  headerOpen: ec,
  headerHasDropdown: nc,
  title: sc
};
class oc extends D {
  // It's important to keep the displayName because it's used by the collapseCard
  // To determine the type of it's children
  static displayName = "CollapseCard.Header";
  static defaultProps = {
    title: ""
  };
  getRootClassName(t) {
    const { dropdown: e, className: n } = this.props;
    return f(
      pn.header,
      { [pn.headerOpen]: t, [pn.headerHasDropdown]: !!e },
      n
    );
  }
  render() {
    const {
      children: t,
      className: e,
      title: n,
      avatar: o,
      wrap: r = "nowrap",
      dropdown: a,
      onDropdownToggle: l,
      dropdownTrigger: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(Vs.Consumer, { children: ({ isOpen: h, onToggle: u }) => {
      const p = this.getRootClassName(h);
      return /* @__PURE__ */ s.jsxs(
        "div",
        {
          ...d,
          onClick: u,
          className: p,
          "data-testid": "header",
          children: [
            /* @__PURE__ */ s.jsxs(O, { alignItems: "center", padding: "400 0", children: [
              o,
              /* @__PURE__ */ s.jsx("div", { onMouseDown: (m) => m.stopPropagation(), children: /* @__PURE__ */ s.jsx(
                L.Paragraph,
                {
                  variant: "1",
                  wrap: r,
                  className: pn.title,
                  children: t
                }
              ) })
            ] }),
            /* @__PURE__ */ s.jsxs(O, { alignItems: "center", children: [
              !!a && /* @__PURE__ */ s.jsx(
                ae,
                {
                  onClick: (m) => m.stopPropagation(),
                  icon: c ? void 0 : "dots-h",
                  dropdown: a,
                  buttonProps: { variant: "tertiary" },
                  onToggle: l,
                  children: c
                }
              ),
              /* @__PURE__ */ s.jsx(
                K,
                {
                  icon: h ? "angle-down" : "angle-right",
                  variant: "tertiary"
                }
              )
            ] })
          ]
        }
      );
    } });
  }
}
const rc = "h-collapseCard--line__line", ic = "h-collapseCard--line__lineHasLabel", ac = "h-collapseCard--line__value", lc = "h-collapseCard--line__lineHideOverflow", mn = {
  line: rc,
  lineHasLabel: ic,
  value: ac,
  lineHideOverflow: lc
};
class cc extends D {
  render() {
    const { label: t, children: e, className: n, hideOverflow: o, ...r } = this.props, a = f(
      {
        [mn.line]: !0,
        [mn.lineHasLabel]: !!t,
        [mn.lineHideOverflow]: o
      },
      n
    );
    return /* @__PURE__ */ s.jsxs("li", { ...r, className: a, children: [
      t && /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", subdued: !0, wrap: "nowrap", children: t }),
      t ? /* @__PURE__ */ s.jsx("span", { className: mn.value, children: e }) : e
    ] });
  }
}
const dc = "h-collapseCard--readMore__readMore", hc = {
  readMore: dc
};
class uc extends D {
  render() {
    const { onClick: t, url: e, children: n, className: o, ...r } = this.props, a = f({ [hc.readMore]: !0 }, o);
    return e ? /* @__PURE__ */ s.jsx(L.ExternalLink, { ...r, href: e, className: a, children: n }) : /* @__PURE__ */ s.jsx(
      X,
      {
        variant: "secondary",
        ...r,
        onClick: t,
        className: a,
        children: n
      }
    );
  }
}
const pc = "h-collapseCard--status__status", mc = {
  status: pc
};
class gc extends D {
  render() {
    const { children: t, className: e, ...n } = this.props, o = f({ [mc.status]: !0 }, e);
    return /* @__PURE__ */ s.jsx("li", { ...n, className: o, children: t });
  }
}
class fc extends D {
  static defaultProps = {
    isOpen: !1
  };
  constructor(t) {
    super(t), this.handleToggle = this.handleToggle.bind(this);
  }
  static Line = cc;
  static Header = oc;
  static Content = Ol;
  static ReadMore = uc;
  static Status = gc;
  handleToggle() {
    this.props.onToggle(!this.props.isOpen);
  }
  isHeader(t) {
    return t?.type?.displayName === "CollapseCard.Header" && Pt(t);
  }
  isContent(t) {
    return t?.type?.displayName === "CollapseCard.Content" && Pt(t);
  }
  getHeaderChildren() {
    return Rt.toArray(this.props.children).filter(this.isHeader);
  }
  getContentChildren() {
    return Rt.toArray(this.props.children).filter(this.isContent);
  }
  getRootClassName() {
    const { className: t } = this.props;
    return f(Al.card, t);
  }
  render() {
    const { className: t, onToggle: e, isOpen: n, children: o, ...r } = this.props;
    return /* @__PURE__ */ s.jsx(
      Vs.Provider,
      {
        value: { isOpen: n, onToggle: this.handleToggle },
        children: /* @__PURE__ */ s.jsxs("div", { ...r, className: this.getRootClassName(), children: [
          this.getHeaderChildren(),
          this.getContentChildren()
        ] })
      }
    );
  }
}
const gk = an(fc, {
  fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: "Something went wrong" }) })
}), bc = "h-collapsible--collapsible__root", xc = "h-collapsible--collapsible__collapsible", yc = "h-collapsible--collapsible__children", ls = {
  root: bc,
  collapsible: xc,
  children: yc
};
class fk extends D {
  childrenRef;
  resizeObserver = null;
  constructor(t) {
    super(t), this.childrenRef = B(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = {
      childrenHeight: t.isOpen ? "auto" : 0
    };
  }
  componentDidMount() {
    this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentDidUpdate(t) {
    t.isOpen !== this.props.isOpen && this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentWillUnmount() {
    this.disconnectResizeObserver();
  }
  setupResizeObserver() {
    this.childrenRef.current && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(() => {
      this.measureChildrenHeight();
    }), this.resizeObserver.observe(this.childrenRef.current));
  }
  disconnectResizeObserver() {
    this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  measureChildrenHeight() {
    const t = this.childrenRef.current;
    t && this.setState({
      childrenHeight: t.offsetHeight
    });
  }
  render() {
    const { className: t, header: e, isOpen: n, children: o, ...r } = this.props, { childrenHeight: a } = this.state, l = f(
      {
        [ls.root]: !0
      },
      t
    ), c = {
      maxHeight: n ? a : 0
    };
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("div", { children: e }) }),
      !!o && /* @__PURE__ */ s.jsx("div", { style: c, className: ls.collapsible, children: /* @__PURE__ */ s.jsx("span", { className: ls.children, ref: this.childrenRef, children: o }) })
    ] });
  }
}
const _c = "h-colorPicker--colorPicker__root", Cc = {
  root: _c
}, wc = "h-inputWrapper--inputWrapper__root", vc = "h-inputWrapper--inputWrapper__rootDisabled", Sc = "h-inputWrapper--inputWrapper__rootActive", Ic = "h-inputWrapper--inputWrapper__rootHasError", Dc = "h-inputWrapper--inputWrapper__rootHasWarning", kc = "h-inputWrapper--inputWrapper__rootHasSuccess", Tc = "h-inputWrapper--inputWrapper__inputWrapper", jc = "h-inputWrapper--inputWrapper__rootWithPrefix", Nc = "h-inputWrapper--inputWrapper__rootWithSuffix", Fc = "h-inputWrapper--inputWrapper__suffixesContainer", Pc = "h-inputWrapper--inputWrapper__prefix", Rc = "h-inputWrapper--inputWrapper__suffix", Ec = "h-inputWrapper--inputWrapper__prefixDropdownButton", Lc = "h-inputWrapper--inputWrapper__suffixDropdownButton", Ac = "h-inputWrapper--inputWrapper__prefixButton", $c = "h-inputWrapper--inputWrapper__suffixButton", Bc = "h-inputWrapper--inputWrapper__icon", at = {
  root: wc,
  rootDisabled: vc,
  rootActive: Sc,
  rootHasError: Ic,
  rootHasWarning: Dc,
  rootHasSuccess: kc,
  inputWrapper: Tc,
  rootWithPrefix: jc,
  rootWithSuffix: Nc,
  suffixesContainer: Fc,
  prefix: Pc,
  suffix: Rc,
  prefixDropdownButton: Ec,
  suffixDropdownButton: Lc,
  prefixButton: Ac,
  suffixButton: $c,
  icon: Bc
}, js = Ot({
  position: null,
  disabled: !1,
  active: !1,
  status: "success"
}), Oc = "inputWrapper";
class Hc extends D {
  renderIcon() {
    const { icon: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx(N, { className: at.icon, name: t }) : null;
  }
  isButtonAddon(t) {
    return !!t && "type" in t && t.type === "button";
  }
  isCustomAddon(t) {
    return !!t && "type" in t && (!t.type || t.type === "custom");
  }
  renderAddon(t) {
    const e = this.props[t], { disabled: n } = this.props;
    if (!e)
      return null;
    let o;
    if (typeof e != "object" || !("type" in e))
      o = /* @__PURE__ */ s.jsx("div", { className: f(at[t]), children: e });
    else if (this.isCustomAddon(e))
      o = e.noWrap ? e.value : /* @__PURE__ */ s.jsx("div", { className: at[t], children: e.value });
    else if (this.isButtonAddon(e)) {
      const {
        className: r,
        disabled: a,
        ...l
      } = e.button;
      o = /* @__PURE__ */ s.jsx(
        K,
        {
          className: f(
            {
              [at[t]]: !e.noStyle,
              [at[`${t}Button`]]: !e.noStyle
            },
            r
          ),
          disabled: n || a,
          ...l
        }
      );
    }
    return o;
  }
  getContextValue(t) {
    const { disabled: e, active: n, status: o } = this.props;
    return {
      position: t,
      disabled: !!e,
      active: !!n,
      status: o || "success"
    };
  }
  render() {
    const {
      className: t,
      disabled: e,
      active: n,
      status: o,
      prefix: r,
      suffix: a,
      icon: l,
      children: c,
      innerRef: d,
      ...h
    } = this.props, u = f(
      at.root,
      {
        [at.rootActive]: n,
        [at.rootDisabled]: e,
        [at.rootHasError]: o === "error",
        [at.rootHasWarning]: o === "warning",
        [at.rootHasSuccess]: o === "success",
        [at.rootWithPrefix]: !!r,
        [at.rootWithSuffix]: !!a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Oc,
        className: u,
        ref: d,
        ...h,
        children: [
          /* @__PURE__ */ s.jsx(js.Provider, { value: this.getContextValue("prefix"), children: this.renderAddon("prefix") }),
          /* @__PURE__ */ s.jsx("div", { className: at.inputWrapper, children: c }),
          /* @__PURE__ */ s.jsxs("span", { className: at.suffixesContainer, children: [
            this.renderIcon(),
            /* @__PURE__ */ s.jsx(js.Provider, { value: this.getContextValue("suffix"), children: this.renderAddon("suffix") })
          ] })
        ]
      }
    );
  }
}
const Et = $(function(t, e) {
  return /* @__PURE__ */ s.jsx(Hc, { innerRef: e, ...t, children: t.children });
}), Wc = "h-colorPicker-input--colorPickerInput__input", Mc = {
  input: Wc
}, zc = ({
  className: i,
  ...t
}) => /* @__PURE__ */ s.jsx(Et, { prefix: "#", children: /* @__PURE__ */ s.jsx(
  gi,
  {
    className: f(Mc.input, i),
    "aria-label": "Enter hex value",
    placeholder: "Hex value",
    ...t
  }
) }), Vc = "h-colorPicker-presets--colorPickerPresets__root", Kc = {
  root: Vc
}, Uc = "h-colorPicker-presets-preset--colorPickerPreset__root", qc = "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected", Gc = "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha", Yc = "h-colorPicker-presets-preset--colorPickerPreset__preset", gn = {
  root: Uc,
  rootIsSelected: qc,
  rootAlpha: Gc,
  preset: Yc
}, Xc = ({
  color: i,
  onSelect: t,
  isSelected: e,
  alpha: n,
  className: o
}) => /* @__PURE__ */ s.jsx(
  "li",
  {
    className: f(gn.root, o, {
      [gn.rootIsSelected]: e,
      [gn.rootAlpha]: n
    }),
    children: /* @__PURE__ */ s.jsx(
      "button",
      {
        type: "button",
        "aria-label": i,
        className: gn.preset,
        style: { backgroundColor: i },
        onClick: () => {
          t?.(i);
        }
      }
    )
  }
);
Bs([Os]);
const Qc = ({
  presets: i,
  className: t,
  onChange: e,
  color: n,
  alpha: o,
  ...r
}) => /* @__PURE__ */ s.jsx(
  O,
  {
    as: "ul",
    gap: "200",
    flexWrap: "wrap",
    className: f(Kc.root, t),
    ...r,
    children: i.map((a) => /* @__PURE__ */ s.jsx(
      Xc,
      {
        onSelect: e,
        color: a,
        isSelected: n === (a.startsWith("#") ? a : $n(a).toHex()),
        alpha: o
      },
      a
    ))
  }
);
Bs([Os]);
const Zc = ({
  onChange: i,
  color: t,
  alpha: e,
  className: n,
  ...o
}) => {
  const r = F((a) => {
    setTimeout(() => {
      i?.($n(a).toHex());
    });
  }, []);
  return e ? /* @__PURE__ */ s.jsx(
    bi,
    {
      className: n,
      color: $n(t ?? "").toRgbString(),
      onChange: r,
      ...o
    }
  ) : /* @__PURE__ */ s.jsx(
    fi,
    {
      className: n,
      color: t,
      onChange: i,
      ...o
    }
  );
};
Bs([Os]);
const Jc = "colorPickerTestId", Xn = ({
  className: i,
  color: t,
  onChange: e,
  alpha: n,
  children: o,
  ...r
}) => {
  const [a, l] = V();
  return U(() => {
    const c = t?.startsWith("#") ? t : $n(t ?? "").toHex();
    l(c);
  }, [t]), /* @__PURE__ */ s.jsx(
    O,
    {
      flexDirection: "column",
      gap: "250",
      className: f(Cc.root, i),
      "data-testid": Jc,
      ...r,
      children: Rt.map(
        o,
        (c) => Pt(c) && rn(c, {
          onChange: e,
          color: a,
          alpha: n,
          ...c.props
        })
      )
    }
  );
};
Xn.Input = zc;
Xn.Sliders = Zc;
Xn.Presets = Qc;
const td = "h-columns--columns__root", ed = {
  root: td
}, nd = "1fr", sd = $(function({ as: t = "div", children: e, className: n, style: o, ...r }, a) {
  const c = Rt.toArray(e).map((d) => d.props.size ?? nd).join(" ");
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...r,
      ref: a,
      className: f(ed.root, n),
      style: { ...o, gridTemplateColumns: c },
      children: e
    }
  );
}), od = "h-columns-column--column__root", rd = {
  root: od
}, id = "h-columns-column-row--columnRow__root", ad = "h-columns-column-row--columnRow__noMinHeight", ld = "h-columns-column-row--columnRow__noVerticalPadding", cd = "h-columns-column-row--columnRow__noHorizontalPadding", dd = "h-columns-column-row--columnRow__borderTop", hd = "h-columns-column-row--columnRow__borderBottom", ud = "h-columns-column-row--columnRow__scrollable", pd = "h-columns-column-row--columnRow__slottable", Wt = {
  root: id,
  noMinHeight: ad,
  noVerticalPadding: ld,
  noHorizontalPadding: cd,
  borderTop: dd,
  borderBottom: hd,
  scrollable: ud,
  slottable: pd
}, md = 1, gd = $(function({
  as: t = "div",
  children: e,
  className: n,
  noVerticalPadding: o,
  noHorizontalPadding: r,
  noMinHeight: a,
  borderTop: l,
  borderBottom: c,
  scrollable: d,
  size: h,
  slottable: u,
  style: p,
  ...m
}, g) {
  const b = f(n, Wt.root, {
    [Wt.slottable]: u,
    [Wt.noVerticalPadding]: u ?? o,
    [Wt.noHorizontalPadding]: r,
    [Wt.borderTop]: l,
    [Wt.borderBottom]: c,
    [Wt.scrollable]: d,
    [Wt.noMinHeight]: a
  });
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...m,
      ref: g,
      className: b,
      style: {
        ...p,
        flexGrow: h ?? d ? md : void 0
      },
      children: e
    }
  );
}), fd = "h-columns-column-slot--columnSlot__root", bd = "h-columns-column-slot--columnSlot__noVerticalPadding", mo = {
  root: fd,
  noVerticalPadding: bd
}, xd = ({
  children: i,
  className: t,
  noVerticalPadding: e,
  placement: n = "start"
}) => {
  const o = f(mo.root, t, {
    [mo.noVerticalPadding]: e
  });
  return /* @__PURE__ */ s.jsx(
    O,
    {
      alignItems: "center",
      alignSelf: "stretch",
      justifySelf: n,
      className: o,
      children: i
    }
  );
}, pt = ({
  as: i,
  children: t,
  className: e
}) => /* @__PURE__ */ s.jsx(
  O,
  {
    as: i,
    flexDirection: "column",
    className: f(rd.root, e),
    children: t
  }
);
pt.Row = gd;
pt.Slot = xd;
const yd = "h-copyToClipboard--copyToClipboard__copyToClipboard", _d = "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip", go = {
  copyToClipboard: yd,
  copyToClipboardTooltip: _d
};
class Cd extends _t {
  timerHandle;
  static defaultProps = {
    tooltip: !0,
    disabled: !1,
    transitionDuration: 2e3,
    clickedProps: {}
  };
  constructor(t) {
    super(t), this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
  }
  componentWillUnmount() {
    this.timerHandle && clearTimeout(this.timerHandle);
  }
  executeCopy(t) {
    const e = document.body;
    if (!t || !document.body)
      return;
    const n = document.createElement("textarea");
    n.value = t, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", e.appendChild(n), n.select(), document.execCommand("copy"), e.removeChild(n);
  }
  handleClick(t) {
    const { disabled: e, textToCopy: n, transitionDuration: o, onClick: r } = this.props;
    e || (typeof r == "function" && r(t), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
      this.timerHandle = setTimeout(() => {
        this.setState({ clicked: !1 });
      }, o);
    }));
  }
  render() {
    const { className: t, children: e, clickedProps: n, tooltip: o } = this.props, { clicked: r } = this.state, a = f(
      go.copyToClipboard,
      { [go.copyToClipboardTooltip]: r && o },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { className: a, children: Rt.map(e, (l) => Pt(l) ? rn(l, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onClick: this.handleClick.bind(this),
      ...r ? n : {}
    }) : l) });
  }
}
class bk extends D {
  render() {
    const { buttonProps: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx(Cd, { ...e, children: /* @__PURE__ */ s.jsx(K, { icon: "copy", variant: "secondary", ...t }) });
  }
}
const wd = "h-simplePagination--simplePagination__paginationButton", fo = {
  paginationButton: wd
}, vd = "simplePaginationTestId", Sd = ({
  nextButtonClick: i = E,
  previousButtonClick: t = E,
  nextButtonText: e = "Next page",
  previousButtonText: n = "Previous page",
  nextButtonDisabled: o = !1,
  previousButtonDisabled: r = !1,
  nextButtonHidden: a = !1,
  previousButtonHidden: l = !1,
  nextButtonExtraProps: c,
  previousButtonExtraProps: d,
  loading: h = !1,
  loadingText: u = "Loading...",
  ...p
}) => /* @__PURE__ */ s.jsxs("div", { "data-testid": vd, ...p, children: [
  !l && /* @__PURE__ */ s.jsx(
    X,
    {
      disabled: r || h,
      onClick: t,
      variant: "secondary",
      ...d,
      className: f(
        fo.paginationButton,
        d?.className
      ),
      children: h ? u : n
    }
  ),
  !a && /* @__PURE__ */ s.jsx(
    X,
    {
      disabled: o || h,
      onClick: i,
      variant: "secondary",
      ...c,
      className: f(
        fo.paginationButton,
        c?.className
      ),
      children: h ? u : e
    }
  )
] }), Qn = Ot(
  void 0
);
var ct = /* @__PURE__ */ ((i) => (i.Foot = "table-foot", i.Body = "table-body", i.Head = "table-head", i.Row = "table-row", i.PaginationRow = "table-pagination-row", i.Td = "table-body-cell", i.Th = "table-header-cell", i.RowExpansionTrigger = "table-row-expansion-trigger", i.LoadingRow = "table-loading-row", i.LoadingFailedRow = "table-loading-failed-row", i.EmptyRow = "table-empty-row", i))(ct || {});
const Id = "h-table-tfoot--tfoot__root", Dd = "h-table-tfoot--tfoot__rootIsLoading", bo = {
  root: Id,
  rootIsLoading: Dd
}, vr = Ot(
  void 0
), xo = ({ className: i, children: t, ...e }, n) => /* @__PURE__ */ s.jsx(Qn.Consumer, { children: (o) => o?.status.loading && ["spinner"].includes(o?.loading.loadingStrategy) ? null : /* @__PURE__ */ s.jsx(vr.Provider, { value: { isTableFoot: !0 }, children: /* @__PURE__ */ s.jsx(
  "tfoot",
  {
    ...e,
    ref: n,
    className: f(
      {
        [bo.rootIsLoading]: o?.status.loading
      },
      bo.root,
      i
    ),
    "data-testid": ct.Foot,
    children: t
  }
) }) }), kd = Object.assign($(xo), { name: xo.name }), Td = "h-table-thead--thead__root", jd = "h-table-thead--thead__rootIsLoading", yo = {
  root: Td,
  rootIsLoading: jd
}, Sr = Ot(
  void 0
), _o = ({ className: i, ...t }, e) => /* @__PURE__ */ s.jsx(Qn.Consumer, { children: (n) => {
  const o = f(yo.root, i, {
    [yo.rootIsLoading]: n?.status.loading
  });
  return /* @__PURE__ */ s.jsx(Sr.Provider, { value: { isTableHead: !0 }, children: /* @__PURE__ */ s.jsx(
    "thead",
    {
      ...t,
      ref: e,
      className: o,
      "data-testid": ct.Head
    }
  ) });
} }), Nd = Object.assign($(_o), { name: _o.name }), Pe = (i) => {
  const t = Gt(Qn);
  if (!t)
    throw new Error(
      "TableContext not accessible. Make sure <TableContextReader> is a child of <Table>"
    );
  const e = Gt(Sr) || {
    isTableHead: !1
  }, n = Gt(vr) || {
    isTableFoot: !1
  };
  return i.children({
    ...t,
    ...e,
    ...n
  });
}, Fd = "h-table-tableFooter--tableFooter__root", Pd = "h-table-tableFooter--tableFooter__rootIsLoading", Co = {
  root: Fd,
  rootIsLoading: Pd
}, wo = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Pe, { children: ({ status: o }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: n,
    className: f(
      {
        [Co.rootIsLoading]: o.loading
      },
      Co.root,
      t
    ),
    ...e,
    children: i
  }
) }), Ks = Object.assign($(wo), {
  name: wo.name
});
function Rd(i) {
  return Rt.toArray(i).reduce(
    (t, e) => {
      const n = e;
      return n.type === Ks ? t.footers.push(n) : t.children.push(n), t;
    },
    { children: [], footers: [] }
  );
}
var On = /* @__PURE__ */ ((i) => (i.PageNumber = "page-number", i.PrevPageButton = "prev-page-button", i.NextPageButton = "next-page-button", i))(On || {});
const Ed = "h-pagination--pageNumber__button", Ld = "h-pagination--pageNumber__text", Ad = "h-pagination--pageNumber__textSelected", cs = {
  button: Ed,
  text: Ld,
  textSelected: Ad
}, $d = ({
  number: i,
  isSelected: t = !1,
  onClick: e
}) => {
  const n = f(cs.text, {
    [cs.textSelected]: t
  });
  return /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
    X,
    {
      styleText: !1,
      variant: "tertiary",
      onClick: () => e(i),
      "data-testid": On.PageNumber,
      className: cs.button,
      children: /* @__PURE__ */ s.jsx("span", { className: n, children: i })
    }
  ) });
}, Bd = "h-pagination--pagination__root", Od = "h-pagination--pagination__pageNumberSeparatorWrapper", vo = {
  root: Bd,
  pageNumberSeparatorWrapper: Od
};
class Hd extends _t {
  static defaultProps = {
    pageRangeDisplayed: 6
  };
  constructor(t) {
    super(t), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
  }
  arePropsValid() {
    const { currentPage: t, pageCount: e, pageRangeDisplayed: n } = this.props, o = (r) => !Number.isNaN(r) && Number.isInteger(r) && r > 0;
    return [t, e, n].every(
      o
    );
  }
  thereIsEnoughPagesToRender() {
    return this.props.pageCount > 1;
  }
  getBoundaries() {
    return {
      canGoToPrevPage: this.props.currentPage > 1,
      canGoToNextPage: this.props.currentPage < this.props.pageCount
    };
  }
  goToPrevPage() {
    this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
  }
  goToNextPage() {
    this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
  }
  handlePageSelect(t) {
    const { currentPage: e, onPageChange: n } = this.props;
    t !== e && n(t);
  }
  areAllPagedDisplayable() {
    const { pageCount: t, pageRangeDisplayed: e } = this.props;
    return e >= t;
  }
  leadingTruncationIsNeeded() {
    const { start: e } = this.calculateMiddlePagesRange();
    return e - 1 > 1;
  }
  trailingTruncationIsNeeded() {
    const { pageCount: t } = this.props, { start: e, length: n } = this.calculateMiddlePagesRange(), o = e - 1 + n;
    return t - o > 1;
  }
  getMiddlePagesLength() {
    const { pageRangeDisplayed: t } = this.props;
    return t - 2;
  }
  calculateMiddlePagesRange(t) {
    const { pageCount: e, currentPage: n } = this.props, o = Math.max(
      this.getMiddlePagesLength() - (t?.extraPadding ?? 0),
      1
    ), r = o % 2 === 0 ? o / 2 - 1 : Math.floor(o / 2);
    return { start: Rn(
      n - r,
      2,
      e - o
    ), length: o };
  }
  createPageNumbers(t, e = 1) {
    return Array.from({ length: t }, (n, o) => o + e);
  }
  renderPageNumbers(t, e = 1) {
    return this.createPageNumbers(t, e).map(
      (n) => this.renderSinglePageNumber(n)
    );
  }
  renderSinglePageNumber(t) {
    const { currentPage: e } = this.props, n = t === e;
    return /* @__PURE__ */ s.jsx(
      $d,
      {
        number: t,
        isSelected: n,
        onClick: this.handlePageSelect
      },
      t
    );
  }
  renderAllPages() {
    return this.renderPageNumbers(this.props.pageCount);
  }
  renderGap(t = 0) {
    return /* @__PURE__ */ s.jsx("li", { className: vo.pageNumberSeparatorWrapper, children: /* @__PURE__ */ s.jsx(Li, { name: "dots-h" }) }, `gap-${t}`);
  }
  renderLeadingTruncation() {
    return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
  }
  renderTrailingTruncation() {
    const { pageCount: t } = this.props;
    return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(t)] : this.renderSinglePageNumber(t);
  }
  renderMiddlePageNumbers() {
    if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
      const { start: n, length: o } = this.calculateMiddlePagesRange({
        extraPadding: 1
      });
      return this.renderPageNumbers(o, n);
    }
    const { start: t, length: e } = this.calculateMiddlePagesRange();
    return this.renderPageNumbers(e, t);
  }
  renderPages() {
    return this.areAllPagedDisplayable() ? this.renderAllPages() : [
      this.renderLeadingTruncation(),
      this.renderMiddlePageNumbers(),
      this.renderTrailingTruncation()
    ];
  }
  warnAboutBadProps() {
    console.error("Pagination can not render due to bad props", this.props);
  }
  render() {
    const { className: t } = this.props;
    return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ s.jsxs("ul", { className: f(vo.root, t), children: [
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-left",
          variant: "tertiary",
          onClick: this.goToPrevPage,
          disabled: !this.getBoundaries().canGoToPrevPage,
          "data-testid": On.PrevPageButton
        }
      ) }),
      this.renderPages(),
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-right",
          variant: "tertiary",
          onClick: this.goToNextPage,
          disabled: !this.getBoundaries().canGoToNextPage,
          "data-testid": On.NextPageButton
        }
      ) })
    ] }) : (this.warnAboutBadProps(), null) : null;
  }
}
const So = ({ children: i, ...t }, e) => /* @__PURE__ */ s.jsx(Pe, { children: ({ pagination: n }) => !n.paginated || n.pageCount <= 1 ? null : /* @__PURE__ */ s.jsx(Ks, { children: /* @__PURE__ */ s.jsx("div", { ref: e, ...t, "data-testid": ct.PaginationRow, children: /* @__PURE__ */ s.jsx(O, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
  Hd,
  {
    currentPage: n.selectedPage,
    pageCount: n.pageCount,
    onPageChange: n.onPageChange,
    pageRangeDisplayed: n.pageRangeDisplayed
  }
) }) }) }) }), Wd = Object.assign($(So), {
  name: So.name
}), Md = "h-table-tbody--tbody__root", zd = "h-table-tbody--tbody__rootIsLoading", Vd = "h-table-tbody--tbody__rootIsLoadingFade", ds = {
  root: Md,
  rootIsLoading: zd,
  rootIsLoadingFade: Vd
}, Kd = "h-emptyState--emptyState__textWrapper", Ud = "h-emptyState--emptyState__rootSmall", qd = "h-emptyState--emptyState__rootLarge", hs = {
  textWrapper: Kd,
  rootSmall: Ud,
  rootLarge: qd
}, Gd = ({
  className: i,
  title: t,
  description: e,
  icon: n = "info",
  iconColor: o = "neutral.500",
  size: r = "large",
  buttonProps: a
}) => {
  const l = f(
    {
      [hs.rootSmall]: r === "small",
      [hs.rootLarge]: r === "large"
    },
    i
  );
  return /* @__PURE__ */ s.jsxs(
    O,
    {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      className: l,
      children: [
        n && /* @__PURE__ */ s.jsx(N, { name: n, size: 20, color: tn(o) }),
        /* @__PURE__ */ s.jsxs(
          O,
          {
            flexDirection: "column",
            alignItems: "center",
            gap: "100",
            className: hs.textWrapper,
            children: [
              /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "1", children: t }),
              /* @__PURE__ */ s.jsx(
                L.Paragraph,
                {
                  variant: "2",
                  as: typeof e == "string" ? "p" : "div",
                  children: e
                }
              )
            ]
          }
        ),
        a?.children && /* @__PURE__ */ s.jsx(X, { ...a })
      ]
    }
  );
};
function Yd(i) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ct.EmptyRow, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsx(O, { justifyContent: "center", alignItems: "center", padding: "500", children: /* @__PURE__ */ s.jsx(Gd, { ...i }) }) }) });
}
function Xd({
  onRetry: i,
  ...t
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ct.LoadingFailedRow, ...t, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    O,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: "Something went wrong..." }),
        i && /* @__PURE__ */ s.jsx(X, { variant: "tertiary", onClick: i, children: "Try again" })
      ]
    }
  ) }) });
}
function Qd({
  ...i
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ct.LoadingRow, ...i, children: /* @__PURE__ */ s.jsx("td", { align: "center", colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    O,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(Un, {}),
        /* @__PURE__ */ s.jsx(it, { margin: "300", children: /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: "Loading..." }) })
      ]
    }
  ) }) });
}
const Io = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Pe, { children: ({
  status: { loading: o, loadingFailed: r, onLoadingRetry: a, emptyState: l },
  loading: { loadingStrategy: c }
}) => {
  const d = r && !o, h = ["spinner"].includes(c) ? !o && !d : !d;
  return /* @__PURE__ */ s.jsxs(
    "tbody",
    {
      ...e,
      "data-testid": ct.Body,
      ref: n,
      className: f(
        {
          [ds.rootIsLoading]: o,
          [ds.rootIsLoadingFade]: o && c === "fade"
        },
        ds.root,
        t
      ),
      children: [
        c === "spinner" && o && /* @__PURE__ */ s.jsx(Qd, {}),
        d && /* @__PURE__ */ s.jsx(Xd, { onRetry: a }),
        l && /* @__PURE__ */ s.jsx(Yd, { ...l }),
        h && i
      ]
    }
  );
} }), Zd = Object.assign($(Io), { name: Io.name }), Jd = "h-table-td--td__root", th = "h-table-td--td__rootExtraPaddingForFirstChild", eh = "h-table-td--td__rootStickyFooterTd", us = {
  root: Jd,
  rootExtraPaddingForFirstChild: th,
  rootStickyFooterTd: eh
}, Do = ({ className: i, children: t, ...e }, n) => /* @__PURE__ */ s.jsx(Pe, { children: ({ rows: o, presentation: r, isTableFoot: a }) => {
  const l = f(
    us.root,
    {
      [us.rootExtraPaddingForFirstChild]: !o.expandableRows,
      [us.rootStickyFooterTd]: r.stickyFooter === !0 && a === !0
    },
    i
  );
  return /* @__PURE__ */ s.jsx(
    it,
    {
      as: "td",
      ref: n,
      className: l,
      ...e,
      "data-testid": ct.Td,
      children: t
    }
  );
} }), oe = Object.assign($(Do), { name: Do.name }), nh = "h-table-th--th__root", sh = "h-table-th--th__rootSticky", oh = "h-table-th--th__rootShowBG", rh = "h-table-th--th__rootClickable", ih = "h-table-th--th__icon", ah = "h-table-th--th__contentWrapper", lh = "h-table-th--th__tooltip", Jt = {
  root: nh,
  rootSticky: sh,
  rootShowBG: oh,
  rootClickable: rh,
  icon: ih,
  contentWrapper: ah,
  tooltip: lh
};
class ko extends D {
  context = void 0;
  columnIsInSortableColumns() {
    return this.context?.sorting.sortableColumns?.some(
      (t) => t === this.props.columnId
    ) ?? !0;
  }
  getContextualInfo() {
    const { columnId: t } = this.props, { context: e } = this;
    return {
      sortByThisColumn: e?.sorting.sortStatus?.sortBy === t,
      sortDirection: e?.sorting.sortStatus?.direction,
      columnIsSortable: e?.sorting.sortable && !yt(t) ? this.columnIsInSortableColumns() : !1
    };
  }
  getTheNewSortDirection(t) {
    const { sortByThisColumn: e, sortDirection: n } = this.getContextualInfo(), o = {
      sortBy: t,
      direction: "asc"
    };
    if (!e)
      return o;
    switch (n) {
      // not sorted => make it asc
      case void 0:
        return o;
      // desc sorted => not sorted
      case "desc":
        return null;
      // asc sorted => make it desc
      case "asc":
        return {
          sortBy: t,
          direction: "desc"
        };
      default:
        return o;
    }
  }
  getClickHandler() {
    const { onClick: t } = this.props, { context: e } = this;
    return (n) => {
      const { columnIsSortable: o } = this.getContextualInfo(), { columnId: r } = this.props;
      t?.(n), o && !yt(r) && e?.sorting.onSortChange(this.getTheNewSortDirection(r));
    };
  }
  renderIcon(t) {
    return t ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: Jt.icon,
        name: t === "asc" ? "sort-up" : "sort-down"
      }
    ) : null;
  }
  warnAboutNoColumnIdProps() {
    console.error(`
      <Table.Th> needs a 'columnId' prop when table is sortable.
      Pass 'columndId: null' prop if you want that column not to be sortable.
    `);
  }
  render() {
    return /* @__PURE__ */ s.jsx(Pe, { children: (t) => {
      this.context = t;
      const { sorting: e, presentation: n } = t;
      e.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
      const {
        className: o,
        children: r,
        tooltip: a,
        columnId: l,
        thRef: c,
        ...d
      } = this.props, { sortByThisColumn: h, columnIsSortable: u, sortDirection: p } = this.getContextualInfo(), m = f(
        Jt.root,
        {
          [Jt.rootClickable]: u,
          [Jt.rootSticky]: n.stickyHeader,
          [Jt.rootShowBG]: n.headerWithBackground
        },
        o
      ), g = f({
        [Jt.tooltip]: a
      });
      return /* @__PURE__ */ s.jsx(
        it,
        {
          as: "th",
          ...d,
          ref: c,
          className: m,
          onClick: this.getClickHandler(),
          "data-testid": ct.Th,
          children: /* @__PURE__ */ s.jsxs("span", { className: Jt.contentWrapper, children: [
            /* @__PURE__ */ s.jsx(gt, { content: a, disabled: !a, children: /* @__PURE__ */ s.jsx("span", { className: g, children: r }) }),
            h && this.renderIcon(p)
          ] })
        }
      );
    } });
  }
}
const Ns = Object.assign(
  $(
    function(t, e) {
      return /* @__PURE__ */ s.jsx(ko, { ...t, thRef: e });
    }
  ),
  { name: ko.name }
), ch = (i) => i === !1, dh = "h-table-tr--tr__trHoverable", hh = "h-table-tr--tr__expansionTriggerWrapper", uh = "h-table-tr--tr__expansionTriggerWrapperExpanded", ph = "h-table-tr--tr__checkboxCell", mh = "h-table-tr--tr__checkboxCellExpanded", gh = "h-table-tr--tr__expandedRowContentWrapper", St = {
  trHoverable: dh,
  expansionTriggerWrapper: hh,
  expansionTriggerWrapperExpanded: uh,
  checkboxCell: ph,
  checkboxCellExpanded: mh,
  expandedRowContentWrapper: gh
}, fh = ({
  rowId: i,
  isExpandable: t,
  isExpanded: e,
  onExpansionToggle: n,
  expandableContent: o,
  isSelectable: r,
  isSelected: a,
  onSelect: l,
  isHoverable: c,
  children: d,
  trRef: h,
  ...u
}) => {
  const p = f(u.className, {
    [St.trHoverable]: c
  }) || void 0;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "tr",
      {
        ...u,
        ref: h,
        className: p,
        "data-testid": ct.Row,
        children: [
          t && /* @__PURE__ */ s.jsx(
            oe,
            {
              className: f(St.expansionTriggerWrapper, {
                [St.expansionTriggerWrapperExpanded]: e
              }),
              children: o && /* @__PURE__ */ s.jsx(
                K,
                {
                  variant: "tertiary",
                  icon: e ? "angle-down" : "angle-right",
                  "data-testid": ct.RowExpansionTrigger,
                  onClick: () => {
                    yt(i) || n(i);
                  }
                }
              )
            }
          ),
          r && /* @__PURE__ */ s.jsx(
            oe,
            {
              className: f(St.checkboxCell, {
                [St.checkboxCellExpanded]: e
              }),
              children: /* @__PURE__ */ s.jsx(O, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
                cn,
                {
                  checked: a,
                  name: `selection-trigger-${i}`,
                  id: `selection-trigger-${i}`,
                  onChange: () => {
                    yt(i) || l(i);
                  }
                }
              ) })
            }
          ),
          d
        ]
      }
    ),
    t && e && /* @__PURE__ */ s.jsxs("tr", { "data-testid": ct.Row, children: [
      /* @__PURE__ */ s.jsx(oe, { className: St.expansionTriggerWrapper }),
      r && /* @__PURE__ */ s.jsx(oe, { className: St.checkboxCell }),
      /* @__PURE__ */ s.jsx(
        oe,
        {
          colSpan: Number.MAX_SAFE_INTEGER,
          className: St.expandedRowContentWrapper,
          children: o
        }
      )
    ] })
  ] });
}, bh = ({
  isExpandable: i,
  children: t,
  trRef: e,
  ...n
}) => /* @__PURE__ */ s.jsxs("tr", { ...n, ref: e, "data-testid": ct.Row, children: [
  i && /* @__PURE__ */ s.jsx(oe, { className: St.expansionTriggerWrapper, children: /* @__PURE__ */ s.jsx("span", {}) }),
  t
] }), xh = ({
  isExpandable: i,
  isSelectable: t,
  allRowsSelected: e,
  allRowsSelectedIndeterminate: n,
  onAllRowsSelect: o,
  children: r,
  trRef: a,
  ...l
}) => /* @__PURE__ */ s.jsxs("tr", { ...l, ref: a, "data-testid": ct.Row, children: [
  i && /* @__PURE__ */ s.jsx(Ns, { className: St.expansionTriggerWrapper, columnId: null, children: /* @__PURE__ */ s.jsx("span", {}) }),
  t && /* @__PURE__ */ s.jsx(Ns, { className: St.checkboxCell, columnId: null, children: /* @__PURE__ */ s.jsx(O, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
    cn,
    {
      checked: e,
      indeterminate: n,
      onChange: o,
      name: "all-rows-selector",
      id: "all-rows-selector"
    }
  ) }) }),
  r
] });
class To extends D {
  context = void 0;
  isRowExpanded(t, e) {
    return t.includes(e);
  }
  hasSelectableRow() {
    const { rowId: t } = this.props;
    return this.context?.rows.selectableRows === !0 && !yt(t);
  }
  hasExpandableRow() {
    const { expandableContent: t, rowId: e } = this.props;
    return this.context?.rows.expandableRows === !0 && !yt(t) && !yt(e);
  }
  shouldRenderRegularTr() {
    return [this.hasExpandableRow(), this.hasSelectableRow()].every(ch);
  }
  rowIdIsPresent(t) {
    return !yt(t);
  }
  render() {
    const { children: t, expandableContent: e, rowId: n, ...o } = this.props;
    return /* @__PURE__ */ s.jsx(Pe, { children: (r) => {
      this.context = r;
      const { rows: a } = r;
      if (r.isTableHead)
        return /* @__PURE__ */ s.jsx(
          xh,
          {
            ...o,
            isExpandable: a.expandableRows,
            isSelectable: a.selectableRows,
            allRowsSelected: a.allRowsSelected,
            allRowsSelectedIndeterminate: a.allRowsSelectedIndeterminate,
            onAllRowsSelect: a.onAllRowsSelect,
            children: t
          }
        );
      if (r.isTableFoot)
        return /* @__PURE__ */ s.jsx(bh, { ...o, isExpandable: a.expandableRows, children: t });
      const l = yt(n) ? !1 : this.isRowExpanded(a.expandedRows, n), c = yt(n) ? !1 : a.selectedRowIds.includes(n);
      return /* @__PURE__ */ s.jsx(
        fh,
        {
          ...o,
          rowId: n,
          isExpanded: l,
          isSelected: c,
          onSelect: a.onRowSelect,
          isExpandable: a.expandableRows,
          expandableContent: e,
          isSelectable: a.selectableRows,
          onExpansionToggle: a.onExpansionToggle,
          isHoverable: r.presentation.hoverable,
          children: t
        }
      );
    } });
  }
}
const yh = Object.assign(
  $(function(t, e) {
    return /* @__PURE__ */ s.jsx(To, { ...t, trRef: e });
  }),
  { name: To.name }
), _h = "h-table--table__wrapper", Ch = "h-table--table__wrapperIsFramed", wh = "h-table--table__wrapperIsLoading", vh = "h-table--table__innerWrapper", Sh = "h-table--table__wrapperIsDisabled", Ih = "h-table--table__table", ue = {
  wrapper: _h,
  wrapperIsFramed: Ch,
  wrapperIsLoading: wh,
  innerWrapper: vh,
  wrapperIsDisabled: Sh,
  table: Ih
};
class Hn extends D {
  static defaultProps = {
    headerWithBackground: !0,
    stickyHeader: !1,
    stickyFooter: !1,
    framed: !0,
    hoverable: !1,
    loadingStrategy: "spinner"
  };
  constructor(t) {
    super(t), this.state = {
      expandedRows: t.expandableRowsProps?.initiallyExpandedRows ?? []
    }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }
  static fallback = /* @__PURE__ */ s.jsx(
    O,
    {
      justifyContent: "center",
      alignItems: "center",
      style: { minHeight: "10vh" },
      children: /* @__PURE__ */ s.jsx(L.Paragraph, { children: "Oops! something went wrong..." })
    }
  );
  handleExpansionToggle(t) {
    this.state.expandedRows.includes(t) ? this.setState(({ expandedRows: e }) => ({
      expandedRows: e.filter((n) => n !== t)
    })) : this.setState(({ expandedRows: e }) => ({
      expandedRows: [...e, t]
    }));
  }
  getContextValue() {
    const {
      props: {
        headerWithBackground: t,
        stickyHeader: e,
        stickyFooter: n,
        sortingProps: o,
        paginationProps: r,
        selectableRowsProps: a,
        expandableRowsProps: l,
        loading: c,
        loadingFailed: d,
        onLoadingRetry: h,
        emptyState: u,
        loadingStrategy: p,
        hoverable: m
      }
    } = this;
    return {
      status: {
        loading: c ?? !1,
        loadingFailed: d ?? !1,
        onLoadingRetry: h,
        emptyState: u
      },
      presentation: {
        headerWithBackground: !!t,
        stickyHeader: !!e,
        stickyFooter: !!n,
        hoverable: !!m
      },
      sorting: {
        sortable: !!o,
        sortableColumns: o?.sortableColumns,
        sortStatus: o?.sortStatus ?? null,
        onSortChange: o?.onSortChange ?? E
      },
      pagination: {
        paginated: !!r,
        selectedPage: r?.selectedPage ?? 1,
        pageCount: r?.pageCount ?? 1,
        onPageChange: r?.onPageChange ?? E,
        pageRangeDisplayed: r?.pageRangeDisplayed
      },
      rows: {
        expandableRows: l?.expandableRows ?? !1,
        expandedRows: this.state.expandedRows,
        onExpansionToggle: this.handleExpansionToggle,
        selectableRows: !!a,
        selectedRowIds: a?.selectedRowIds ?? [],
        onRowSelect: a?.onRowSelect ?? E,
        onAllRowsSelect: a?.onAllRowsSelect ?? E,
        allRowsSelected: a?.allRowsSelected ?? !1,
        allRowsSelectedIndeterminate: a?.allRowsSelectedIndeterminate ?? !1
      },
      loading: {
        loadingStrategy: p ?? "spinner"
      }
    };
  }
  render() {
    const {
      framed: t,
      className: e,
      children: n,
      wrapperProps: o,
      wrapperRef: r,
      innerWrapperClassName: a,
      nativeProps: l,
      tableRef: c
    } = this.props, d = Rd(n), h = f(ue.wrapper, o?.className, {
      [ue.wrapperIsFramed]: t,
      [ue.wrapperIsLoading]: this.props.loading,
      [ue.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
    }), u = f(
      {
        [ue.innerWrapper]: !0
      },
      a
    ), p = f(ue.table, e), m = this.getContextValue();
    return /* @__PURE__ */ s.jsx(Ms, { fallback: Hn.fallback, children: /* @__PURE__ */ s.jsx(Qn.Provider, { value: m, children: /* @__PURE__ */ s.jsxs("div", { ...o, className: h, children: [
      /* @__PURE__ */ s.jsx("div", { className: u, ref: r, children: /* @__PURE__ */ s.jsx("table", { ...l, ref: c, className: p, children: d.children }) }),
      m.pagination.paginated && /* @__PURE__ */ s.jsx(Wd, {}),
      !m.pagination.paginated && d.footers
    ] }) }) });
  }
}
const mt = Object.assign(
  $(
    function(t, e) {
      return /* @__PURE__ */ s.jsx(Hn, { ...t, tableRef: e });
    }
  ),
  {
    name: Hn.name,
    Thead: Nd,
    Tbody: Zd,
    Tfoot: kd,
    Tr: yh,
    Th: Ns,
    Td: oe,
    Footer: Ks
  }
), Dh = "h-helpIcon--helpIcon__infoIcon", kh = {
  infoIcon: Dh
};
class Us extends D {
  render() {
    const {
      side: t,
      text: e,
      title: n,
      disabled: o,
      requireClick: r,
      className: a,
      alwaysShow: l,
      tooltipClassName: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      gt,
      {
        head: n,
        content: e,
        disabled: o,
        side: t,
        requireClick: r,
        alwaysShow: l,
        className: c,
        wrap: "none",
        ...d,
        children: /* @__PURE__ */ s.jsx("span", { className: f(kh.infoIcon, a), children: /* @__PURE__ */ s.jsx(N, { name: "info" }) })
      }
    );
  }
}
const Ir = ({
  columns: i
}) => /* @__PURE__ */ s.jsx(s.Fragment, { children: i.map(({ label: t, style: e, helpIcon: n, columnId: o }, r) => /* @__PURE__ */ s.jsxs(mt.Th, { columnId: o || t, style: e, children: [
  t,
  n?.title && n?.text && /* @__PURE__ */ s.jsx(Us, { side: "bottom", ...n })
] }, t || r)) }), Th = ({
  columns: i,
  data: t
}) => /* @__PURE__ */ s.jsxs(mt, { headerWithBackground: !1, framed: !1, children: [
  /* @__PURE__ */ s.jsx(mt.Thead, { children: /* @__PURE__ */ s.jsx(mt.Tr, { children: /* @__PURE__ */ s.jsx(Ir, { columns: i }) }) }),
  /* @__PURE__ */ s.jsx(mt.Tbody, { children: t.map((e, n) => /* @__PURE__ */ s.jsx(mt.Tr, { children: i.map(({ selector: o }, r) => /* @__PURE__ */ s.jsx(mt.Td, { children: o(e) }, r)) }, n)) })
] }), jh = ({
  data: i,
  rowId: t,
  columns: e,
  subTableColumns: n,
  subTableDataSelector: o
}) => /* @__PURE__ */ s.jsx(
  mt.Tr,
  {
    expandableContent: !!(n && o) && /* @__PURE__ */ s.jsx(
      Th,
      {
        data: o(i),
        columns: n
      }
    ),
    rowId: t,
    children: e.map(({ selector: r }, a) => /* @__PURE__ */ s.jsx(mt.Td, { children: r(i) }, a))
  }
), xk = ({
  columns: i,
  subTableColumns: t,
  data: e,
  subTableDataSelector: n,
  tableWrapperProps: o,
  tableInnerWrapperClassName: r,
  paginationProps: a,
  sortingProps: l,
  selectableRowsProps: c,
  tableStyleProps: d,
  tableStatusProps: h,
  tableRowIdSelector: u,
  tableLoadingStrategy: p,
  tableWrapperRef: m
}) => {
  const g = i.filter((b) => b.sortable).reduce(
    (b, x) => x.columnId ? [...b, x.columnId] : b,
    []
  );
  return g.length && l && (l.sortableColumns = g), /* @__PURE__ */ s.jsxs(
    mt,
    {
      stickyHeader: !0,
      wrapperProps: o,
      innerWrapperClassName: r,
      expandableRowsProps: {
        expandableRows: !!(t && n)
      },
      sortingProps: l,
      selectableRowsProps: c,
      loadingStrategy: p,
      wrapperRef: m,
      ...d,
      ...h,
      children: [
        /* @__PURE__ */ s.jsx(mt.Thead, { children: /* @__PURE__ */ s.jsx(mt.Tr, { children: /* @__PURE__ */ s.jsx(Ir, { columns: i }) }) }),
        /* @__PURE__ */ s.jsx(mt.Tbody, { children: e.map((b, x) => /* @__PURE__ */ s.jsx(
          jh,
          {
            rowId: u ? u(b) : x,
            data: b,
            columns: i,
            subTableDataSelector: n,
            subTableColumns: t
          },
          x
        )) }),
        a && /* @__PURE__ */ s.jsx(mt.Footer, { children: /* @__PURE__ */ s.jsx(Sd, { ...a }) })
      ]
    }
  );
}, Nh = "h-datePickerOld--datePickerDay__root", Fh = "h-datePickerOld--datePickerDay__rootActive", Ph = "h-datePickerOld--datePickerDay__rootDisabled", Rh = "h-datePickerOld--datePickerDay__rootDim", Eh = "h-datePickerOld--datePickerDay__label", Be = {
  root: Nh,
  rootActive: Fh,
  rootDisabled: Ph,
  rootDim: Rh,
  label: Eh
};
class Lh extends D {
  render() {
    const {
      className: t,
      dim: e,
      active: n,
      disabled: o,
      children: r,
      onClick: a,
      ...l
    } = this.props, c = f(
      {
        [Be.root]: !0,
        [Be.rootDim]: e,
        [Be.rootActive]: n,
        [Be.rootDisabled]: !n && o
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...l,
        onClick: a,
        className: c,
        disabled: o,
        children: /* @__PURE__ */ s.jsx("span", { className: Be.label, children: r })
      }
    );
  }
}
const Ah = "h-datePickerOld--datePickerOld__grid", $h = "h-datePickerOld--datePickerOld__gridItem", Bh = "h-datePickerOld--datePickerOld__day", Oh = "h-datePickerOld--datePickerOld__month", Hh = "h-datePickerOld--datePickerOld__timeButtonContainerLeft", Wh = "h-datePickerOld--datePickerOld__timeButtonContainerRight", Mh = "h-datePickerOld--datePickerOld__arrowTime", zh = "h-datePickerOld--datePickerOld__arrow", Vh = "h-datePickerOld--datePickerOld__dayNames", Kh = "h-datePickerOld--datePickerOld__dayName", Uh = "h-datePickerOld--datePickerOld__time", qh = "h-datePickerOld--datePickerOld__timeDisplay", G = {
  grid: Ah,
  gridItem: $h,
  day: Bh,
  month: Oh,
  timeButtonContainerLeft: Hh,
  timeButtonContainerRight: Wh,
  arrowTime: Mh,
  arrow: zh,
  dayNames: Vh,
  dayName: Kh,
  time: Uh,
  timeDisplay: qh
}, yk = (i) => [0, 6].indexOf(i.getDay()) !== -1;
class Ze extends D {
  static defaultProps;
  static getDateValue(t) {
    const e = t.value instanceof Date ? t.value : /* @__PURE__ */ new Date();
    return new Date(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes()
    );
  }
  constructor(t) {
    super(t);
    const e = Ze.getDateValue(t.input);
    this.state = {
      selectedDate: e,
      showDate: e
    };
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { input: e } = this.props;
    t.input !== e && this.setState({
      selectedDate: Ze.getDateValue(t.input)
    });
  }
  generateGrid() {
    const { selectedDate: t, showDate: e } = this.state, { input: n, disabled: o, minDate: r, maxDate: a } = this.props, l = [], c = new Date(
      e.getFullYear(),
      e.getMonth(),
      1,
      t.getHours(),
      t.getMinutes()
    ), d = c.getDay() || 7, h = new Date(
      c.getFullYear(),
      c.getMonth() + 1,
      1
    );
    d < 3 && c.setDate(c.getDate() - 7), c.setDate(c.getDate() - (d - 1));
    const u = Ze.getDateValue(n).getTime();
    let p = 0;
    for (; c < h || c.getDay() !== 1 || p < 6; ) {
      const m = c.getTime(), g = new Date(m);
      l.push({
        date: g,
        label: c.getDate().toString(),
        isThisMonth: c.getMonth() === e.getMonth(),
        selected: m === u,
        disabled: o(c) || !!(a && g > a) || !!(r && g < r)
      }), c.getDay() === 1 && (p += 1), c.setDate(c.getDate() + 1);
    }
    return l;
  }
  goToMonth(t) {
    const { showDate: e } = this.state, n = new Date(e.getTime());
    n.setMonth(e.getMonth() + t), this.setState({
      showDate: n
    });
  }
  nextMonth = (t) => {
    t.preventDefault(), this.goToMonth(1);
  };
  prevMonth = (t) => {
    t.preventDefault(), this.goToMonth(-1);
  };
  handleDateClick(t, e) {
    t.preventDefault();
    const {
      input: { onChange: n }
    } = this.props, { showDate: o } = this.state, r = {
      ...this.state,
      selectedDate: e
    };
    o.getMonth() !== e.getMonth() && (r.showDate = e), this.setState(r), n(e);
  }
  goToTime(t, e, n = "hours") {
    const o = n === "minutes" ? "setMinutes" : "setHours", r = n === "minutes" ? "getMinutes" : "getHours", {
      input: { onChange: a }
    } = this.props, { selectedDate: l } = this.state, c = new Date(l.getTime());
    c[o](c[r]() + e), this.setState({
      selectedDate: c
    }), a(c);
  }
  nextMinutes = (t) => {
    t.preventDefault(), this.goToTime(t, 15, "minutes");
  };
  prevMinutes = (t) => {
    t.preventDefault(), this.goToTime(t, -15, "minutes");
  };
  nextHour = (t) => {
    t.preventDefault(), this.goToTime(t, 1);
  };
  prevHour = (t) => {
    t.preventDefault(), this.goToTime(t, -1);
  };
  canGoPrevMonth() {
    const { minDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth(),
      1
    );
    return t < n;
  }
  canGoNextMonth() {
    const { maxDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth() + 1,
      1,
      0,
      0,
      0,
      -1
    );
    return t > n;
  }
  canGoDirection(t = "hours", e) {
    const n = t === "minutes" ? "setMinutes" : "setHours", o = t === "minutes" ? "getMinutes" : "getHours", { maxDate: r } = this.props, { selectedDate: a } = this.state, l = new Date(a.getTime());
    return l[n](l[o]() + e), !(l.getDate() !== a.getDate()) && (r === null || r >= l);
  }
  render() {
    const {
      className: t,
      input: e,
      hasTime: n,
      disabled: o,
      minDate: r,
      maxDate: a,
      ...l
    } = this.props, { selectedDate: c, showDate: d } = this.state, h = f({}, t), u = this.generateGrid(), p = {
      month: "long",
      year: "numeric"
    };
    let m = null;
    try {
      m = d.toLocaleDateString("en-US", p);
    } catch (g) {
      m = `${d.getMonth() + 1} / ${d.getFullYear()}`, console.warn("toLocaleDateString exception", g);
    }
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsxs("div", { className: G.month, children: [
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: G.arrow,
            disabled: !this.canGoPrevMonth(),
            onClick: this.prevMonth,
            "aria-label": "Previous month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
          }
        ),
        m,
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: G.arrow,
            disabled: !this.canGoNextMonth(),
            onClick: this.nextMonth,
            "aria-label": "Next month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: G.dayNames, children: [
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Mon" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Tue" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Wed" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Thu" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Fri" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Sat" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Sun" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: G.grid, children: u.map((g) => /* @__PURE__ */ s.jsx("div", { className: G.gridItem, children: /* @__PURE__ */ s.jsx(
        Lh,
        {
          onClick: (b) => this.handleDateClick(b, g.date),
          dim: !g.isThisMonth,
          active: g.selected,
          disabled: g.disabled,
          className: G.day,
          children: g.label
        }
      ) }, g.date.getTime())) }),
      n && /* @__PURE__ */ s.jsxs("div", { className: G.time, children: [
        /* @__PURE__ */ s.jsxs("div", { className: G.timeButtonContainerLeft, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: G.arrowTime,
              disabled: !this.canGoDirection("hours", -1),
              onClick: this.prevHour,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-left", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: G.arrowTime,
              disabled: !this.canGoDirection("minutes", -15),
              onClick: this.prevMinutes,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: G.timeDisplay, children: `${io(
          c.getHours().toString(),
          2,
          "0"
        )}:${io(c.getMinutes().toString(), 2, "0")}` }),
        /* @__PURE__ */ s.jsxs("div", { className: G.timeButtonContainerRight, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: G.arrowTime,
              disabled: !this.canGoDirection("minutes", 15),
              onClick: this.nextMinutes,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: G.arrowTime,
              disabled: !this.canGoDirection("hours", 1),
              onClick: this.nextHour,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-right", className: "icon-vertical-fix" })
            }
          )
        ] })
      ] })
    ] });
  }
}
Ze.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: () => !1,
  minDate: null,
  maxDate: null,
  hasTime: !1
};
function Gh(i) {
  return Math.abs(i.diff(j())) < 25e3 ? "just now" : i.fromNow();
}
function Fs(i) {
  return j(i, j.ISO_8601).isValid();
}
function De(i) {
  return !!j.tz.zone(i ?? "");
}
const Nt = "HH:mm", Dr = mr(24), kr = mr(0, 60, 15), Tr = (i) => j("1995-12-25").format(i);
function jr(i) {
  if (i < 0 || i > 23)
    throw new Error("Hour must be between 0 and 23.");
}
function Nr(i) {
  if (i < 0 || i > 59)
    throw new Error("Minute must be between 0 and 59.");
}
function Fr({
  hour: i,
  minute: t,
  timeFormat: e
}) {
  const n = j({ hour: i, minute: t });
  return {
    id: n.format(Nt),
    name: n.format(e)
  };
}
function Yh(i, t) {
  return t?.map(({ hour: e, minute: n }) => (jr(e), Nr(n), Fr({ hour: e, minute: n, timeFormat: i }))) || [];
}
function Pr({
  hours: i,
  minutes: t,
  overrides: e,
  timeFormat: n
}) {
  return xi(
    i.reduce(
      (o, r, a) => [
        ...o,
        ...t.map((l, c) => (c === 0 && jr(r), a === 0 && Nr(l), Fr({ hour: r, minute: l, timeFormat: n })))
      ],
      []
    ).concat(Yh(n, e)),
    ["id"]
  );
}
const Xh = "h-datePicker--datePicker__root", Qh = "h-datePicker--datePicker__navigationButton", Zh = "h-datePicker--datePicker__nextMonthButton", Jh = "h-datePicker--datePicker__prevMonthButton", Ie = {
  root: Xh,
  navigationButton: Qh,
  nextMonthButton: Zh,
  prevMonthButton: Jh
}, Wn = {
  previousMonth({ ariaLabel: i, ...t }) {
    const e = f(
      Ie.navigationButton,
      Ie.prevMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(N, { ...t, "aria-label": i, size: 24, name: "angle-left" }) });
  },
  nextMonth({ ariaLabel: i, ...t }) {
    const e = f(
      Ie.navigationButton,
      Ie.nextMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(N, { ...t, "aria-label": i, size: 24, name: "angle-right" }) });
  }
}, Rr = (i) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx("span", { className: "date-number-container", children: i.date() }),
  /* @__PURE__ */ s.jsx("span", { className: "day-complimentary-highlight" })
] }), Er = ({ month: i }) => /* @__PURE__ */ s.jsx("span", { children: i.format("MMMM YYYY") }), Lr = (i) => {
  const { value: t, presets: e, onSelect: n } = i, o = F(
    (r) => {
      n(r.key === t ? null : r);
    },
    [n, t]
  );
  return /* @__PURE__ */ s.jsxs(Xt, { children: [
    /* @__PURE__ */ s.jsx(qn, { orientation: "vertical" }),
    /* @__PURE__ */ s.jsx(ho, { children: e.map((r) => /* @__PURE__ */ s.jsx(
      ho.Item,
      {
        isSelected: r.key === t,
        onClick: () => o(r),
        children: r.label
      },
      r.key
    )) })
  ] });
}, tu = "h-fieldLabel--fieldLabel__root", eu = "h-fieldLabel--fieldLabel__label", nu = "h-fieldLabel--fieldLabel__labelChildren", su = "h-fieldLabel--fieldLabel__rootRequired", ou = "h-fieldLabel--fieldLabel__helpIcon", Oe = {
  root: tu,
  label: eu,
  labelChildren: nu,
  rootRequired: su,
  helpIcon: ou
}, ru = "fieldLabel";
class qs extends D {
  render() {
    const { required: t, helpIcon: e, className: n, children: o, ...r } = this.props, a = f(Oe.root, n, {
      [Oe.rootRequired]: t
    });
    return /* @__PURE__ */ s.jsxs("div", { className: a, "data-testid": ru, children: [
      /* @__PURE__ */ s.jsx("label", { className: Oe.label, ...r, children: /* @__PURE__ */ s.jsx("div", { className: Oe.labelChildren, children: o }) }),
      !!e?.text && /* @__PURE__ */ s.jsx(
        Us,
        {
          ...e,
          className: f(Oe.helpIcon, e.className)
        }
      )
    ] });
  }
}
const iu = "h-dropdownSelect--dropdownInfinite__item", au = "h-dropdownSelect--dropdownInfinite__list", lu = "h-dropdownSelect--dropdownInfinite__listEmpty", ps = {
  item: iu,
  list: au,
  listEmpty: lu
};
class jo extends D {
  render() {
    const {
      item: t,
      itemComponent: e,
      tooltip: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      checked: c,
      disabled: d,
      isLoading: h,
      active: u,
      id: p
    } = this.props, m = /* @__PURE__ */ s.jsx(
      e,
      {
        item: t,
        onSelect: o,
        onChange: r,
        onKeyDown: a,
        clearSearch: l,
        checked: c,
        disabled: d,
        isLoading: h,
        active: u,
        tabIndex: u ? 0 : -1,
        id: p,
        role: "option",
        "aria-disabled": d,
        "aria-selected": c
      }
    );
    return n ? /* @__PURE__ */ s.jsx(gt, { ...n, children: m }, t.id) : m;
  }
}
const cu = 6, du = 48;
class Gs extends D {
  listRef;
  infiniteListRef;
  static defaultProps = {
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  constructor(t) {
    super(t), this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = B(), this.infiniteListRef = B();
  }
  componentDidUpdate(t) {
    const { activeItem: e, items: n, pagination: o } = this.props, r = typeof t.activeItem == "object" && t.activeItem ? t.activeItem.id : t.activeItem, a = typeof e == "object" && e ? e.id : e;
    if (r !== a && a !== null) {
      const l = n.findIndex(
        (c) => c.id === a
      );
      if (l >= 0) {
        if (typeof o == "object" && o.infinite && this.infiniteListRef.current)
          this.infiniteListRef.current.scrollToItem(l, "smart");
        else if (this.listRef.current) {
          const c = this.listRef.current.children[l];
          c && c.scrollIntoView({ block: "nearest" });
        }
      }
    }
  }
  isItemLoaded(t) {
    const { items: e } = this.props;
    return t < e.length;
  }
  isItemActive(t) {
    if (!t) return !1;
    const { activeItem: e } = this.props;
    return e ? typeof e == "object" && "id" in e ? t.id === e.id : t.id === e : !1;
  }
  isItemChecked(t) {
    if (!t) return !1;
    const { selectedItems: e } = this.props;
    return (e?.findIndex((o) => typeof o == "object" ? o.id === t.id : o === t.id) ?? -1) > -1;
  }
  isItemDisabled(t) {
    return t ? (this.props.disabledItems?.indexOf(t.id) ?? -1) >= 0 : !0;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !t || Hs(e?.[t.id]) ? null : e?.[t.id] ?? null;
  }
  goToTop() {
    this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
  }
  focusActiveItem() {
    const { items: t, activeItem: e } = this.props;
    if (!e || !this.listRef.current) return;
    const n = typeof e == "object" && "id" in e ? e.id : e, o = t.findIndex((r) => r.id === n);
    if (o >= 0 && this.listRef.current.children[o]) {
      const r = this.listRef.current.children[o];
      (r.querySelector('[tabindex="0"]') || r)?.focus();
    }
  }
  getItemId(t) {
    const { id: e } = this.props;
    return e ? `${e}-option-${t}` : void 0;
  }
  /**
   * This attribute is supposed to be a React component. The FixedSizeList
   * component expects a component is a child.
   *
   * @see https://react-window.vercel.app/#/examples/list/fixed-size
   */
  ListItem = ({
    index: t,
    style: e
  }) => {
    const { items: n, itemComponent: o, onSelect: r, onChange: a, clearSearch: l } = this.props, c = this.isItemLoaded(t), d = t === n.length - 1, h = c ? n[t] : { id: nn(), name: "Loading..." }, u = this.props.pagination ? this.props.pagination.nextEnable : !1;
    return /* @__PURE__ */ s.jsxs("div", { style: e, className: ps.item, children: [
      /* @__PURE__ */ s.jsx(
        jo,
        {
          id: this.getItemId(t),
          checked: this.isItemChecked(h),
          clearSearch: l,
          disabled: this.isItemDisabled(h),
          isLoading: !c,
          item: h,
          itemComponent: o,
          onChange: a,
          onSelect: r,
          tooltip: this.getTooltip(h),
          active: this.isItemActive(h)
        }
      ),
      d && u && c && /* @__PURE__ */ s.jsx(yi, { onEnter: this.loadMoreItems })
    ] });
  };
  loadMoreItems = async () => {
    this.props.pagination && await this.props.pagination.onNext?.();
  };
  render() {
    const {
      items: t,
      pagination: e,
      itemComponent: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      itemsDisplayCount: c = cu,
      itemHeight: d = du,
      id: h,
      ariaLabelledby: u
    } = this.props;
    if (!e || !e.infinite || !e.onNext)
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          style: { maxHeight: `${c * d}px` },
          className: f({
            [ps.list]: !0,
            [ps.listEmpty]: t.length === 0
          }),
          ref: this.listRef,
          role: "listbox",
          id: h,
          "aria-labelledby": u,
          children: t.map((v, y) => {
            const C = _i(v) ? v : v.id.toString() || v.name.toString() || v.toString();
            return /* @__PURE__ */ s.jsx(
              jo,
              {
                id: this.getItemId(y),
                checked: this.isItemChecked(v),
                clearSearch: l,
                disabled: this.isItemDisabled(v),
                item: v,
                itemComponent: n,
                onChange: r,
                onSelect: o,
                onKeyDown: a,
                tooltip: this.getTooltip(v),
                active: this.isItemActive(v)
              },
              C
            );
          })
        }
      );
    const { nextEnable: p, itemCount: m } = e, g = m || (p ? t.length + c : t.length), b = {
      items: t,
      selectedItems: this.props.selectedItems,
      disabledItems: this.props.disabledItems,
      tooltipItems: this.props.tooltipItems,
      activeItem: this.props.activeItem,
      pagination: this.props.pagination
    }, x = Math.min(
      g * d,
      c * d
    );
    return /* @__PURE__ */ s.jsx(Ci, { disableHeight: !0, doNotBailOutOnEmptyChildren: !0, children: ({ width: v }) => /* @__PURE__ */ s.jsx(
      wi,
      {
        ...b,
        ref: this.infiniteListRef,
        width: v,
        height: x,
        itemCount: g,
        itemSize: d,
        "aria-labelledby": u,
        children: this.ListItem
      }
    ) });
  }
}
const hu = "h-selectItems-checkableBaseItem--checkableBaseItem__root", uu = "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive", pu = "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled", mu = "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox", gu = "h-selectItems-checkableBaseItem--checkableBaseItem__content", He = {
  root: hu,
  rootActive: uu,
  rootDisabled: pu,
  checkbox: mu,
  content: gu
};
class Ys extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleChange() {
    const { onChange: t, item: e, checked: n } = this.props;
    typeof t == "function" && t(e, !n);
  }
  handleKeyDown(t) {
    const { disabled: e, onKeyDown: n } = this.props;
    (t.key === "Enter" || t.key === " ") && !e && (t.preventDefault(), this.handleChange()), n && n(t);
  }
  noop(t) {
    t.preventDefault();
  }
  render() {
    const {
      item: t,
      onChange: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      children: l,
      active: c,
      tabIndex: d,
      onKeyDown: h,
      ...u
    } = this.props, p = f(He.root, {
      [He.rootDisabled]: r,
      [He.rootActive]: c
    }), m = r ? E : this.handleChange;
    return /* @__PURE__ */ s.jsxs(
      "label",
      {
        ...u,
        className: p,
        tabIndex: d,
        onKeyDown: this.handleKeyDown,
        children: [
          /* @__PURE__ */ s.jsx(
            cn,
            {
              id: t?.id,
              name: "",
              className: He.checkbox,
              checked: o,
              onChange: m,
              tabIndex: -1
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: He.content, children: l })
        ]
      }
    );
  }
}
const fu = "h-selectItems-emptySelectItem--emptySelectItem__root", bu = "h-selectItems-emptySelectItem--emptySelectItem__name", No = {
  root: fu,
  name: bu
};
class hn extends D {
  render() {
    const { label: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx("div", { ...e, className: No.root, children: /* @__PURE__ */ s.jsx("div", { className: No.name, children: t }) });
  }
}
const xu = "h-selectItems-selectItem--selectItem__root", yu = "h-selectItems-selectItem--selectItem__rootActive", _u = "h-selectItems-selectItem--selectItem__name", Cu = "h-selectItems-selectItem--selectItem__nameBold", wu = "h-selectItems-selectItem--selectItem__nameWithDescription", vu = "h-selectItems-selectItem--selectItem__description", Su = "h-selectItems-selectItem--selectItem__icon", te = {
  root: xu,
  rootActive: yu,
  name: _u,
  nameBold: Cu,
  nameWithDescription: wu,
  description: vu,
  icon: Su
};
class Ar extends _t {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: t,
      onSelect: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      active: a,
      isLoading: l,
      ...c
    } = this.props, { description: d, name: h, icon: u, iconSize: p } = t, m = f(te.root, {
      [te.rootActive]: a
    }), g = f(te.name, {
      [te.nameBold]: o,
      [te.nameWithDescription]: !!d
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": a,
        className: m,
        disabled: r,
        onClick: () => {
          e(t);
        },
        children: [
          u ? /* @__PURE__ */ s.jsx(N, { className: te.icon, name: u, size: p ?? 16 }) : null,
          /* @__PURE__ */ s.jsxs(O, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
            /* @__PURE__ */ s.jsx("span", { className: g, "data-testid": "name", children: h }),
            d && /* @__PURE__ */ s.jsx("span", { className: te.description, "data-testid": "description", children: d })
          ] }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
const Iu = "h-selectItems-checkableSelectItem--checkableSelectItem__name", Du = {
  name: Iu
};
class _k extends D {
  render() {
    const { item: t, isLoading: e } = this.props, { name: n } = e ? { name: "Loading..." } : t;
    return /* @__PURE__ */ s.jsx(Ys, { ...this.props, children: /* @__PURE__ */ s.jsx("span", { className: Du.name, children: n }) });
  }
}
const ku = "h-selectItems-tagSelectItem--tagSelectItem__root", Tu = "h-selectItems-tagSelectItem--tagSelectItem__rootActive", ju = "h-selectItems-tagSelectItem--tagSelectItem__name", Nu = "h-selectItems-tagSelectItem--tagSelectItem__nameBold", Fu = "h-selectItems-tagSelectItem--tagSelectItem__dotContainer", Pu = "h-selectItems-tagSelectItem--tagSelectItem__dot", pe = {
  root: ku,
  rootActive: Tu,
  name: ju,
  nameBold: Nu,
  dotContainer: Fu,
  dot: Pu
};
class Ck extends D {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: t,
      onSelect: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      active: l,
      ...c
    } = this.props, { name: d, color: h = "#000" } = t, u = f(pe.root, {
      [pe.rootActive]: l
    }), p = f(pe.name, {
      [pe.nameBold]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": l,
        className: u,
        onClick: () => {
          e(t), n();
        },
        tabIndex: 0,
        title: typeof d == "string" ? d : d.toString(),
        disabled: r,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: pe.dotContainer, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: pe.dot,
              style: { backgroundColor: h ?? void 0 }
            }
          ) }),
          /* @__PURE__ */ s.jsx("div", { className: p, children: d }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" }),
          r && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ]
      }
    );
  }
}
const Ru = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name", Eu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer", Lu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot", Au = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer", fn = {
  name: Ru,
  dotContainer: Eu,
  dot: Lu,
  nameContainer: Au
};
class wk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: t, item: e, checked: n } = this.props;
    typeof t == "function" && t(e, !n);
  }
  render() {
    const { item: t, isLoading: e, disabled: n } = this.props, { name: o, color: r } = e ? { name: "Loading...", color: "#000" } : t;
    return /* @__PURE__ */ s.jsx(
      Ys,
      {
        ...this.props,
        disabled: this.props.checked ? !1 : n,
        children: /* @__PURE__ */ s.jsxs("div", { className: fn.nameContainer, children: [
          r && /* @__PURE__ */ s.jsx("div", { className: fn.dotContainer, children: /* @__PURE__ */ s.jsx("div", { className: fn.dot, style: { backgroundColor: r } }) }),
          /* @__PURE__ */ s.jsx("span", { className: fn.name, children: o }),
          n && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ] })
      }
    );
  }
}
const $u = "h-selectItems-avatarSelectItem--avatarSelectItem__root", Bu = "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive", Ou = "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName", Hu = "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName", Wu = "h-selectItems-avatarSelectItem--avatarSelectItem__names", Mu = "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold", zu = "h-selectItems-avatarSelectItem--avatarSelectItem__container", Vu = "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable", Mt = {
  root: $u,
  rootActive: Bu,
  secondaryName: Ou,
  primaryName: Hu,
  names: Wu,
  namesBold: Mu,
  container: zu,
  containerCheckable: Vu
};
class Ku extends D {
  static defaultProps = {
    checked: !1
  };
  getNames(t) {
    const e = /* @__PURE__ */ new Set();
    typeof t.name == "string" && e.add(t.name), typeof t.name != "string" && typeof t.display_name == "string" && e.add(t.display_name), typeof t.phone_number == "string" && e.add(t.phone_number), typeof t.email == "string" && e.add(t.email);
    const n = Array.from(e);
    return {
      primaryName: n.length > 0 ? n[0] : "No name",
      secondaryName: n.length > 1 ? n[1] : null
    };
  }
  getAvatar(t) {
    return typeof t.icon == "string" ? /* @__PURE__ */ s.jsx(N, { name: t.icon, size: 16 }) : /* @__PURE__ */ s.jsx(Cr, { user: t });
  }
  renderContent() {
    const t = this.props.isLoading ? {
      id: "",
      name: "Loading..."
    } : this.props.item, e = this.getAvatar(t), n = this.getNames(t), o = f(Mt.container, {
      [Mt.containerCheckable]: this.props.checkable
    }), r = f(Mt.names, {
      [Mt.namesBold]: this.props.checked
    });
    return /* @__PURE__ */ s.jsxs("div", { className: o, children: [
      e,
      /* @__PURE__ */ s.jsxs("div", { className: r, children: [
        /* @__PURE__ */ s.jsx("div", { className: Mt.primaryName, children: n.primaryName }),
        n.secondaryName !== null && /* @__PURE__ */ s.jsx("div", { className: Mt.secondaryName, children: n.secondaryName })
      ] })
    ] });
  }
  render() {
    const t = this.renderContent(), { checkable: e, ...n } = this.props;
    if (e) {
      const m = n;
      return /* @__PURE__ */ s.jsx(Ys, { ...m, children: t });
    }
    const o = n, { item: r, disabled: a, onSelect: l, active: c, checked: d, isLoading: h, ...u } = o, p = f(Mt.root, {
      [Mt.rootActive]: c
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...u,
        type: "button",
        className: p,
        disabled: a,
        onClick: () => {
          l(r);
        },
        "aria-current": c,
        children: [
          t,
          d && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
class vk extends D {
  render() {
    return /* @__PURE__ */ s.jsx(Ku, { checkable: !0, ...this.props });
  }
}
const Uu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root", qu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive", Gu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion", Yu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon", bn = {
  root: Uu,
  rootActive: qu,
  suggestion: Gu,
  icon: Yu
};
class Sk extends _t {
  static defaultProps = {
    searchSuggestion: (t, e) => t.find((n) => n.name.toLowerCase() === e.toLowerCase()),
    renderSuggestion: (t) => `Add "${t}" tag`
  };
  constructor(t) {
    super(t), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(t) {
    const { searched: e, active: n } = this.props;
    e !== t.searched && this.searchItem(), n !== t.active && (n ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
  searchItem() {
    const { items: t, searched: e, searchSuggestion: n } = this.props;
    this.setState({ searching: !0 }, async () => {
      try {
        const o = await n?.(t, e);
        this.setState({ item: o });
      } catch (o) {
        console.error(o);
      } finally {
        this.setState({ searching: !1 });
      }
    });
  }
  onSuggest() {
    const { searched: t, onSuggest: e, clearSearch: n, triggerClose: o } = this.props;
    o?.(), e?.(t), n();
  }
  handleKeyDown(t) {
    this.props.active && t.key === "Enter" && this.onSuggest();
  }
  render() {
    const {
      className: t,
      triggerClose: e,
      onSuggest: n,
      searched: o,
      items: r,
      active: a,
      renderSuggestion: l,
      searchSuggestion: c,
      clearSearch: d,
      ...h
    } = this.props, { item: u, searching: p } = this.state;
    if (!o || p || u)
      return null;
    const m = f(t, bn.root, {
      [bn.rootActive]: a
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...h,
        type: "button",
        "aria-current": a,
        className: m,
        onClick: this.onSuggest,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: bn.suggestion, children: l?.(o) }),
          /* @__PURE__ */ s.jsx("div", { className: bn.icon, children: /* @__PURE__ */ s.jsx(N, { name: "plus" }) })
        ]
      }
    );
  }
}
const Xu = "h-selectItems-deselectItem--deselectItem__root", Qu = "h-selectItems-deselectItem--deselectItem__rootDisabled", Zu = "h-selectItems-deselectItem--deselectItem__name", Ju = "h-selectItems-deselectItem--deselectItem__icon", xn = {
  root: Xu,
  rootDisabled: Qu,
  name: Zu,
  icon: Ju
};
class tp extends D {
  render() {
    const { item: t, onSelect: e, clearSearch: n, disabled: o, ...r } = this.props, { name: a } = t, l = f(xn.root, {
      [xn.rootDisabled]: o
    });
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { className: xn.name, children: a }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: xn.icon,
          onClick: () => {
            e(t);
          },
          disabled: o,
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const ep = "h-selectItems-tagDeselectItem--tagDeselectItem__root", np = "h-selectItems-tagDeselectItem--tagDeselectItem__name", sp = "h-selectItems-tagDeselectItem--tagDeselectItem__icon", op = "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer", rp = "h-selectItems-tagDeselectItem--tagDeselectItem__dot", We = {
  root: ep,
  name: np,
  icon: sp,
  dotContainer: op,
  dot: rp
};
class Ik extends D {
  render() {
    const { item: t, onSelect: e, clearSearch: n, disabled: o, isLoading: r, ...a } = this.props, { name: l, color: c } = t, d = f(We.root);
    return /* @__PURE__ */ s.jsxs("div", { ...a, className: d, children: [
      /* @__PURE__ */ s.jsx("div", { className: We.dotContainer, children: /* @__PURE__ */ s.jsx(
        "div",
        {
          className: We.dot,
          style: { backgroundColor: c ?? void 0 }
        }
      ) }),
      /* @__PURE__ */ s.jsx("div", { className: We.name, children: l }),
      o && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: We.icon,
          onClick: () => {
            e(t);
          },
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const ip = "h-chip--chip__root", ap = "h-chip--chip__rootLight", lp = "h-chip--chip__rootNoBorder", cp = "h-chip--chip__rootDisabled", dp = "h-chip--chip__rootInteractable", Me = {
  root: ip,
  rootLight: ap,
  rootNoBorder: lp,
  rootDisabled: cp,
  rootInteractable: dp
}, hp = ({
  className: i,
  children: t,
  onClick: e,
  light: n,
  noBorder: o,
  disabled: r,
  ...a
}) => {
  const l = f(
    {
      [Me.root]: !0,
      [Me.rootLight]: n,
      [Me.rootNoBorder]: o,
      [Me.rootDisabled]: r,
      [Me.rootInteractable]: typeof e == "function" && !r
    },
    i
  ), c = typeof e == "function" ? "button" : "div";
  return /* @__PURE__ */ s.jsx(it, { ...a, as: c, className: l, onClick: e, children: t });
}, up = "h-tag--tag__tagName", pp = "h-tag--tag__tagNameTruncated", mp = "h-tag--tag__icon", gp = "h-tag--tag__deleteButton", fp = "h-tag--tag__deleteButtonDisabled", bp = "h-tag--tag__deleteIcon", me = {
  tagName: up,
  tagNameTruncated: pp,
  icon: mp,
  deleteButton: gp,
  deleteButtonDisabled: fp,
  deleteIcon: bp
}, ke = ({
  className: i,
  tagNameClassName: t,
  children: e,
  onDelete: n,
  color: o,
  light: r,
  noBorder: a,
  noTruncation: l = !1,
  disabled: c,
  ...d
}) => {
  const h = f(
    {
      [me.tagName]: !0,
      [me.tagNameTruncated]: !l
    },
    t
  ), u = f(me.deleteButton, {
    [me.deleteButtonDisabled]: c
  });
  return /* @__PURE__ */ s.jsxs(
    hp,
    {
      ...d,
      className: i,
      light: r,
      noBorder: a,
      disabled: c,
      children: [
        o && /* @__PURE__ */ s.jsx(
          "span",
          {
            className: me.icon,
            style: { backgroundColor: tn(o) ?? void 0 }
          }
        ),
        /* @__PURE__ */ s.jsx("span", { className: h, children: e }),
        !!n && !c && /* @__PURE__ */ s.jsx("button", { className: u, type: "button", onClick: n, children: /* @__PURE__ */ s.jsx(N, { name: "close", className: me.deleteIcon }) })
      ]
    }
  );
}, xp = "h-select--select__root", yp = "h-select--select__rootDisabled", _p = "h-select--select__inputWrapper", Cp = "h-select--select__control", wp = "h-select--select__rootHasIcon", vp = "h-select--select__selection", Sp = "h-select--select__selectionItem", Ip = "h-select--select__tag", Dp = "h-select--select__tagName", kp = "h-select--select__tagLimiter", Tp = "h-select--select__text", jp = "h-select--select__rootSearchable", Np = "h-select--select__rootDropdownOpen", Fp = "h-select--select__rootIsSearching", Pp = "h-select--select__search", Rp = "h-select--select__rootSingle", Ep = "h-select--select__indicators", Lp = "h-select--select__spinner", Ap = "h-select--select__clearIndicator", $p = "h-select--select__dropdownIndicator", Bp = "h-select--select__dropdown", Op = "h-select--select__dropdownFixed", Hp = "h-select--select__pagination", q = {
  root: xp,
  rootDisabled: yp,
  inputWrapper: _p,
  control: Cp,
  rootHasIcon: wp,
  selection: vp,
  selectionItem: Sp,
  tag: Ip,
  tagName: Dp,
  tagLimiter: kp,
  text: Tp,
  rootSearchable: jp,
  rootDropdownOpen: Np,
  rootIsSearching: Fp,
  search: Pp,
  rootSingle: Rp,
  indicators: Ep,
  spinner: Lp,
  clearIndicator: Ap,
  dropdownIndicator: $p,
  dropdown: Bp,
  dropdownFixed: Op,
  pagination: Hp
};
class Te extends D {
  controlRef;
  searchRef;
  listRef;
  static defaultProps = {
    id: gr("select"),
    selectedItems: [],
    disabledItems: [],
    itemComponent: Ar,
    emptyComponent: hn,
    emptyMessage: "No options",
    placeholder: "",
    disabled: !1,
    loading: !1,
    multiple: !1,
    searchable: !1,
    clearable: !1,
    keepOpen: !1,
    hideSelectedItems: !1,
    hasDropDownIndicator: !0
  };
  constructor(t) {
    super(t), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = B(), this.searchRef = B(), this.listRef = B();
    const e = this.initSelectedItems(), n = this.initHighlightedIndex(e);
    this.state = {
      dropdownOpen: !1,
      search: "",
      selectedItems: e,
      highlightedIndex: n
    }, !Te.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn(
      "SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"
    ), Te.isSuggestionComponentWarningShown = !0);
  }
  componentDidUpdate(t, e) {
    const { dropdownOpen: n } = this.state;
    if (n !== e.dropdownOpen)
      if (window[n ? "addEventListener" : "removeEventListener"](
        "click",
        this.handleClickOutside
      ), n) {
        this.searchRef.current?.focus();
        const o = this.initHighlightedIndex();
        this.highlightIndex(o, "auto");
      } else
        this.searchRef.current?.blur();
    fr(t.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
  }
  componentWillUnmount() {
    const { dropdownOpen: t } = this.state;
    t && window.removeEventListener("click", this.handleClickOutside);
  }
  static isSuggestionComponentWarningShown = !1;
  get a11y() {
    const { id: t } = this.props, { highlightedIndex: e } = this.state, n = `${t}-label`, o = `${t}-dropdown`, r = e !== null ? `${o}-option-${e}` : "";
    return { label: n, dropdown: o, option: r };
  }
  isItemIdType(t) {
    return typeof t == "string" || typeof t == "number";
  }
  initSelectedItems() {
    const { selectedItems: t = [] } = this.props;
    return t.map(this.resolveItem).filter(Boolean);
  }
  initHighlightedIndex(t = this.state.selectedItems) {
    const { multiple: e, items: n, hideSelectedItems: o } = this.props;
    if (!e && !o && t.length) {
      const r = this.resolveItem(t[0]);
      return n.indexOf(r);
    }
    return null;
  }
  resolveItem(t) {
    return this.isItemIdType(t) ? this.props.items.find((n) => n.id === t) : t;
  }
  resetSearch() {
    this.state.search && (this.setState({ search: "" }), this.searchRef.current?.focus());
  }
  handleSearch(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    this.setState({ search: n }, () => {
      e?.(n), n && (this.highlightIndex(this.hasSuggestionComponent() ? -1 : 0), this.listRef.current?.goToTop());
    });
  }
  handleDropdown(t = "toggle") {
    const { dropdownOpen: e } = this.state, { keepOpen: n, onToggle: o } = this.props;
    if (n)
      return this.setState({ dropdownOpen: !0 });
    if (t === "toggle")
      return o?.(!e), this.controlRef.current?.focus(), this.setState({ dropdownOpen: !e });
    if (t === "open")
      return o?.(!0), this.setState({ dropdownOpen: !0 });
    if (t === "close" && e)
      return o?.(!1), this.controlRef.current?.blur(), this.setState({
        dropdownOpen: !1,
        search: ""
      });
  }
  handleClickOutside(t) {
    if (!this.controlRef || !(t.target instanceof Node)) return;
    const e = this.controlRef.current, { target: n } = t;
    n && n !== e && !e?.contains(n) && this.handleDropdown("close");
  }
  highlightIndex(t, e = "smooth") {
    this.setState({ highlightedIndex: t }, () => {
      if (t === null || t === -1) return;
      (this.listRef.current?.listRef.current?.children ?? [])[t]?.scrollIntoView({
        behavior: e,
        block: "nearest",
        inline: "start"
      });
    });
  }
  handleKeyDown(t) {
    const { search: e, dropdownOpen: n, highlightedIndex: o, selectedItems: r } = this.state, { multiple: a, hideSelectedItems: l } = this.props, c = this.getAvailableItems(), d = t.key === "Escape", h = t.key === "Enter", u = t.key === "ArrowUp", p = t.key === "ArrowDown", m = t.key === "Backspace";
    if ((h || u || p) && t.preventDefault(), p && !n)
      return t.preventDefault(), this.handleDropdown("open");
    if (d && (n && t.stopPropagation(), this.handleDropdown("close")), m && a && !e) {
      const g = r[r.length - 1];
      g && this.handleRemove(g);
    }
    if (this.hasSuggestionComponent()) {
      if (p && (o === null || o === c.length - 1 || o === 0 && c.length === 0))
        return this.highlightIndex(-1);
      if (u && o === 0)
        return this.highlightIndex(-1);
      if (h && o === -1) {
        this.props.onSuggest?.(e), this.resetSearch();
        return;
      }
    }
    if (p && o === null)
      return this.highlightIndex(0);
    if (o !== null) {
      if (p && o === c.length - 1)
        return this.highlightIndex(0);
      if (p)
        return this.highlightIndex(o + 1);
      if (u && o > 0)
        return this.highlightIndex(o - 1);
      if (u && o <= 0)
        return this.highlightIndex(c.length - 1);
      if (h) {
        const g = c[o], b = g && this.isItemDisabled(g);
        if (g && !b) {
          this.handleSelect(g);
          const x = Math.min(
            l ? o : o + 1,
            c.length - 2
          );
          this.highlightIndex(x);
        }
      }
    }
  }
  handleSelect(t) {
    const { multiple: e, keepOpen: n, onSelect: o } = this.props;
    if (e) {
      const r = this.isItemSelected(t);
      this.handleChange(t, !r);
    } else
      this.setState({
        selectedItems: [t],
        dropdownOpen: n ?? !1
      }), this.resetSearch(), o?.(t);
  }
  handleChange(t, e) {
    const { onChange: n } = this.props, { selectedItems: o } = this.state;
    this.setState({
      selectedItems: e ? [...o, t] : o.filter((r) => r.id !== t.id)
    }), this.resetSearch(), n?.(t, e);
  }
  handleRemove(t, e) {
    e && (e.preventDefault(), e.stopPropagation()), this.handleChange(t, !1);
  }
  handleClear(t) {
    t.stopPropagation();
    const { onClear: e } = this.props;
    e?.(), this.setState({ selectedItems: [] });
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  getPlaceholder() {
    return this.state.selectedItems.length ? "" : this.props.placeholder;
  }
  getInputSize() {
    return this.state.search ? this.state.search.length : this.state.selectedItems?.length ? 5 : this.props.placeholder?.length || 5;
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  getAvailableItems() {
    const { search: t } = this.state, { items: e, hideSelectedItems: n, onSearch: o, searchBy: r } = this.props, a = new RegExp(Ws(t), "i");
    return e.filter((c) => {
      const d = [];
      return t && !o && (r && typeof r == "function" ? d.push(r(c, t)) : r && r instanceof Array ? d.push(
        r.some((h) => {
          const u = c[h];
          return (typeof u == "string" || typeof u == "number") && a.test(u.toString().trim());
        })
      ) : d.push(a.test(this.getItemName(c)))), n && d.push(!this.isItemSelected(c)), d.every((h) => h);
    });
  }
  isItemSelected(t) {
    return this.state.selectedItems.some(
      (e) => e.id === t.id
    );
  }
  isItemDisabled(t) {
    return this.props.disabledItems?.includes(t.id);
  }
  isEmpty() {
    return this.state.selectedItems.length === 0;
  }
  hasSuggestionComponent(t) {
    return !!this.state.search && typeof this.props.suggestionComponent == "function";
  }
  renderHiddenItems() {
    const { limit: t } = this.props, { selectedItems: e } = this.state;
    if (t && t > 0)
      return /* @__PURE__ */ s.jsx(O, { flexDirection: "column", children: e?.slice(t).map((n) => /* @__PURE__ */ s.jsxs(
        O,
        {
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item",
          children: [
            /* @__PURE__ */ s.jsx(it, { margin: "0 400 0 0", children: this.getItemName(n) }),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "close",
                variant: "tertiary",
                onClick: (o) => this.handleRemove(n, o)
              }
            )
          ]
        },
        n.id
      )) });
  }
  renderSelection(t) {
    return this.props.renderSelection?.(t) ?? this.getItemName(t);
  }
  renderMultipleSelection() {
    const { selectedItems: t } = this.state, e = this.props.limit || t.length, n = e < t.length, o = t?.slice(0, e).map((r) => {
      const a = this.renderSelection(r);
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          onClick: (l) => l.stopPropagation(),
          "data-testid": "select-selection",
          className: q.selectionItem,
          children: /* @__PURE__ */ s.jsx(
            ke,
            {
              className: q.tag,
              tagNameClassName: q.tagName,
              onDelete: (l) => this.handleRemove(r, l),
              color: r.color,
              noTruncation: !0,
              "data-testid": "select-tag",
              children: a
            }
          )
        },
        r.id
      );
    });
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      n && /* @__PURE__ */ s.jsx("div", { onClick: (r) => r.stopPropagation(), children: /* @__PURE__ */ s.jsx(
        gt,
        {
          content: this.renderHiddenItems(),
          requireClick: !0,
          "data-testid": "select-limiter",
          light: !0,
          children: /* @__PURE__ */ s.jsxs(
            ke,
            {
              className: f(q.tag, q.tagLimiter),
              noTruncation: !0,
              children: [
                "+",
                t.length - e
              ]
            }
          )
        }
      ) })
    ] });
  }
  renderSingleSelection() {
    const { search: t, selectedItems: e } = this.state, n = e[0], o = /* @__PURE__ */ s.jsx("span", { style: { width: 0 }, "data-testid": "select-selection-empty", children: " " });
    return n ? /* @__PURE__ */ s.jsx(
      "span",
      {
        className: q.text,
        "aria-hidden": !!t,
        "data-testid": "select-selection",
        children: this.renderSelection(n)
      }
    ) : o;
  }
  renderSearch() {
    const { searchable: t } = this.props;
    return !t && !this.isEmpty() ? null : /* @__PURE__ */ s.jsx(
      "input",
      {
        className: q.search,
        ref: this.searchRef,
        tabIndex: -1,
        onFocus: (e) => e.stopPropagation(),
        value: this.state.search,
        size: this.getInputSize(),
        onChange: this.handleSearch,
        placeholder: this.getPlaceholder(),
        autoComplete: "off",
        readOnly: !t,
        "aria-autocomplete": "list",
        "aria-controls": this.a11y.dropdown,
        "aria-labelledby": this.a11y.label,
        "data-testid": "select-input"
      }
    );
  }
  renderDropdown() {
    const { dropdownOpen: t, highlightedIndex: e, search: n } = this.state, {
      disabledItems: o,
      tooltipItems: r,
      emptyComponent: a,
      suggestionComponent: l,
      emptyMessage: c,
      pagination: d,
      dropdownProps: h,
      searchSuggestion: u,
      renderSuggestion: p,
      onSuggest: m,
      multiple: g
    } = this.props, b = f(
      {
        [q.dropdown]: !0,
        [q.dropdownFixed]: h?.fixed ?? !1
      },
      h?.className
    ), x = this.getAvailableItems(), v = x[e ?? -1] ?? null, y = !x.length;
    return /* @__PURE__ */ s.jsxs(
      Zt,
      {
        onClick: this.handleDropdownClick,
        ...h,
        className: b,
        isOpen: t,
        "data-testid": "select-dropdown",
        children: [
          y && typeof a == "function" && /* @__PURE__ */ s.jsx(
            a,
            {
              label: c ?? "No options",
              "data-testid": "select-dropdown-empty"
            }
          ),
          this.hasSuggestionComponent(l) && /* @__PURE__ */ s.jsx(
            l,
            {
              searched: n,
              onSuggest: m,
              triggerClose: g ? void 0 : () => this.handleDropdown("close"),
              items: x,
              active: e === -1,
              clearSearch: this.resetSearch,
              searchSuggestion: u,
              renderSuggestion: p
            }
          ),
          !y && /* @__PURE__ */ s.jsx(
            Gs,
            {
              id: this.a11y.dropdown,
              ariaLabelledby: this.a11y.label,
              ref: this.listRef,
              pagination: d,
              items: x,
              clearSearch: this.resetSearch,
              onSelect: this.handleSelect,
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              selectedItems: this.state.selectedItems,
              disabledItems: o,
              tooltipItems: r,
              activeItem: v,
              itemComponent: this.props.itemComponent
            }
          ),
          !!d && !d.infinite && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: q.pagination,
              "data-testid": "select-dropdown-pagination",
              children: [
                /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: "secondary",
                    disabled: !d.previousEnable,
                    onClick: d.onPrevious,
                    children: "Prev page"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: "secondary",
                    disabled: !d.nextEnable,
                    onClick: d.onNext,
                    children: "Next page"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  render() {
    const {
      className: t,
      disabled: e,
      hasDropDownIndicator: n,
      loading: o,
      multiple: r,
      searchable: a,
      clearable: l,
      prefix: c,
      suffix: d,
      icon: h,
      status: u
    } = this.props, { search: p, dropdownOpen: m } = this.state, g = f(
      {
        [q.root]: !0,
        [q.rootSingle]: !r,
        [q.rootDisabled]: e,
        [q.rootSearchable]: a,
        [q.rootDropdownOpen]: m,
        [q.rootIsSearching]: !!p,
        [q.rootHasIcon]: !!h
      },
      t
    ), b = p ? void 0 : () => this.handleDropdown("toggle");
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: g,
        role: "combobox",
        "aria-expanded": m,
        "aria-owns": this.a11y.dropdown,
        "aria-haspopup": "listbox",
        "data-testid": "select-root",
        children: [
          /* @__PURE__ */ s.jsx(
            Et,
            {
              prefix: c,
              suffix: d,
              icon: h,
              status: u,
              active: m,
              disabled: e,
              className: q.inputWrapper,
              children: /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: q.control,
                  ref: this.controlRef,
                  onKeyDown: this.handleKeyDown,
                  onClick: b,
                  tabIndex: e ? -1 : 0,
                  "aria-activedescendant": this.a11y.option,
                  "data-testid": "select-control",
                  children: [
                    /* @__PURE__ */ s.jsxs("div", { className: q.selection, children: [
                      r ? this.renderMultipleSelection() : this.renderSingleSelection(),
                      this.renderSearch()
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: q.indicators, children: [
                      o && /* @__PURE__ */ s.jsx(
                        Un,
                        {
                          className: q.spinner,
                          size: 16,
                          "aria-label": "Loading",
                          "data-testid": "select-loading"
                        }
                      ),
                      !this.isEmpty() && l && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: q.clearIndicator,
                          icon: "close",
                          variant: "tertiary",
                          onClick: this.handleClear,
                          "aria-label": "Clear",
                          "data-testid": "select-clear"
                        }
                      ),
                      n && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: q.dropdownIndicator,
                          icon: m ? "angle-up" : "angle-down",
                          variant: "tertiary",
                          onClick: (x) => {
                            x.stopPropagation(), this.handleDropdown("toggle");
                          },
                          "aria-label": m ? "Close" : "Open",
                          "data-testid": "select-toggle"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          !e && m && this.renderDropdown()
        ]
      }
    );
  }
}
function Wp(i) {
  return /* @__PURE__ */ s.jsx(
    Ms,
    {
      fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: "Something went wrong" }) }),
      children: /* @__PURE__ */ s.jsx(Te, { ...i })
    }
  );
}
const Mp = "h-datePicker-timezoneSelector--timezoneSelector__root", zp = "h-datePicker-timezoneSelector--timezoneSelector__label", Fo = {
  root: Mp,
  label: zp
}, $r = ({
  disabled: i,
  tooltipProps: t,
  selectedTimezone: e,
  onChange: n
}) => {
  const o = j.tz.guess(!0), r = F((h, u) => {
    const [p, m] = j.tz(h).format("Z").split(":"), [g, b] = j.tz(u).format("Z").split(":");
    return +parseInt(p) * 60 + parseInt(m) - (+parseInt(g) * 60 + parseInt(b));
  }, []), a = (h) => `(GMT${j.tz(h).format("Z")})`, l = (h) => `${a(h)} ${h}`, c = U(() => {
    const h = j.tz.names().filter((m) => m !== o), u = {
      id: o,
      name: `Default ${a(o)}`
    }, p = h.sort(r).map((m) => ({ id: m, name: l(m) }));
    return [u, ...p];
  }, [r]), d = ({ id: h }) => {
    n(h);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: Fo.root, children: [
    /* @__PURE__ */ s.jsx(qs, { className: Fo.label, children: "Time zone" }),
    /* @__PURE__ */ s.jsx(gt, { ...t, side: "top", children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
      Wp,
      {
        disabled: i,
        items: c,
        onSelect: d,
        selectedItems: [
          De(e) ? e : o
        ],
        searchable: !0
      }
    ) }) })
  ] });
}, Vp = "h-fieldAlert--fieldAlert__root", Kp = "h-fieldAlert--fieldAlert__alert", Up = "h-fieldAlert--fieldAlert__icon", ms = {
  root: Vp,
  alert: Kp,
  icon: Up
}, qp = "h-fieldAlert-fieldAlertButton--fieldAlertButton__root", Gp = {
  root: qp
};
function Yp({
  className: i,
  variant: t = "tertiary",
  ...e
}) {
  return /* @__PURE__ */ s.jsx(
    X,
    {
      ...e,
      variant: t,
      className: f(i, Gp.root)
    }
  );
}
const Xp = {
  error: "exclamation-circle-filled",
  warning: "exclamation-triangle-filled",
  success: "check-circle-filled",
  title: null
};
function Zn({
  children: i,
  className: t,
  ...e
}) {
  const n = e.variant || "title", o = f(ms.root, t), [r, a] = V(!1), l = Xp[n], c = F(
    (d) => {
      if (!d) return;
      const { offsetWidth: h, scrollWidth: u } = d;
      a(h < u);
    },
    [i]
  );
  return /* @__PURE__ */ s.jsxs(L.Input, { ...e, variant: n, className: o, children: [
    !!l && /* @__PURE__ */ s.jsx(N, { className: ms.icon, name: l }),
    /* @__PURE__ */ s.jsx("div", { className: ms.alert, ref: c, children: r ? /* @__PURE__ */ s.jsx(gt, { content: i, children: i }) : i })
  ] });
}
Zn.Button = Yp;
const yn = (i, t = 0) => {
  if (!i)
    return t;
  if (typeof i == "number")
    return i;
  const e = parseFloat(i);
  return isNaN(e) ? t : e;
}, Qp = "h-inputText-inputNumberArrows--inputNumberArrows__root", Zp = "h-inputText-inputNumberArrows--inputNumberArrows__button", Jp = "h-inputText-inputNumberArrows--inputNumberArrows__buttonUp", tm = "h-inputText-inputNumberArrows--inputNumberArrows__buttonDown", em = "h-inputText-inputNumberArrows--inputNumberArrows__spacer", ge = {
  root: Qp,
  button: Zp,
  buttonUp: Jp,
  buttonDown: tm,
  spacer: em
}, nm = 50, Po = 300, sm = "inputNumberArrowsTestId";
class om extends D {
  intervalId;
  timeoutId;
  constructor(t) {
    super(t), this.intervalId = null, this.timeoutId = null, this.increaseValue = this.increaseValue.bind(this), this.decreaseValue = this.decreaseValue.bind(this), this.startIncreaseValue = this.startIncreaseValue.bind(this), this.startDecreaseValue = this.startDecreaseValue.bind(this), this.stopChangeValue = this.stopChangeValue.bind(this);
  }
  componentDidMount() {
    window.addEventListener("mouseup", this.stopChangeValue);
  }
  componentWillUnmount() {
    window.removeEventListener("mouseup", this.stopChangeValue);
  }
  getNewValue(t) {
    const {
      step: e,
      min: n,
      max: o,
      inputRef: { current: r }
    } = this.props;
    if (!r)
      return 0;
    const a = yn(r.value), l = yn(e, 1), c = yn(n, Number.MIN_SAFE_INTEGER), d = yn(o, Number.MAX_SAFE_INTEGER);
    return t == "decrease" ? Math.max(a - l, c) : Math.min(a + l, d);
  }
  startIncreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("increase"),
      Po
    );
  }
  startDecreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("decrease"),
      Po
    );
  }
  startChangeValue(t) {
    this.intervalId || (this.intervalId = setInterval(
      () => this.triggerInputChange(t),
      nm
    ));
  }
  stopChangeValue() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null), this.intervalId && (clearInterval(this.intervalId), this.intervalId = null);
  }
  increaseValue(t) {
    t.preventDefault(), this.triggerInputChange("increase");
  }
  decreaseValue(t) {
    t.preventDefault(), this.triggerInputChange("decrease");
  }
  triggerInputChange(t) {
    const {
      inputRef: { current: e },
      readOnly: n
    } = this.props;
    if (!e || n)
      return;
    const o = this.getNewValue(t), r = new Event("input", { bubbles: !0 }), a = Object.getPrototypeOf(e);
    Object.getOwnPropertyDescriptor(
      a,
      "value"
    )?.set?.call(e, o), e.dispatchEvent(r), e.focus();
  }
  render() {
    return /* @__PURE__ */ s.jsxs("div", { className: ge.root, "data-testid": sm, children: [
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(ge.button, ge.buttonUp),
          tabIndex: -1,
          onClick: this.increaseValue,
          onMouseDown: this.startIncreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-up" })
        }
      ),
      /* @__PURE__ */ s.jsx("span", { className: ge.spacer }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(ge.button, ge.buttonDown),
          tabIndex: -1,
          onClick: this.decreaseValue,
          onMouseDown: this.startDecreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-down" })
        }
      )
    ] });
  }
}
const rm = "h-inputText--inputText__rootReadOnly", im = "h-inputText--inputText__container", am = "h-inputText--inputText__rootHasIcon", lm = "h-inputText--inputText__rootTypeNumber", cm = "h-inputText--inputText__input", ze = {
  rootReadOnly: rm,
  container: im,
  rootHasIcon: am,
  rootTypeNumber: lm,
  input: cm
}, dm = "inputText", qt = $(function(t, e) {
  const n = Y(null);
  je(e, () => n.current);
  const {
    className: o,
    disabled: r,
    readOnly: a,
    type: l = "text",
    name: c,
    prefix: d,
    suffix: h,
    icon: u,
    status: p,
    min: m,
    max: g,
    step: b,
    hideNumberArrows: x = !1,
    active: v = !1,
    ...y
  } = t, C = f(o, {
    [ze.rootTypeNumber]: l === "number",
    [ze.rootHasIcon]: !!u,
    [ze.rootReadOnly]: a
  });
  return /* @__PURE__ */ s.jsx(
    Et,
    {
      className: C,
      status: p,
      disabled: r,
      active: v,
      prefix: d,
      suffix: h,
      icon: u,
      children: /* @__PURE__ */ s.jsxs("div", { className: ze.container, children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            "data-testid": dm,
            dir: "auto",
            id: c,
            name: c,
            ref: n,
            ...y,
            min: m,
            max: g,
            step: b,
            type: l,
            disabled: r,
            readOnly: a,
            className: ze.input
          }
        ),
        l === "number" && !x && /* @__PURE__ */ s.jsx(
          om,
          {
            min: m,
            max: g,
            step: b,
            inputRef: n,
            readOnly: a
          }
        )
      ] })
    }
  );
}), hm = "hmm A", um = (i, t) => {
  const e = `${i}`.padStart(2, "0"), n = `${t}`.padStart(2, "0");
  return `${e}:${n}`;
}, Ro = (i, t) => {
  const e = i.hours(), n = i.minutes();
  return {
    id: um(e, n),
    name: i.format(t)
  };
}, sn = ({
  hasDropDownIndicator: i = !0,
  allowCustomTimeInput: t = !1,
  timeOptions: e,
  overrides: n,
  selectedItems: o,
  selectableHours: r = Dr,
  selectableMinutes: a = kr,
  timeFormat: l = j.localeData().longDateFormat("LT"),
  onSelect: c,
  onIsCustomTimeValid: d,
  ...h
}) => {
  const [u] = o || [], [p, m] = V(
    () => typeof u == "object" ? u?.id : u || null
  ), [g, b] = V(""), x = U(
    () => e || Pr({
      hours: r,
      minutes: a,
      overrides: n,
      timeFormat: l
    }),
    [
      e,
      r,
      a,
      n,
      l
    ]
  ), v = U(() => {
    const _ = j(
      g || (typeof u == "object" ? u.id : u) || p,
      [l, hm]
    );
    if (!_.isValid())
      return null;
    const I = _.hours(), S = _.minutes();
    if (!d || d(I, S))
      return Ro(_, l);
    const T = I <= 12, P = I + 12, A = d(P, S);
    return T && A ? Ro(j({ hours: P, minutes: S }), l) : null;
  }, [u, g]), y = U(() => {
    if (!t)
      return x;
    const _ = p ? x.filter(({ name: I }) => I !== v?.name) : x.filter(
      ({ name: I }) => I.startsWith(g) && I !== v?.name
    );
    if (!v)
      return _;
    const w = p !== v.id ? 0 : _.findIndex(
      (I) => j(I.id, [l]) > j(v.id, [l])
    );
    return _.splice(
      // If it's -1 then there was no later time, so add it to the end.
      w === -1 ? _.length : w,
      0,
      v
    ), _;
  }, [v, g, p, x]), C = F(
    (_) => {
      _?.id !== v?.id && b(""), c(_?.id || null), m(_?.id || null);
    },
    [v]
  );
  return et(() => {
    u ? (b(""), m(
      typeof u == "object" ? u.id : u
    )) : m(null);
  }, [u]), /* @__PURE__ */ s.jsx(
    Te,
    {
      searchable: !0,
      placeholder: Tr(l),
      ...h,
      selectedItems: o,
      hasDropDownIndicator: i,
      items: t ? y : x,
      onChange: E,
      onClear: C,
      onSelect: C,
      ...t && { onSearch: b }
    }
  );
}, pm = "h-timePicker-range--timeRangePicker__root", mm = "h-timePicker-range--timeRangePicker__timePickerFrom", gm = "h-timePicker-range--timeRangePicker__timePickerTo", fm = "h-timePicker-range--timeRangePicker__arrowContainer", bm = "h-timePicker-range--timeRangePicker__arrowContainerHasError", xm = "h-timePicker-range--timeRangePicker__arrowContainerHasWarning", ym = "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess", ee = {
  root: pm,
  timePickerFrom: mm,
  timePickerTo: gm,
  arrowContainer: fm,
  arrowContainerHasError: bm,
  arrowContainerHasWarning: xm,
  arrowContainerHasSuccess: ym
}, _m = ({
  className: i,
  disabled: t,
  endTime: e,
  onSelect: n,
  overrides: o,
  placeholder: r,
  selectableHours: a = Dr,
  selectableMinutes: l = kr,
  status: c,
  startTime: d,
  allowCustomTimeInput: h = !1,
  timeFormat: u = j.localeData().longDateFormat("LT"),
  ...p
}) => {
  const [{ startTime: m, endTime: g }, b] = V({
    startTime: d || null,
    endTime: e || null
  }), x = U(
    () => Pr({
      hours: a,
      minutes: l,
      overrides: o,
      timeFormat: u
    }),
    [a, l, o, u]
  ), v = U(() => {
    const w = x.map(
      ({ id: T }) => j(T, [u])
    ), I = j(m, [u]), S = m && w.findIndex(
      (T) => T > I
    ) || 0;
    return x.slice(S);
  }, [x, m, u]);
  et(() => {
    const w = typeof d == "string", I = typeof d == "string";
    (w && d !== m || I && e !== g) && b((S) => ({
      ...S,
      ...w && { startTime: d },
      ...I && { endTime: e }
    }));
  });
  const y = F(
    (w) => (I) => void b((S) => {
      const T = j(I, [u]), P = j(S.startTime, [u]), A = j(S.endTime, [u]), k = x.map(
        ({ id: tt }) => j(tt, [u])
      ), R = k.findIndex(
        (tt) => tt >= T
      ) || -1, W = w === "startTime" ? R : k.findIndex(
        (tt) => tt >= P
      ), nt = w === "endTime" ? -1 : k.findIndex(
        (tt) => tt >= A
      ), st = {
        ...S,
        [w]: I,
        ...S.endTime !== null && w !== "endTime" && W >= nt && {
          endTime: x[R + 1]?.id || null
        }
      };
      return n(st), st;
    }),
    [n]
  ), C = F(
    (w, I) => {
      const S = j(m, [u]);
      if (!S.isValid())
        return !0;
      const P = S.hours(), A = S.minutes();
      return P < w || P === w && A < I;
    },
    [m, u]
  ), _ = (w) => r?.[w] || r || Tr(u);
  return /* @__PURE__ */ s.jsxs(it, { className: f(ee.root, i), children: [
    /* @__PURE__ */ s.jsx(
      sn,
      {
        className: ee.timePickerFrom,
        searchable: !0,
        ...p,
        disabled: t,
        hasDropDownIndicator: !1,
        timeOptions: x,
        onSelect: y("startTime"),
        placeholder: _("startTime"),
        allowCustomTimeInput: h,
        selectedItems: m ? [m] : [],
        status: c
      }
    ),
    /* @__PURE__ */ s.jsx(
      it,
      {
        className: f(ee.arrowContainer, {
          [ee.arrowContainerHasError]: c === "error",
          [ee.arrowContainerHasWarning]: c === "warning",
          [ee.arrowContainerHasSuccess]: c === "success"
        }),
        children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" })
      }
    ),
    /* @__PURE__ */ s.jsx(
      sn,
      {
        className: ee.timePickerTo,
        searchable: !0,
        disabled: t || !m,
        ...p,
        hasDropDownIndicator: !1,
        timeOptions: v,
        onSelect: y("endTime"),
        placeholder: _("endTime"),
        ...h && {
          allowCustomTimeInput: h,
          onIsCustomTimeValid: C
        },
        selectedItems: g ? [g] : [],
        status: c
      }
    )
  ] });
};
class Ut {
  constructor(t, e, n) {
    this.dateFormat = t, this.dateParser = e, this.dateRangeConstraint = n, this.dateFormat = t, this.dateParser = e, this.dateRangeConstraint = n;
  }
  static validationOK = { isValid: !0, error: null };
  isValidDate(t) {
    try {
      return this.dateParser(t).isValid();
    } catch {
      return !1;
    }
  }
  isSingleDateValid(t) {
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "Date is not valid"
      };
    const { minDate: e, maxDate: n } = this.dateRangeConstraint, o = this.dateParser(t);
    return o.isBefore(e, "day") ? {
      isValid: !1,
      error: `Date must be after ${e.format(this.dateFormat)}`
    } : o.isAfter(n, "day") ? {
      isValid: !1,
      error: `Date must be before ${n.format(this.dateFormat)}`
    } : Ut.validationOK;
  }
  /**
   * Mind that this is dependant on end date as well because it's a range
   */
  isStartDateValid({
    startDateInputValue: t,
    endDateInputValue: e
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "From date is not valid"
      };
    const r = this.dateParser(t), a = this.dateParser(e);
    return r.isBefore(n, "day") ? {
      isValid: !1,
      error: `From date must be after ${n.format(this.dateFormat)}`
    } : e && this.isValidDate(e) && r.isAfter(a, "day") ? {
      isValid: !1,
      error: `From date must be before ${a.format(
        this.dateFormat
      )}`
    } : r.isAfter(o, "day") ? {
      isValid: !1,
      error: `From date must be before ${o.format(this.dateFormat)}`
    } : Ut.validationOK;
  }
  /**
   * Mind that this is dependant on start date as well because it's a range
   */
  isEndDateValid({
    startDateInputValue: t,
    endDateInputValue: e
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "To date is not valid"
      };
    const r = this.dateParser(t), a = this.dateParser(e);
    return a.isAfter(o, "day") ? {
      isValid: !1,
      error: `To date must be before ${o.format(this.dateFormat)}`
    } : t && this.isValidDate(t) && a.isBefore(r, "day") ? {
      isValid: !1,
      error: `To date must be after ${r.format(
        this.dateFormat
      )}`
    } : a.isBefore(n, "day") ? {
      isValid: !1,
      error: `To date must be after ${n.format(this.dateFormat)}`
    } : Ut.validationOK;
  }
  isTimeOrderValid({
    startDate: t,
    endDate: e
  }) {
    return !t || !e ? Ut.validationOK : t.isAfter(e) ? {
      isValid: !1,
      error: "From time should be before to time"
    } : Ut.validationOK;
  }
}
const Cm = "h-datePicker-range-inputFields--dateRangePickerInputFields__root", wm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop", vm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector", Sm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom", Im = "h-datePicker-range-inputFields--dateRangePickerInputFields__fields", Dm = "h-datePicker-range-inputFields--dateRangePickerInputFields__input", km = "h-datePicker-range-inputFields--dateRangePickerInputFields__alert", zt = {
  root: Cm,
  rootPlacementTop: wm,
  rootPlacementTopWithTimezoneSelector: vm,
  rootPlacementBottom: Sm,
  fields: Im,
  input: Dm,
  alert: km
};
Array(24).fill(0).map((i, t) => t);
class Xs extends D {
  dateRangeValidators;
  timeOptions;
  instanceId;
  constructor(t) {
    super(t);
    const { dateFormat: e } = t;
    this.state = {
      startDateInputValue: this.props.startDate?.format(e) ?? "",
      startDateError: null,
      endDateInputValue: this.props.endDate?.format(e) ?? "",
      endDateError: null,
      timeOrderError: null
    }, this.timeOptions = [], this.instanceId = Xs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new Ut(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncStartDateWithProps(t), this.syncEndDateWithProps(t), this.validateTimesOrder();
  }
  static instanceCount = 0;
  validateTimesOrder() {
    const { startDate: t, endDate: e } = this.props, { isValid: n, error: o } = this.dateRangeValidators.isTimeOrderValid({
      startDate: t,
      endDate: e
    });
    n ? this.setState({ timeOrderError: null }) : this.setState({
      timeOrderError: o
    });
  }
  syncEndDateWithProps(t) {
    const { endDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.endDate || e?.isSame(t.endDate, n)))
      return this.props.endDate ? this.setState({
        endDateError: null,
        endDateInputValue: this.props.endDate.format(this.props.dateFormat)
      }) : this.setState({
        endDateError: null,
        endDateInputValue: ""
      });
  }
  syncStartDateWithProps(t) {
    const { startDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.startDate || e?.isSame(t.startDate, n)))
      return this.props.startDate ? this.setState({
        startDateError: null,
        startDateInputValue: this.props.startDate.format(this.props.dateFormat)
      }) : this.setState({
        startDateError: null,
        startDateInputValue: ""
      });
  }
  handleInputValueChange(t, e) {
    const n = t.target.value;
    switch (e) {
      case "startDate":
        this.setState(
          { startDateInputValue: this.ensureValidChars(n) },
          this.propagateStartDateChangeEvent
        );
        break;
      case "endDate":
        this.setState(
          { endDateInputValue: this.ensureValidChars(n) },
          this.propagateEndDateChangeEvent
        );
        break;
    }
  }
  propagateStartDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (t === "") {
      this.props.onStartDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ startDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), l = e !== "" && !r ? a : null;
    this.setState(
      {
        startDateError: null,
        endDateError: l
      },
      () => this.props.onStartDateChange(this.parseDateString(t))
    );
  }
  propagateEndDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (e === "") {
      this.props.onEndDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ endDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), l = t !== "" && !r ? a : null;
    this.setState(
      {
        endDateError: null,
        startDateError: l
      },
      () => this.props.onEndDateChange(this.parseDateString(e))
    );
  }
  parseDateString(t) {
    return j(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  getOverrides(t) {
    if (t !== "startTime")
      return [
        {
          hour: 23,
          minute: 59
        }
      ];
  }
  renderFields(t, e, n, o, r, a, l) {
    const {
      dateFormat: c,
      disabled: d,
      focusedInput: h,
      onFocusChange: u,
      onTimeChange: p,
      timeFormat: m,
      withTimePicker: g,
      withDateInput: b
    } = this.props, { timeOrderError: x } = this.state;
    return /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx(qs, { children: t === "startDate" ? "From" : "To" }),
      b && /* @__PURE__ */ s.jsx(
        qt,
        {
          className: zt.input,
          placeholder: c.toLowerCase(),
          name: `input__${t}__${this.instanceId}`,
          value: r,
          onChange: (v) => this.handleInputValueChange(v, t),
          onFocus: () => u(t),
          autoComplete: "off",
          status: a ? "error" : void 0,
          disabled: d,
          active: h === t
        }
      ),
      g && /* @__PURE__ */ s.jsx("div", { className: zt.input, children: /* @__PURE__ */ s.jsx(
        gt,
        {
          content: "Please select a date first.",
          disabled: !!n || d,
          side: "right",
          children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
            sn,
            {
              disabled: !n,
              overrides: this.getOverrides(e),
              selectedItems: o ? [o] : void 0,
              status: x ? "error" : void 0,
              ...l,
              timeFormat: m,
              onSelect: (v) => p(e, v)
            }
          ) })
        }
      ) })
    ] });
  }
  getError() {
    const { startDateError: t, endDateError: e, timeOrderError: n } = this.state;
    return t || e || n || null;
  }
  renderErrors() {
    const t = this.getError();
    return /* @__PURE__ */ s.jsx(
      Zn,
      {
        className: zt.alert,
        variant: t ? "error" : void 0,
        children: t
      }
    );
  }
  render() {
    const {
      startDate: t,
      startTime: e,
      endDate: n,
      endTime: o,
      timePickerProps: r = { start: {}, end: {} },
      hasTimezoneSelector: a
    } = this.props, {
      startDateInputValue: l,
      startDateError: c,
      endDateInputValue: d,
      endDateError: h
    } = this.state, { placement: u } = this.props, p = f(zt.root, {
      [zt.rootPlacementTop]: u === "top",
      [zt.rootPlacementTopWithTimezoneSelector]: u === "top" && a,
      [zt.rootPlacementBottom]: u === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: p, children: [
      /* @__PURE__ */ s.jsxs("div", { className: zt.fields, children: [
        this.renderFields(
          "startDate",
          "startTime",
          t,
          e,
          l,
          c,
          r.start
        ),
        this.renderFields(
          "endDate",
          "endTime",
          n,
          o,
          d,
          h,
          r.end
        )
      ] }),
      this.renderErrors()
    ] });
  }
}
const Tm = "dateRangePickerTestId";
class jm extends D {
  static defaultProps = {
    withDateInput: !0,
    withTimePicker: !1,
    timePickerProps: { start: {}, end: {} },
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(t) {
    super(t);
    const {
      startDate: e,
      endDate: n,
      timezone: o,
      presetKey: r,
      presets: a,
      focusedInput: l = "startDate"
    } = t;
    this.state = {
      startTime: e ? j(e).format(Nt) : null,
      endTime: n ? j(n).format(Nt) : null,
      timezone: De(o) ? o : j.tz.guess(!0),
      presetKey: a?.find(({ key: c }) => c === r)?.key ?? null,
      focusedInput: l,
      dateRangePickerKey: 0
    }, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey(t), this.updateTimezoneFromProps(t), this.updatePresetKey(t);
  }
  visibleCalendarMonthRef = B();
  updatePresetKey(t) {
    const { presetKey: e } = this.props;
    t.presetKey !== e && this.setState({
      presetKey: this.props.presets?.find(({ key: n }) => n === e)?.key ?? null
    });
  }
  updateTimezoneFromProps(t) {
    const { timezone: e } = this.props;
    t.timezone !== e && De(e) && this.setState({ timezone: e });
  }
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props, n = this.dateFormat;
    return {
      minDate: e ? j(e, n) : j("0001-01-01"),
      maxDate: t ? j(t, n) : j("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { startDate: e, endDate: n } = this.props, { presetKey: o } = this.state;
    this.setState(
      { timezone: t },
      () => this.onDatesChange({ startDate: e, endDate: n }, o)
    );
  }
  onStartDateChange(t) {
    this.onDatesChange({ startDate: t, endDate: this.props.endDate });
  }
  onEndDateChange(t) {
    this.onDatesChange({ endDate: t, startDate: this.props.startDate });
  }
  onDatesChange(t, e = null) {
    const { startTime: n, endTime: o, timezone: r } = this.state, { timeRoundingStrategy: a } = this.props, l = this.addTimezoneToDate(
      t.startDate,
      r
    ), c = this.addTimezoneToDate(
      t.endDate,
      r
    );
    let d = l?.clone().startOf(a) || null, h = c?.clone().endOf(a) || null, u = t.startDate?.clone().startOf(a) || null, p = t.endDate?.clone().endOf(a) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          startTime: t.startDate?.clone().startOf(a).format(Nt) ?? null,
          endTime: t.endDate?.clone().startOf(a).format(Nt) ?? null
        },
        () => {
          this.props.onChange({
            startDate: d,
            localStartDate: u,
            endDate: h,
            localEndDate: p,
            timezone: r,
            localTimezone: j.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (d = this.addTimeToDate(
      l,
      n,
      "startDate"
    ), u = this.addTimeToDate(
      t.startDate,
      n,
      "startDate"
    )), o && (h = this.addTimeToDate(c, o, "endDate"), p = this.addTimeToDate(t.endDate, o, "endDate")), this.props.onChange({
      startDate: d,
      localStartDate: u,
      endDate: h,
      localEndDate: p,
      timezone: r,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    if (!t)
      this.onDatesChange({ startDate: null, endDate: null });
    else {
      const { startDate: e, endDate: n, key: o } = t;
      this.onDatesChange({ startDate: e, endDate: n }, o);
    }
    this.handleFocusChange("startDate");
  }
  handleTimeChange(t, e) {
    const { startDate: n, endDate: o } = this.props;
    this.setState(
      (r) => ({
        ...r,
        [t]: e
      }),
      () => this.onDatesChange({ startDate: n, endDate: o })
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return De(e) ? t.clone().tz(e, !0) : t.clone().startOf(n);
  }
  handleFocusChange(t) {
    this.setState({ focusedInput: t ?? "startDate" });
  }
  addTimeToDate(t, e, n) {
    if (!t)
      return null;
    const { timeRoundingStrategy: o } = this.props, [r, a] = e.split(":");
    return !r || !a ? n === "startDate" ? t.clone().startOf(o) : t.clone().endOf(o) : t.clone().set({
      hours: parseInt(r, 10),
      minutes: parseInt(a, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    if (this.props.disabled)
      return !0;
    const { timeRoundingStrategy: e } = this.props, { minDate: n, maxDate: o } = this.getDateConstraints();
    return !t.isBetween(n, o, e);
  }
  updateTimeOnDateChange({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: o } = this.props;
    n?.isSame(t) || this.setState({
      startTime: n ? j(n).format(Nt) : null
    }), o?.isSame(e) || this.setState({
      endTime: o ? j(o).format(Nt) : null
    });
  }
  recalculateDatePickerKey({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: o } = this.props;
    if (e && t && !n && !o)
      return this.setState({ dateRangePickerKey: this.generateRandomKey() });
    if (!(!o && !e) && !(!o && e)) {
      if (o && !e) {
        const r = this.visibleCalendarMonthRef.current?.state.currentMonth;
        if (this.visibleCalendarMonthRef.current && o.isSame(r, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
      if (o && e) {
        if (o.isSame(e, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
    }
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || j.localeData().longDateFormat("L");
  }
  renderTimezoneSelector() {
    const {
      startDate: t,
      endDate: e,
      disabled: n,
      withTimezoneSelector: o,
      timezoneSelectorProps: r
    } = this.props, { timezone: a } = this.state;
    if (!o)
      return null;
    const l = !!t || !!e, c = !l && !n, d = !l || n || r?.disabled;
    return /* @__PURE__ */ s.jsx(
      $r,
      {
        disabled: d,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !c,
          ...r?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: a
      }
    );
  }
  renderInputFields(t) {
    const {
      withDateInput: e,
      withTimePicker: n,
      withTimezoneSelector: o,
      timePickerProps: r,
      disabled: a,
      startDate: l,
      endDate: c,
      selectableMinutes: d,
      selectableHours: h,
      inputsPlacement: u,
      timeFormat: p,
      timeRoundingStrategy: m
    } = this.props;
    if (u !== t || !e && !n)
      return null;
    const { startTime: g, endTime: b, focusedInput: x } = this.state, { minDate: v, maxDate: y } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Xs,
      {
        dateFormat: this.dateFormat,
        timeFormat: p,
        onStartDateChange: this.onStartDateChange,
        onEndDateChange: this.onEndDateChange,
        onTimeChange: this.handleTimeChange,
        onFocusChange: this.handleFocusChange,
        startDate: l,
        endDate: c,
        startTime: g,
        endTime: b,
        minDate: v,
        maxDate: y,
        disabled: a,
        withDateInput: e,
        withTimePicker: n,
        hasTimezoneSelector: o,
        timePickerProps: r,
        selectableMinutes: d,
        selectableHours: h,
        placement: t,
        timeRoundingStrategy: m,
        focusedInput: x
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t?.length ? /* @__PURE__ */ s.jsx(
      Lr,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, startDate: o, endDate: r } = this.props, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Wn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Wn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Tm,
        className: f(Ie.root, t),
        children: [
          /* @__PURE__ */ s.jsxs(O, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              br.DayPickerRangeController,
              {
                ref: this.visibleCalendarMonthRef,
                startDate: o,
                endDate: r,
                onDatesChange: this.onDatesChange,
                onFocusChange: this.handleFocusChange,
                focusedInput: this.state.focusedInput,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Rr,
                daySize: 32,
                minimumNights: 0,
                disabled: n,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Er,
                initialVisibleMonth: () => o || r || j(),
                transitionDuration: 0,
                ...e
              },
              this.state.dateRangePickerKey
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Nm = "h-datePicker-single-inputFields--datePickerInputFields__root", Fm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop", Pm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector", Rm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom", Em = "h-datePicker-single-inputFields--datePickerInputFields__input", Lm = "h-datePicker-single-inputFields--datePickerInputFields__alert", ne = {
  root: Nm,
  rootPlacementTop: Fm,
  rootPlacementTopWithTimezoneSelector: Pm,
  rootPlacementBottom: Rm,
  input: Em,
  alert: Lm
};
class Qs extends D {
  dateValidators;
  instanceId;
  constructor(t) {
    super(t);
    const { dateFormat: e } = t;
    this.state = {
      dateInputValue: this.props.date?.format(e) ?? "",
      dateError: null
    }, this.instanceId = Qs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new Ut(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncDateWithProps(t);
  }
  static instanceCount = 0;
  syncDateWithProps(t) {
    const { date: e, timeRoundingStrategy: n } = this.props, o = j(e);
    if (!(e === t.date || o?.isSame(j(t.date), n)))
      return this.props.date ? this.setState({
        dateError: null,
        dateInputValue: o.format(this.props.dateFormat)
      }) : this.setState({
        dateError: null,
        dateInputValue: ""
      });
  }
  handleInputValueChange(t) {
    const e = this.ensureValidChars(t.target.value);
    this.setState({ dateInputValue: e }, this.propagateDateChangeEvent);
  }
  propagateDateChangeEvent() {
    const { dateInputValue: t } = this.state;
    if (t === "") {
      this.props.onDateChange(null);
      return;
    }
    const { isValid: e, error: n } = this.dateValidators.isSingleDateValid(t);
    if (!e) {
      this.setState({ dateError: n });
      return;
    }
    this.setState(
      {
        dateError: null
      },
      () => this.props.onDateChange(this.parseDateString(t))
    );
  }
  parseDateString(t) {
    return j(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  renderDateInput() {
    const { disabled: t, dateFormat: e, withDateInput: n } = this.props, { dateInputValue: o, dateError: r } = this.state;
    return n ? /* @__PURE__ */ s.jsx(
      qt,
      {
        className: ne.input,
        required: !0,
        name: `date__input__${this.instanceId}`,
        value: o,
        onChange: this.handleInputValueChange,
        autoComplete: "off",
        placeholder: e.toLowerCase(),
        disabled: t,
        status: r ? "error" : void 0
      }
    ) : null;
  }
  renderTimeInput() {
    const {
      date: t,
      time: e,
      withTimePicker: n,
      timePickerProps: o = {},
      disabled: r,
      onTimeChange: a,
      timeFormat: l
    } = this.props;
    if (!n)
      return null;
    const c = !t && !r, d = !t || r;
    return /* @__PURE__ */ s.jsx(
      gt,
      {
        content: "Please select a date first.",
        disabled: !c,
        side: "right",
        children: /* @__PURE__ */ s.jsx("div", { className: ne.input, children: /* @__PURE__ */ s.jsx(
          sn,
          {
            disabled: d,
            onSelect: a,
            selectedItems: e ? [e] : void 0,
            ...o,
            timeFormat: l
          }
        ) })
      }
    );
  }
  renderErrors() {
    const { dateError: t } = this.state;
    return /* @__PURE__ */ s.jsx(
      Zn,
      {
        className: ne.alert,
        variant: t ? "error" : void 0,
        children: this.state.dateError
      }
    );
  }
  render() {
    const { hasTimezoneSelector: t, placement: e } = this.props, n = f(ne.root, {
      [ne.rootPlacementTop]: e === "top",
      [ne.rootPlacementTopWithTimezoneSelector]: e === "top" && t,
      [ne.rootPlacementBottom]: e === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: n, children: [
      this.renderDateInput(),
      this.renderTimeInput(),
      this.renderErrors()
    ] });
  }
}
const Am = "datePickerTestId";
class $m extends D {
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    withDateInput: !1,
    withTimePicker: !1,
    timePickerProps: {},
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(t) {
    super(t);
    const { date: e, timezone: n, presets: o, presetKey: r } = t;
    this.state = {
      time: e ? j(e).format(Nt) : null,
      timezone: De(n) ? n : j.tz.guess(!0),
      presetKey: o?.find(({ key: a }) => a === r)?.key ?? null,
      datePickerKey: 0
    }, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey();
  }
  visibleCalendarMonthRef = B();
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props;
    return {
      minDate: e || j("0001-01-01"),
      maxDate: t || j("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { date: e } = this.props, { presetKey: n } = this.state;
    this.setState({ timezone: t }, () => this.onDateChange(e, n));
  }
  onDateChange(t, e = null) {
    const { time: n, timezone: o } = this.state, { timeRoundingStrategy: r } = this.props, a = this.addTimezoneToDate(t, o);
    let l = a?.clone().startOf(r) || null, c = t?.clone().startOf(r) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          time: t?.clone().startOf(r).format(Nt) ?? null
        },
        () => {
          this.props.onChange({
            date: l,
            localDate: c,
            timezone: o,
            localTimezone: j.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (l = this.addTimeToDate(a, n), c = this.addTimeToDate(t, n)), this.props.onChange({
      date: l,
      localDate: c,
      timezone: o,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    t ? this.onDateChange(t.date, t.key) : this.onDateChange(null);
  }
  handleTimeChange(t) {
    const { date: e } = this.props;
    this.setState(
      (n) => ({
        ...n,
        time: t
      }),
      () => this.onDateChange(e)
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return De(e) ? j(t).clone().tz(e, !0) : t.clone().startOf(n);
  }
  addTimeToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props, [o, r] = e.split(":");
    return !o || !r ? t.clone().startOf(n) : t.clone().set({
      hours: parseInt(o, 10),
      minutes: parseInt(r, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    const { disabled: e, timeRoundingStrategy: n } = this.props;
    if (e)
      return !0;
    const { minDate: o, maxDate: r } = this.getDateConstraints();
    return !t.isBetween(o, r, n);
  }
  updateTimeOnDateChange(t) {
    const { date: e } = this.props;
    t.date?.isSame(e) || this.setState({
      time: e ? j(e).format(Nt) : null
    });
  }
  recalculateDatePickerKey() {
    const { date: t } = this.props, e = this.visibleCalendarMonthRef.current?.state.currentMonth;
    if (e && t && !t.isSame(e, "month"))
      return this.setState({ datePickerKey: this.generateRandomKey() });
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  renderTimezoneSelector() {
    const { date: t, disabled: e, withTimezoneSelector: n, timezoneSelectorProps: o } = this.props, { timezone: r } = this.state;
    if (!n)
      return null;
    const a = !!t, l = !a && !e, c = !a || e || o?.disabled;
    return /* @__PURE__ */ s.jsx(
      $r,
      {
        disabled: c,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !l,
          ...o?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: r,
        ...o
      }
    );
  }
  renderInputFields(t) {
    const {
      dateFormat: e,
      timeFormat: n,
      withDateInput: o,
      withTimePicker: r,
      withTimezoneSelector: a,
      timePickerProps: l,
      selectableMinutes: c,
      selectableHours: d,
      disabled: h,
      date: u,
      inputsPlacement: p,
      timeRoundingStrategy: m
    } = this.props;
    if (p !== t || !o && !r)
      return null;
    const { time: g } = this.state, { minDate: b, maxDate: x } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Qs,
      {
        dateFormat: e,
        timeFormat: n,
        onDateChange: this.onDateChange,
        onTimeChange: this.handleTimeChange,
        time: g,
        date: u,
        minDate: b,
        maxDate: x,
        disabled: h,
        withDateInput: o,
        withTimePicker: r,
        hasTimezoneSelector: a,
        timePickerProps: l,
        selectableMinutes: c,
        selectableHours: d,
        placement: t,
        timeRoundingStrategy: m
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t?.length ? /* @__PURE__ */ s.jsx(
      Lr,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, date: o } = this.props, { datePickerKey: r } = this.state, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Wn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Wn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Am,
        className: f(Ie.root, t),
        children: [
          /* @__PURE__ */ s.jsxs(O, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              br.DayPickerSingleDateController,
              {
                ref: this.visibleCalendarMonthRef,
                date: o,
                onDateChange: this.onDateChange,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Rr,
                daySize: 32,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Er,
                initialVisibleMonth: () => o || j(),
                onFocusChange: E,
                focused: !0,
                transitionDuration: 0,
                ...e
              },
              r
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Bm = "h-dialer--dialer__dialer", Om = "h-dialer--dialer__number", Hm = "h-dialer--dialer__letters", Wm = "h-dialer--dialer__asterisk", An = {
  dialer: Bm,
  number: Om,
  letters: Hm,
  asterisk: Wm
}, Mm = [
  { value: "1", letters: " " },
  { value: "2", letters: "abc" },
  { value: "3", letters: "def" },
  { value: "4", letters: "ghi" },
  { value: "5", letters: "jkl" },
  { value: "6", letters: "mno" },
  { value: "7", letters: "pqrs" },
  { value: "8", letters: "tuv" },
  { value: "9", letters: "wxyz" },
  { value: "*", letters: null, classNames: An.asterisk },
  { value: "0", letters: null },
  { value: "#", letters: null }
];
class Dk extends D {
  render() {
    const { className: t, onInput: e, ...n } = this.props, o = f(An.dialer, t);
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: Mm.map((r) => /* @__PURE__ */ Fi(
      "div",
      {
        className: f(An.number),
        ...Gn(() => e(r.value)),
        key: r.value
      },
      /* @__PURE__ */ s.jsx(L.Heading, { variant: "heading-1", color: "neutral.700", children: /* @__PURE__ */ s.jsx("span", { className: r.classNames ?? "", children: r.value }) }),
      /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "1", color: "neutral.700", children: !!r.letters && /* @__PURE__ */ s.jsx("span", { className: An.letters, children: r.letters }) })
    )) });
  }
}
const zm = "h-fieldWrapper--fieldWrapper__root", Vm = "h-fieldWrapper--fieldWrapper__rootDisabled", Km = "h-fieldWrapper--fieldWrapper__label", Um = "h-fieldWrapper--fieldWrapper__alert", _n = {
  root: zm,
  rootDisabled: Vm,
  label: Km,
  alert: Um
}, qm = "fieldWrapper";
class z extends D {
  static hasStatus(t, e) {
    return t?.[e] ? t?.touched === void 0 || t.touched === !0 : !1;
  }
  static getStatusMessage(t, e) {
    if (this.hasStatus(t, e))
      return t?.[e];
  }
  static getStatus(t) {
    return z.hasStatus(t, "error") ? "error" : z.hasStatus(t, "warning") ? "warning" : z.hasStatus(t, "success") ? "success" : void 0;
  }
  renderAlerts() {
    const { meta: t, description: e } = this.props;
    let n = e, o;
    return z.hasStatus(t, "error") ? (n = z.getStatusMessage(t, "error"), o = "error") : z.hasStatus(t, "warning") ? (n = z.getStatusMessage(t, "warning"), o = "warning") : z.hasStatus(t, "success") && (n = z.getStatusMessage(t, "success"), o = "success"), /* @__PURE__ */ s.jsx(Zn, { variant: o, className: _n.alert, children: n });
  }
  render() {
    const {
      className: t,
      labelFor: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = f(
      _n.root,
      {
        [_n.rootDisabled]: a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": qm,
        ...u,
        className: p,
        children: [
          !d && /* @__PURE__ */ s.jsx(
            qs,
            {
              required: r,
              htmlFor: e,
              helpIcon: l,
              className: _n.label,
              children: n
            }
          ),
          h,
          !c && this.renderAlerts()
        ]
      }
    );
  }
}
class Ps extends D {
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noLabel: d,
      noAlert: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noLabel: d,
        noAlert: h,
        children: /* @__PURE__ */ s.jsx(
          qt,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...e,
            ...u
          }
        )
      }
    );
  }
}
const Gm = "h-dropdownSelect--dropdownSelectContainer__search", Ym = "h-dropdownSelect--dropdownSelectContainer__pagination", Xm = "h-dropdownSelect--dropdownSelectContainer__selectionActions", Qm = "h-dropdownSelect--dropdownSelectContainer__extra", Cn = {
  search: Gm,
  pagination: Ym,
  selectionActions: Xm,
  extra: Qm
}, Zm = "DROP_SEARCH_INPUT";
class Br extends _t {
  listRef;
  searchRef;
  static getDerivedStateFromProps(t, e) {
    const { dropdownOpen: n } = t, o = { ...e };
    return n || (o.searchValue = "", o.activeItemIndex = 0), o;
  }
  constructor(t) {
    super(t), this.state = {
      searchValue: "",
      activeItemIndex: 0
    }, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.handleItemKeyDown = this.handleItemKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = B(), this.searchRef = B();
  }
  componentDidMount() {
    this.onOpen();
  }
  componentDidUpdate(t) {
    const { dropdownOpen: e } = this.props;
    !t.dropdownOpen && e && this.onOpen();
  }
  getInput() {
    const { searchValue: t } = this.state;
    return {
      name: Zm,
      value: t,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: "off",
      "aria-label": "Search"
    };
  }
  searchKeyDown(t) {
    const { key: e } = t, { searchValue: n, activeItemIndex: o } = this.state, { triggerClose: r, items: a, disabledItems: l = [] } = this.props, c = a.map((h, u) => ({ item: h, index: u })).filter(({ item: h }) => !l.includes(h.id)).map(({ index: h }) => h), d = c.indexOf(o);
    if (e === "Escape")
      n === "" ? r() : this.clearSearch();
    else if (e === "ArrowDown") {
      if (t.preventDefault(), c.length > 0) {
        const h = d < c.length - 1 ? d + 1 : 0;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "ArrowUp") {
      if (t.preventDefault(), c.length > 0) {
        const h = d > 0 ? d - 1 : c.length - 1;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "Home")
      t.preventDefault(), c.length > 0 && this.setState(
        { activeItemIndex: c[0] },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (e === "End")
      t.preventDefault(), c.length > 0 && this.setState(
        {
          activeItemIndex: c[c.length - 1]
        },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (e === "Enter" || e === " ") {
      t.preventDefault();
      const h = a[o];
      if (h && !l.includes(h.id)) {
        const { onChange: u, selectedItems: p = [] } = this.props;
        if (u) {
          const m = p.some((g) => (typeof g == "object" ? g.id : g) === h.id);
          this.onChange(h, !m);
        } else
          this.onSelect(h);
      }
    }
  }
  handleItemKeyDown(t) {
    const { key: e } = t, { activeItemIndex: n } = this.state, { triggerClose: o, items: r, disabledItems: a = [] } = this.props, l = r.map((d, h) => ({ item: d, index: h })).filter(({ item: d }) => !a.includes(d.id)).map(({ index: d }) => d), c = l.indexOf(n);
    if (e === "Escape")
      o();
    else if (e === "ArrowDown") {
      if (t.preventDefault(), l.length > 0) {
        const d = c < l.length - 1 ? c + 1 : 0;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "ArrowUp") {
      if (t.preventDefault(), l.length > 0) {
        const d = c > 0 ? c - 1 : l.length - 1;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else e === "Home" ? (t.preventDefault(), l.length > 0 && this.setState(
      { activeItemIndex: l[0] },
      () => this.listRef.current?.focusActiveItem()
    )) : e === "End" && (t.preventDefault(), l.length > 0 && this.setState(
      {
        activeItemIndex: l[l.length - 1]
      },
      () => this.listRef.current?.focusActiveItem()
    ));
  }
  search(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    typeof e == "function" && e(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
      searchValue: n,
      activeItemIndex: 0
    });
  }
  onSelect(t) {
    const { onSelect: e, keepOpen: n, triggerClose: o } = this.props;
    typeof e == "function" && e(t), n && this.focusSearch(), !n && typeof o == "function" && o();
  }
  onChange(t, e) {
    const { onChange: n, keepOpen: o, triggerClose: r } = this.props;
    typeof n == "function" && n(t, e), o && this.focusSearch(), !o && typeof r == "function" && r();
  }
  onOpen() {
    const { hasSearch: t } = this.props;
    t ? this.focusSearch() : setTimeout(() => {
      this.listRef.current?.focusActiveItem();
    }, 0);
  }
  focusSearch() {
    const { hasSearch: t } = this.props;
    if (t && this.searchRef.current) {
      const e = this.searchRef.current.querySelector("input");
      e && e.focus();
    }
  }
  clearSearch = () => {
    const { onSearch: t } = this.props, { searchValue: e } = this.state;
    e && (typeof t == "function" && t(""), this.setState({ searchValue: "" }));
  };
  render() {
    const {
      className: t,
      itemComponent: e,
      emptyComponent: n,
      suggestionComponent: o,
      optionComponent: r,
      items: a,
      hasSearch: l,
      searchPlaceholder: c,
      pagination: d,
      keepOpen: h,
      onSelect: u,
      onSearch: p,
      onSuggest: m,
      onChange: g,
      onClear: b,
      onClearText: x,
      triggerClose: v,
      dropdownOpen: y,
      emptyMessage: C,
      selectedItems: _,
      disabledItems: w,
      tooltipItems: I,
      activeItem: S,
      itemsDisplayCount: T,
      itemHeight: P,
      renderSuggestion: A,
      searchSuggestion: k,
      ...R
    } = this.props;
    if (!y)
      return null;
    const { searchValue: W, activeItemIndex: nt } = this.state, st = a.length === 0, tt = a[nt] ?? S ?? a[0] ?? null, H = f(t);
    return /* @__PURE__ */ s.jsxs("div", { ...R, className: H, children: [
      l && /* @__PURE__ */ s.jsx("div", { className: Cn.search, ref: this.searchRef, children: /* @__PURE__ */ s.jsx(
        Ps,
        {
          input: this.getInput(),
          meta: { error: null, touched: !0 },
          icon: "search",
          noAlert: !0,
          noLabel: !0,
          placeholder: c
        }
      ) }),
      !!(l && o || r) && /* @__PURE__ */ s.jsxs("div", { className: Cn.extra, children: [
        r,
        l && typeof o == "function" && /* @__PURE__ */ s.jsx(
          o,
          {
            searched: W,
            onSuggest: m,
            triggerClose: h ? void 0 : v,
            clearSearch: this.clearSearch,
            items: a,
            searchSuggestion: k,
            renderSuggestion: A
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        !st && /* @__PURE__ */ s.jsx(
          Gs,
          {
            ref: this.listRef,
            pagination: d,
            items: a,
            onSelect: this.onSelect,
            onChange: this.onChange,
            onKeyDown: this.handleItemKeyDown,
            clearSearch: this.clearSearch,
            selectedItems: _,
            disabledItems: w,
            itemComponent: e,
            tooltipItems: I,
            itemsDisplayCount: T,
            itemHeight: P,
            activeItem: tt
          }
        ),
        st && typeof n == "function" && /* @__PURE__ */ s.jsx(n, { label: C || "" })
      ] }),
      typeof b == "function" && /* @__PURE__ */ s.jsx("div", { className: Cn.selectionActions, children: /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "secondary",
          disabled: _?.length === 0,
          onClick: b,
          children: x || "Clear"
        }
      ) }),
      !!d && !d.infinite && /* @__PURE__ */ s.jsxs("div", { className: Cn.pagination, children: [
        /* @__PURE__ */ s.jsx(
          X,
          {
            variant: "secondary",
            disabled: !d.previousEnable,
            onClick: d.onPrevious,
            children: "Prev page"
          }
        ),
        /* @__PURE__ */ s.jsx(
          X,
          {
            variant: "secondary",
            disabled: !d.nextEnable,
            onClick: d.onNext,
            children: "Next page"
          }
        )
      ] })
    ] });
  }
}
class Zs extends D {
  static defaultProps = {
    className: "",
    buttonProps: {},
    dropdownProps: {},
    containerProps: {},
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    pagination: !1,
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    onToggle: () => {
    },
    onKeyDown: () => {
    },
    emptyComponent: hn,
    emptyMessage: "No items found",
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  render() {
    const {
      className: t,
      items: e,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      onClearText: l,
      onKeyDown: c,
      hasSearch: d,
      searchPlaceholder: h = "Search...",
      onSuggest: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      children: b,
      buttonProps: x,
      dropdownProps: v,
      containerProps: y,
      pagination: C,
      emptyComponent: _,
      emptyMessage: w,
      selectedItems: I,
      disabledItems: S,
      tooltipItems: T,
      activeItem: P,
      itemsDisplayCount: A,
      itemHeight: k,
      optionComponent: R,
      renderSuggestion: W,
      searchSuggestion: nt,
      ...st
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      ae,
      {
        ...st,
        className: t,
        buttonProps: { variant: "secondary", ...x },
        dropdownProps: v,
        dropdown: /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ toggleDropdown: tt, dropdownOpen: H }) => /* @__PURE__ */ s.jsx(
          Br,
          {
            ...y,
            items: e,
            itemComponent: m,
            hasSearch: d,
            searchPlaceholder: h,
            suggestionComponent: g,
            onSuggest: u,
            keepOpen: p,
            onSearch: r,
            onSelect: n,
            onChange: o,
            onClear: a,
            onClearText: l,
            onKeyDown: c,
            triggerClose: tt,
            dropdownOpen: H,
            pagination: C,
            emptyComponent: _,
            emptyMessage: w,
            selectedItems: I,
            disabledItems: S,
            tooltipItems: T,
            activeItem: P,
            itemsDisplayCount: A,
            itemHeight: k,
            optionComponent: R,
            renderSuggestion: W,
            searchSuggestion: nt
          }
        ) }),
        children: b
      }
    );
  }
}
const Jm = "h-dropdownSelectMultiple--dropdownSelectMultiple__items", tg = "h-dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown", eg = "h-dropdownSelectMultiple--dropdownSelectMultiple__tagName", gs = {
  items: Jm,
  moreItemsDropdown: tg,
  tagName: eg
};
class ng extends _t {
  static defaultProps = {
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    emptyComponent: hn,
    emptyMessage: "No items found",
    buttonText: "+Select item",
    selectedItems: []
  };
  getItems() {
    const { items: t } = this.props;
    return t;
  }
  render() {
    const {
      items: t,
      itemComponent: e,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      hasSearch: l,
      searchPlaceholder: c,
      onSuggest: d,
      suggestionComponent: h,
      emptyComponent: u,
      emptyMessage: p,
      keepOpen: m,
      containerProps: g,
      buttonText: b,
      selectedItems: x,
      optionComponent: v,
      ...y
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Zs,
      {
        ...y,
        containerProps: g,
        items: this.getItems(),
        itemComponent: e,
        hasSearch: l,
        searchPlaceholder: c,
        suggestionComponent: h,
        onSuggest: d,
        keepOpen: m,
        onSearch: r,
        onSelect: n,
        onChange: o,
        onClear: a,
        emptyComponent: u,
        emptyMessage: p,
        selectedItems: x,
        optionComponent: v,
        children: b
      }
    );
  }
}
class kk extends _t {
  static defaultProps = {
    MoreItemsItemComponent: tp,
    hideSelectedItems: !1,
    disabledItems: [],
    tooltipItems: {}
  };
  constructor(t) {
    super(t), this.getListItem = this.getListItem.bind(this), this.getListMoreItem = this.getListMoreItem.bind(this);
  }
  resolveItem(t) {
    if (typeof t == "object")
      return t;
    const e = this.props.items.find((n) => n.id === t);
    return e || { id: gr(), name: "Unknown" };
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  isItemDisabled(t) {
    return this.props.disabledItems ? this.props.disabledItems.indexOf(t.id) >= 0 : !1;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !e || Hs(e[t.id]) ? null : e[t.id];
  }
  getListItem(t, e) {
    const { onRemove: n } = this.props, o = this.resolveItem(t), r = this.getItemName(o), a = this.getTooltip(o), l = /* @__PURE__ */ s.jsx(
      ke,
      {
        className: gs.tagName,
        onDelete: () => n(o),
        color: o.color,
        disabled: this.isItemDisabled(o),
        children: r
      },
      o.id
    );
    return a ? /* @__PURE__ */ s.jsx(gt, { ...a, children: l }, e) : l;
  }
  getListMoreItem(t) {
    const { MoreItemsItemComponent: e, onRemove: n } = this.props, o = this.resolveItem(t), r = this.getTooltip(o), a = /* @__PURE__ */ s.jsx(
      e,
      {
        item: o,
        onSelect: n,
        disabled: this.isItemDisabled(o),
        clearSearch: E,
        isLoading: !1,
        checked: !1
      },
      o.id
    );
    return r ? /* @__PURE__ */ s.jsx(gt, { ...r, children: a }, o.id) : a;
  }
  getPreviewItems() {
    const {
      selectedItems: t,
      previewItemsNumber: e,
      moreItemsDropdownProps: n = {}
    } = this.props;
    let o = [], r = [], a = "";
    if (e && t) {
      if (t.length > 0 && t.length < e)
        o = t.map(this.getListItem);
      else if (t.length >= e) {
        const h = t.slice(0, e), u = t.slice(
          e,
          t.length
        );
        o = h.map(this.getListItem), r = u.map(this.getListMoreItem), a = u.length.toString();
      }
    } else
      o = t.map(this.getListItem);
    const { className: l, ...c } = n, d = /* @__PURE__ */ s.jsx(
      "div",
      {
        ...c,
        className: f(gs.moreItemsDropdown, l),
        children: r
      }
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      e && t.length > e ? /* @__PURE__ */ s.jsxs(
        ae,
        {
          noArrow: !0,
          buttonProps: { variant: "tertiary" },
          dropdown: d,
          children: [
            "+ ",
            a,
            /* @__PURE__ */ s.jsx("span", { children: " selected" })
          ]
        }
      ) : null
    ] });
  }
  render() {
    const {
      items: t,
      selectedItems: e,
      previewItemsNumber: n,
      className: o,
      onSelect: r,
      onChange: a,
      onSearch: l,
      hasSearch: c,
      searchPlaceholder: d,
      onSuggest: h,
      onRemove: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      pagination: b,
      emptyComponent: x,
      emptyMessage: v,
      containerProps: y,
      moreItemsDropdownProps: C,
      MoreItemsItemComponent: _,
      hideSelectedItems: w,
      disabledItems: I,
      tooltipItems: S,
      optionComponent: T,
      ...P
    } = this.props, A = f(
      {
        [gs.items]: !0
      },
      o
    );
    return /* @__PURE__ */ s.jsxs("div", { className: A, children: [
      /* @__PURE__ */ s.jsx(
        ng,
        {
          items: t,
          itemComponent: m,
          hasSearch: c,
          searchPlaceholder: d,
          suggestionComponent: g,
          onSuggest: h,
          keepOpen: p,
          onSearch: l,
          onSelect: r,
          onChange: a,
          pagination: b,
          emptyComponent: x,
          emptyMessage: v,
          containerProps: y,
          selectedItems: e,
          disabledItems: I,
          tooltipItems: S,
          optionComponent: T,
          ...P
        }
      ),
      !w && this.getPreviewItems()
    ] });
  }
}
const sg = "h-fieldButton--fieldButton__button", og = {
  button: sg
}, Tk = $(
  function({
    className: t,
    buttonClassName: e,
    label: n,
    meta: o,
    disabled: r,
    helpIcon: a,
    description: l,
    noAlert: c,
    noLabel: d,
    children: h,
    ...u
  }, p) {
    const m = f(e, og.button);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        meta: o,
        disabled: r,
        helpIcon: a,
        description: l,
        noAlert: c,
        noLabel: d,
        children: /* @__PURE__ */ s.jsx(
          X,
          {
            ref: p,
            disabled: r,
            ...u,
            className: m,
            children: h
          }
        )
      }
    );
  }
), rg = "h-inputDatePicker--inputDatePicker__root", ig = "h-inputDatePicker--inputDatePicker__inputContainer", ag = "h-inputDatePicker--inputDatePicker__input", lg = "h-inputDatePicker--inputDatePicker__rootReadOnly", cg = "h-inputDatePicker--inputDatePicker__iconsContainer", dg = "h-inputDatePicker--inputDatePicker__rootHasClearIcon", hg = "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon", ug = "h-inputDatePicker--inputDatePicker__calendarIcon", pg = "h-inputDatePicker--inputDatePicker__clearIcon", At = {
  root: rg,
  inputContainer: ig,
  input: ag,
  rootReadOnly: lg,
  iconsContainer: cg,
  rootHasClearIcon: dg,
  rootHasWrapperIcon: hg,
  calendarIcon: ug,
  clearIcon: pg
}, mg = "inputDatePickerTestId";
class gg extends D {
  inputRef;
  rootRef;
  datePickerContainerRef;
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    name: Math.floor(Math.random() * 1e8).toString()
  };
  constructor(t) {
    super(t), this.inputRef = B(), this.rootRef = B(), this.datePickerContainerRef = B(), this.state = {
      isDropdownOpen: !1,
      shouldRerenderDatePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDatePickerInput() {
    this.datePickerContainerRef.current?.querySelector('input[type="text"]')?.focus();
  }
  handleWindowClick(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    Fe(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDateChange(t) {
    const { onChange: e, value: n } = this.props;
    typeof e == "function" && e(t), (n ?? t !== null) && this.inputRef.current?.focus();
  }
  handleClearIconClick() {
    this.handleDateChange({
      date: null,
      localDate: null,
      timezone: null,
      localTimezone: null
    });
  }
  showDropdown() {
    this.setState({
      isDropdownOpen: !0,
      shouldRerenderDatePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus() {
    const { readOnly: t } = this.props;
    t || this.showDropdown();
  }
  handleInputBlur(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleInputClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  handleInputKeydown({ key: t }) {
    Yn(t) && this.showDropdown();
  }
  handleCalendarIconClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  renderInputAndIcons() {
    const {
      className: t,
      name: e,
      value: n,
      onChange: o,
      dateFormat: r,
      dropdownProps: a,
      prefix: l,
      suffix: c,
      icon: d,
      status: h,
      placeholder: u,
      disabled: p,
      datePickerProps: m,
      clearable: g,
      minDate: b,
      maxDate: x,
      readOnly: v,
      ...y
    } = this.props, { isDropdownOpen: C } = this.state;
    return /* @__PURE__ */ s.jsx(
      Et,
      {
        prefix: l,
        suffix: c,
        disabled: p,
        icon: d,
        active: C,
        status: h,
        children: /* @__PURE__ */ s.jsxs("div", { className: At.inputContainer, children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ...y,
              id: e,
              name: e,
              className: At.input,
              ref: this.inputRef,
              onClick: this.handleInputClick,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onKeyDown: this.handleInputKeydown,
              disabled: p,
              placeholder: u || r?.toLowerCase(),
              autoComplete: "off",
              value: Bn(n) ? void 0 : n?.format(r) ?? "",
              onChange: Bn(n) ? void 0 : E,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: At.iconsContainer, children: [
            this.renderClearIcon(),
            this.renderCalendarIcon()
          ] })
        ] })
      }
    );
  }
  renderCalendarIcon() {
    const { disabled: t } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: At.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: this.handleCalendarIconClick,
        tabIndex: -1,
        disabled: t
      }
    );
  }
  renderClearIcon() {
    const { clearable: t, value: e, disabled: n } = this.props;
    return !t || !e ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: At.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: n,
        onClick: this.handleClearIconClick
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: o,
      datePickerProps: r,
      disabled: a,
      dropdownProps: l,
      dateFormat: c
    } = this.props, { isDropdownOpen: d, shouldRerenderDatePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(Zt, { ...l, isOpen: d, children: /* @__PURE__ */ s.jsx("div", { ref: this.datePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      $m,
      {
        disabled: a,
        ...r,
        dateFormat: c,
        date: t ?? null,
        timezone: o,
        onChange: this.handleDateChange,
        minDate: e,
        maxDate: n
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: o, icon: r } = this.props, a = f(At.root, t, {
      [At.rootHasClearIcon]: n && e,
      [At.rootHasWrapperIcon]: !!r,
      [At.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": mg,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputAndIcons(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class jk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(t) {
    const {
      input: { onChange: e }
    } = this.props;
    e?.({
      date: t?.date ? t.date.toISOString() : "",
      localDate: t?.localDate ? t.localDate.toISOString() : "",
      timezone: t?.timezone || "",
      localTimezone: t?.localTimezone || ""
    });
  }
  render() {
    const {
      className: t,
      input: { value: e, name: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      helpIcon: h,
      description: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: a,
        labelFor: n,
        meta: l,
        required: c,
        disabled: d,
        helpIcon: h,
        description: u,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          gg,
          {
            name: n,
            value: Fs(e?.localDate) ? j(e.localDate, j.ISO_8601) : null,
            timezone: e?.timezone,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const fg = "h-inputDateRangePicker--inputDateRangePicker__root", bg = "h-inputDateRangePicker--inputDateRangePicker__inputsContainer", xg = "h-inputDateRangePicker--inputDateRangePicker__arrowContainer", yg = "h-inputDateRangePicker--inputDateRangePicker__inputContainer", _g = "h-inputDateRangePicker--inputDateRangePicker__input", Cg = "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly", wg = "h-inputDateRangePicker--inputDateRangePicker__iconsContainer", vg = "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon", Sg = "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer", Ig = "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon", Dg = "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer", kg = "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon", Tg = "h-inputDateRangePicker--inputDateRangePicker__calendarIcon", jg = "h-inputDateRangePicker--inputDateRangePicker__clearIcon", ht = {
  root: fg,
  inputsContainer: bg,
  arrowContainer: xg,
  inputContainer: yg,
  input: _g,
  rootReadOnly: Cg,
  iconsContainer: wg,
  rootStartDateHasClearIcon: vg,
  startDateIconsContainer: Sg,
  rootEndDateHasClearIcon: Ig,
  endDateIconsContainer: Dg,
  rootHasWrapperIcon: kg,
  calendarIcon: Tg,
  clearIcon: jg
}, Ng = "inputDateRangePickerTestId";
class on extends D {
  inputsRef;
  rootRef;
  dateRangePickerContainerRef;
  static getInputName(t, e) {
    return t[e] || `${t}__${e}`;
  }
  static defaultProps = {
    name: {
      startDate: Math.floor(Math.random() * 1e8).toString(),
      endDate: Math.floor(Math.random() * 1e8).toString()
    }
  };
  constructor(t) {
    super(t), this.inputsRef = {
      startDate: B(),
      endDate: B()
    }, this.rootRef = B(), this.dateRangePickerContainerRef = B(), this.state = {
      isDropdownOpen: !1,
      focusedInput: "startDate",
      shouldRerenderDateRangePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n, focusedInput: o } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== e.isDropdownOpen || o !== e.focusedInput) && this.focusDateRangePickerInput();
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDateRangePickerInput() {
    const { focusedInput: t } = this.state, e = this.dateRangePickerContainerRef.current?.querySelectorAll(
      'input[type="text"]'
    );
    t === "startDate" ? e?.[0]?.focus() : e?.[1]?.focus();
  }
  handleWindowClick(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    Fe(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDatesChange(t) {
    const { onChange: e, value: n } = this.props, { focusedInput: o } = this.state;
    typeof e == "function" && e(t), (n?.[o] ?? t[o] !== null) && this.inputsRef[o].current?.focus();
  }
  handleClearIconClick(t, e) {
    const { value: n, timezone: o, localTimezone: r } = this.props, a = {
      startDate: e === "startDate" ? null : n?.startDate ?? null,
      localStartDate: e === "startDate" ? null : n?.localStartDate ?? null,
      endDate: e === "endDate" ? null : n?.endDate ?? null,
      localEndDate: e === "endDate" ? null : n?.localEndDate ?? null,
      timezone: o || null,
      localTimezone: r || null
    };
    this.handleDatesChange(a);
  }
  showDropdown(t) {
    this.setState({
      isDropdownOpen: !0,
      focusedInput: t,
      shouldRerenderDateRangePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus(t, e) {
    const { readOnly: n } = this.props;
    n || this.showDropdown(e);
  }
  handleInputBlur(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleInputKeydown({ key: t }, e) {
    Yn(t) && this.showDropdown(e);
  }
  handleInputClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  handleCalendarIconClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || j.localeData().longDateFormat("L");
  }
  renderInputLayout() {
    const { prefix: t, suffix: e, icon: n, status: o, disabled: r } = this.props, { isDropdownOpen: a } = this.state;
    return /* @__PURE__ */ s.jsx(
      Et,
      {
        prefix: t,
        suffix: e,
        disabled: r,
        icon: n,
        active: a,
        status: o,
        children: /* @__PURE__ */ s.jsxs("div", { className: ht.inputsContainer, children: [
          this.renderInputAndIcons("startDate"),
          /* @__PURE__ */ s.jsx("div", { className: ht.arrowContainer, children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" }) }),
          this.renderInputAndIcons("endDate", -1)
        ] })
      }
    );
  }
  renderInputAndIcons(t, e) {
    const {
      className: n,
      clearable: o,
      dateFormat: r,
      dateRangePickerProps: a,
      disabled: l,
      dropdownProps: c,
      icon: d,
      localTimezone: h,
      maxDate: u,
      minDate: p,
      name: m,
      onChange: g,
      placeholder: b,
      prefix: x,
      readOnly: v,
      status: y,
      suffix: C,
      tabIndex: _,
      timezone: w,
      value: I,
      ...S
    } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: ht.inputContainer, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...S,
          id: on.getInputName(m, t),
          name: on.getInputName(m, t),
          className: ht.input,
          ref: this.inputsRef[t],
          onClick: (T) => this.handleInputClick(T, t),
          onFocus: (T) => this.handleInputFocus(T, t),
          onBlur: (T) => this.handleInputBlur(T),
          onKeyDown: (T) => this.handleInputKeydown(T, t),
          disabled: l,
          placeholder: b?.[t] || b || this.dateFormat?.toLowerCase(),
          autoComplete: "off",
          value: I && j(I[t]).isValid() ? j(I[t]).format(this.dateFormat) : "",
          onChange: Bn(I) ? void 0 : E,
          tabIndex: e ?? _,
          readOnly: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: f(ht.iconsContainer, {
            [ht.startDateIconsContainer]: t === "startDate",
            [ht.endDateIconsContainer]: t === "endDate"
          }),
          children: [
            this.renderClearIcon(t),
            this.renderCalendarIcon(t)
          ]
        }
      )
    ] });
  }
  renderCalendarIcon(t) {
    const { disabled: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: ht.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: (n) => this.handleCalendarIconClick(n, t),
        tabIndex: -1,
        disabled: e
      }
    );
  }
  renderClearIcon(t) {
    const { clearable: e, value: n, disabled: o } = this.props;
    return !e || !n?.[t] ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: ht.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: o,
        onClick: (r) => this.handleClearIconClick(r, t)
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: o,
      dateRangePickerProps: r,
      disabled: a,
      dropdownProps: l
    } = this.props, { isDropdownOpen: c, focusedInput: d, shouldRerenderDateRangePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(Zt, { ...l, isOpen: c, children: /* @__PURE__ */ s.jsx("div", { ref: this.dateRangePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      jm,
      {
        disabled: a,
        ...r,
        dateFormat: this.dateFormat,
        onChange: this.handleDatesChange,
        startDate: t?.startDate ?? null,
        endDate: t?.endDate ?? null,
        timezone: o ?? null,
        minDate: e,
        maxDate: n,
        focusedInput: d
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: o, icon: r } = this.props, a = f(ht.root, t, {
      [ht.rootStartDateHasClearIcon]: n && e?.startDate,
      [ht.rootEndDateHasClearIcon]: n && e?.endDate,
      [ht.rootHasWrapperIcon]: !!r,
      [ht.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Ng,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputLayout(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class Nk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(t) {
    const {
      input: { onChange: e }
    } = this.props;
    e?.({
      startDate: t?.startDate ? t.startDate.toISOString() : "",
      localStartDate: t?.localStartDate ? t.localStartDate.toISOString() : "",
      endDate: t?.endDate ? t.endDate.toISOString() : "",
      localEndDate: t?.localEndDate ? t.localEndDate.toISOString() : "",
      timezone: t?.timezone ?? "",
      localTimezone: t?.localTimezone ?? ""
    });
  }
  getDateRange({
    localStartDate: t,
    localEndDate: e
  }) {
    const n = Fs(t) ? j(t, j.ISO_8601) : null, o = Fs(e) ? j(e, j.ISO_8601) : null;
    return {
      startDate: n,
      endDate: o
    };
  }
  render() {
    const {
      className: t,
      input: { name: e, value: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      description: h,
      helpIcon: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props, { timezone: b, localTimezone: x } = n;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: a,
        labelFor: on.getInputName(e, "startDate"),
        meta: l,
        required: c,
        disabled: d,
        helpIcon: u,
        description: h,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          on,
          {
            name: e,
            value: this.getDateRange(n),
            timezone: b,
            localTimezone: x,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Fg = [
  "link",
  "bold",
  "italic",
  "unorderedList",
  "orderedList",
  "format"
], ie = /(Mac|iPhone|iPod|iPad)/i.test(
  navigator.userAgent
), Mn = (i) => vi(i), Js = (i, t = window) => t.getComputedStyle(i).display === "block";
function fs(i, t) {
  const e = {
    ctrlKey: [
      "Control",
      ...ie ? ["$controlOrAlt"] : ["$metaOrCtrl"]
    ],
    shiftKey: ["Shift"],
    altKey: ["Alt", ...ie ? [] : ["$controlOrAlt"]],
    metaKey: ["Meta", "OS", ...ie ? ["$metaOrCtrl"] : []]
  };
  return i.some((n) => {
    if (t.code !== n[1])
      return !1;
    const o = n[0] ?? [];
    return Object.entries(e).every(
      ([r, a]) => {
        const l = Si(
          a,
          o
        ).length;
        return t[r] ? l > 0 : l === 0;
      }
    );
  });
}
const Pg = (i, t, e) => {
  if (!i || t < 0 || e < 0) return !1;
  const n = i?.textContent?.length ?? 0;
  return !(t > n || e > n);
}, Rg = (i, t) => i.document.queryCommandState(t), Eg = (i) => i.document.queryCommandValue("formatBlock"), Lg = (i) => i.type.indexOf("image/") === 0, Eo = (i, t) => {
  const e = nn();
  return {
    src: (i.URL || i.webkitURL).createObjectURL(t),
    uid: e
  };
}, Ag = (i) => {
  i && i.querySelectorAll("td").forEach((t) => {
    t.style.border = "1px solid currentColor";
  });
}, Rs = (i) => {
  i.setAttribute("dir", "auto");
  const t = window.getComputedStyle(i).direction;
  i.setAttribute("dir", t);
}, Lo = (i) => {
  i && i.childNodes.forEach((t) => {
    t.nodeType !== Node.ELEMENT_NODE && t.nodeType !== Node.TEXT_NODE || Mn(t) && Js(t) && Rs(t);
  });
}, to = (i, t = !0) => {
  const e = document.createElement("div");
  return e.style.display = "none", e.innerHTML = i, document.body.appendChild(e), e.childNodes.forEach((n) => {
    if (!(n.nodeType !== Node.ELEMENT_NODE && n.nodeType !== Node.TEXT_NODE)) {
      if (Mn(n) && Js(n))
        n.innerHTML = to(n.innerHTML, !1), Rs(n);
      else if (t) {
        const o = document.createElement("div");
        o.appendChild(n.cloneNode(!0)), n.replaceWith(o), Rs(o);
      }
    }
  }), document.body.removeChild(e), e.innerHTML;
}, Ao = (i, t = { side: "both" }) => {
  const { side: e } = t, n = i.split(""), o = " ", r = "&nbsp;";
  let a = 0, l = n.length - 1;
  if (e === "both" || e === "start")
    for (; n[a] === o; )
      n[a++] = r;
  if (e === "both" || e === "end")
    for (; n[l] === o; )
      n[l--] = r;
  return n.join("");
}, zn = (i, t) => i.split(/\r\n|\r|\n/g).map((e, n) => e ? t.inline && n === 0 ? Ao(e, { side: "end" }) : `<div>${Ao(e)}</div>` : "<br />").join("");
function $g(i) {
  const t = "&nbsp;", e = " ", n = " ", o = Bg(i.anchorNode), r = Og(i.anchorNode);
  if (i.anchorNode?.nodeType === Node.TEXT_NODE && o.endsWith(t)) {
    const { focusOffset: a, anchorOffset: l } = i, c = Array.prototype.indexOf.call(
      i.anchorNode.parentElement?.childNodes,
      i.anchorNode
    ), d = r.replaceAll(t, n).replace(/.$/, e), h = document.createTextNode(d);
    if (i.anchorNode.parentElement?.childNodes[c].replaceWith(h), i?.rangeCount && i?.rangeCount > 0 && Pg(h, a, l)) {
      const u = i.getRangeAt(0);
      u.setStart(h, a), u.setEnd(h, l);
    }
  }
}
function Bg(i) {
  if (!i)
    return "";
  if (i instanceof Element)
    return i.innerHTML;
  const t = document.createElement("span");
  return t.appendChild(i.cloneNode()), t.innerHTML;
}
function Og(i) {
  return !i || !i.textContent ? "" : i.textContent;
}
const Hg = "h-inputRichText-addonTrigger--addonTrigger__root", Wg = {
  root: Hg
};
function Mg(i) {
  if (!i)
    return null;
  const { focusOffset: t, anchorOffset: e, anchorNode: n } = i;
  return t !== e || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, t) || null;
}
const wn = (i, t) => {
  const e = Or(i, t);
  return e && i.triggers.isAddonTrigger(e.matchedTrigger) ? e.matchedTrigger : null;
}, vn = (i, t) => {
  const e = Or(i, t);
  return e ? e.match : null;
}, Or = (i, t) => t ? i.triggers.test(t) : null, $o = "input-rich-text-addon-trigger", zg = (i, t) => {
  const e = i.selection.recreate();
  if (!e || !t) return null;
  const n = e.getRangeAt(0).getBoundingClientRect();
  return i.ref.current && n && e?.rangeCount && e?.rangeCount > 0 ? e.getRangeAt(0).getBoundingClientRect() : null;
}, Vg = (i, t) => {
  if (i.ref.current && t) {
    const e = i.ref.current.getBoundingClientRect();
    return {
      left: `${t.x - e.x}px`,
      top: `${t.y - e.y}px`,
      height: "0",
      width: t.width,
      position: "absolute"
    };
  }
  return {};
}, Vt = (i) => Mg(i.selection.recreate()) || "", bs = (i, t) => !!t && i.triggers.isAddonTrigger(t), xs = (i) => i?.nodeType === Node.ELEMENT_NODE, Es = (i, t) => i.dataset.testid === t ? i : i.parentElement ? Es(i.parentElement, t) : null, fe = {};
class Kg extends EventTarget {
  /**
   * A map of event listeners for each event type.
   *
   * Since it can be tricky to register/unregister event listeners as data
   * changes in the consumer, we store the event listeners in a map to be able
   * to clear them easily, in order to avoid memory leaks.
   */
  callbacks = {
    focus: [],
    insert: [],
    up: [],
    down: []
  };
  addEventListener(t, e, n) {
    super.addEventListener(t, e, n), e && this.callbacks[t].push(e);
  }
  /** Clear all event listeners for a given event type. */
  clearEventListeners(t) {
    this.callbacks[t].forEach((e) => {
      this.removeEventListener(t, e);
    }), this.callbacks[t] = [];
  }
}
const ve = new Kg(), Ug = Ot({
  matchText: "",
  insertContent: () => {
  },
  eventEmitter: ve
});
var qg = /* @__PURE__ */ ((i) => (i.FOCUS = "focus", i.INSERT = "insert", i.UP = "up", i.DOWN = "down", i))(qg || {});
const Gg = (i) => {
  const { editor: t } = i, [e, n] = V(null), [o, r] = V(null), [a, l] = V(null), [c, d] = V(!1), h = Vg(t, a), [u] = V(nn()), { dismissText: p } = fe[u] ?? { dismissText: "" }, m = e?.[0] ?? "", g = p && /**
  * Replaces trailing spaces with regular spaces. If a text was dismissed
  * with trailing space, editor uses non-breaking space (U+00A0) instead of
  * regular ` ` space, which results in isDismissed being `false` where it
  * should be `true`.
  */
  m?.replace(/\s+$/, " ").startsWith(p.replace(/\s+$/, " ")) || !1, b = F(() => {
    const I = wn(t, Vt(t)), S = vn(t, Vt(t)), T = zg(t, I);
    bs(t, I) && I?.shouldHandleSelectionChange?.() !== !1 ? (r(I), n(S), l(T)) : (r(null), n(null), l(null)), d(!0);
  }, [t]), x = F(() => {
    const I = wn(t, Vt(t)), S = vn(t, Vt(t))?.[0];
    return bs(t, I) && !!S;
  }, [t]), v = F(() => {
    const I = wn(t, Vt(t)), S = vn(t, Vt(t))?.[0], T = fe[u]?.dismissText || "", P = T ? S?.startsWith(T) : !1;
    return bs(t, I) && !!S && !P;
  }, [t, u]), y = F(() => {
    t.hotkeys.add([
      {
        keybindings: [[[], "Tab"]],
        condition: v,
        callback: () => {
          ve.dispatchEvent(new Event(
            "focus"
            /* FOCUS */
          ));
        }
      },
      {
        keybindings: [[[], "Enter"]],
        condition: v,
        callback: () => {
          ve.dispatchEvent(new Event(
            "insert"
            /* INSERT */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowUp"]],
        condition: v,
        callback: () => {
          ve.dispatchEvent(new Event(
            "up"
            /* UP */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: v,
        callback: () => {
          ve.dispatchEvent(new Event(
            "down"
            /* DOWN */
          ));
        }
      },
      {
        keybindings: [[[], "Escape"]],
        condition: v,
        callback: (I, S) => {
          const T = vn(t, Vt(t))?.[0];
          if (!T) {
            fe[u] = {
              dismissText: ""
            };
            return;
          }
          wn(t, Vt(t))?.persistOnEsc === !1 && (S.stopPropagation(), r(null), n(null), l(null)), fe[u] = {
            dismissText: (T.trim().length === 1 ? "" : T) ?? ""
          };
        }
      }
    ]);
  }, [t, v, u]);
  et(() => {
    x() && p !== m && // If persistOnEsc is non-false - preserve existing behavior and reset trigger if the match text changes.
    (g && o?.persistOnEsc !== !1 || // If trigger has been dismissed with Esc and persistOnEsc is false
    // reset dismissText when text is being removed, but preserve dismissText when characters are only added.
    !g && o?.persistOnEsc === !1) && (fe[u] = {
      dismissText: ""
    });
  }, [p, g, x, m, u, o]);
  const C = F((I) => {
    const S = I.nativeEvent.relatedTarget, T = xs(S) && Es(S, Kr), P = xs(S) && Es(S, $o);
    (!xs(S) || !T && !P) && d(!1);
  }, []), _ = F(
    (I, { inline: S } = {}) => {
      const T = t.selection.recreate();
      if (!T || !o)
        return;
      const A = !!T.anchorNode?.textContent?.match(
        `^${o?.trigger.source}`
      ) && !S ? (
        // Adjust each lines direction if it's been added to a new line
        to(
          zn(I, { inline: !1 })
        )
      ) : (
        // Or concatenate to the end of the current line without changing direction
        zn(I, { inline: !0 })
      );
      T?.rangeCount && T?.rangeCount > 0 && t.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        T.getRangeAt(0).createContextualFragment(A),
        {
          getSelection: () => {
            const k = t.selection.recreate();
            if (!k)
              return null;
            const { focusOffset: R } = k, st = o.trigger.exec(m)?.[1]?.length ?? 0, tt = m.length - st;
            return k?.anchorNode && k.extend(
              k.anchorNode,
              R - tt
            ), k;
          }
        }
      );
    },
    [t, m, o]
  );
  if (Ne(() => {
    y(), t.selection.onUpdate(b), t.events.onBlur(C);
  }), Qt(() => {
    delete fe[u];
  }), !o || !c || !m || g)
    return null;
  const w = o.customContainer?.current || window.document.body;
  return /* @__PURE__ */ s.jsx("div", { style: h, children: /* @__PURE__ */ s.jsxs(Ii, { open: !0, children: [
    /* @__PURE__ */ s.jsx(Di, {}),
    /* @__PURE__ */ s.jsx(ki, { container: w, children: /* @__PURE__ */ s.jsx(
      Ti,
      {
        onOpenAutoFocus: (I) => I.preventDefault(),
        "data-testid": $o,
        className: Wg.root,
        side: o.popoverContent?.side ?? "top",
        align: o.popoverContent?.align ?? void 0,
        children: /* @__PURE__ */ s.jsx(
          Ug.Provider,
          {
            value: { matchText: m, insertContent: _, eventEmitter: ve },
            children: o.component
          }
        )
      }
    ) })
  ] }) });
}, Yg = "h-inputRichText-toolbarButton--toolbarButton__root", Xg = "h-inputRichText-toolbarButton--toolbarButton__rootDisabled", Qg = "h-inputRichText-toolbarButton--toolbarButton__rootActive", Zg = "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge", Jg = "h-inputRichText-toolbarButton--toolbarButton__rootWithText", be = {
  root: Yg,
  rootDisabled: Xg,
  rootActive: Qg,
  rootWithBadge: Zg,
  rootWithText: Jg
};
function Ft({
  className: i,
  isActive: t,
  icon: e,
  disabled: n,
  showBadge: o,
  text: r,
  ...a
}) {
  const l = f(
    {
      [be.root]: be.root,
      [be.rootActive]: t,
      [be.rootDisabled]: n,
      [be.rootWithBadge]: o,
      [be.rootWithText]: r
    },
    i
  );
  return /* @__PURE__ */ s.jsx(
    "button",
    {
      tabIndex: -1,
      type: "button",
      ...a,
      className: l,
      disabled: n,
      children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(N, { name: e }) }),
        r && /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(L.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: r }) })
      ] })
    }
  );
}
const tf = "h-inputRichText-attachmentButton--attachmentButton__dropzone", ef = "h-inputRichText-attachmentButton--attachmentButton__fileInput", nf = "h-inputRichText-attachmentButton--attachmentButton__dropdown", sf = "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon", Sn = {
  dropzone: tf,
  fileInput: ef,
  dropdown: nf,
  dropzoneIcon: sf
};
let of = class extends D {
  static displayName = "AttachmentButtonDropzone";
  constructor(t) {
    super(t), this.state = {
      fileHover: !1
    };
  }
  handleDragEnter = (t) => {
    t.preventDefault();
    const { allowAttachments: e } = this.props;
    !e || !t.dataTransfer?.types?.includes("Files") || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (t) => {
    t.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleAttachmentDrop = (t) => {
    t.preventDefault();
    const { onAddAttachment: e } = this.props;
    t.dataTransfer && e(t.dataTransfer.files), this.setState({
      fileHover: !1
    });
  };
  render() {
    const {
      className: t,
      children: e,
      isAttachmentsUploading: n,
      allowAttachments: o,
      allowInline: r,
      onAddAttachment: a,
      ...l
    } = this.props, { fileHover: c } = this.state, d = f(t), h = c || n;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...l,
        className: d,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragEnter,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleAttachmentDrop,
        children: [
          e,
          h && /* @__PURE__ */ s.jsx(Xt, { children: n ? "Uploading..." : "Drop to add an attachment" }),
          !h && "Drop the file or click to upload"
        ]
      }
    );
  }
};
const rf = [
  {
    name: "addAttachment",
    label: "Add attachment",
    keybindings: [[["$metaOrCtrl"], "KeyU"]]
  }
];
class af extends D {
  unsubscribeAddAttachment;
  fileInputRef;
  constructor(t) {
    super(t), this.fileInputRef = B(), this.unsubscribeAddAttachment = Hi;
  }
  componentDidMount() {
    this.unsubscribeAddAttachment = this.props.editor.events.subscribe(
      "addAttachment",
      () => {
        this.fileInputRef.current?.click();
      }
    );
  }
  componentWillUnmount() {
    this.unsubscribeAddAttachment?.();
  }
  openFileBrowser = (t) => {
    t.preventDefault();
    const { current: e } = this.fileInputRef;
    e && e.click();
  };
  handleFileChanged = (t) => {
    const { onAttachFiles: e, editorWindow: n } = this.props, o = t.target;
    o !== null && o instanceof n.HTMLInputElement && (e(o.files), o.value = "");
  };
  renderDropdown() {
    const { isAttachmentsUploading: t, attachments: e, onAttachFiles: n, children: o } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: Sn.dropdown, children: [
      /* @__PURE__ */ s.jsx(
        of,
        {
          className: Sn.dropzone,
          onAddAttachment: n,
          attachments: e,
          isAttachmentsUploading: t,
          allowInline: !1,
          onClick: this.openFileBrowser,
          allowAttachments: !0,
          children: /* @__PURE__ */ s.jsx(N, { name: "paperclip", className: Sn.dropzoneIcon })
        }
      ),
      o
    ] });
  }
  preventDefault = (t) => {
    t.preventDefault();
  };
  render() {
    const {
      className: t,
      attachments: e,
      onAttachFiles: n,
      onDetachFile: o,
      isAttachmentsUploading: r,
      dropdownRef: a,
      editorWindow: l,
      ...c
    } = this.props;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: this.fileInputRef,
          type: "file",
          className: Sn.fileInput,
          onChange: this.handleFileChanged,
          multiple: !0
        }
      ),
      /* @__PURE__ */ s.jsx(
        ae,
        {
          ...c,
          className: t,
          noStyle: !0,
          ref: a,
          dropdown: this.renderDropdown(),
          children: /* @__PURE__ */ s.jsx(
            Ft,
            {
              onMouseDown: this.preventDefault,
              icon: "paperclip",
              showBadge: e.length > 0
            }
          )
        }
      )
    ] });
  }
}
const lf = "h-inputRichText-dropzone--dropzone__root", cf = "h-inputRichText-dropzone--dropzone__inlineDropzone", df = "h-inputRichText-dropzone--dropzone__attachmentDropzone", hf = "h-inputRichText-dropzone--dropzone__rootDual", uf = "h-inputRichText-dropzone--dropzone__icon", xe = {
  root: lf,
  inlineDropzone: cf,
  attachmentDropzone: df,
  rootDual: hf,
  icon: uf
};
class pf extends D {
  static displayName = "InputRichTextDropzone";
  constructor(t) {
    super(t), this.state = {
      fileHover: !1,
      overDropzone: !1
    };
  }
  handleDragEnter = (t) => {
    t.preventDefault();
    const { allowInlineAttachments: e, allowAttachments: n } = this.props;
    !e && !n || !t.dataTransfer?.types?.includes("Files") || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (t) => {
    t.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleEnterDropzone = (t) => {
    t.preventDefault(), this.setState({
      overDropzone: !0
    });
  };
  handleLeaveDropzone = (t) => {
    t.preventDefault(), this.setState({
      overDropzone: !1
    });
  };
  handleInlineDrop = (t) => {
    t.preventDefault();
    const { onAddInline: e } = this.props;
    t.dataTransfer && typeof e == "function" && e(t.dataTransfer.files), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  handleAttachmentDrop = (t) => {
    t.preventDefault();
    const { onAddAttachment: e } = this.props;
    t.dataTransfer && typeof e == "function" && e(t.dataTransfer.files), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  render() {
    const {
      className: t,
      children: e,
      allowInlineAttachments: n,
      allowAttachments: o,
      onAddInline: r,
      onMouseDown: a,
      attachments: l,
      onAddAttachment: c,
      ...d
    } = this.props, { fileHover: h, overDropzone: u } = this.state, p = f(
      {
        [xe.root]: !0,
        [xe.rootDual]: n && o
      },
      t
    ), m = n || o, g = {};
    return a && (g.onClick = a), m && (g.onDragEnter = this.handleDragEnter, g.onDragOver = this.handleDragEnter, g.onDragLeave = this.handleDragLeave), /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...d,
        tabIndex: -1,
        className: p,
        ...g,
        children: [
          e,
          (h || u) && /* @__PURE__ */ s.jsxs(Xt, { children: [
            n && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleInlineDrop,
                className: xe.inlineDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "upload", size: 24, className: xe.icon }),
                  "Drop to add inline"
                ]
              }
            ),
            o && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleAttachmentDrop,
                className: xe.attachmentDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "paperclip", size: 24, className: xe.icon }),
                  "Drop to add an attachment"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
}
const Hr = (i, t) => i.split(new RegExp(`(${Ws(t)})`, "gi")).map(
  (e, n) => e.toLowerCase() === t.toLowerCase() ? /* @__PURE__ */ s.jsx("span", { children: e }, n) : e
), mf = "h-inputRichText-emoji--emoji__root", gf = "h-inputRichText-emoji--emoji__decorator", ff = "h-inputRichText-emoji--emoji__suggestion", bf = "h-inputRichText-emoji--emoji__suggestionActive", xf = "h-inputRichText-emoji--emoji__suggestionName", Je = {
  root: mf,
  decorator: gf,
  suggestion: ff,
  suggestionActive: bf,
  suggestionName: xf
}, yf = Pi(
  () => import("./emoji-jMLUxSo3.js").then((i) => i.g).then((i) => ({
    default: i.EmojiPicker
  }))
), Vn = {};
Ai.emojis.forEach((i) => {
  i.forEach(
    (t) => {
      t.shortNames && t.shortNames.forEach((e) => {
        Vn[e.replace(/:/g, "")] = t.emoji;
      });
    }
  );
});
const _f = (i) => {
  const { active: t, item: e, match: n, onSelect: o } = i, r = n ? Hr(e, n) : e;
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: () => o(e),
      type: "button",
      "aria-current": t,
      className: f(Je.suggestion, {
        [Je.suggestionActive]: t
      }),
      children: [
        Vn[e],
        /* @__PURE__ */ s.jsx("span", { className: Je.suggestionName, children: r })
      ]
    }
  );
};
class Cf extends D {
  constructor(t) {
    super(t), this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: /(^|\s):/,
      minChars: 2,
      allowSpaces: !1,
      getSuggestions: this.getSuggestions,
      suggestionComponent: _f,
      insertContent: this.insertContent
    });
  }
  insertContent(t, e = "", n) {
    this.insertEmoji(Vn[t], e, n);
  }
  insertEmoji(t, e, n) {
    const { editor: o } = this.props, r = document.createElement("span");
    r.classList.add(Je.decorator), r.innerHTML = t, o.content.insert(r, {
      getSelection: () => {
        const a = o.selection.recreate();
        return e && a?.anchorNode && a.extend(a.anchorNode, n), a;
      }
    });
  }
  getSuggestions = (t) => Object.keys(Vn).filter((n) => n.indexOf(t) !== -1);
  // eslint-disable-next-line no-undef
  preventDefault = (t) => {
    t.preventDefault();
  };
  renderDropdown = () => /* @__PURE__ */ s.jsx(Ri, { fallback: /* @__PURE__ */ s.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ toggleDropdown: t }) => /* @__PURE__ */ s.jsx(
    yf,
    {
      onSelect: (e) => {
        this.insertEmoji(e), t();
      }
    }
  ) }) });
  render() {
    const { className: t } = this.props, e = f(
      {
        [Je.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(ae, { icon: "smile", dropdown: this.renderDropdown(), noStyle: !0, children: /* @__PURE__ */ s.jsx(
      Ft,
      {
        icon: "smile",
        title: "Emojis",
        onMouseDown: this.preventDefault
      }
    ) }) });
  }
}
const wf = "h-inputRichText--inputRichText__inputWrapper", vf = "h-inputRichText--inputRichText__root", Sf = "h-inputRichText--inputRichText__toolbar", If = "h-inputRichText--inputRichText__toolbarHint", Df = "h-inputRichText--inputRichText__toolbarHintVisible", kf = "h-inputRichText--inputRichText__toolbarHintHidden", Tf = "h-inputRichText--inputRichText__editorWrap", jf = "h-inputRichText--inputRichText__placeholder", Nf = "h-inputRichText--inputRichText__editor", Ff = "h-inputRichText--inputRichText__fileInput", Pf = "h-inputRichText--inputRichText__uiBlocker", xt = {
  inputWrapper: wf,
  root: vf,
  toolbar: Sf,
  toolbarHint: If,
  toolbarHintVisible: Df,
  toolbarHintHidden: kf,
  editorWrap: Tf,
  placeholder: jf,
  editor: Nf,
  fileInput: Ff,
  uiBlocker: Pf
}, Rf = "h-inputRichText-linkButton--linkButton__linkOpener", Ef = "h-inputRichText-linkButton--linkButton__dropdownContainer", Bo = {
  linkOpener: Rf,
  dropdownContainer: Ef
}, Lf = "h-inputRichText-linkButton--linkMenu__root", Af = "h-inputRichText-linkButton--linkMenu__field", ys = {
  root: Lf,
  field: Af
};
class $f extends D {
  constructor(t) {
    super(t);
    const { initialText: e, initialUrl: n } = t;
    this.state = {
      textValue: e,
      urlValue: n
    };
  }
  componentDidUpdate(t) {
    const { initialText: e, initialUrl: n } = this.props;
    (e !== t.initialText || n !== t.initialUrl) && this.setState({
      textValue: e,
      urlValue: n
    });
  }
  handleTextChange = (t) => {
    t && this.setState({
      textValue: t.target.value
    });
  };
  handleUrlChange = (t) => {
    t && this.setState({
      urlValue: t.target.value
    });
  };
  handleAddLink = (t) => {
    t?.preventDefault();
    const { onAddLink: e, toggleDropdown: n } = this.props, { textValue: o, urlValue: r } = this.state;
    o && r && (e(o, r), n());
  };
  handleUnlink = (t) => {
    t.preventDefault();
    const { onUnlink: e, toggleDropdown: n } = this.props;
    e(), n();
  };
  handleKeyDown = (t) => {
    t.key === "Enter" && (t.preventDefault(), this.handleAddLink());
  };
  render() {
    const {
      className: t,
      initialText: e,
      initialUrl: n,
      onAddLink: o,
      toggleDropdown: r,
      onUnlink: a,
      ...l
    } = this.props, { textValue: c, urlValue: d } = this.state, h = f({ [ys.root]: !0 }, t);
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsx(
        Ps,
        {
          label: "Link title",
          noAlert: !0,
          className: ys.field,
          input: {
            value: c,
            name: "pleasedontautofillthis",
            onChange: this.handleTextChange
          },
          onKeyDown: this.handleKeyDown
        }
      ),
      /* @__PURE__ */ s.jsx(
        Ps,
        {
          label: "Link URL",
          noAlert: !0,
          className: ys.field,
          input: {
            value: d,
            name: "link_url",
            onChange: this.handleUrlChange
          },
          onKeyDown: this.handleKeyDown,
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(O, { gap: "200", children: [
        /* @__PURE__ */ s.jsx(X, { variant: "primary", onClick: this.handleAddLink, children: "Add" }),
        !!d && /* @__PURE__ */ s.jsx(X, { variant: "secondary", onClick: this.handleUnlink, children: "Remove link" })
      ] })
    ] });
  }
}
const Bf = [
  {
    name: "hyperlink",
    label: "Link: insert",
    keybindings: ie ? [[["Control", "Meta"], "KeyK"]] : [[["Control", "Alt"], "KeyK"]]
  },
  {
    name: "removeHyperlink",
    label: "Link: remove",
    keybindings: [],
    callback: (i) => i.command.run("unlink")
  }
], Of = ({ editor: i }) => {
  const [t, e] = Ei((y) => y + 1, 0), [n, o] = $i(!1), r = Y(null), a = Y(), [
    { hoverLinkBounds: l, hoverLinkHref: c, selectedLink: d, selectedText: h },
    u
  ] = Bi({
    selectedLink: "",
    selectedText: "",
    hoverLinkHref: null,
    hoverLinkBounds: null
  });
  Ne(() => {
    i.events.onMouseOver((y) => {
      m(y);
    }), a.current = i.events.subscribe("hyperlink", () => {
      o(!0);
    }), i.selection.onUpdate(() => {
      p();
    });
  }), Qt(() => {
    a.current?.();
  });
  const p = () => {
    const y = i.selection.recreate();
    if (!y)
      return;
    const { anchorNode: C, focusNode: _ } = y;
    if (C && _ === C && C.parentElement?.nodeName === "A") {
      const { href: w, innerText: I } = C.parentElement;
      u({
        selectedLink: w,
        selectedText: I
      });
    } else
      u({
        selectedLink: "",
        selectedText: y.toString()
      });
  }, m = F(
    (y) => {
      const { target: C } = y, { current: _ } = i.ref;
      if (_ && C && C instanceof HTMLAnchorElement) {
        const w = _.getBoundingClientRect(), I = C.getBoundingClientRect();
        u({
          hoverLinkHref: C.getAttribute("href"),
          hoverLinkBounds: {
            top: I.top - w.top,
            left: I.left - w.left,
            width: I.width
          }
        });
      } else
        u({
          hoverLinkHref: null,
          hoverLinkBounds: null
        });
    },
    [i.ref, u]
  ), g = F(() => {
    const y = i.selection.recreate();
    if (!y)
      return;
    const { anchorNode: C, focusNode: _ } = y;
    if (C && C === _ && C.parentElement?.nodeName === "A") {
      const w = document.createRange();
      w.selectNodeContents(C.parentElement), y.removeAllRanges(), y.addRange(w);
    }
  }, [i.selection]), b = F(
    (y, C) => {
      C && (g(), i.command.run("insertHTML", `<a href="${C}">${y || C}</a>`), e());
    },
    [i.command, g]
  ), x = F(() => {
    g(), i.command.run("unlink");
  }, [i.command, g]), v = F((y) => {
    y.preventDefault();
  }, []);
  return _r(r, () => {
    o(!1);
  }), yr("Escape", () => {
    o(!1), g();
  }), /* @__PURE__ */ s.jsxs(Xt, { children: [
    /* @__PURE__ */ s.jsxs("div", { ref: r, className: Bo.dropdownContainer, children: [
      /* @__PURE__ */ s.jsx(
        Ft,
        {
          isActive: !!d,
          icon: "link",
          onMouseDown: v,
          onClick: () => o()
        }
      ),
      n && /* @__PURE__ */ s.jsx(Zt, { isOpen: n, children: /* @__PURE__ */ s.jsx(
        $f,
        {
          onAddLink: b,
          toggleDropdown: o,
          initialUrl: d,
          initialText: h,
          onUnlink: x
        }
      ) })
    ] }),
    !!l && !!c && /* @__PURE__ */ s.jsx(
      "a",
      {
        className: Bo.linkOpener,
        href: c,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          top: `${l.top}px`,
          left: `${l.left + l.width}px`
        },
        children: /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "external-link" })
      }
    )
  ] });
}, Hf = "h-tabs--tabs__root", Wf = "h-tabs--tabs__tabs", Mf = "h-tabs--tabs__tab", zf = "h-tabs--tabs__tabTop", Vf = "h-tabs--tabs__tabTopActive", Kf = "h-tabs--tabs__tabTopSelected", Uf = "h-tabs--tabs__tabLeft", qf = "h-tabs--tabs__tabLeftActive", Gf = "h-tabs--tabs__tabLeftSelected", Yf = "h-tabs--tabs__tabBottom", Xf = "h-tabs--tabs__tabBottomActive", Qf = "h-tabs--tabs__tabBottomSelected", Zf = "h-tabs--tabs__tabRight", Jf = "h-tabs--tabs__tabRightActive", tb = "h-tabs--tabs__tabRightSelected", eb = "h-tabs--tabs__tabDisabled", rt = {
  root: Hf,
  tabs: Wf,
  tab: Mf,
  tabTop: zf,
  tabTopActive: Vf,
  tabTopSelected: Kf,
  tabLeft: Uf,
  tabLeftActive: qf,
  tabLeftSelected: Gf,
  tabBottom: Yf,
  tabBottomActive: Xf,
  tabBottomSelected: Qf,
  tabRight: Zf,
  tabRightActive: Jf,
  tabRightSelected: tb,
  tabDisabled: eb
}, nb = 13;
class sb extends D {
  constructor(t) {
    super(t), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
  }
  handleOnClick() {
    const { id: t, onChange: e, disabled: n } = this.props;
    n || e(t);
  }
  handleOnKeyDown(t) {
    t.keyCode === nb && this.handleOnClick();
  }
  getClassName() {
    const {
      selected: t,
      placement: e,
      className: n,
      disabled: o,
      active: r,
      selectedClassName: a
    } = this.props;
    let l = f(rt.tab, n, {
      [rt.tabDisabled]: o,
      [rt.tabTop]: e === "top",
      [rt.tabRight]: e === "right",
      [rt.tabLeft]: e === "left",
      [rt.tabBottom]: e === "bottom",
      [rt.tabTopSelected]: e === "top" && t,
      [rt.tabRightSelected]: e === "right" && t,
      [rt.tabLeftSelected]: e === "left" && t,
      [rt.tabBottomSelected]: e === "bottom" && t,
      [rt.tabTopActive]: e === "top" && r,
      [rt.tabRightActive]: e === "right" && r,
      [rt.tabLeftActive]: e === "left" && r,
      [rt.tabBottomActive]: e === "bottom" && r
    });
    return a && (l = f(l, { [a]: t })), l;
  }
  render() {
    const { id: t, label: e, icon: n, disabled: o, slotEnd: r, slotStart: a } = this.props;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        role: "tab",
        className: this.getClassName(),
        onClick: this.handleOnClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: o ? -1 : 0,
        children: [
          a || !!n && /* @__PURE__ */ s.jsx(N, { name: n, className: "icon-vertical-fix" }),
          e,
          r
        ]
      },
      t
    );
  }
}
class eo extends D {
  containerRef;
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(t) {
    super(t), this.containerRef = B(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
  }
  renderTab({
    id: t,
    label: e,
    icon: n,
    disabled: o,
    slotEnd: r,
    slotStart: a
  }) {
    const {
      selectedId: l,
      activeId: c,
      onChange: d,
      tabsPlacement: h,
      tabClassName: u,
      tabSelectedClassName: p
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      sb,
      {
        selected: t === l,
        className: u,
        selectedClassName: p,
        id: t,
        label: e,
        icon: n,
        onChange: d,
        placement: h,
        disabled: o,
        active: t === c,
        slotEnd: r,
        slotStart: a
      },
      t
    );
  }
  renderTabs() {
    const { tabs: t } = this.props;
    return t.map(this.renderTab);
  }
  render() {
    const {
      className: t,
      tabClassName: e,
      tabSelectedClassName: n,
      tabs: o,
      selectedId: r,
      onChange: a,
      tabsPlacement: l,
      activeId: c,
      ...d
    } = this.props, h = f(rt.root, t);
    return /* @__PURE__ */ s.jsx("div", { ref: this.containerRef, ...d, className: h, children: /* @__PURE__ */ s.jsx("div", { className: rt.tabs, children: this.renderTabs() }) });
  }
}
const ob = an(eo, {
  fallback: null
}), rb = "h-inputRichText-quickResponseSelector--quickResponseItem__root", ib = "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive", ab = "h-inputRichText-quickResponseSelector--quickResponseItem__name", Ve = {
  root: rb,
  rootActive: ib,
  name: ab
};
class _s extends D {
  constructor(t) {
    super(t), this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect() {
    const { isLoading: t, onSelect: e, item: n } = this.props;
    t || e(n);
  }
  render() {
    const {
      className: t,
      item: e,
      isLoading: n,
      onSelect: o,
      active: r,
      searchValue: a,
      clearSearch: l,
      ...c
    } = this.props, { name: d, content: h, matched: u } = !n && e ? e : {
      name: "Loading...",
      content: "",
      matched: ""
    }, p = f(
      {
        [Ve.root]: Ve.root,
        [Ve.rootActive]: r
      },
      t
    ), m = u ? Hr(d, u) : d;
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        "aria-current": r,
        ...c,
        className: p,
        onClick: this.handleSelect,
        title: d,
        children: [
          /* @__PURE__ */ s.jsx(L.Heading, { variant: "heading-3", className: Ve.name, children: m }),
          /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "4", className: Ve.name, subdued: !0, children: h })
        ]
      }
    );
  }
}
const lb = "h-inputRichText-quickResponseSelector--quickResponseSelector__container", cb = "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer", db = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown", hb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs", ub = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent", pb = "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown", ye = {
  container: lb,
  dropdownButtonContainer: cb,
  tabbedDropdown: db,
  tabbedDropdownTabs: hb,
  tabbedDropdownTabsContent: ub,
  regularDropdown: pb
}, Oo = /(^|\s)=/, Ho = "Quick responses";
class mb extends _t {
  constructor(t) {
    super(t), this.state = {
      searchTerm: "",
      selectedTab: t.languages[0]?.code
    }, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: Oo,
      minChars: 0,
      allowSpaces: !0,
      getSuggestions: this.handleSearchChange,
      suggestionComponent: _s,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }
  normalizeSuggestion(t) {
    const { quickResponsesApi: e } = this.props;
    return {
      id: t.name,
      matched: e.params.search ?? "",
      ...t
    };
  }
  getTabDefinitions() {
    const { languages: t } = this.props;
    return t.map((e) => ({
      id: e.code,
      label: e.label
    }));
  }
  handleNextPage() {
    const { quickResponsesApi: t } = this.props;
    return new Promise((e) => t.getItemsAsyncStatus === "loading" ? e(t.items.map(this.normalizeSuggestion)) : e(
      t.nextPage().then((n) => n.map(this.normalizeSuggestion)).catch((n) => {
        console.error(n);
      })
    ));
  }
  preventDefault = (t) => {
    t.preventDefault();
  };
  handleSelect = (t, e) => {
    this.insertContent(t)?.then(() => {
      e && e();
    });
  };
  insertContent = (t, e, n) => {
    const { renderQuickResponse: o, sanitize: r, editor: a } = this.props;
    return o(t).then((l) => {
      const c = a.selection.recreate();
      if (!c)
        return;
      const d = !!e, h = d && !!c.anchorNode?.textContent?.match(
        `^${Oo.source}`
      ) || !d && !c.anchorNode?.textContent;
      let u;
      h ? u = to(
        zn(r(l), { inline: !1 })
      ) : u = zn(r(l), { inline: !0 }), c?.rangeCount && c?.rangeCount > 0 && a.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        c.getRangeAt(0).createContextualFragment(u),
        {
          getSelection: () => {
            const p = a.selection.recreate();
            return d && p?.anchorNode && p.extend(p.anchorNode, n), p;
          }
        }
      );
    });
  };
  handleToggle(t) {
    const { quickResponsesApi: e, languages: n } = this.props;
    t && (e.params.search !== "" || e.params.locale !== n[0]?.code) && this.setState({ searchTerm: "", selectedTab: n[0]?.code }, () => {
      const { searchTerm: o, selectedTab: r } = this.state;
      this.handleSearchChange(o, r, 0);
    });
  }
  getPagination() {
    const { quickResponsesApi: t } = this.props;
    return {
      nextEnable: t.hasNextPage,
      previousEnable: !1,
      infinite: !0,
      onNext: this.handleNextPage
    };
  }
  handleSearchChange(t, e, n) {
    const { quickResponsesApi: o } = this.props;
    return o.paramsChange({ search: t, locale: e }, n).then((r) => r.map(this.normalizeSuggestion));
  }
  handleTabbedSearchChange(t) {
    this.setState({ searchTerm: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n);
    });
  }
  handleTabChange(t) {
    this.setState({ selectedTab: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n, 0);
    });
  }
  renderIcon() {
    return /* @__PURE__ */ s.jsx(
      Ft,
      {
        icon: this.props.iconName ?? "bolt",
        title: Ho,
        onMouseDown: this.preventDefault
      }
    );
  }
  renderItemsWithoutTabs() {
    const { className: t, quickResponsesApi: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      Zs,
      {
        className: t,
        dropdownProps: {
          className: ye.regularDropdown
        },
        containerProps: { className: ye.container },
        items: e.items.map(this.normalizeSuggestion),
        pagination: this.getPagination(),
        itemComponent: _s,
        hasSearch: !0,
        noStyle: !0,
        onSearch: this.handleSearchChange,
        onSelect: this.handleSelect,
        onToggle: this.handleToggle,
        emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
        children: this.renderIcon()
      }
    );
  }
  renderItemsWithTabs() {
    const { className: t } = this.props, { selectedTab: e } = this.state;
    return /* @__PURE__ */ s.jsx("div", { className: ye.dropdownButtonContainer, children: /* @__PURE__ */ s.jsx(
      ae,
      {
        className: t,
        noStyle: !0,
        onToggle: this.handleToggle,
        buttonProps: { title: Ho },
        dropdown: /* @__PURE__ */ s.jsxs("div", { className: ye.tabbedDropdown, children: [
          /* @__PURE__ */ s.jsx(
            eo,
            {
              className: ye.tabbedDropdownTabs,
              tabs: this.getTabDefinitions(),
              tabsPlacement: "left",
              selectedId: e,
              onChange: this.handleTabChange
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: ye.tabbedDropdownTabsContent, children: this.renderTabItems() })
        ] }),
        children: this.renderIcon()
      }
    ) });
  }
  renderTabItems() {
    const { quickResponsesApi: t } = this.props;
    return /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ dropdownOpen: e, closeDropdown: n }) => /* @__PURE__ */ s.jsx(
      Br,
      {
        dropdownOpen: e,
        triggerClose: n,
        hasSearch: !0,
        pagination: this.getPagination(),
        items: t.items.map(this.normalizeSuggestion),
        itemComponent: _s,
        onSearch: this.handleTabbedSearchChange,
        onSelect: (o) => this.handleSelect(o, n),
        emptyComponent: hn,
        emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
      }
    ) });
  }
  render() {
    const { languages: t } = this.props;
    return t?.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
  }
}
const gb = "h-inputRichText-formatSelector--formatSelector__root", fb = "h-inputRichText-formatSelector--formatSelector__list", bb = "h-inputRichText-formatSelector--formatSelector__selector", xb = "h-inputRichText-formatSelector--formatSelector__option", yb = "h-inputRichText-formatSelector--formatSelector__optionActive", _b = "h-inputRichText-formatSelector--formatSelector__button", _e = {
  root: gb,
  list: fb,
  selector: bb,
  option: xb,
  optionActive: yb,
  button: _b
}, Ls = [
  {
    name: "noHeading",
    label: "Normal",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "div"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h1",
    label: "Headline 1",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H1>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h2",
    label: "Headline 2",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H2>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h3",
    label: "Headline 3",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H3>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h4",
    label: "Headline 4",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H4>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h5",
    label: "Headline 5",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H5>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "quote",
    label: "Blockquote",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<BLOCKQUOTE>"),
    condition: (i) => i.allowFormatting.includes("format")
  }
], Wo = {
  h1: { tag: "<H1>" },
  h2: { tag: "<H2>" },
  h3: { tag: "<H3>" },
  h4: { tag: "<H4>" },
  h5: { tag: "<H5>" },
  noHeading: { default: !0, tag: "div" },
  quote: { tag: "<BLOCKQUOTE>" }
};
class Cb extends D {
  preventDefault = (t) => {
    t.preventDefault();
  };
  renderDropdown() {
    const { editor: t } = this.props;
    return /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ closeDropdown: e }) => /* @__PURE__ */ s.jsx("ul", { className: _e.list, children: Ls.map((n) => {
      const o = "condition" in n;
      if (!(!o || o && n.condition(t)))
        return;
      const a = Wo[n.name];
      return /* @__PURE__ */ s.jsx(
        "li",
        {
          className: f(_e.option, {
            [_e.optionActive]: this.isActiveFormat(a)
          }),
          children: /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              className: _e.button,
              onClick: () => {
                n.callback?.(t), e();
              },
              children: n.label
            }
          )
        },
        n.name
      );
    }).filter(Boolean) }) });
  }
  isActiveFormat(t) {
    const { formatBlock: e } = this.props;
    return !!(!e && t.default || t.tag === e || t.tag === `<${e.toUpperCase()}>`);
  }
  getCurrentFormatName() {
    return Ls.find(
      (t) => this.isActiveFormat(Wo[t.name])
    )?.label ?? "Normal";
  }
  render() {
    const { className: t, editor: e, formatBlock: n, ...o } = this.props, r = f(_e.root, t);
    return /* @__PURE__ */ s.jsx(
      ae,
      {
        className: r,
        ...o,
        dropdown: this.renderDropdown(),
        noStyle: !0,
        children: /* @__PURE__ */ s.jsxs("div", { className: _e.selector, children: [
          this.getCurrentFormatName(),
          /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "angle-down" })
        ] })
      }
    );
  }
}
const wb = "h-inputRichText-stylingMenu--stylingMenu__menu", vb = "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer", Mo = {
  menu: wb,
  buttonsContainer: vb
}, Wr = [
  {
    name: "bold",
    label: "Bold",
    icon: "bold",
    keybindings: [[["$metaOrCtrl"], "KeyB"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
    callback: (i) => i.command.run("bold"),
    condition: (i) => i.allowFormatting.includes("bold")
  },
  {
    name: "italic",
    label: "Italic",
    icon: "italic",
    keybindings: [[["$metaOrCtrl"], "KeyI"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
    callback: (i) => i.command.run("italic"),
    condition: (i) => i.allowFormatting.includes("italic")
  },
  {
    name: "orderedList",
    label: "List: ordered",
    icon: "list-ol",
    keybindings: ie ? [[["Control", "Meta"], "Digit7"]] : [[["Control", "Alt"], "Digit7"]],
    callback: (i) => i.command.run("insertOrderedList"),
    condition: (i) => i.allowFormatting.includes("orderedList")
  },
  {
    name: "unorderedList",
    label: "List: unordered",
    icon: "list-ul",
    keybindings: ie ? [[["Control", "Meta"], "Digit8"]] : [[["Control", "Alt"], "Digit8"]],
    callback: (i) => i.command.run("insertUnorderedList"),
    condition: (i) => i.allowFormatting.includes("unorderedList")
  },
  {
    name: "noFormat",
    label: "Clear formatting",
    icon: "pen-slash",
    keybindings: [],
    callback: (i) => i.command.run("removeFormat")
  }
], Mr = [...Ls, ...Wr];
class Sb extends D {
  domRef;
  constructor(t) {
    super(t), this.state = {
      isOpen: !1,
      currentFormat: ""
    }, this.domRef = B(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(() => {
      this.updateCurrentFormat();
    });
  }
  componentDidUpdate(t, e) {
    const { isOpen: n } = this.state, { editorWindow: o } = this.props;
    n !== e.isOpen && o[n ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutside,
      !0
    );
  }
  componentWillUnmount() {
    const { isOpen: t } = this.state, { editorWindow: e } = this.props;
    t && e.removeEventListener("click", this.handleClickOutside, !0);
  }
  updateCurrentFormat() {
    const { editorWindow: t } = this.props;
    this.setState({
      currentFormat: Eg(t)
    });
  }
  handleClickOutside = (t) => {
    const { current: e } = this.domRef;
    e && t.target instanceof Element && t.target !== e && !e.contains(t.target) && this.setState({
      isOpen: !1
    });
  };
  handleClick = (t) => {
    t.preventDefault();
    const { isOpen: e } = this.state;
    this.setState({
      isOpen: !e
    });
  };
  handleToolbarButtonClick(t) {
    return (e) => {
      const { editor: n } = this.props;
      e.preventDefault(), t && (Mr.find(
        (r) => r.name === t
      )?.callback(n), this.forceUpdate());
    };
  }
  styleActive(t) {
    const { editor: e } = this.props;
    return e.command.active(t);
  }
  render() {
    const { className: t, isActive: e, editor: n, editorWindow: o, ...r } = this.props, { isOpen: a, currentFormat: l } = this.state, c = f(t);
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: c, ref: this.domRef, children: [
      a && /* @__PURE__ */ s.jsxs("div", { className: Mo.menu, children: [
        n.allowFormatting.includes("format") && /* @__PURE__ */ s.jsx(
          Cb,
          {
            formatBlock: l,
            editor: this.props.editor
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: Mo.buttonsContainer, children: Wr.map((d) => {
          const h = "condition" in d;
          if (!h || h && d.condition(n))
            return /* @__PURE__ */ s.jsx(
              Ft,
              {
                isActive: this.styleActive(d.name),
                onMouseDown: this.handleToolbarButtonClick(d.name),
                icon: d.icon
              },
              d.name
            );
        }).filter(Boolean) })
      ] }),
      /* @__PURE__ */ s.jsx(
        Ft,
        {
          isActive: e,
          icon: "format",
          onClick: this.handleClick
        }
      )
    ] });
  }
}
const Ib = "h-inputRichText-suggestions--suggestions__dropdown", Db = "h-inputRichText-suggestions--suggestions__dropdownWithTabs", kb = "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs", Tb = "h-inputRichText-suggestions--suggestions__dropdownTabs", jb = "h-inputRichText-suggestions--suggestions__dropdownTabsContent", Ke = {
  dropdown: Ib,
  dropdownWithTabs: Db,
  dropdownWithoutTabs: kb,
  dropdownTabs: Tb,
  dropdownTabsContent: jb
};
function Nb(i) {
  if (!i)
    return null;
  const { focusOffset: t, anchorOffset: e, anchorNode: n } = i;
  return t !== e || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, t);
}
class Fb extends D {
  dropdownRef;
  tabsRef;
  constructor(t) {
    super(t), this.state = {
      listenForSelectionChange: !0,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: "",
      selectedTab: null,
      selectionMode: "suggestion",
      tabIndex: 0
    }, this.dropdownRef = B(), this.tabsRef = B(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(this.handleSelectionChange), t.events.onBlur(this.handleBlur), t.hotkeys.add([
      {
        keybindings: [[[], "ArrowUp"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(-1)
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(1)
      },
      {
        keybindings: [[[], "Escape"]],
        condition: () => this.hasSuggestions() || this.hasTabs(),
        callback: (e, n) => this.handleEscapeKey(n)
      },
      {
        keybindings: [[[], "Enter"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleEnterKey()
      }
    ]);
  }
  componentDidUpdate(t, e) {
    const { suggestionIndex: n, tabIndex: o } = this.state;
    n !== e.suggestionIndex && this.updateSuggestionScroll(), o !== e.tabIndex && this.updateTabScroll();
  }
  shouldHandleKey() {
    const { selectionMode: t } = this.state;
    return t === "suggestion" && this.hasSuggestions() || t === "tab" && this.hasTabs();
  }
  handleArrowKey(t) {
    const { selectionMode: e } = this.state;
    e === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(t) : e === "tab" && this.hasTabs() && this.tabsNavigate(t);
  }
  handleEscapeKey(t) {
    const { selectionMode: e } = this.state;
    this.shouldRenderDropdown() && t.stopPropagation(), e === "suggestion" && this.hasTabs() ? this.setState({
      selectionMode: "tab",
      tabIndex: this.getSelectedTabIndex()
    }) : this.clearSuggestions();
  }
  handleEnterKey() {
    const { selectionMode: t, tabIndex: e, suggestionTrigger: n } = this.state;
    if (t === "suggestion" && this.hasSuggestions())
      this.expandSuggestion();
    else if (t === "tab" && this.hasTabs()) {
      const o = n?.getTabs?.()[e];
      o && this.handleTabChange(o.id);
    }
  }
  handleBlur(t) {
    const {
      nativeEvent: { relatedTarget: e }
    } = t;
    e === null && this.clearSuggestions();
  }
  hasSuggestions() {
    const { suggestions: t } = this.state;
    return !!t?.length;
  }
  hasTabs() {
    return !!this.state.suggestionTrigger?.getTabs?.().length;
  }
  getSelectedTabIndex() {
    const { suggestionTrigger: t, selectedTab: e } = this.state;
    return this.hasTabs() ? t?.getTabs?.().findIndex((n) => n.id === e) : -1;
  }
  clearSuggestions() {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: "suggestion"
    });
  }
  suggestionsNavigate(t) {
    this.setState(({ suggestionIndex: e, suggestions: n }) => {
      if (n && n.length) {
        let o;
        return t < 0 ? o = e > 0 ? e - 1 : n.length - 1 : o = (e + 1) % n.length, {
          suggestionIndex: o
        };
      }
      return null;
    });
  }
  tabsNavigate(t) {
    this.setState(({ tabIndex: e, suggestionTrigger: n }) => {
      const o = n?.getTabs?.();
      if (o?.length) {
        let r;
        return t < 0 ? r = e > 0 ? e - 1 : o.length - 1 : r = (e + 1) % o.length, {
          tabIndex: r
        };
      }
      return null;
    });
  }
  lookForTriggers(t, e) {
    const { editor: n } = this.props, { selectedTab: o, selectionMode: r } = this.state, a = Nb(n.selection.recreate());
    if (a) {
      const l = n.triggers.test(a);
      if (l && n.triggers.isSuggestionTrigger(l.matchedTrigger)) {
        const { match: c, matchedTrigger: d } = l, h = d?.getTabs?.();
        if (h?.length) {
          let p = null;
          if (t ? p = {
            selectionMode: "suggestion",
            selectedTab: t,
            tabIndex: -1
          } : o ? t = o : p = {
            selectionMode: "tab",
            selectedTab: h[0].id,
            tabIndex: 0
          }, p && this.setState(p, () => {
            t || this.lookForTriggers();
          }), !t)
            return;
        } else r !== "suggestion" && this.setState({ selectionMode: "suggestion" });
        Promise.resolve(
          d.getSuggestions(c[1], t, e)
        ).then((p) => {
          this.updateSuggestions(c, d, p);
        });
        return;
      }
    }
    this.clearSuggestions();
  }
  findTriggerPosition(t, e) {
    this.setState(
      {
        listenForSelectionChange: !1
      },
      () => {
        const { onError: n, editor: o } = this.props, r = o.selection.recreate();
        if (r) {
          const { focusOffset: a, anchorNode: l } = r;
          if (l) {
            if (a - t >= 0)
              try {
                r.extend(l, a - t);
              } catch (c) {
                n?.(c);
              }
            if (r?.rangeCount && r?.rangeCount > 0) {
              const c = r.getRangeAt(0).getBoundingClientRect();
              r.collapseToEnd(), setTimeout(() => {
                e(c), this.setState({
                  listenForSelectionChange: !0
                });
              });
            }
          }
        }
      }
    );
  }
  updateSuggestions(t, e, n) {
    const { editor: o } = this.props;
    this.findTriggerPosition(t[0].length, (r) => {
      const a = o.selection.recreate();
      if (!a)
        return;
      const { focusOffset: l } = a, h = new RegExp(e.trigger).exec(t[0])?.[1]?.length ?? 0, u = t[0].length - h;
      this.setState({
        suggestions: n,
        suggestionTrigger: e,
        suggestionPosition: r,
        suggestionIndex: 0,
        suggestionMatchedString: t[1],
        suggestionExtendBy: l - u,
        listenForSelectionChange: !0
      });
    });
  }
  updateSuggestionScroll() {
    const { suggestionIndex: t } = this.state, { current: e } = this.dropdownRef;
    if (e) {
      if (e.infiniteListRef.current)
        e.infiniteListRef.current.scrollToItem(t);
      else if (e.listRef.current) {
        const n = e.listRef.current, r = e.listRef.current.children[t].getBoundingClientRect(), a = n.getBoundingClientRect();
        a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
      }
    }
  }
  updateTabScroll() {
    const { tabIndex: t } = this.state, { current: e } = this.tabsRef;
    if (!(t < 0 || !e) && e.containerRef.current) {
      const n = e.containerRef.current, r = e.containerRef.current.children[0].children[t].getBoundingClientRect(), a = n.getBoundingClientRect();
      a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
    }
  }
  expandSuggestion() {
    const {
      suggestions: t,
      suggestionIndex: e,
      suggestionExtendBy: n,
      suggestionTrigger: o
    } = this.state;
    if (!(!t || !t[e] || !o))
      return o.insertContent(
        t[e],
        o.trigger,
        n
      );
  }
  handleSelectionChange() {
    const { listenForSelectionChange: t } = this.state;
    t && this.lookForTriggers();
  }
  handleSuggestionClick(t) {
    this.setState(
      (e) => ({
        suggestionIndex: e.suggestions ? e.suggestions.indexOf(t) : 0
      }),
      () => {
        this.expandSuggestion();
      }
    );
  }
  calculateSuggestionBoxPosition() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        bottom: n.bottom - t.bottom + t.height,
        left: t.x - n.x + t.width
      };
    }
    return {};
  }
  suggestionBoxStyle() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        left: `${t.x - n.x}px`,
        top: `${t.y - n.y + t.height / 2}px`,
        //`${suggestionPosition.x}px`,
        height: 1,
        width: t.width,
        position: "absolute"
      };
    }
    return {};
  }
  getPagination() {
    const { suggestionTrigger: t } = this.state;
    if (!t || !t.getPagination)
      return !1;
    const e = t.getPagination();
    return !e || !e.onNext ? !1 : {
      ...e,
      onNext: () => e.onNext?.().then((n) => {
        this.setState({ suggestions: n });
      }) ?? Promise.resolve(void 0)
    };
  }
  handleTabChange(t) {
    this.lookForTriggers(t, 0);
  }
  renderEmptyState() {
    return /* @__PURE__ */ s.jsx(hn, { label: "No suggestions found" });
  }
  renderTabs() {
    const { suggestions: t, suggestionTrigger: e, selectedTab: n, tabIndex: o } = this.state, r = e?.getTabs?.() ?? [], a = !!t?.length;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        eo,
        {
          ref: this.tabsRef,
          className: Ke.dropdownTabs,
          tabs: r,
          tabsPlacement: "left",
          selectedId: n,
          activeId: r?.[o]?.id,
          onChange: this.handleTabChange
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: Ke.dropdownTabsContent, children: a ? this.renderItems() : this.renderEmptyState() })
    ] });
  }
  renderItems() {
    const { suggestions: t, suggestionIndex: e, suggestionTrigger: n, selectionMode: o } = this.state, r = n ? n.suggestionComponent : null;
    return /* @__PURE__ */ s.jsx(
      Gs,
      {
        ref: this.dropdownRef,
        pagination: this.getPagination(),
        items: t || void 0,
        onSelect: this.handleSuggestionClick,
        itemComponent: r,
        activeItem: o === "suggestion" ? t?.[e] : void 0
      }
    );
  }
  shouldRenderDropdown() {
    const { suggestionPosition: t, selectedTab: e, suggestions: n } = this.state;
    return !(!t || !this.hasTabs() && !n?.length || this.hasTabs() && !e);
  }
  render() {
    const { editor: t, onError: e, ...n } = this.props;
    if (!this.shouldRenderDropdown())
      return null;
    const o = f(Ke.dropdown, {
      [Ke.dropdownWithTabs]: this.hasTabs(),
      [Ke.dropdownWithoutTabs]: !this.hasTabs()
    });
    return /* @__PURE__ */ s.jsx("div", { ...n, children: /* @__PURE__ */ s.jsx("div", { style: this.suggestionBoxStyle(), children: /* @__PURE__ */ s.jsx(Zt, { className: o, isOpen: !0, children: this.hasTabs() ? this.renderTabs() : this.renderItems() }) }) });
  }
}
function zo(i) {
  return i instanceof RegExp ? i.source : i;
}
function Pb(i) {
  return i.replace(/\(/g, "(?:");
}
class zr {
  storedTriggers;
  constructor() {
    this.storedTriggers = [];
  }
  get excludeTriggersRegex() {
    return this.storedTriggers.map(
      (t) => `(?!${zo(t.trigger)})`
    ).join("");
  }
  add(t) {
    this.storedTriggers.push(t);
  }
  update(t) {
    const e = this.storedTriggers.findIndex(
      (n) => this.isAddonTrigger(n) && n.id === t.id
    );
    e !== -1 && (this.storedTriggers[e] = t);
  }
  test(t) {
    let e;
    for (let n = 0; n < this.storedTriggers.length; n += 1) {
      const o = this.storedTriggers[n], { trigger: r, allowSpaces: a, minChars: l } = o, c = Pb(
        zo(r)
      ), d = this.excludeTriggersRegex, h = a ? "." : "\\S";
      if (e = new RegExp(`${c}((?:${d}${h})*)$`, "g").exec(t), e && (!l || e[1].length >= l))
        return {
          match: e,
          matchedTrigger: o
        };
    }
    return null;
  }
  isSuggestionTrigger(t) {
    return "getSuggestions" in t;
  }
  isAddonTrigger(t) {
    return !this.isSuggestionTrigger(t);
  }
}
const In = 25;
let It = null, re = null;
function Rb(i, t) {
  const e = t.document.createElement("div");
  return e.className = `image-resize-handle image-resize-handle-${i}`, e.dataset.handle = i, e;
}
function Eb(i, t) {
  const e = t.document.createElement("div");
  return e.className = "image-resize-wrapper", e.contentEditable = "false", i.parentNode?.insertBefore(e, i), e.appendChild(i), ["nw", "ne", "se", "sw"].forEach((o) => {
    const r = Rb(o, t);
    e.appendChild(r);
  }), e;
}
function Vr(i) {
  const t = i.querySelector("img");
  t && i.parentNode && (i.parentNode.insertBefore(t, i), i.remove());
}
function Lb(i, t, e) {
  const { startX: n, startWidth: o, handle: r, aspectRatio: a } = i, l = t - n;
  let c = o;
  switch (r) {
    case "se":
    case "ne":
      c = o + l;
      break;
    case "sw":
    case "nw":
      c = o - l;
      break;
  }
  let d = c / a;
  c < In && (c = In, d = In / a);
  const h = In / a;
  return d < h && (d = h, c = h * a), { width: c, height: d };
}
function no(i) {
  if (!It) return;
  i.preventDefault(), i.stopPropagation();
  const { width: t } = Lb(
    It,
    i.clientX,
    i.clientY
  );
  It.img.style.width = `${t}px`, It.img.style.height = "auto";
}
function so(i) {
  if (!It) return;
  i.preventDefault(), i.stopPropagation();
  const { img: t } = It, e = t.ownerDocument.defaultView;
  e.document.removeEventListener("mousemove", no), e.document.removeEventListener("mouseup", so), It = null;
  const n = new Event("input", { bubbles: !0 });
  t.closest('[contenteditable="true"]')?.dispatchEvent(n);
}
function Ab(i, t, e) {
  i.preventDefault(), i.stopPropagation();
  const n = t.ownerDocument.defaultView, o = t.closest(".image-resize-wrapper");
  if (!o) return;
  const r = t.naturalWidth, a = t.naturalHeight, l = r / a, c = t.getBoundingClientRect(), d = c.width, h = c.height;
  It = {
    img: t,
    originalWidth: r,
    originalHeight: a,
    aspectRatio: l,
    startX: i.clientX,
    startY: i.clientY,
    startWidth: d,
    startHeight: h,
    handle: e,
    wrapper: o
  }, n.document.addEventListener("mousemove", no), n.document.addEventListener("mouseup", so);
}
function $b(i, t) {
  re && (Vr(re), re = null);
  const e = Eb(i, t);
  re = e, e.querySelectorAll(".image-resize-handle").forEach((o) => {
    const r = o.dataset.handle;
    o.addEventListener(
      "mousedown",
      (a) => Ab(a, i, r)
    );
  });
}
function Cs() {
  if (re && (Vr(re), re = null), It) {
    const i = It.img.ownerDocument.defaultView;
    i.document.removeEventListener("mousemove", no), i.document.removeEventListener("mouseup", so), It = null;
  }
}
function Bb(i) {
  return i ? i.classList.contains("image-resize-wrapper") || i.classList.contains("image-resize-handle") || i.closest(".image-resize-wrapper") !== null : !1;
}
function Vo(i) {
  if (!i) return i;
  const n = new DOMParser().parseFromString(`<div>${i}</div>`, "text/html").body.firstChild;
  return n ? (n.querySelectorAll(".image-resize-wrapper").forEach((r) => {
    const a = r.querySelector("img");
    a && r.parentNode && (r.parentNode.insertBefore(a, r), r.remove());
  }), n.innerHTML) : i;
}
const Kr = "input-rich-text-editor", Ob = [
  {
    name: "insertInlineAttachment",
    label: "Insert inline image",
    keybindings: ie ? [[["Control", "Meta"], "KeyM"]] : [[["Control"], "KeyM"]]
  }
], Ko = [
  ...Ob,
  ...Mr,
  ...Bf,
  ...rf
], Hb = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, Wb = Ot({
  command: {
    run: E,
    active: () => !1
  },
  content: {
    insert: E,
    setUiBlocker: E
  },
  hotkeys: {
    add: E,
    updateKeybindings: E
  },
  selection: {
    recreate: () => null,
    getRange: () => null,
    isWithinEditor: () => !1,
    onUpdate: E
  },
  events: {
    subscribe: () => E,
    publish: E,
    onMouseOver: E,
    onBlur: E
  },
  allowFormatting: [],
  triggers: new zr(),
  ref: B(),
  window,
  history: {
    canUndo: () => !1,
    undo: E,
    takeSnapshot: E,
    reset: E
  }
});
class oo extends D {
  editor;
  editorRef;
  currentSuggestionRef;
  fileInputRef;
  attachmentDropdownButtonRef;
  unsubscribeInlineAttachment;
  isInserting;
  contentInsertionQueue;
  /**
   * Button that can be used in `toolbarAddons` to have same styles as the
   * buitlin buttons.
   */
  static ToolbarButton = Ft;
  /** Context containing props and methods to interact with the editor. */
  static Context = Wb;
  static defaultProps = {
    allowAttachments: !1,
    allowInlineAttachments: !1,
    allowEmoji: !0,
    languages: [],
    onTriggerSend() {
      console.warn("InputRichText: onTriggerSend callback missing in props");
    },
    onToggleSendOnEnter: E,
    sendOnEnter: !1,
    editorWindow: window,
    onMount: E,
    onUnmount: E,
    disabled: !1,
    hasAutocompleteSuggestionsFeature: !1
  };
  constructor(t) {
    super(t), this.editorRef = B(), this.currentSuggestionRef = B(), this.fileInputRef = B(), this.attachmentDropdownButtonRef = B(), this.unsubscribeInlineAttachment = E, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
      keyDownHandled: !1,
      keyCommands: Ko,
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: "",
      lastSelection: null,
      hasFocus: !1,
      selectedText: "",
      selectedLink: "",
      showHint: !1,
      pubsub: {},
      uiBlocker: t.uiBlocker,
      undoStack: []
    }, this.editor = {
      command: {
        run: this.commandRun.bind(this),
        active: this.commandActive.bind(this)
      },
      content: {
        insert: this.insertContent.bind(this),
        setUiBlocker: this.setUiBlocker.bind(this)
      },
      hotkeys: {
        add: this.addKeyCommands.bind(this),
        updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
      },
      selection: {
        onUpdate: this.addSelectionUpdateListener.bind(this),
        recreate: this.recreateSelection.bind(this),
        getRange: this.getSelectionRange.bind(this),
        isWithinEditor: this.isSelectionWithinEditor.bind(this)
      },
      events: {
        onMouseOver: this.addMouseOverListener.bind(this),
        onBlur: this.addBlurListener.bind(this),
        subscribe: this.subscribe.bind(this),
        publish: this.publish.bind(this)
      },
      allowFormatting: this.getAllowedFormattingOptions(),
      triggers: new zr(),
      ref: this.editorRef,
      window: this.props.editorWindow ?? window,
      history: {
        undo: this.undo,
        canUndo: this.canUndo,
        reset: this.resetUndoStack,
        takeSnapshot: this.addCurrentContentToUndoStack
      }
    };
  }
  componentDidMount() {
    const { editorWindow: t = window, onMount: e } = this.props;
    t.document.execCommand(
      "defaultParagraphSeparator",
      !1,
      "div"
    );
    const { value: n } = this.props;
    n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe(
      "insertInlineAttachment",
      () => {
        this.props.allowInlineAttachments && this.openFileBrowser();
      }
    ), e(), this.updateKeyCommandsKeybindings(this.props.keybindings);
  }
  componentDidUpdate(t) {
    const { fileUploadStatuses: e, autocomplete: n, keybindings: o, uiBlocker: r } = this.props, { current: a } = this.editorRef;
    e && e !== t.fileUploadStatuses && a && (Object.keys(e).forEach((l) => {
      this.updateFileLoader(l, e[l]);
    }), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== t.autocomplete?.showAutocompleteSuggestions && this.setState({ showHint: !0 }, () => {
      setTimeout(() => {
        this.setState({ showHint: !1 });
      }, 1e3);
    }), fr(t.keybindings, o) || this.updateKeyCommandsKeybindings(o), t.uiBlocker !== r && this.setUiBlocker(r);
  }
  componentWillUnmount() {
    const { onUnmount: t } = this.props;
    this.unsubscribeInlineAttachment?.(), Cs(), t(this.getSanitizedHtml());
  }
  getCommandsWithInputKeybindings() {
    const { keybindings: t } = this.props;
    return Ko.map((e) => ({
      ...e,
      keybindings: t && e.name ? t[e.name] ?? [] : e.keybindings
    }));
  }
  subscribe(t, e) {
    return this.setState((n) => ({
      pubsub: {
        ...n.pubsub,
        [t]: [...n.pubsub[t] ?? [], e]
      }
    })), () => {
      this.setState((n) => xr(n, t));
    };
  }
  publish(t) {
    this.state.pubsub[t]?.forEach((e) => e(this.editor));
  }
  /**
   * The core update function, that triggers every time the selection is
   * changed, which will also trigger when the contents change.
   *
   * This method handles calling onChange prop.
   *
   * @returns {void | undefined} Description
   * @todo Test if onInput would be a better way of triggering onChange
   */
  handleSelectionChange = () => {
    const { onChange: t, onSelectionChange: e } = this.props, { htmlOld: n, selectionUpdateListeners: o } = this.state, { current: r } = this.editorRef;
    if (r) {
      this.forceUpdate();
      const a = this.extractEditorContent();
      a !== n && (this.setState({
        htmlOld: a
      }), t(a));
    }
    o.forEach((a) => {
      a();
    }), e && e();
  };
  /** Handle any mouse over events on the editor */
  handleMouseOver = (t) => {
    const { mouseOverListeners: e } = this.state;
    e.forEach((n) => {
      n(t);
    });
  };
  /** Handle click events on the editor to select images */
  handleEditorClick = (t) => {
    const e = t.target, { editorWindow: n = window } = this.props;
    if (Mn(e) && e.tagName === "IMG") {
      t.preventDefault();
      const o = n.getSelection();
      if (o) {
        const r = n.document.createRange();
        r.selectNode(e), o.removeAllRanges(), o.addRange(r), this.handleSelectionChange();
      }
      $b(e, n);
    } else Bb(e) || Cs();
  };
  /** Handle blur events on the editor */
  handleBlurListeners = (t) => {
    const { blurListeners: e } = this.state;
    e.forEach(
      (n) => {
        n(t);
      }
    );
  };
  handleKeyDown = (t) => {
    if (t.getModifierState(t.key))
      return;
    const { keyCommands: e } = this.state, { sendOnEnter: n, onKeyDown: o } = this.props;
    if (o?.(t), e.some(
      ({ preventDefaultKeybinding: a }) => a && fs(a, t)
    ) && t.preventDefault(), e.some(
      ({ name: a, keybindings: l, condition: c, callback: d }) => {
        if (fs(l, t) && (c === void 0 || c(this.editor)))
          return d?.(this.editor, t), a && this.editor.events.publish(a), !0;
      }
    )) {
      this.setKeyDownHandled(t);
      return;
    }
    if (fs([[["$metaOrCtrl"], "Enter"]], t)) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(t), a();
    } else if (t.key === "Enter" && n && !t.shiftKey) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(t), a();
    }
    return null;
  };
  getBlockLevelParent = (t) => {
    const { editorWindow: e = window } = this.props;
    let n = Mn(t) ? t : t.parentElement;
    for (; !Js(n, e); )
      n = n.parentElement;
    return n;
  };
  // Insert actual text direction into the html
  onInput = (t) => {
    const { current: e } = this.editorRef, n = t?.nativeEvent;
    if (!n)
      return;
    this.resetUndoStack();
    const { inputType: o } = n;
    if (o === "insertFromPaste" || !o) {
      Lo(e), Ag(e);
      return;
    }
    const a = document.getSelection()?.anchorNode;
    if (o === "insertText" && a && a.textContent?.length === 1) {
      const l = this.getBlockLevelParent(a);
      if (
        // if the parent element is `ol` or `ul`, and if it has direction, do not change it
        (l.tagName === "UL" || l.tagName === "OL") && l.hasAttribute("dir")
      )
        return;
      l.setAttribute("dir", "auto");
      const c = window.getComputedStyle(l).direction;
      l.setAttribute("dir", c), l.style.textAlign = "";
    }
  };
  handleKeyUp = () => {
    const { keyDownHandled: t } = this.state;
    t || this.handleSelectionChange(), this.setState({
      keyDownHandled: !1
    });
  };
  setKeyDownHandled = (t) => {
    t.preventDefault(), this.setState({
      keyDownHandled: !0
    });
  };
  addKeyCommands = (t) => {
    this.setState(({ keyCommands: e }) => ({
      keyCommands: [...e, ...t]
    }));
  };
  updateKeyCommandsKeybindings = (t) => {
    if (!t)
      return;
    const { keyCommands: e } = this.state;
    Object.entries(t).forEach(([n, o]) => {
      const r = e.findIndex(
        ({ name: a }) => a === n
      );
      r > -1 && o && (e[r].keybindings = o);
    });
  };
  addSelectionUpdateListener(t) {
    this.setState(({ selectionUpdateListeners: e }) => ({
      selectionUpdateListeners: [...e, t]
    }));
  }
  addMouseOverListener(t) {
    this.setState(({ mouseOverListeners: e }) => ({
      mouseOverListeners: [...e, t]
    }));
  }
  addBlurListener(t) {
    this.setState(({ blurListeners: e }) => ({
      blurListeners: [...e, t]
    }));
  }
  handlePaste = (t) => {
    const {
      onFileDropped: e,
      allowInlineAttachments: n,
      editorWindow: o = window,
      sanitize: r
    } = this.props, { clipboardData: a } = t;
    if (!a)
      return;
    let l = a.getData("text/html");
    const c = a.getData("text/plain"), d = a.files.item(0);
    if (l) {
      t.preventDefault(), this.commandRun("insertHTML", r?.(l));
      return;
    }
    if (c && Hb.test(c)) {
      t.preventDefault(), l = `<a href="${c}">${c}</a>`, this.commandRun("insertHTML", l);
      return;
    }
    if (d) {
      if (n && e) {
        const { src: h, uid: u } = Eo(o, d);
        this.insertImageLoader(h, u), e(d, u);
      }
      t.preventDefault();
    }
  };
  commandRun(t, e = null) {
    setTimeout(() => {
      const { hasFocus: n } = this.state, { current: o } = this.editorRef, { editorWindow: r = window } = this.props;
      o && (n || this.recreateSelection(), r.document.execCommand(
        t,
        !1,
        // execCommand 3rd expects string | null, TS thinks it needs string | undefined
        e
      ));
    });
  }
  commandActive(t) {
    const { hasFocus: e } = this.state, { editorWindow: n = window } = this.props;
    return !!(e && Rg(n, t));
  }
  getText = () => {
    const { current: t } = this.editorRef;
    return t && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
  };
  getSanitizedHtml = () => this.props.sanitize?.(this.getText());
  getPlainText = () => {
    const { current: t } = this.editorRef, e = (
      // innerHTML of <div></div> should count as empty
      t && this.hasContent(this.extractEditorContent()) ? t.innerText : ""
    );
    return e ? e.replace(/\n\n/g, `
`).trim() : "";
  };
  setHtml(t) {
    const { current: e } = this.editorRef, n = this.props.sanitize?.(t);
    e && (e.innerHTML = n || "", Lo(e)), this.setState({
      htmlOld: n
    }), this.handleSelectionChange();
  }
  handleInlineUpload = (t) => {
    if (t === null) return;
    const { onFileDropped: e, editorWindow: n = window } = this.props;
    t && e && Array.from(t).forEach((r) => {
      if (Lg(r)) {
        const { src: a, uid: l } = Eo(n, r);
        this.insertImageLoader(a, l), e(r, l);
      } else {
        const a = nn();
        this.insertFileLoader(r.name, a), e(r, a);
      }
    });
  };
  handleAttachmentUpload = (t) => {
    const { onAttachmentsFile: e } = this.props, { current: n } = this.attachmentDropdownButtonRef;
    n && n.open(), t && typeof e == "function" && Array.from(t).forEach((r) => {
      const a = nn();
      e(r, a);
    });
  };
  handleDetachAttachmentFile = (t) => {
    const { onDetachAttacmentFile: e } = this.props;
    typeof e == "function" && e(t);
  };
  handleFileSelect = (t) => {
    const e = t.target;
    e?.ownerDocument?.defaultView && e instanceof e.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(e.files), e.value = "");
  };
  openFileBrowser = (t) => {
    t?.preventDefault();
    const { current: e } = this.fileInputRef;
    e && e.click();
  };
  insertImageLoader(t, e) {
    const { editorWindow: n = window } = this.props, o = n.document.createElement("img");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", e), o.setAttribute("src", t), this.insertContent(o);
  }
  insertFileLoader(t, e) {
    const { editorWindow: n = window } = this.props, o = n.document.createElement("a");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", e), o.setAttribute("href", "#"), o.innerText = t, this.insertContent(o);
  }
  updateFileLoader(t, { link: e, status: n, filename: o }) {
    const { current: r } = this.editorRef;
    if (r) {
      const a = r.querySelector(`[data-uid="${t}"]`);
      a && (n === "failed" && a.parentElement ? a.parentElement.removeChild(a) : (a.classList.remove(
        "async-loading",
        "async-succeeded",
        "async-failed"
      ), a.classList.add(`async-${n}`), e && a.tagName === "IMG" && (a.src = e, o && (a.title = o)), e && a.tagName === "A" && (a.href = e)));
    }
  }
  handleToggleSendOnEnter = (t) => {
    t.preventDefault();
    const { onToggleSendOnEnter: e } = this.props;
    e();
  };
  handleToggleAutocompleteSuggestions = (t) => {
    t.preventDefault();
    const { autocomplete: e } = this.props;
    e && e.onToggleShowAutocompleteSuggestions();
  };
  isSelectionWithinEditor(t) {
    const { anchorNode: e } = t;
    let { parentElement: n = null } = e || {};
    const o = `.${xt.editor}`;
    let r = e !== null && e.nodeType === Node.ELEMENT_NODE ? e.matches(o) : !1;
    for (; !r && n !== null; ) {
      if (n.matches(o)) {
        r = !0;
        break;
      }
      n = n.parentElement;
    }
    return r;
  }
  insertContent = (t, e) => {
    this.contentInsertionQueue.push(t), e?.getSelection ? this.processContentInsertionQueue(e.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
      this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
    }));
  };
  processContentInsertionQueue = (t) => {
    if (!(!t || !this.isSelectionWithinEditor(t))) {
      if ($g(t), t?.rangeCount && t?.rangeCount > 0) {
        const e = t.getRangeAt(0);
        if (t.isCollapsed || e.deleteContents(), this.contentInsertionQueue.length === 1)
          e.insertNode(this.contentInsertionQueue[0]);
        else if (this.contentInsertionQueue.length > 1) {
          const n = document.createElement("span");
          this.contentInsertionQueue.forEach((o) => {
            n.appendChild(o);
          }), e.insertNode(n);
        }
      }
      this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
        t.collapseToEnd();
      }), this.handleSelectionChange();
    }
  };
  setUiBlocker(t) {
    this.setState({ uiBlocker: t });
  }
  getSelectionRange() {
    const { editorWindow: t = window } = this.props;
    if (t.document.activeElement === this.editorRef.current) {
      const e = t.document.getSelection();
      return e?.rangeCount && e?.rangeCount > 0 ? e.getRangeAt(0) : null;
    }
    return this.state.lastSelection;
  }
  recreateSelection() {
    const { current: t } = this.editorRef, { hasFocus: e, lastSelection: n } = this.state, { editorWindow: o = window } = this.props, r = o.getSelection();
    return t && !e && (t.focus(), n && r && (r.removeAllRanges(), r.addRange(n))), r;
  }
  handleFocus = () => {
    const { editorWindow: t = window } = this.props;
    this.setState({
      hasFocus: !0
    }), t.document.addEventListener(
      "selectionchange",
      this.handleSelectionChange
    );
  };
  handleBlur = (t) => {
    const { editorWindow: e = window } = this.props, n = e.getSelection(), o = () => n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0) : null;
    Cs(), this.setState({
      lastSelection: o(),
      hasFocus: !1
    }), e.document.removeEventListener(
      "selectionchange",
      this.handleSelectionChange
    ), this.handleBlurListeners(t);
  };
  focus = () => {
    const { current: t } = this.editorRef, { hasFocus: e } = this.state;
    t && (e || t.focus());
  };
  moveCursorToEnd = () => {
    const { current: t } = this.editorRef, { editorWindow: e = window } = this.props;
    if (!t) return;
    const n = e.getSelection();
    if (n) {
      const o = e.document.createRange();
      o.selectNodeContents(t), o.collapse(!1), n.removeAllRanges(), n.addRange(o);
    }
  };
  hasContent(t) {
    return t?.length ? !t.match(
      /^\s*<br>\s*$|^<[A-z\s="0-9]*>\s*(<br>\s*)?<\/[A-z\s="0-9]*>$/
    ) : !1;
  }
  isStylingActive() {
    return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList");
  }
  getAllowedFormattingOptions() {
    const { allowFormatting: t } = this.props;
    return Array.isArray(t) ? t : t ? Fg : [];
  }
  lastExtractedContent = B();
  extractEditorContent() {
    const { editorContentExtractor: t, sanitize: e } = this.props, { current: n } = this.editorRef, o = n?.innerHTML ?? "";
    if (!t)
      return Vo(o);
    if (o === this.lastExtractedContent.current)
      return this.lastExtractedContent.current;
    const r = t(n);
    return this.lastExtractedContent.current = Vo(
      e?.(r) ?? r
    ), this.lastExtractedContent.current;
  }
  canUndo = () => this.state.undoStack.length > 0;
  undo = () => {
    const { undoStack: t } = this.state;
    if (t.length > 0) {
      const e = t[t.length - 1];
      this.setHtml(e), this.setState({
        undoStack: t.slice(0, -1)
      });
    }
  };
  resetUndoStack = () => {
    this.setState({
      undoStack: []
    });
  };
  addCurrentContentToUndoStack = () => {
    this.setState({
      // To prevent undo stack from growing indefinitely, we only keep a finite amount
      undoStack: [...this.state.undoStack.slice(-50), this.getText()]
    });
  };
  render() {
    const {
      className: t,
      wrapperClassName: e,
      renderQuickResponse: n,
      quickResponsesApi: o,
      sendOnEnter: r,
      placeholder: a,
      allowInlineAttachments: l,
      allowAttachments: c,
      allowEmoji: d,
      attachmentsFields: h,
      attachments: u,
      isAttachmentsUploading: p,
      hideSendOnEnterToggle: m,
      editorWindow: g = window,
      languages: b,
      disabled: x,
      status: v,
      onError: y,
      icon: C,
      prefix: _,
      suffix: w,
      id: I,
      autocomplete: S,
      toolbarAddons: T
    } = this.props, { htmlOld: P, uiBlocker: A } = this.state, k = f(xt.root, t);
    return /* @__PURE__ */ s.jsx(oo.Context.Provider, { value: this.editor, children: /* @__PURE__ */ s.jsx(
      Et,
      {
        status: v,
        icon: C,
        prefix: _,
        suffix: w,
        disabled: x,
        className: f(xt.inputWrapper, e),
        children: /* @__PURE__ */ s.jsxs("div", { className: k, children: [
          /* @__PURE__ */ s.jsxs(
            pf,
            {
              className: xt.editorWrap,
              onAddInline: this.handleInlineUpload,
              onAddAttachment: this.handleAttachmentUpload,
              attachments: Array.isArray(u) ? u : [],
              allowInlineAttachments: l,
              allowAttachments: c,
              children: [
                /* @__PURE__ */ s.jsx(
                  "div",
                  {
                    id: I,
                    ref: this.editorRef,
                    onPaste: this.handlePaste,
                    onKeyDown: this.handleKeyDown,
                    onInput: this.onInput,
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onMouseOver: this.handleMouseOver,
                    onClick: this.handleEditorClick,
                    className: xt.editor,
                    "data-testid": Kr,
                    contentEditable: !0
                  }
                ),
                !this.hasContent(P) && !!a && /* @__PURE__ */ s.jsx("span", { role: "presentation", className: xt.placeholder, children: a })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: xt.toolbar, children: [
            this.editor.allowFormatting.length > 0 && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                Sb,
                {
                  isActive: this.isStylingActive(),
                  editor: this.editor,
                  editorWindow: g
                }
              ),
              this.editor.allowFormatting.includes("link") && /* @__PURE__ */ s.jsx(Of, { editor: this.editor })
            ] }),
            l && /* @__PURE__ */ s.jsx(
              Ft,
              {
                icon: "upload",
                onMouseDown: this.openFileBrowser
              }
            ),
            c && /* @__PURE__ */ s.jsx(
              af,
              {
                dropdownRef: this.attachmentDropdownButtonRef,
                onAttachFiles: this.handleAttachmentUpload,
                attachments: Array.isArray(u) ? u : [],
                isAttachmentsUploading: p,
                onDetachFile: this.handleDetachAttachmentFile,
                editorWindow: g,
                editor: this.editor,
                children: h
              }
            ),
            d && /* @__PURE__ */ s.jsx(Cf, { "data-tip": "Emojis", editor: this.editor }),
            !!o && !!n && /* @__PURE__ */ s.jsx(
              mb,
              {
                languages: b,
                renderQuickResponse: n,
                quickResponsesApi: o,
                editor: this.editor,
                sanitize: this.props.sanitize,
                iconName: this.props.quickResponseIcon
              }
            ),
            S && S.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ s.jsx(
              Ft,
              {
                isActive: S.showAutocompleteSuggestions,
                onMouseDown: this.handleToggleAutocompleteSuggestions,
                icon: "autocomplete"
              }
            ),
            T,
            !m && /* @__PURE__ */ s.jsx(
              Ft,
              {
                isActive: r,
                onMouseDown: this.handleToggleSendOnEnter,
                icon: "enter"
              }
            ),
            S ? /* @__PURE__ */ s.jsxs(
              "span",
              {
                className: f(xt.toolbarHint, {
                  [xt.toolbarHintVisible]: this.state.showHint,
                  [xt.toolbarHintHidden]: !this.state.showHint
                }),
                children: [
                  "Autocomplete",
                  " ",
                  S.showAutocompleteSuggestions ? "ON" : "OFF"
                ]
              }
            ) : null
          ] }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              tabIndex: -1,
              ref: this.fileInputRef,
              type: "file",
              className: xt.fileInput,
              onChange: this.handleFileSelect,
              multiple: !0
            }
          ),
          /* @__PURE__ */ s.jsx(Fb, { editor: this.editor, onError: y }),
          /* @__PURE__ */ s.jsx(Gg, { editor: this.editor }),
          A && /* @__PURE__ */ s.jsx("div", { className: xt.uiBlocker, children: A })
        ] })
      }
    ) });
  }
}
const Mb = "h-textarea--textarea__inputWrapper", zb = "h-textarea--textarea__input", Uo = {
  inputWrapper: Mb,
  input: zb
}, Vb = "textarea", Ur = $(function(t, e) {
  const n = Y(null), {
    className: o,
    disabled: r,
    readOnly: a,
    name: l,
    prefix: c,
    suffix: d,
    icon: h,
    status: u,
    height: p = 0,
    style: m,
    autoGrow: g,
    ...b
  } = t, [x, v] = V(p), y = {
    ...m,
    height: x ? `${x}px` : void 0
  }, C = F(() => {
    if (!n.current)
      return;
    const _ = n.current.clientHeight, w = window.getComputedStyle(n.current), I = parseInt(w.lineHeight || "16");
    n.current.style.height = "auto";
    const S = n.current.scrollHeight + I, T = Math.max(
      p,
      Math.min(_, S)
    ), P = S > T ? S : T;
    n.current.style.height = `${P}px`, v(P);
  }, [p]);
  return et(() => {
    if (g)
      return C(), window.addEventListener("resize", C), () => {
        window.removeEventListener("resize", C);
      };
  }, [g, C]), /* @__PURE__ */ s.jsx(
    Et,
    {
      className: Uo.inputWrapper,
      status: u,
      disabled: r,
      prefix: c,
      suffix: d,
      icon: h,
      children: /* @__PURE__ */ s.jsx(
        "textarea",
        {
          "data-testid": Vb,
          className: Uo.input,
          dir: "auto",
          id: l,
          ...b,
          onChange: (_) => {
            b?.onChange?.(_), g && C();
          },
          ref: n,
          style: y,
          name: l,
          disabled: r,
          readOnly: a
        }
      )
    }
  );
}), Kb = "h-fieldRichText--fieldRichText__editorContainer", Ub = "h-fieldRichText--fieldRichText__fallbackTextArea", qo = {
  editorContainer: Kb,
  fallbackTextArea: Ub
};
class Pk extends D {
  static defaultProps = {
    allowFormatting: !0
  };
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        helpIcon: l,
        disabled: a,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Ms,
          {
            fallback: /* @__PURE__ */ s.jsx(
              Ur,
              {
                ...e,
                className: qo.fallbackTextArea,
                disabled: a,
                value: e.value,
                onChange: (p) => e.onChange(p.target.value)
              }
            ),
            children: /* @__PURE__ */ s.jsx("div", { className: qo.editorContainer, children: /* @__PURE__ */ s.jsx(
              oo,
              {
                disabled: a,
                status: z.getStatus(o),
                ...e,
                ...u,
                hideSendOnEnterToggle: !0,
                onTriggerSend: E
              }
            ) })
          }
        )
      }
    );
  }
}
class Rk extends D {
  constructor(t) {
    super(t), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
  }
  getSelectedItems() {
    const {
      input: { value: t },
      items: e
    } = this.props;
    return typeof t == "string" && e?.some((n) => n.id === t) ? [t] : Array.isArray(t) && t.length && e?.some((n) => t.some((o) => o === n.id)) ? t : [];
  }
  handleSelect(t) {
    const {
      input: { onChange: e }
    } = this.props;
    typeof e == "function" && e(t === null ? "" : t.id.toString());
  }
  handleClear() {
    const {
      input: { value: t },
      onClear: e
    } = this.props;
    typeof t == "string" && this.handleSelect(null), typeof e == "function" && e();
  }
  render() {
    const {
      className: t,
      input: e,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      description: l,
      helpIcon: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: o,
        labelFor: e.name,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: c,
        description: l,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Te,
          {
            ...u,
            id: e.name,
            disabled: a,
            selectedItems: this.getSelectedItems(),
            onSelect: this.handleSelect,
            onClear: this.handleClear,
            status: z.getStatus(n)
          }
        )
      }
    );
  }
}
function qr(i, t = "") {
  return Rt.toArray(i).reduce((e, n) => Pt(n) ? n.type === Xt ? [
    ...e,
    ...qr(n.props.children, n.key)
  ] : [...e, { ...n, key: `${t}${n.key}` }] : e, []);
}
const Jn = (i) => U(() => qr(i), [i]), qb = "h-selectionList--selectionList__root", Gb = "h-selectionList--selectionList__disabled", Go = {
  root: qb,
  disabled: Gb
}, Re = ji(
  () => Ot({
    list: {
      isMultiple: !1,
      isActive: !1,
      isFocused: !1,
      isDisabled: !1
    },
    item: {
      isActive: !1,
      setActive: E,
      register: E,
      isSelected: () => !1,
      onSelect: E,
      isOnlyVisibleItem: !1
    }
  })
), ro = ({ defaultActiveItemIndex: i = 0 } = {
  defaultActiveItemIndex: 0
}) => {
  const [t, e] = V(!1), [n, o] = V(-1), [r, a] = V([]), [l, c] = V({}), d = F(
    ({
      isActivatable: g,
      isLastChild: b,
      isOnlyVisibleItem: x,
      keysTakenOverHandlingFromParent: v
    }, y) => {
      g !== void 0 && a((C) => {
        const _ = g ? [...C, y].sort((w, I) => w - I) : C.filter((w) => w !== y);
        return b && o((w) => (_.includes(y) && !C.includes(y) || y !== w) && _.includes(w) && y !== _[i] ? w : _[i] ?? _[0] ?? w), _;
      }), x !== void 0 && e(x), v !== void 0 && c((C) => ({
        ...C,
        [y]: v
      }));
    },
    [i]
  ), h = F(
    (g) => "index" in g ? g.index : g.step === "first" ? r[0] : g.step === "last" ? r[r.length - 1] : r[(r.findIndex(
      (b) => b === n
    ) + g.step + r.length) % r.length],
    [r, n]
  ), u = F(
    (g) => {
      o(h(g));
    },
    [h]
  );
  et(() => {
    (n < 0 || n === void 0) && o(r[i]);
  }, [n, r, i]);
  const p = U(
    () => l[n] ?? [],
    [n, l]
  );
  return U(
    () => ({
      activeItemIndex: n,
      getActiveItemIndex: h,
      activatableItemIndices: r,
      setActiveItem: u,
      handleItemRegister: d,
      isOnlyActiveItemVisible: t,
      keysDelegatedHandlingToItem: p
    }),
    [
      r,
      n,
      h,
      d,
      t,
      p,
      u
    ]
  );
}, Yo = ({
  className: i,
  selectedValues: t = [],
  isActive: e,
  isDisabled: n,
  isMultiple: o = !1,
  onChange: r = E,
  equalityFn: a = Object.is,
  tabIndex: l = 0,
  defaultActiveItemIndex: c,
  children: d,
  ...h
}, u) => {
  const [p, m] = V(!1), [g, b] = V({ isActive: !!e, source: "parent" }), x = Re(), {
    activeItemIndex: v,
    setActiveItem: y,
    handleItemRegister: C,
    isOnlyActiveItemVisible: _,
    keysDelegatedHandlingToItem: w
  } = ro({ defaultActiveItemIndex: c }), I = Jn(d), S = F(
    (k) => k !== void 0 && (t || []).some(
      (R) => a(R, k)
    ),
    [a, t]
  ), T = F(
    ({ value: k, meta: R }, W) => {
      y({ index: W }), k !== void 0 && r(o ? {
        selectedValues: S(k) ? t.filter(
          (nt) => !a(nt, k)
        ) : [...t, k],
        selectedItem: {
          isNode: R?.isNode,
          isSelected: !S(k),
          value: k
        },
        event: R?.event
      } : {
        selectedValues: [k],
        selectedItem: {
          isNode: R?.isNode,
          isSelected: !0,
          value: k
        },
        event: R?.event
      });
    },
    [
      a,
      S,
      o,
      r,
      t,
      y
    ]
  ), P = U(
    () => !n && (g.isActive || p),
    [n, g.isActive, p]
  ), A = (k) => {
    !P || w.includes(k.key) || (k.key === "Enter" ? k.preventDefault() : k.key === "Home" ? (y({ step: "first" }), k.preventDefault()) : k.key === "End" ? (y({ step: "last" }), k.preventDefault()) : k.key === "ArrowDown" ? (y({ step: 1 }), k.preventDefault()) : k.key === "ArrowUp" && (y({ step: -1 }), k.preventDefault()));
  };
  return et(() => {
    b({ isActive: !!e, source: "parent" });
  }, [e]), ln("keydown", A), /* @__PURE__ */ s.jsx(
    "ul",
    {
      ref: u,
      role: "listbox",
      tabIndex: n || e ? -1 : l,
      ...h,
      className: f(i, Go.root, {
        [Go.disabled]: n
      }),
      onFocus: () => m(!0),
      onBlur: () => m(!1),
      onMouseLeave: () => {
        g.source === "child" && b({ isActive: !1, source: "self" });
      },
      children: I.map(
        (k, R) => Pt(k) && (!_ || R === v) && /* @__PURE__ */ s.jsx(
          x.Provider,
          {
            value: {
              list: {
                isFocused: p,
                isMultiple: o,
                isActive: g.isActive,
                isDisabled: n
              },
              item: {
                isActive: P && R === v,
                setActive: () => {
                  b({ isActive: !0, source: "child" }), y({ index: R });
                },
                register: (W) => C(W, R),
                isSelected: S,
                onSelect: (W) => T(W, R),
                isOnlyVisibleItem: _,
                isLastChild: R === I.length - 1
              }
            },
            children: k
          },
          R
        )
      )
    }
  );
}, Xo = ({ className: i, label: t, ...e }, n) => {
  const {
    item: { register: o, isLastChild: r }
  } = Gt(Re());
  return Ne(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), Qt(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), /* @__PURE__ */ s.jsx(
    qn,
    {
      ref: n,
      as: "li",
      color: "tertiary",
      padding: "200 250",
      ...e,
      children: /* @__PURE__ */ s.jsx(L.Paragraph, { as: "span", variant: "4", color: "secondary", children: t })
    }
  );
}, Gr = Object.assign($(Xo), {
  name: Xo.name
}), Yb = "h-selectionList-subComponents-item--selectionListItem__root", Xb = "h-selectionList-subComponents-item--selectionListItem__rootDisabled", Qb = "h-selectionList-subComponents-item--selectionListItem__rootActive", Zb = "h-selectionList-subComponents-item--selectionListItem__selectionState", Jb = "h-selectionList-subComponents-item--selectionListItem__fixedSize", tx = "h-selectionList-subComponents-item--selectionListItem__content", ex = "h-selectionList-subComponents-item--selectionListItem__contentDisabled", se = {
  root: Yb,
  rootDisabled: Xb,
  rootActive: Qb,
  selectionState: Zb,
  fixedSize: Jb,
  content: tx,
  contentDisabled: ex
}, Qo = ({
  value: i,
  isDisabled: t = !1,
  isIndeterminate: e = !1,
  className: n,
  contentClassName: o,
  noFixedSelectionStateSpace: r,
  onActiveStateChange: a,
  onSelectedStateChange: l,
  onSelect: c,
  children: d,
  ...h
}, u) => {
  const {
    list: {
      isMultiple: p,
      isDisabled: m,
      isActive: g,
      isFocused: b
    },
    item: {
      register: x,
      isSelected: v,
      onSelect: y,
      isActive: C,
      isNode: _ = !1,
      isLastChild: w = !1,
      setActive: I
    }
  } = Gt(Re()), S = v(i), T = U(
    () => !m && (g || b),
    [g, m, b]
  ), P = U(
    () => !t && C && T,
    [C, t, T]
  ), A = Y(null);
  je(
    u,
    () => A.current
  );
  const k = F(
    (H) => {
      !t && !m && (c?.({ value: i, meta: { target: H?.target } }), y({
        value: i,
        meta: {
          target: H?.target,
          event: H || void 0
        }
      }));
    },
    [t, m, c, y, i]
  ), R = F(
    (H) => {
      P && H.key === "Enter" && k(H);
    },
    [P, k]
  );
  et(() => {
    C && T && A.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    });
  }, [C]);
  const W = F(
    () => ({
      isActive: C,
      isSelected: S,
      isLastChild: w,
      isNode: _,
      value: i
    }),
    [C, w, _, S, i]
  ), nt = en(C), st = en(S);
  Yt(() => {
    C !== nt && a?.(W()), S !== st && l?.(W());
  }, [
    W,
    C,
    S,
    a,
    l,
    nt,
    st
  ]), ln("keydown", R), et(() => (x({ isActivatable: !t, isLastChild: w }), () => x({ isActivatable: !1, isLastChild: w })), [t]);
  const tt = !p && S || p && i !== void 0 || !r;
  return /* @__PURE__ */ s.jsxs(
    "li",
    {
      ref: A,
      role: "option",
      "aria-selected": S,
      "aria-disabled": t,
      onClick: k,
      onMouseMove: I,
      className: f(se.root, n, {
        [se.rootActive]: P,
        [se.rootDisabled]: t
      }),
      ...h,
      children: [
        tt && /* @__PURE__ */ s.jsxs(
          O,
          {
            className: f(se.selectionState, {
              [se.fixedSize]: !r
            }),
            children: [
              !p && S && /* @__PURE__ */ s.jsx(N, { name: "done" }),
              p && i !== void 0 && /* @__PURE__ */ s.jsx(
                cn,
                {
                  checked: S,
                  indeterminate: !S && e,
                  disabled: t,
                  onChange: E,
                  tabIndex: -1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          it,
          {
            className: f(se.content, o, {
              [se.contentDisabled]: t
            }),
            children: d
          }
        ),
        _ && /* @__PURE__ */ s.jsx(N, { name: "angle-right" })
      ]
    }
  );
}, nx = Object.assign($(Qo), {
  name: Qo.name
}), sx = "h-selectionList-subComponents-list-backItem--selectionListBackItem__root", ox = "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive", Zo = {
  root: sx,
  rootActive: ox
}, Jo = ({
  className: i,
  content: t,
  onActiveStateChange: e,
  onSelected: n,
  ...o
}, r) => {
  const {
    list: {
      isDisabled: a,
      isActive: l,
      isFocused: c
    },
    item: { register: d, isActive: h, onSelect: u, setActive: p }
  } = Gt(Re()), m = U(
    () => !a && (l || c),
    [l, a, c]
  ), g = U(
    () => h && m,
    [h, m]
  ), b = Y(null);
  je(
    r,
    () => b.current
  );
  const x = F(() => {
    u({}), n?.();
  }, [u, n]), v = F(
    (C) => {
      !g || a || C.key === "Enter" && x();
    },
    [x, g, a]
  );
  et(() => {
    h && m && b.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    });
  }, [h]);
  const y = en(h);
  return Yt(() => {
    h !== y && e?.({ isActive: h });
  }, [h, e, y]), ln("keydown", v), Ne(() => {
    d({ isActivatable: !0 });
  }), Qt(() => {
    d({ isActivatable: !1 });
  }), /* @__PURE__ */ s.jsx(
    "li",
    {
      ref: b,
      role: "navigation",
      className: f(Zo.root, i, {
        [Zo.rootActive]: g
      }),
      onClick: x,
      onMouseMove: p,
      ...o,
      children: t || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(N, { name: "angle-left" }),
        /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "1", children: "Back" })
      ] })
    }
  );
}, Yr = Object.assign(
  $(Jo),
  {
    name: Jo.name
  }
), rx = "h-selectionList-subComponents-list--selectionListList__list", ix = {
  list: rx
}, tr = ({
  parentItem: i,
  children: t,
  backItemProps: e = {},
  listProps: { className: n, ...o } = {},
  onActiveStateChange: r,
  ...a
}, l) => {
  const c = Re(), d = Gt(c), {
    list: {
      isFocused: h,
      isActive: u,
      isDisabled: p
    },
    item: {
      isActive: m,
      onSelect: g,
      isOnlyVisibleItem: b,
      register: x,
      setActive: v,
      isLastChild: y = !1
    }
  } = d, C = U(
    () => !p && (u || h),
    [u, p, h]
  ), _ = Jn(t), {
    activeItemIndex: w,
    setActiveItem: I,
    handleItemRegister: S,
    isOnlyActiveItemVisible: T,
    keysDelegatedHandlingToItem: P
  } = ro({ defaultActiveItemIndex: 1 }), A = F(
    (H, ot) => {
      I({ index: ot }), g(H);
    },
    [g, I]
  ), k = (H) => {
    !C || !b || P.includes(H.key) || (H.key === "Home" ? (I({ step: "first" }), H.preventDefault()) : H.key === "End" ? (I({ step: "last" }), H.preventDefault()) : H.key === "ArrowDown" ? (I({ step: 1 }), H.preventDefault()) : H.key === "ArrowUp" && (I({ step: -1 }), H.preventDefault()));
  }, R = en(
    b
  );
  Yt(() => {
    b !== R && r?.({
      isActive: b,
      isLastChild: y
    });
  }, [
    b,
    r,
    R
  ]), et(() => {
    x(b ? {
      keysTakenOverHandlingFromParent: [
        "Home",
        "End",
        "ArrowDown",
        "ArrowUp"
      ]
    } : { keysTakenOverHandlingFromParent: [] });
  }, [b]), ln("keydown", k);
  const W = F(
    ({ value: H, meta: ot }) => {
      ot?.target instanceof HTMLInputElement && ot.target.type === "checkbox" ? g({ value: H, meta: { isNode: !0 } }) : x({ isOnlyVisibleItem: !0 });
    },
    // excluding `register` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), nt = F(() => {
    x({ isOnlyVisibleItem: !1 });
  }, []);
  et(() => {
    b || I({ index: -1 });
  }, [b, I]);
  const st = U(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: W,
        isNode: !0
      }
    }),
    [W, d]
  ), tt = U(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: nt,
        isActive: w === 0,
        setActive: () => {
          v(), I({ index: 0 });
        },
        register: (H) => S(H, 0)
      }
    }),
    [
      w,
      nt,
      S,
      d,
      v,
      I
    ]
  );
  return b ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !T && /* @__PURE__ */ s.jsx(c.Provider, { value: tt, children: /* @__PURE__ */ s.jsx(Yr, { ...e }) }),
    /* @__PURE__ */ s.jsx("li", { ref: l, ...a, children: /* @__PURE__ */ s.jsx(
      "ul",
      {
        role: "listbox",
        className: f(ix.list, n),
        ...o,
        children: _.map((H, ot) => {
          const Dt = ot + 1;
          return Pt(H) && (!T || Dt === w) && /* @__PURE__ */ s.jsx(
            c.Provider,
            {
              value: {
                ...d,
                item: {
                  ...d.item,
                  isActive: m && Dt === w,
                  setActive: () => {
                    v(), I({ index: Dt });
                  },
                  register: (le) => S(le, Dt),
                  onSelect: (le) => A(le, Dt),
                  isOnlyVisibleItem: T,
                  isLastChild: ot === _.length - 1
                }
              },
              children: H
            },
            ot
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ s.jsx(c.Provider, { value: st, children: i });
}, ax = Object.assign($(tr), {
  name: tr.name
}), lx = "h-selectionList-subComponents-section--selectionListSection__section", cx = {
  section: lx
}, er = ({
  title: i,
  children: t,
  listProps: { className: e, ...n } = {},
  onActiveStateChange: o,
  ...r
}, a) => {
  const l = Re(), c = Gt(l), {
    list: {
      isFocused: d,
      isActive: h,
      isDisabled: u
    },
    item: {
      isActive: p,
      setActive: m,
      onSelect: g,
      register: b,
      isLastChild: x = !1
    }
  } = c, v = U(
    () => !u && (h || d),
    [h, u, d]
  ), y = Jn(t), {
    activatableItemIndices: C,
    activeItemIndex: _,
    setActiveItem: w,
    handleItemRegister: I,
    keysDelegatedHandlingToItem: S
  } = ro(), T = F(
    (k, R) => {
      w({ index: R }), g(k);
    },
    [g, w]
  ), P = (k) => {
    !v || S.includes(k.key) || (k.key === "Home" ? w({ step: "first" }) : k.key === "End" && w({ step: "last" }), p ? k.key === "ArrowDown" && _ !== C[C.length - 1] ? (w({ step: 1 }), k.preventDefault()) : k.key === "ArrowUp" && _ !== C[0] && (w({ step: -1 }), k.preventDefault()) : k.key === "ArrowDown" ? w({ step: "first" }) : k.key === "ArrowUp" && w({ step: "last" }));
  }, A = en(p);
  return Yt(() => {
    p !== A && o?.({
      isActive: p,
      isLastChild: x
    });
  }, [p, o, A]), et(() => {
    const k = [];
    p && (_ !== C[C.length - 1] && k.push("ArrowDown"), _ !== C[0] && k.push("ArrowUp")), b({ keysTakenOverHandlingFromParent: k });
  }, [C, _, p]), Ne(() => b({ isActivatable: !0 })), Qt(() => b({ isActivatable: !1 })), ln("keydown", P), /* @__PURE__ */ s.jsx("li", { ref: a, ...r, children: /* @__PURE__ */ s.jsxs(
    "ul",
    {
      role: "group",
      className: f(cx.section, e),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(Gr, { label: i }),
        y.map(
          (k, R) => Pt(k) && /* @__PURE__ */ s.jsx(
            l.Provider,
            {
              value: {
                ...c,
                item: {
                  ...c.item,
                  isActive: p && R === _,
                  setActive: () => {
                    m(), w({ index: R });
                  },
                  register: (W) => I(W, R),
                  onSelect: (W) => T(W, R),
                  isLastChild: x && R === y.length - 1
                }
              },
              children: k
            },
            R
          )
        )
      ]
    }
  ) });
}, dx = Object.assign($(er), {
  name: er.name
}), hx = Object.assign($(Yo), {
  name: Yo.name,
  Item: nx,
  BackItem: Yr,
  Divider: Gr,
  Section: dx,
  List: ax
}), ux = "h-inputSelectionList-chip--inputSelectionListChip__root", px = "h-inputSelectionList-chip--inputSelectionListChip__name", nr = {
  root: ux,
  name: px
}, ws = ({
  onDelete: i,
  className: t,
  disabled: e,
  readOnly: n,
  ...o
}) => {
  const r = U(() => {
    if (!(!i || e || n))
      return (a) => {
        a.stopPropagation(), i();
      };
  }, [e, i, n]);
  return /* @__PURE__ */ s.jsx(
    ke,
    {
      ...o,
      onDelete: r,
      className: f(nr.root, t),
      tagNameClassName: nr.name
    }
  );
}, mx = "h-inputSelectionList--inputSelectionList__root", gx = "h-inputSelectionList--inputSelectionList__inputWrapper", fx = "h-inputSelectionList--inputSelectionList__inputWrapperChild", bx = "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon", xx = "h-inputSelectionList--inputSelectionList__rootReadOnly", yx = "h-inputSelectionList--inputSelectionList__titleContainer", _x = "h-inputSelectionList--inputSelectionList__filterInput", Cx = "h-inputSelectionList--inputSelectionList__placeholder", wx = "h-inputSelectionList--inputSelectionList__titleBox", vx = "h-inputSelectionList--inputSelectionList__iconContainer", Sx = "h-inputSelectionList--inputSelectionList__iconButton", Ix = "h-inputSelectionList--inputSelectionList__dropdown", Dx = "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip", kx = "h-inputSelectionList--inputSelectionList__hiddenItemsChip", lt = {
  root: mx,
  inputWrapper: gx,
  inputWrapperChild: fx,
  rootHasWrapperIcon: bx,
  rootReadOnly: xx,
  titleContainer: yx,
  filterInput: _x,
  placeholder: Cx,
  titleBox: wx,
  iconContainer: vx,
  iconButton: Sx,
  dropdown: Ix,
  hiddenItemsTooltip: Dx,
  hiddenItemsChip: kx
}, Tx = "inputSelectionListTestId", sr = ({
  className: i,
  name: t,
  value: e,
  onChange: n,
  prefix: o,
  suffix: r,
  icon: a,
  status: l,
  placeholder: c,
  disabled: d,
  readOnly: h,
  children: u,
  filter: p,
  multiple: m,
  getItemTitleByValue: g,
  tabIndex: b,
  keepOpen: x,
  onToggleDropdown: v,
  onClick: y,
  onBlur: C,
  onKeyDown: _,
  limit: w = Number.POSITIVE_INFINITY,
  clearable: I = !1,
  equalityFn: S = Object.is,
  defaultActiveItemIndex: T,
  valueArrayToStringFn: P = JSON.stringify,
  rootClassName: A,
  dropdownProps: k,
  selectionListProps: R,
  slotBeforeList: W,
  slotAfterList: nt,
  ...st
}, tt) => {
  const H = Y(null), ot = Y(null), Dt = Y(null), le = Y(null), [Q, Qr] = V(!1);
  je(
    tt,
    () => ot.current
  );
  const es = U(
    () => p?.value !== void 0 && p.onChange !== void 0 && Q,
    [p, Q]
  ), Zr = U(() => {
    if (!e?.length)
      return c;
    if (!m) {
      const M = g(e[0]);
      return typeof M == "object" ? "" : M?.toString();
    }
    return "";
  }, [m, c, g, e]), Jr = U(() => es ? m && !!e?.length : !0, [m, es, e?.length]), ns = F(
    (M) => {
      !h && !d && n?.({
        selectedItem: {
          isSelected: !1,
          value: M
        },
        selectedValues: e?.filter((Ae) => !S(Ae, M)) ?? []
      });
    },
    [d, S, n, h, e]
  ), ti = U(() => {
    if (!e?.length)
      return /* @__PURE__ */ s.jsx(O, { alignItems: "center", className: lt.placeholder, children: c });
    if (m) {
      const M = w < e.length ? e.slice(0, w) : e, Ae = w < e.length ? e.slice(w) : [];
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        M?.map(($e, ss) => /* @__PURE__ */ s.jsx(
          ws,
          {
            onDelete: () => {
              ns($e);
            },
            disabled: d,
            readOnly: h,
            children: g($e)
          },
          ss
        )),
        !!Ae.length && /* @__PURE__ */ s.jsx(
          gt,
          {
            disabled: d,
            requireClick: !0,
            content: /* @__PURE__ */ s.jsx(
              O,
              {
                className: lt.hiddenItemsTooltip,
                gap: "100",
                flexWrap: "wrap",
                children: Ae?.map(($e, ss) => /* @__PURE__ */ s.jsx(
                  ws,
                  {
                    onDelete: () => {
                      ns($e);
                    },
                    disabled: d,
                    readOnly: h,
                    children: g($e)
                  },
                  ss
                ))
              }
            ),
            light: !0,
            children: /* @__PURE__ */ s.jsxs(
              ws,
              {
                className: lt.hiddenItemsChip,
                disabled: d,
                children: [
                  "+ ",
                  Ae.length
                ]
              }
            )
          }
        )
      ] });
    }
    return /* @__PURE__ */ s.jsx(it, { className: lt.titleBox, children: g(e[0]) });
  }, [
    e,
    m,
    g,
    c,
    w,
    d,
    h,
    ns
  ]), dt = F(
    (M) => {
      (h || d) && M || (M !== Q && v?.(M), Qr(M));
    },
    [d, Q, v, h]
  ), Ee = F(
    ({ target: M }) => {
      le.current?.contains(M) || (H.current?.contains(M) && ot.current?.focus(), dt(!1));
    },
    [dt]
  ), Le = F(
    (M) => {
      Fe(M.key) && Q && (dt(!1), ot.current?.focus());
    },
    [Q, dt]
  ), ei = F(
    (M) => {
      M.relatedTarget && H.current?.contains(M.relatedTarget) || (dt(!1), C?.(M));
    },
    [C, dt]
  ), ni = F(
    (M) => {
      Q || M.stopPropagation(), dt(!0), y?.(M);
    },
    [Q, y, dt]
  ), si = F(
    (M) => {
      Yn(M.key) && dt(!0), _?.(M);
    },
    [_, dt]
  ), oi = F(
    (M) => {
      M.stopPropagation(), dt(!Q), ot.current?.focus();
    },
    [Q, dt]
  ), ri = F(
    (M) => {
      M.stopPropagation(), ot.current?.focus(), !d && !h && n?.({ selectedValues: [] });
    },
    [d, n, h]
  ), ii = F(
    (M) => {
      n?.(M), ot.current?.focus(), !x && !m ? dt(!1) : Dt.current?.focus();
    },
    [m, x, n, dt]
  );
  return et(() => (Q ? (window.addEventListener("click", Ee), window.addEventListener("keydown", Le)) : (window.removeEventListener("click", Ee), window.removeEventListener("keydown", Le)), () => {
    window.removeEventListener("click", Ee), window.removeEventListener("keydown", Le);
  }), [Ee, Le, Q]), et(() => {
    Q && Dt.current?.focus();
  }, [Q]), Qt(() => {
    window.removeEventListener("click", Ee), window.removeEventListener("keydown", Le);
  }), /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Tx,
      ref: H,
      className: f(lt.root, A, {
        [lt.rootHasWrapperIcon]: !!a,
        [lt.rootReadOnly]: h
      }),
      "aria-expanded": Q,
      "aria-haspopup": "listbox",
      role: "combobox",
      children: [
        /* @__PURE__ */ s.jsx(
          Et,
          {
            ...st,
            ref: ot,
            className: f(i, lt.inputWrapper),
            prefix: o,
            suffix: r,
            disabled: d,
            icon: a,
            active: Q,
            status: l,
            onClick: ni,
            onBlur: ei,
            onKeyDown: si,
            tabIndex: d ? -1 : b ?? 0,
            children: /* @__PURE__ */ s.jsxs(O, { className: lt.inputWrapperChild, children: [
              /* @__PURE__ */ s.jsxs(O, { gap: "100", flexWrap: "wrap", className: lt.titleContainer, children: [
                Jr && ti,
                es && /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    ...p,
                    ref: Dt,
                    className: f(lt.filterInput, p?.className),
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    placeholder: Zr,
                    disabled: d || p?.disabled
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsxs(O, { alignItems: "center", className: lt.iconContainer, children: [
                I && !d && !h && !!e?.length && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: lt.iconButton,
                    variant: "tertiary",
                    icon: "close",
                    disabled: d,
                    onClick: ri,
                    "aria-label": "Clear"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: lt.iconButton,
                    variant: "tertiary",
                    icon: Q ? "angle-up" : "angle-down",
                    disabled: d,
                    onClick: oi,
                    "aria-label": Q ? "Close" : "Open"
                  }
                )
              ] })
            ] })
          }
        ),
        t && /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "hidden",
            disabled: d,
            name: t,
            value: P(e)
          }
        ),
        /* @__PURE__ */ s.jsx(
          Zt,
          {
            isOpen: Q,
            ...k,
            className: f(k?.className, lt.dropdown),
            children: /* @__PURE__ */ s.jsx("div", { ref: le, style: { width: "100%" }, children: Q && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              W,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              /* @__PURE__ */ s.jsx(
                hx,
                {
                  ...R,
                  equalityFn: S,
                  defaultActiveItemIndex: T,
                  isActive: Q,
                  isMultiple: m,
                  selectedValues: e,
                  onChange: ii,
                  children: u
                }
              ),
              nt
            ] }) })
          }
        )
      ]
    }
  );
}, jx = Object.assign($(sr), {
  name: sr.name
}), Ek = ({
  className: i,
  input: { value: t, name: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: e,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      jx,
      {
        name: e,
        value: t || [],
        onChange: (g) => {
          n(g.selectedValues);
        },
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Nx = "h-slider--slider__rootWrapper", Fx = "h-slider--slider__rootWrapperNoAnnotations", Px = "h-slider--slider__root", Rx = "h-slider--slider__rootDark", Ex = "h-slider--slider__rootDisabled", Lx = "h-slider--slider__handle", Ax = "h-slider--slider__trackWrapper", $x = "h-slider--slider__track", Bx = "h-slider--slider__highlight", Ox = "h-slider--slider__minValueIndicator", Hx = "h-slider--slider__maxValueIndicator", ft = {
  rootWrapper: Nx,
  rootWrapperNoAnnotations: Fx,
  root: Px,
  rootDark: Rx,
  rootDisabled: Ex,
  handle: Lx,
  trackWrapper: Ax,
  track: $x,
  highlight: Bx,
  minValueIndicator: Ox,
  maxValueIndicator: Hx
};
var jt = /* @__PURE__ */ ((i) => (i.LowBoundIndicator = "input-slider-low-indicator", i.HighBoundIndicator = "input-slider-high-indicator", i.Handle = "input-slider-handle", i.Value = "input-slider-value", i.TrackBackground = "input-slider-tack-background", i.Track = "input-slider-track", i.Highlight = "input-slider-highlight", i))(jt || {});
const Wx = (i) => {
  i.preventDefault();
}, Mx = (i, t, e) => typeof i != "number" && !Array.isArray(i) ? "" : typeof i == "number" ? /* @__PURE__ */ s.jsxs(L.Paragraph, { variant: "3", children: [
  t,
  i,
  e
] }) : /* @__PURE__ */ s.jsxs(L.Paragraph, { variant: "3", children: [
  t,
  i[0],
  e,
  " - ",
  t,
  i[1],
  e
] });
class zx extends D {
  static defaultProps = {
    min: 0,
    max: 100,
    dark: !1,
    highlightRange: null,
    formatValue: Mx,
    hideAnnotations: !1
  };
  constructor(t) {
    super(t), this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    }, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
  }
  sliderRef = B();
  isInterval(t) {
    return Array.isArray(t);
  }
  handleChange(t) {
    typeof t == "number" ? this.props.onChange?.(Math.round(t)) : this.props.onChange?.(
      t.map((e) => Math.round(e))
    );
  }
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */
  handleHandleGrab(t) {
    t.target instanceof Element && this.setState({
      currentIndex: parseInt(
        t.target.getAttribute("data-index") || "",
        10
      )
    });
  }
  handleHandleMove(t) {
    t.preventDefault();
    const { startVal: e, startX: n, sliderWidth: o, currentIndex: r } = this.state, a = e + (t.clientX - n) / o, l = this.getAbsoluteValue(a, r);
    this.handleChange(l);
  }
  handleHandleDrop() {
    window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
  }
  handleKeyDown(t) {
    const { step: e = 1, value: n } = this.props;
    t.preventDefault();
    const o = this.isInterval(n) && t.target instanceof Element ? parseInt(t.target.getAttribute("data-index") || "", 10) : null;
    switch (t.key) {
      case "ArrowRight":
      case "ArrowUp":
        this.increment(e, o);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        this.increment(-e, o);
        break;
    }
  }
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */
  handleSliderMouseDown(t) {
    if (!this.sliderRef.current) return;
    const { value: e } = this.props, { currentIndex: n } = this.state, o = this.sliderRef.current.getBoundingClientRect(), r = (t.clientX - o.left) / o.width;
    this.setState({
      startX: t.clientX,
      // save the current mouse x
      startVal: r,
      // save the current percentage
      sliderWidth: o.width
      // save the slider width
    });
    let a;
    if (this.isInterval(e)) {
      const l = n ?? this.findTheNearestHandle(r, e);
      this.setState({
        currentIndex: l
      }), a = this.getAbsoluteValue(r, l);
    } else
      a = this.getAbsoluteValue(r);
    this.handleChange(a), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
  }
  findTheNearestHandle(t, e) {
    const [n, o] = e.map(
      this.absoluteValueToRelativeValue
    );
    return t > o && t > n ? 1 : t < o && t < n ? 0 : Math.abs(n - t) > Math.abs(o - t) ? 1 : 0;
  }
  getAdjustedStep(t) {
    const { min: e, max: n } = this.props;
    return t / (n - e);
  }
  getAbsoluteValue(t, e) {
    const { value: n, step: o } = this.props;
    let r = Rn(t, 0, 1);
    if (o) {
      const h = this.getAdjustedStep(o);
      r = Math.round(r / h) * h;
    }
    if (!this.isInterval(n))
      return this.relativeValueToAbsoluteValue(r);
    const [a, l] = n;
    let c = this.relativeValueToAbsoluteValue(r);
    e === 0 && c > l ? c = l : e === 1 && c < a && (c = a);
    const d = [a, l];
    return typeof e == "number" && (d[e] = c), d;
  }
  /**
   * @param ratio Is a number between 0 and 1 and it represents the **relative**
   *   placement of the handle within the slider track.
   */
  relativeValueToAbsoluteValue(t) {
    const { min: e, max: n } = this.props, o = e + (n - e) * t;
    return Rn(o, e, n);
  }
  /**
   * @param value Is a number between 'min' and 'max' and it represents the
   *   **absolute** value that is derived from the relative placement of the
   *   handle.
   */
  absoluteValueToRelativeValue(t) {
    const { min: e, max: n } = this.props, o = (t - e) / (n - e);
    return Rn(o, 0, 1);
  }
  increment(t, e) {
    const { value: n } = this.props;
    let o;
    if (this.isInterval(n)) {
      const r = [...n];
      r[e ?? 0] = r[e ?? 0] + t, o = r;
    } else
      o = n + t;
    this.handleChange(o);
  }
  getTrackStyles() {
    const { value: t, min: e } = this.props, n = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[1]) - this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(t), o = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(e);
    return {
      width: `${n * 100}%`,
      left: `${o * 100}%`
    };
  }
  getHandleStyles(t) {
    const { value: e } = this.props;
    return {
      left: `${(this.isInterval(e) ? this.absoluteValueToRelativeValue(e[t ?? 0]) : this.absoluteValueToRelativeValue(e)) * 100}%`
    };
  }
  getHighlightStyles() {
    const { highlightRange: t } = this.props;
    if (yt(t)) return {};
    const [e, n] = t.map(this.absoluteValueToRelativeValue);
    return {
      left: `${e * 100}%`,
      width: `${(n - e) * 100}%`
    };
  }
  render() {
    const {
      className: t,
      value: e,
      step: n,
      highlightRange: o,
      min: r,
      max: a,
      dark: l,
      disabled: c,
      onChange: d,
      formatValue: h,
      hideAnnotations: u,
      valuePrefix: p,
      valueSuffix: m,
      onBlur: g,
      onFocus: b,
      children: x,
      ...v
    } = this.props, y = f(
      ft.root,
      { [ft.rootDark]: l },
      { [ft.rootDisabled]: c },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: f(ft.rootWrapper, {
          [ft.rootWrapperNoAnnotations]: u
        }),
        children: [
          /* @__PURE__ */ s.jsxs(
            "div",
            {
              ...v,
              className: y,
              ref: this.sliderRef,
              onMouseDown: this.handleSliderMouseDown,
              children: [
                /* @__PURE__ */ s.jsxs(
                  "div",
                  {
                    className: ft.trackWrapper,
                    "data-testid": jt.TrackBackground,
                    children: [
                      !yt(o) && /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: ft.highlight,
                          style: this.getHighlightStyles(),
                          "data-testid": jt.Highlight
                        }
                      ),
                      /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: ft.track,
                          style: this.getTrackStyles(),
                          "data-testid": jt.Track
                        }
                      )
                    ]
                  }
                ),
                !this.isInterval(e) && /* @__PURE__ */ s.jsx(
                  "button",
                  {
                    tabIndex: 0,
                    role: "slider",
                    type: "button",
                    "aria-valuemin": r,
                    "aria-valuemax": a,
                    "aria-valuenow": e,
                    className: ft.handle,
                    onClick: Wx,
                    onKeyDown: this.handleKeyDown,
                    style: this.getHandleStyles(),
                    "data-testid": jt.Handle
                  }
                ),
                this.isInterval(e) && /* @__PURE__ */ s.jsxs(Xt, { children: [
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "0",
                      className: ft.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(0),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": jt.Handle
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "1",
                      className: ft.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(1),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": jt.Handle
                    }
                  )
                ] }),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    "data-testid": jt.LowBoundIndicator,
                    className: ft.minValueIndicator,
                    children: /* @__PURE__ */ s.jsxs(L.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      r,
                      m
                    ] })
                  }
                ),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    className: ft.maxValueIndicator,
                    "data-testid": jt.HighBoundIndicator,
                    children: /* @__PURE__ */ s.jsxs(L.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      a,
                      m
                    ] })
                  }
                )
              ]
            }
          ),
          !u && /* @__PURE__ */ s.jsx("div", { "data-testid": jt.Value, children: h(e, p, m) })
        ]
      }
    );
  }
}
const As = an(zx, {
  fallback: null
}), Vx = "h-fieldSlider--fieldSlider__root", Kx = {
  root: Vx
};
class Lk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(t) {
    const e = new Event("change");
    Object.defineProperty(e, "target", {
      writable: !0,
      value: { value: t, name: this.props.input.name }
    }), this.props.input.onChange(e);
  }
  /**
   * Redux form performs a value check when `blur` happens, so we need to make
   * sure the value is attached to the blur event otherwise it will be set to
   * null
   *
   * @see https://github.com/redux-form/redux-form/issues/2768
   */
  handleBlur(t) {
    const { input: e } = this.props, n = new FocusEvent(
      "blur",
      t
    );
    Object.defineProperty(n, "target", {
      writable: !0,
      value: { value: e.value, name: e.name }
    }), e.onBlur?.(n);
  }
  render() {
    const {
      className: t,
      input: e,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props, p = f(Kx.root, t);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: p,
        label: o,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          As,
          {
            ...e,
            onChange: this.handleChange,
            disabled: a,
            ...u
          }
        )
      }
    );
  }
}
const Ux = "h-switch--switch__root", qx = "h-switch--switch__input", Gx = "h-switch--switch__inner", Yx = "h-switch--switch__pending", Xx = "h-switch--switch__active", Ue = {
  root: Ux,
  input: qx,
  inner: Gx,
  pending: Yx,
  active: Xx
}, or = {
  input: "Switch-input",
  label: "Switch-label"
};
class Qx extends D {
  render() {
    const { id: t, className: e, variant: n, ...o } = this.props, r = t || `switch_${Math.random()}`;
    return /* @__PURE__ */ s.jsxs("div", { className: f(e, Ue.root), "data-testid": t, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...o,
          id: r,
          type: "checkbox",
          className: Ue.input,
          "data-testid": or.input
        }
      ),
      /* @__PURE__ */ s.jsx(
        "label",
        {
          htmlFor: r,
          className: f(Ue.inner, {
            [Ue.active]: n === "active",
            [Ue.pending]: n === "pending"
          }),
          "data-testid": or.label
        }
      )
    ] });
  }
}
class Ak extends D {
  render() {
    const { input: t, ...e } = this.props, { ref: n, ...o } = t;
    return /* @__PURE__ */ s.jsx(Qx, { ...o, ...e });
  }
}
class $k extends D {
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Ur,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...e,
            ...u
          }
        )
      }
    );
  }
}
const Bk = ({
  className: i,
  input: { name: t, value: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = F(
    (b) => void n(b ?? ""),
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: t,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        sn,
        {
          selectedItems: e ? [e] : [],
          ...o,
          ...m,
          disabled: c,
          id: t,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, Ok = ({
  className: i,
  input: { name: t, value: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = F(
    (b) => void n({
      startTime: b.startTime ?? "",
      endTime: b.endTime ?? ""
    }),
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: t,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        _m,
        {
          endTime: e.endTime,
          startTime: e.startTime,
          ...o,
          ...m,
          disabled: c,
          id: t,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, Zx = "h-inputColorPicker-indicator--inputColorPickerIndicator__root", Jx = "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha", ty = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator", ey = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor", Dn = {
  root: Zx,
  rootAlpha: Jx,
  indicator: ty,
  indicatorNoColor: ey
}, ny = ({
  color: i,
  alpha: t,
  className: e,
  ...n
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ...n,
    className: f(Dn.root, e, {
      [Dn.rootAlpha]: t
    }),
    children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(Dn.indicator, {
          [Dn.indicatorNoColor]: !i
        }),
        style: { backgroundColor: i }
      }
    )
  }
), sy = "h-inputColorPicker--inputColorPicker__root", oy = "h-inputColorPicker--inputColorPicker__inputContainer", ry = "h-inputColorPicker--inputColorPicker__input", iy = "h-inputColorPicker--inputColorPicker__rootReadOnly", ay = "h-inputColorPicker--inputColorPicker__iconContainer", ly = "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon", cy = "h-inputColorPicker--inputColorPicker__clearIcon", dy = "h-inputColorPicker--inputColorPicker__colorIndicator", Kt = {
  root: sy,
  inputContainer: oy,
  input: ry,
  rootReadOnly: iy,
  iconContainer: ay,
  rootHasWrapperIcon: ly,
  clearIcon: cy,
  colorIndicator: dy
}, hy = "inputColorPickerTestId", uy = ({
  className: i,
  name: t = Math.floor(Math.random() * 1e8).toString(),
  value: e,
  onChange: n,
  dropdownProps: o,
  prefix: r,
  suffix: a,
  icon: l,
  status: c,
  placeholder: d,
  disabled: h,
  colorPickerProps: u,
  clearable: p,
  readOnly: m,
  children: g,
  ...b
}) => {
  const x = Y(null), v = Y(null), y = Y(null), [C, _] = V(!1);
  et(() => {
    C ? (window.addEventListener("click", I), window.addEventListener("keydown", S)) : (window.removeEventListener("click", I), window.removeEventListener("keydown", S)), C && w();
  }, [C]), Qt(() => {
    window.removeEventListener("click", I), window.removeEventListener("keydown", S);
  });
  const w = () => {
    y.current?.querySelector("input")?.focus();
  }, I = ({ target: R }) => {
    v.current?.contains(R) || _(!1);
  }, S = (R) => {
    Fe(R.key) && C && (R.stopPropagation(), _(!1));
  }, T = () => {
    m || _(!0);
  }, P = ({ target: R }) => {
    v.current?.contains(R) || _(!1);
  }, A = () => {
    m || _(!0);
  }, k = ({ key: R }) => {
    Yn(R) && _(!0);
  };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": hy,
      ref: v,
      className: f(Kt.root, i, {
        [Kt.rootHasWrapperIcon]: !!l,
        [Kt.rootReadOnly]: m
      }),
      children: [
        /* @__PURE__ */ s.jsx(
          Et,
          {
            prefix: r,
            suffix: a,
            disabled: h,
            icon: l,
            active: C,
            status: c,
            children: /* @__PURE__ */ s.jsxs("div", { className: Kt.inputContainer, children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  ...b,
                  id: t,
                  name: t,
                  className: Kt.input,
                  ref: x,
                  onClick: A,
                  onFocus: T,
                  onBlur: P,
                  onKeyDown: k,
                  disabled: h,
                  placeholder: d,
                  autoComplete: "off",
                  value: e,
                  onChange: Bn(e) ? void 0 : E,
                  readOnly: !0
                }
              ),
              /* @__PURE__ */ s.jsx("div", { className: Kt.iconContainer, children: p && e && /* @__PURE__ */ s.jsx(
                K,
                {
                  className: Kt.clearIcon,
                  variant: "tertiary",
                  icon: "close",
                  disabled: h,
                  onClick: () => n?.("")
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                ny,
                {
                  className: Kt.colorIndicator,
                  onClick: A,
                  color: e,
                  alpha: u?.alpha
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s.jsx(Zt, { ...o, isOpen: C, children: /* @__PURE__ */ s.jsx("div", { ref: y, children: /* @__PURE__ */ s.jsx(
          Xn,
          {
            margin: "300",
            ...u,
            color: e,
            onChange: n ?? E,
            children: g
          }
        ) }) })
      ]
    }
  );
}, Hk = ({
  className: i,
  input: { value: t, name: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: e,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      uy,
      {
        name: e,
        value: t,
        onChange: n,
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), py = "h-fieldAddonDropdown--fieldAddonDropdown__root", my = "h-fieldAddonDropdown--fieldAddonDropdown__prefix", gy = "h-fieldAddonDropdown--fieldAddonDropdown__suffix", fy = "h-fieldAddonDropdown--fieldAddonDropdown__angleDown", kn = {
  root: py,
  prefix: my,
  suffix: gy,
  angleDown: fy
}, Wk = ({
  className: i,
  noArrow: t,
  ...e
}) => Hs(e) ? null : /* @__PURE__ */ s.jsx(js.Consumer, { children: ({ position: n, disabled: o }) => /* @__PURE__ */ s.jsx(
  Zs,
  {
    ...xr(e, "meta"),
    noStyle: !0,
    itemComponent: Ar,
    children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: f(
          kn.root,
          {
            [kn.prefix]: n === "prefix",
            [kn.suffix]: n === "suffix"
          },
          i
        ),
        disabled: o || e.meta.disabled,
        type: "button",
        children: [
          /* @__PURE__ */ s.jsx("span", { children: e.meta.selectedValue }),
          !t && /* @__PURE__ */ s.jsx(
            N,
            {
              name: "angle-down",
              className: f("icon-vertical-fix", kn.angleDown)
            }
          )
        ]
      }
    )
  }
) }), by = "h-countryFlag--countryFlag__flag", xy = "h-countryFlag--countryFlag__ad", yy = "h-countryFlag--countryFlag__ae", _y = "h-countryFlag--countryFlag__af", Cy = "h-countryFlag--countryFlag__ag", wy = "h-countryFlag--countryFlag__ai", vy = "h-countryFlag--countryFlag__al", Sy = "h-countryFlag--countryFlag__am", Iy = "h-countryFlag--countryFlag__ao", Dy = "h-countryFlag--countryFlag__aq", ky = "h-countryFlag--countryFlag__ar", Ty = "h-countryFlag--countryFlag__as", jy = "h-countryFlag--countryFlag__at", Ny = "h-countryFlag--countryFlag__au", Fy = "h-countryFlag--countryFlag__aw", Py = "h-countryFlag--countryFlag__ax", Ry = "h-countryFlag--countryFlag__az", Ey = "h-countryFlag--countryFlag__ba", Ly = "h-countryFlag--countryFlag__bb", Ay = "h-countryFlag--countryFlag__bd", $y = "h-countryFlag--countryFlag__be", By = "h-countryFlag--countryFlag__bf", Oy = "h-countryFlag--countryFlag__bg", Hy = "h-countryFlag--countryFlag__bh", Wy = "h-countryFlag--countryFlag__bi", My = "h-countryFlag--countryFlag__bj", zy = "h-countryFlag--countryFlag__bl", Vy = "h-countryFlag--countryFlag__bm", Ky = "h-countryFlag--countryFlag__bn", Uy = "h-countryFlag--countryFlag__bo", qy = "h-countryFlag--countryFlag__bq", Gy = "h-countryFlag--countryFlag__br", Yy = "h-countryFlag--countryFlag__bs", Xy = "h-countryFlag--countryFlag__bt", Qy = "h-countryFlag--countryFlag__bv", Zy = "h-countryFlag--countryFlag__bw", Jy = "h-countryFlag--countryFlag__by", t_ = "h-countryFlag--countryFlag__bz", e_ = "h-countryFlag--countryFlag__ca", n_ = "h-countryFlag--countryFlag__cd", s_ = "h-countryFlag--countryFlag__cf", o_ = "h-countryFlag--countryFlag__cg", r_ = "h-countryFlag--countryFlag__ch", i_ = "h-countryFlag--countryFlag__ci", a_ = "h-countryFlag--countryFlag__ck", l_ = "h-countryFlag--countryFlag__cl", c_ = "h-countryFlag--countryFlag__cm", d_ = "h-countryFlag--countryFlag__cn", h_ = "h-countryFlag--countryFlag__co", u_ = "h-countryFlag--countryFlag__cp", p_ = "h-countryFlag--countryFlag__cr", m_ = "h-countryFlag--countryFlag__cu", g_ = "h-countryFlag--countryFlag__cv", f_ = "h-countryFlag--countryFlag__cw", b_ = "h-countryFlag--countryFlag__cy", x_ = "h-countryFlag--countryFlag__cz", y_ = "h-countryFlag--countryFlag__de", __ = "h-countryFlag--countryFlag__dj", C_ = "h-countryFlag--countryFlag__dk", w_ = "h-countryFlag--countryFlag__dm", v_ = "h-countryFlag--countryFlag__dz", S_ = "h-countryFlag--countryFlag__ec", I_ = "h-countryFlag--countryFlag__ee", D_ = "h-countryFlag--countryFlag__eg", k_ = "h-countryFlag--countryFlag__eh", T_ = "h-countryFlag--countryFlag__er", j_ = "h-countryFlag--countryFlag__es", N_ = "h-countryFlag--countryFlag__et", F_ = "h-countryFlag--countryFlag__eu", P_ = "h-countryFlag--countryFlag__fi", R_ = "h-countryFlag--countryFlag__fj", E_ = "h-countryFlag--countryFlag__fm", L_ = "h-countryFlag--countryFlag__fo", A_ = "h-countryFlag--countryFlag__fr", $_ = "h-countryFlag--countryFlag__ga", B_ = "h-countryFlag--countryFlag__gb", O_ = "h-countryFlag--countryFlag__gd", H_ = "h-countryFlag--countryFlag__ge", W_ = "h-countryFlag--countryFlag__gg", M_ = "h-countryFlag--countryFlag__gh", z_ = "h-countryFlag--countryFlag__gi", V_ = "h-countryFlag--countryFlag__gl", K_ = "h-countryFlag--countryFlag__gm", U_ = "h-countryFlag--countryFlag__gn", q_ = "h-countryFlag--countryFlag__gp", G_ = "h-countryFlag--countryFlag__gq", Y_ = "h-countryFlag--countryFlag__gr", X_ = "h-countryFlag--countryFlag__gt", Q_ = "h-countryFlag--countryFlag__gu", Z_ = "h-countryFlag--countryFlag__gw", J_ = "h-countryFlag--countryFlag__gy", tC = "h-countryFlag--countryFlag__hk", eC = "h-countryFlag--countryFlag__hn", nC = "h-countryFlag--countryFlag__hr", sC = "h-countryFlag--countryFlag__ht", oC = "h-countryFlag--countryFlag__hu", rC = "h-countryFlag--countryFlag__id", iC = "h-countryFlag--countryFlag__ie", aC = "h-countryFlag--countryFlag__il", lC = "h-countryFlag--countryFlag__im", cC = "h-countryFlag--countryFlag__iq", dC = "h-countryFlag--countryFlag__ir", hC = "h-countryFlag--countryFlag__is", uC = "h-countryFlag--countryFlag__it", pC = "h-countryFlag--countryFlag__je", mC = "h-countryFlag--countryFlag__jm", gC = "h-countryFlag--countryFlag__jo", fC = "h-countryFlag--countryFlag__jp", bC = "h-countryFlag--countryFlag__ke", xC = "h-countryFlag--countryFlag__kg", yC = "h-countryFlag--countryFlag__kh", _C = "h-countryFlag--countryFlag__ki", CC = "h-countryFlag--countryFlag__km", wC = "h-countryFlag--countryFlag__kn", vC = "h-countryFlag--countryFlag__kp", SC = "h-countryFlag--countryFlag__kr", IC = "h-countryFlag--countryFlag__kw", DC = "h-countryFlag--countryFlag__ky", kC = "h-countryFlag--countryFlag__kz", TC = "h-countryFlag--countryFlag__la", jC = "h-countryFlag--countryFlag__lb", NC = "h-countryFlag--countryFlag__lc", FC = "h-countryFlag--countryFlag__li", PC = "h-countryFlag--countryFlag__lk", RC = "h-countryFlag--countryFlag__lr", EC = "h-countryFlag--countryFlag__ls", LC = "h-countryFlag--countryFlag__lt", AC = "h-countryFlag--countryFlag__lu", $C = "h-countryFlag--countryFlag__lv", BC = "h-countryFlag--countryFlag__ly", OC = "h-countryFlag--countryFlag__ma", HC = "h-countryFlag--countryFlag__mc", WC = "h-countryFlag--countryFlag__md", MC = "h-countryFlag--countryFlag__me", zC = "h-countryFlag--countryFlag__mf", VC = "h-countryFlag--countryFlag__mg", KC = "h-countryFlag--countryFlag__mh", UC = "h-countryFlag--countryFlag__mk", qC = "h-countryFlag--countryFlag__ml", GC = "h-countryFlag--countryFlag__mm", YC = "h-countryFlag--countryFlag__mn", XC = "h-countryFlag--countryFlag__mo", QC = "h-countryFlag--countryFlag__mq", ZC = "h-countryFlag--countryFlag__mr", JC = "h-countryFlag--countryFlag__ms", tw = "h-countryFlag--countryFlag__mt", ew = "h-countryFlag--countryFlag__mu", nw = "h-countryFlag--countryFlag__mv", sw = "h-countryFlag--countryFlag__mw", ow = "h-countryFlag--countryFlag__mx", rw = "h-countryFlag--countryFlag__my", iw = "h-countryFlag--countryFlag__mz", aw = "h-countryFlag--countryFlag__na", lw = "h-countryFlag--countryFlag__nc", cw = "h-countryFlag--countryFlag__ne", dw = "h-countryFlag--countryFlag__ng", hw = "h-countryFlag--countryFlag__ni", uw = "h-countryFlag--countryFlag__nl", pw = "h-countryFlag--countryFlag__no", mw = "h-countryFlag--countryFlag__np", gw = "h-countryFlag--countryFlag__nq", fw = "h-countryFlag--countryFlag__nr", bw = "h-countryFlag--countryFlag__nu", xw = "h-countryFlag--countryFlag__nz", yw = "h-countryFlag--countryFlag__om", _w = "h-countryFlag--countryFlag__pa", Cw = "h-countryFlag--countryFlag__pe", ww = "h-countryFlag--countryFlag__pf", vw = "h-countryFlag--countryFlag__pg", Sw = "h-countryFlag--countryFlag__ph", Iw = "h-countryFlag--countryFlag__pk", Dw = "h-countryFlag--countryFlag__pl", kw = "h-countryFlag--countryFlag__pr", Tw = "h-countryFlag--countryFlag__ps", jw = "h-countryFlag--countryFlag__pt", Nw = "h-countryFlag--countryFlag__pw", Fw = "h-countryFlag--countryFlag__py", Pw = "h-countryFlag--countryFlag__qa", Rw = "h-countryFlag--countryFlag__re", Ew = "h-countryFlag--countryFlag__ro", Lw = "h-countryFlag--countryFlag__rs", Aw = "h-countryFlag--countryFlag__ru", $w = "h-countryFlag--countryFlag__rw", Bw = "h-countryFlag--countryFlag__sa", Ow = "h-countryFlag--countryFlag__sb", Hw = "h-countryFlag--countryFlag__sc", Ww = "h-countryFlag--countryFlag__sd", Mw = "h-countryFlag--countryFlag__se", zw = "h-countryFlag--countryFlag__sg", Vw = "h-countryFlag--countryFlag__sh", Kw = "h-countryFlag--countryFlag__si", Uw = "h-countryFlag--countryFlag__sj", qw = "h-countryFlag--countryFlag__sk", Gw = "h-countryFlag--countryFlag__sl", Yw = "h-countryFlag--countryFlag__sm", Xw = "h-countryFlag--countryFlag__sn", Qw = "h-countryFlag--countryFlag__so", Zw = "h-countryFlag--countryFlag__sr", Jw = "h-countryFlag--countryFlag__ss", tv = "h-countryFlag--countryFlag__st", ev = "h-countryFlag--countryFlag__sv", nv = "h-countryFlag--countryFlag__sx", sv = "h-countryFlag--countryFlag__sy", ov = "h-countryFlag--countryFlag__sz", rv = "h-countryFlag--countryFlag__tc", iv = "h-countryFlag--countryFlag__td", av = "h-countryFlag--countryFlag__tg", lv = "h-countryFlag--countryFlag__th", cv = "h-countryFlag--countryFlag__tj", dv = "h-countryFlag--countryFlag__tl", hv = "h-countryFlag--countryFlag__tm", uv = "h-countryFlag--countryFlag__tn", pv = "h-countryFlag--countryFlag__to", mv = "h-countryFlag--countryFlag__tr", gv = "h-countryFlag--countryFlag__tt", fv = "h-countryFlag--countryFlag__tv", bv = "h-countryFlag--countryFlag__tw", xv = "h-countryFlag--countryFlag__tz", yv = "h-countryFlag--countryFlag__ua", _v = "h-countryFlag--countryFlag__ug", Cv = "h-countryFlag--countryFlag__us", wv = "h-countryFlag--countryFlag__uy", vv = "h-countryFlag--countryFlag__uz", Sv = "h-countryFlag--countryFlag__va", Iv = "h-countryFlag--countryFlag__vc", Dv = "h-countryFlag--countryFlag__ve", kv = "h-countryFlag--countryFlag__vg", Tv = "h-countryFlag--countryFlag__vi", jv = "h-countryFlag--countryFlag__vn", Nv = "h-countryFlag--countryFlag__vu", Fv = "h-countryFlag--countryFlag__ws", Pv = "h-countryFlag--countryFlag__ye", Rv = "h-countryFlag--countryFlag__yt", Ev = "h-countryFlag--countryFlag__za", Lv = "h-countryFlag--countryFlag__zm", Av = "h-countryFlag--countryFlag__zw", rr = {
  flag: by,
  ad: xy,
  ae: yy,
  af: _y,
  ag: Cy,
  ai: wy,
  al: vy,
  am: Sy,
  ao: Iy,
  aq: Dy,
  ar: ky,
  as: Ty,
  at: jy,
  au: Ny,
  aw: Fy,
  ax: Py,
  az: Ry,
  ba: Ey,
  bb: Ly,
  bd: Ay,
  be: $y,
  bf: By,
  bg: Oy,
  bh: Hy,
  bi: Wy,
  bj: My,
  bl: zy,
  bm: Vy,
  bn: Ky,
  bo: Uy,
  bq: qy,
  br: Gy,
  bs: Yy,
  bt: Xy,
  bv: Qy,
  bw: Zy,
  by: Jy,
  bz: t_,
  ca: e_,
  cd: n_,
  cf: s_,
  cg: o_,
  ch: r_,
  ci: i_,
  ck: a_,
  cl: l_,
  cm: c_,
  cn: d_,
  co: h_,
  cp: u_,
  cr: p_,
  cu: m_,
  cv: g_,
  cw: f_,
  cy: b_,
  cz: x_,
  de: y_,
  dj: __,
  dk: C_,
  dm: w_,
  do: "h-countryFlag--countryFlag__do",
  dz: v_,
  ec: S_,
  ee: I_,
  eg: D_,
  eh: k_,
  er: T_,
  es: j_,
  et: N_,
  eu: F_,
  fi: P_,
  fj: R_,
  fm: E_,
  fo: L_,
  fr: A_,
  ga: $_,
  gb: B_,
  gd: O_,
  ge: H_,
  gg: W_,
  gh: M_,
  gi: z_,
  gl: V_,
  gm: K_,
  gn: U_,
  gp: q_,
  gq: G_,
  gr: Y_,
  gt: X_,
  gu: Q_,
  gw: Z_,
  gy: J_,
  hk: tC,
  hn: eC,
  hr: nC,
  ht: sC,
  hu: oC,
  id: rC,
  ie: iC,
  il: aC,
  im: lC,
  in: "h-countryFlag--countryFlag__in",
  iq: cC,
  ir: dC,
  is: hC,
  it: uC,
  je: pC,
  jm: mC,
  jo: gC,
  jp: fC,
  ke: bC,
  kg: xC,
  kh: yC,
  ki: _C,
  km: CC,
  kn: wC,
  kp: vC,
  kr: SC,
  kw: IC,
  ky: DC,
  kz: kC,
  la: TC,
  lb: jC,
  lc: NC,
  li: FC,
  lk: PC,
  lr: RC,
  ls: EC,
  lt: LC,
  lu: AC,
  lv: $C,
  ly: BC,
  ma: OC,
  mc: HC,
  md: WC,
  me: MC,
  mf: zC,
  mg: VC,
  mh: KC,
  mk: UC,
  ml: qC,
  mm: GC,
  mn: YC,
  mo: XC,
  mq: QC,
  mr: ZC,
  ms: JC,
  mt: tw,
  mu: ew,
  mv: nw,
  mw: sw,
  mx: ow,
  my: rw,
  mz: iw,
  na: aw,
  nc: lw,
  ne: cw,
  ng: dw,
  ni: hw,
  nl: uw,
  no: pw,
  np: mw,
  nq: gw,
  nr: fw,
  nu: bw,
  nz: xw,
  om: yw,
  pa: _w,
  pe: Cw,
  pf: ww,
  pg: vw,
  ph: Sw,
  pk: Iw,
  pl: Dw,
  pr: kw,
  ps: Tw,
  pt: jw,
  pw: Nw,
  py: Fw,
  qa: Pw,
  re: Rw,
  ro: Ew,
  rs: Lw,
  ru: Aw,
  rw: $w,
  sa: Bw,
  sb: Ow,
  sc: Hw,
  sd: Ww,
  se: Mw,
  sg: zw,
  sh: Vw,
  si: Kw,
  sj: Uw,
  sk: qw,
  sl: Gw,
  sm: Yw,
  sn: Xw,
  so: Qw,
  sr: Zw,
  ss: Jw,
  st: tv,
  sv: ev,
  sx: nv,
  sy: sv,
  sz: ov,
  tc: rv,
  td: iv,
  tg: av,
  th: lv,
  tj: cv,
  tl: dv,
  tm: hv,
  tn: uv,
  to: pv,
  tr: mv,
  tt: gv,
  tv: fv,
  tw: bv,
  tz: xv,
  ua: yv,
  ug: _v,
  us: Cv,
  uy: wv,
  uz: vv,
  va: Sv,
  vc: Iv,
  ve: Dv,
  vg: kv,
  vi: Tv,
  vn: jv,
  vu: Nv,
  ws: Fv,
  ye: Pv,
  yt: Rv,
  za: Ev,
  zm: Lv,
  zw: Av
}, $v = 127365, Bv = /^[a-z]{2}$/, Ov = (i) => Bv.test(i) ? String.fromCodePoint(
  ...i.split("").map((t) => $v + t.charCodeAt(0))
) : "", Mk = ({
  className: i,
  countryCode: t,
  size: e = 16
}) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ s.jsx(it, { style: { width: e, height: e }, children: /* @__PURE__ */ s.jsx(
  it,
  {
    className: f(rr.flag, rr[t], i),
    style: {
      width: 32,
      height: 32,
      transform: `scale(calc(${e} / 32))`
    }
  }
) }) : /* @__PURE__ */ s.jsx("span", { className: i, style: { fontSize: e }, children: Ov(t) }), zk = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "bl",
  "mf",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "bq",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "za",
  "zm",
  "zw"
], Hv = "h-formGrid--formGrid__root", Wv = {
  root: Hv
}, Mv = "formGridTestId", Vk = $(function({ className: t, children: e, ...n }, o) {
  const r = f(Wv.root, t);
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-testid": Mv,
      className: r,
      ...n,
      ref: o,
      children: e
    }
  );
}), zv = "h-formGrid-field--formField__root", Vv = "h-formGrid-field--formField__rootSpan5", Kv = "h-formGrid-field--formField__rootSpan4", Uv = "h-formGrid-field--formField__rootSpan3", qv = "h-formGrid-field--formField__rootSpan2", Gv = "h-formGrid-field--formField__rootSpan1", Se = {
  root: zv,
  rootSpan5: Vv,
  rootSpan4: Kv,
  rootSpan3: Uv,
  rootSpan2: qv,
  rootSpan1: Gv
}, Yv = "formFieldTestId", Xv = {
  1: Se.rootSpan1,
  2: Se.rootSpan2,
  3: Se.rootSpan3,
  4: Se.rootSpan4,
  5: Se.rootSpan5,
  6: void 0
};
class Kk extends D {
  static defaultProps = {
    span: 6
  };
  render() {
    const { span: t, className: e, children: n, ...o } = this.props, r = f(
      Se.root,
      e,
      Xv[t]
    );
    return /* @__PURE__ */ s.jsx("div", { "data-testid": Yv, className: r, ...o, children: n });
  }
}
const Qv = "h-helperField--helperField__root", Zv = "h-helperField--helperField__label", Jv = "h-helperField--helperField__helpIcon", tS = "h-helperField--helperField__error", eS = "h-helperField--helperField__rootRequired", qe = {
  root: Qv,
  label: Zv,
  helpIcon: Jv,
  error: tS,
  rootRequired: eS
};
class Uk extends D {
  render() {
    const {
      className: t,
      label: e,
      required: n,
      disabled: o,
      errorMessage: r,
      fieldId: a,
      children: l,
      helpIcon: c,
      ...d
    } = this.props, h = f(
      {
        [qe.root]: !0,
        [qe.rootRequired]: n
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      !!e && /* @__PURE__ */ s.jsx(
        "label",
        {
          className: qe.label,
          htmlFor: a,
          id: `${a}-label`,
          children: e
        }
      ),
      !!c?.text && /* @__PURE__ */ s.jsx(
        Us,
        {
          ...c,
          className: f(qe.helpIcon, c?.className ?? "")
        }
      ),
      !!r && /* @__PURE__ */ s.jsx("p", { className: qe.error, children: r }),
      l
    ] });
  }
}
const nS = "h-inputDuration--inputDuration__root", sS = {
  root: nS
}, vs = (i, t = [
  "hours",
  "minutes",
  "seconds"
]) => {
  const e = Math.floor(i / 1e3), n = {};
  let o = e;
  return t.includes("days") && (n.days = Math.floor(e / (24 * 3600)), o = e % (24 * 3600)), t.includes("hours") && (n.hours = Math.floor(o / 3600), o %= 3600), t.includes("minutes") && (n.minutes = Math.floor(o / 60), o %= 60), t.includes("seconds") && (n.seconds = o), n;
}, Ss = (i) => ((i.days ?? 0) * 86400 + (i.hours ?? 0) * 3600 + (i.minutes ?? 0) * 60 + (i.seconds ?? 0)) * 1e3, oS = [
  "hours",
  "minutes",
  "seconds"
], qk = $(
  function(t, e) {
    const n = Y(null);
    je(e, () => n.current);
    const {
      className: o,
      name: r = "input-duration",
      value: a = 0,
      required: l = !1,
      disabled: c = !1,
      readOnly: d = !1,
      inputParts: h = oS,
      status: u,
      onChange: p,
      onBlur: m
    } = t, [g, b] = V(
      () => vs(a, h)
    );
    et(() => {
      const _ = Ss(g);
      if (a !== _) {
        const w = vs(a, h);
        b(w);
      }
    }, [a, h]);
    const x = F(
      (_, w) => {
        const I = Math.max(0, parseInt(w) || 0);
        if ((_ === "minutes" || _ === "seconds") && I > 60)
          return;
        const S = { ...g, [_]: I };
        b(S);
        const T = Ss(S);
        p?.(T);
      },
      [g, p]
    ), v = F(() => {
      const _ = Ss(g), w = vs(
        _,
        h
      );
      b(w), m?.();
    }, [g, h, m]), y = (_) => {
      const w = g[_] ?? 0, I = w === 0;
      return {
        type: "number",
        id: `${r}-${_}`,
        name: `${r}-${_}`,
        value: I ? "" : w,
        placeholder: I ? "0" : void 0,
        suffix: {
          type: "custom",
          value: _.charAt(0).toUpperCase() + _.slice(1)
        },
        min: 0,
        step: 1,
        required: l,
        disabled: c,
        readOnly: d,
        status: u,
        "aria-required": l,
        "aria-disabled": c,
        "aria-readonly": d,
        onBlur: v,
        onChange: (S) => x(_, S.target.value)
      };
    }, C = f(o, sS.root);
    return /* @__PURE__ */ s.jsxs("div", { ref: n, className: C, children: [
      h.includes("days") && /* @__PURE__ */ s.jsx(qt, { ...y("days") }),
      h.includes("hours") && /* @__PURE__ */ s.jsx(qt, { ...y("hours") }),
      h.includes("minutes") && /* @__PURE__ */ s.jsx(qt, { ...y("minutes"), max: 60 }),
      h.includes("seconds") && /* @__PURE__ */ s.jsx(qt, { ...y("seconds"), max: 60 })
    ] });
  }
), Ge = /* @__PURE__ */ new Map();
function rS({
  containerId: i,
  children: t
}) {
  const [e, n] = V(null), o = (a) => {
    const l = Ge.get(i);
    l !== void 0 && Ge.set(i, l + a);
  }, r = () => {
    const a = document.createElement("div");
    return a.id = i, a;
  };
  return et(() => {
    let a = document.getElementById(i);
    return a || (a = r(), document.body.appendChild(a), Ge.set(i, 0)), n(a), o(1), () => {
      o(-1), Ge.get(i) === 0 && a && (Ge.delete(i), a.remove());
    };
  }, [i]), e ? Wi.createPortal(t, e) : null;
}
const iS = "h-modal--modal__root", aS = "h-modal--modal__modalContainer", lS = "h-modal--modal__rootDisplayed", cS = "h-modal--modal__rootOpened", dS = "h-modal--modal__modalContent", hS = "h-modal--modal__modal", Ce = {
  root: iS,
  modalContainer: aS,
  rootDisplayed: lS,
  rootOpened: cS,
  modalContent: dS,
  modal: hS
};
class uS extends D {
  rootRef;
  haskeydownEventListner;
  closeTimer;
  static defaultProps = {
    allowEscClose: !0,
    restoreFocus: !0,
    bringInFocusOnTab: !0
  };
  constructor(t) {
    super(t), this.rootRef = B(), this.closeTimer = null, this.state = {
      opened: !1,
      displayed: !1
    }, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
  }
  componentDidMount() {
    const { isOpen: t } = this.props;
    t && this.animateOpening();
  }
  componentDidUpdate(t) {
    const { isOpen: e, allowEscClose: n } = this.props, { isOpen: o } = t;
    n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), e !== o && (e ? this.animateOpening() : this.animateClosing());
  }
  componentWillUnmount() {
    this.cancelAnimation(), this.removeKeyDownEventListener();
  }
  handleKey(t) {
    const { isOpen: e, onClose: n } = this.props;
    e && Fe(t.key) && (this.rootRef.current?.querySelector(
      '[role="menu"][aria-expanded="true"]'
    ) || (t.preventDefault(), t.stopPropagation(), this.animateClosing(), n(t)));
  }
  removeKeyDownEventListener = () => {
    window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
  };
  cancelAnimation() {
    const { current: t } = this.rootRef;
    t && t.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  animateOpening() {
    this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 }));
  }
  animateClosing() {
    this.rootRef.current && this.rootRef.current.addEventListener(
      "transitionend",
      this.onTransitionEnd
    ), this.removeKeyDownEventListener(), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred();
  }
  closeIfNoTransitionOccurred() {
    this.closeTimer = setTimeout(() => {
      this.closeTimer && this.onTransitionEnd();
    }, 400);
  }
  onTransitionEnd() {
    this.setState({ displayed: !1 }), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null), this.rootRef.current && this.rootRef.current.removeEventListener(
      "transitionend",
      this.onTransitionEnd
    );
  }
  render() {
    const {
      className: t,
      isOpen: e,
      children: n,
      onClose: o,
      allowClickOutside: r,
      allowEscClose: a,
      // Stops allowEscClose from being passed in with otherProps
      wrapProps: l,
      autoFocus: c,
      restoreFocus: d,
      bringInFocusOnTab: h,
      ...u
    } = this.props, { displayed: p, opened: m } = this.state, g = f(Ce.root, l?.className, {
      [Ce.rootDisplayed]: p,
      [Ce.rootOpened]: m
    }), b = f(Ce.modal, t);
    return /* @__PURE__ */ s.jsx(rS, { containerId: "modal-container", children: /* @__PURE__ */ s.jsx("div", { ...l, className: g, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: Ce.modalContainer,
        ref: this.rootRef,
        ...r ? { onClick: o } : {},
        ...u,
        children: m && // fixes an issue with child-components that need to measure boundingClientRect
        /* @__PURE__ */ s.jsx(
          wr,
          {
            containerRef: this.rootRef,
            autoFocus: c,
            restoreFocus: d,
            bringInFocusOnTab: h,
            children: /* @__PURE__ */ s.jsx("div", { className: Ce.modalContent, children: /* @__PURE__ */ s.jsx(
              "div",
              {
                className: b,
                onClick: (x) => r && x.stopPropagation(),
                children: n
              }
            ) })
          }
        )
      }
    ) }) });
  }
}
const pS = "h-lightbox--lightbox__lightSource", mS = "h-lightbox--lightbox__closeButton", gS = "h-lightbox--lightbox__downloadButton", fS = "h-lightbox--lightbox__image", bS = "h-lightbox--lightbox__loadingContainer", xS = "h-lightbox--lightbox__navButton", yS = "h-lightbox--lightbox__navButtonPrevious", _S = "h-lightbox--lightbox__navButtonNext", CS = "h-lightbox--lightbox__counter", kt = {
  lightSource: pS,
  closeButton: mS,
  downloadButton: gS,
  image: fS,
  loadingContainer: bS,
  navButton: xS,
  navButtonPrevious: yS,
  navButtonNext: _S,
  counter: CS
};
class Gk extends D {
  render() {
    const {
      className: t,
      src: e,
      alt: n,
      isOpen: o,
      onClose: r,
      showNavigation: a = !1,
      currentIndex: l = 0,
      totalImages: c = 1,
      onPrevious: d,
      onNext: h,
      isLoading: u = !1
    } = this.props, p = c > 1;
    return /* @__PURE__ */ s.jsx(
      uS,
      {
        className: t,
        isOpen: o,
        allowClickOutside: !0,
        onClose: r,
        children: /* @__PURE__ */ s.jsxs("div", { className: kt.lightSource, children: [
          u ? /* @__PURE__ */ s.jsx("div", { className: kt.loadingContainer, children: /* @__PURE__ */ s.jsx(Un, { size: 64 }) }) : e && /* @__PURE__ */ s.jsx(zs, { className: kt.image, alt: n, src: e }),
          r && /* @__PURE__ */ s.jsx(
            K,
            {
              onClick: r,
              icon: "close",
              variant: "secondary",
              className: kt.closeButton
            }
          ),
          e && typeof e == "string" && /* @__PURE__ */ s.jsx(
            "a",
            {
              href: e,
              target: "_blank",
              download: !0,
              className: kt.downloadButton,
              rel: "noreferrer",
              children: /* @__PURE__ */ s.jsx(
                N,
                {
                  name: "cloud-download",
                  className: f("icon-vertical-fix")
                }
              )
            }
          ),
          a && p && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-left",
                variant: "primary",
                size: "large",
                onClick: d,
                className: `${kt.navButton} ${kt.navButtonPrevious}`
              }
            ),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-right",
                variant: "primary",
                size: "large",
                onClick: h,
                className: `${kt.navButton} ${kt.navButtonNext}`
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { className: kt.counter, children: [
              l + 1,
              " / ",
              c
            ] })
          ] })
        ] })
      }
    );
  }
}
const wS = "h-list-items--item__root", vS = "h-list-items--item__rootWithHoverEffect", SS = "h-list-items--item__rootDense", IS = "h-list-items--item__rootLarge", DS = "h-list-items--item__contentLeft", kS = "h-list-items--item__contentRight", TS = "h-list-items--item__titles", jS = "h-list-items--item__title", NS = "h-list-items--item__titleSecondary", FS = "h-list-items--item__arrow", Tt = {
  root: wS,
  rootWithHoverEffect: vS,
  rootDense: SS,
  rootLarge: IS,
  contentLeft: DS,
  contentRight: kS,
  titles: TS,
  title: jS,
  titleSecondary: NS,
  arrow: FS
};
class ts extends D {
  static defaultProps = {
    variant: "dense",
    withHoverEffect: !0
  };
  renderTitle() {
    const { title: t, titleSecondary: e } = this.props;
    return t || e ? /* @__PURE__ */ s.jsxs("div", { className: Tt.titles, children: [
      !!t && /* @__PURE__ */ s.jsx(L.Paragraph, { as: "div", variant: "2", className: Tt.title, children: t }),
      !!e && /* @__PURE__ */ s.jsx(
        L.Paragraph,
        {
          as: "div",
          variant: "4",
          subdued: !0,
          className: Tt.titleSecondary,
          children: e
        }
      )
    ] }) : null;
  }
  renderContentLeft() {
    const { contentLeft: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx("div", { className: Tt.contentLeft, children: t }) : null;
  }
  renderContentRight() {
    const { contentRight: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx("div", { className: Tt.contentRight, children: t }) : null;
  }
  renderIcon() {
    const { isLink: t, contentRight: e } = this.props;
    return t && !e ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: f(Tt.arrow, "icon-vertical-fix"),
        name: "angle-right",
        size: 24
      }
    ) : null;
  }
  renderContent() {
    return /* @__PURE__ */ s.jsxs(Xt, { children: [
      this.renderContentLeft(),
      this.renderTitle(),
      this.renderContentRight(),
      this.renderIcon()
    ] });
  }
  getChildrenWithFallback() {
    return this.props.children ?? this.renderContent();
  }
  render() {
    const {
      className: t,
      children: e,
      contentLeft: n,
      contentRight: o,
      title: r,
      titleSecondary: a,
      secondaryTitleBelow: l,
      isLink: c,
      variant: d,
      withHoverEffect: h,
      ...u
    } = this.props, p = f(Tt.root, t, {
      [Tt.rootDense]: d === "dense",
      [Tt.rootLarge]: d === "large",
      [Tt.rootWithHoverEffect]: h
    });
    return /* @__PURE__ */ s.jsx("li", { ...u, className: p, children: this.getChildrenWithFallback() });
  }
}
const PS = "h-list-items--keyValue__root", RS = {
  root: PS
};
class ES extends D {
  static defaultProps = {
    hideIfValueIsEmpty: !0
  };
  isValueEmpty() {
    return !this.props.pair.value;
  }
  render() {
    const { hideIfValueIsEmpty: t, className: e, pair: n, ...o } = this.props, r = f(RS.root, e);
    return t && this.isValueEmpty() ? null : /* @__PURE__ */ s.jsx(
      ts,
      {
        ...o,
        className: r,
        title: /* @__PURE__ */ s.jsx(L.Paragraph, { as: "span", variant: "4", subdued: !0, children: n.key }),
        titleSecondary: /* @__PURE__ */ s.jsx(L.Paragraph, { as: "span", variant: "2", children: n.value }),
        "data-testid": "List-KeyValue"
      }
    );
  }
}
const LS = "h-list-items--text__root", AS = {
  root: LS
};
class $S extends D {
  render() {
    const { children: t, className: e, ...n } = this.props, o = f(AS.root, e);
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        ...n,
        className: o,
        "data-testid": "List-Text",
        children: /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: t })
      }
    );
  }
}
const BS = "h-list-items--user__root", OS = "h-list-items--user__avatarWrapper", ir = {
  root: BS,
  avatarWrapper: OS
};
class HS extends D {
  getTitle() {
    const { user: t, title: e } = this.props;
    return e || t.display_name || t.name || t.phone_number || t.id;
  }
  getSubTitle() {
    const { user: t, titleSecondary: e } = this.props;
    return e || t.email;
  }
  render() {
    const { className: t, user: e, title: n, titleSecondary: o, ...r } = this.props, a = f(t, ir.root);
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        className: a,
        contentLeft: /* @__PURE__ */ s.jsx("div", { className: ir.avatarWrapper, children: /* @__PURE__ */ s.jsx(Cr, { user: e }) }),
        title: this.getTitle(),
        titleSecondary: this.getSubTitle(),
        "data-testid": "<List.User>",
        ...r
      }
    );
  }
}
const WS = "h-list--list__root", MS = {
  root: WS
};
class zS extends D {
  static Item = ts;
  static Text = $S;
  static User = HS;
  static KeyValue = ES;
  render() {
    const { className: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx("ul", { ...e, className: f(MS.root, t) });
  }
}
const Yk = an(zS, {
  fallback: null
}), VS = () => {
  document.exitFullscreen && document.exitFullscreen();
}, KS = (i) => {
  i.requestFullscreen ? i.requestFullscreen() : i.mozRequestFullScreen ? i.mozRequestFullScreen() : i.webkitRequestFullscreen ? i.webkitRequestFullscreen() : i.msRequestFullscreen && i.msRequestFullscreen();
}, US = (i) => document.fullscreenElement === i;
class qS extends Error {
  status;
  url;
  response;
  constructor(t) {
    super(`NetworkError ${t.status} ${t.url}`), this.status = t.status, this.url = t.url, this.response = t;
  }
}
const GS = {
  fetch: (i, ...t) => fetch(i, ...t).then((e) => {
    if (!(e.status >= 200 && e.status < 300))
      throw new qS(e);
    return e;
  })
}, YS = "h-mediaPlayer--mediaPlayer__root", XS = "h-mediaPlayer--mediaPlayer__controls", QS = "h-mediaPlayer--mediaPlayer__unstyled", ZS = "h-mediaPlayer--mediaPlayer__rootFullScreen", JS = "h-mediaPlayer--mediaPlayer__rootHideControls", tI = "h-mediaPlayer--mediaPlayer__control", eI = "h-mediaPlayer--mediaPlayer__progress", nI = "h-mediaPlayer--mediaPlayer__progressSlider", sI = "h-mediaPlayer--mediaPlayer__volumeSlider", oI = "h-mediaPlayer--mediaPlayer__timestamp", rI = "h-mediaPlayer--mediaPlayer__videoWrapper", iI = "h-mediaPlayer--mediaPlayer__rootWaiting", aI = "h-mediaPlayer--mediaPlayer__rootAudio", lI = "h-mediaPlayer--mediaPlayer__video", cI = "h-mediaPlayer--mediaPlayer__volume", dI = "h-mediaPlayer--mediaPlayer__volumeMuteControl", hI = "h-mediaPlayer--mediaPlayer__downloadLink", Z = {
  root: YS,
  controls: XS,
  unstyled: QS,
  rootFullScreen: ZS,
  rootHideControls: JS,
  control: tI,
  progress: eI,
  progressSlider: nI,
  volumeSlider: sI,
  timestamp: oI,
  videoWrapper: rI,
  rootWaiting: iI,
  rootAudio: aI,
  video: lI,
  volume: cI,
  volumeMuteControl: dI,
  downloadLink: hI
};
function uI(i) {
  const t = i >= 3600 ? 8 : 5;
  return Number.isNaN(i) || !Number.isFinite(i) ? "00:00" : new Date(i * 1e3).toISOString().substr(19 - t, t);
}
class Xk extends D {
  intersectionObserver;
  static defaultProps = {
    headers: {}
  };
  constructor(t) {
    super(t), this.state = {
      src: void 0,
      playing: !1,
      actuallyPlaying: !1,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 100,
      isFullScreen: !1,
      hideControls: !1,
      isWaiting: !1,
      buffer: null,
      asyncStatus: null
    }, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.handleIntersection = this.handleIntersection.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
  }
  componentDidMount() {
    const { lazy: t } = this.props, { current: e } = this.playerRef;
    e && e.addEventListener("fullscreenchange", this.handleFullscreenChange), t ? this.createIntersectionObserver() : this.loadSrc();
  }
  componentDidUpdate(t, e) {
    const {
      mediaFile: { src: n }
    } = t, {
      lazy: o,
      mediaFile: { src: r }
    } = this.props;
    n !== r && (o ? this.setSrc() : this.loadSrc()), this.tryReloadPlayer(e);
  }
  componentWillUnmount() {
    const { current: t } = this.playerRef;
    t && t.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    ), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
  }
  videoRef = B();
  playerRef = B();
  hideControlsTimeout = void 0;
  controller = new AbortController();
  loadSrc() {
    const {
      mediaFile: { src: t },
      isPrivateFile: e
    } = this.props;
    this.tryStopPlayer(), e ? this.fetchFile() : this.setSrc(t);
  }
  setSrc(t) {
    this.setState({
      src: t
    });
  }
  handleIntersection([t]) {
    const { src: e, asyncStatus: n } = this.state;
    !e && !(n === "loading") && t.isIntersecting && (this.loadSrc(), this.intersectionObserver?.disconnect());
  }
  createIntersectionObserver() {
    const { current: t } = this.playerRef;
    t && (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 }
    ), this.intersectionObserver.observe(t));
  }
  tryStopPlayer() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    t.currentTime = 0;
    const { playing: e, actuallyPlaying: n } = this.state;
    e && n && (t.pause(), this.setState({ playing: !1, actuallyPlaying: !1 }));
  }
  tryReloadPlayer(t) {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    const { src: n } = this.state;
    n !== t.src && e.load();
  }
  fetchFile(t) {
    const {
      mediaFile: { src: e },
      headers: n,
      filename: o
    } = this.props;
    this.setState({ asyncStatus: "loading" });
    const r = new Headers(n);
    GS.fetch(e, {
      headers: r,
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      signal: this.controller.signal
    }).then((a) => a.blob()).then((a) => {
      const l = window.URL.createObjectURL(a);
      t ? Ni.saveAs(
        a,
        o || decodeURIComponent(e.split("/").pop())
      ) : this.setSrc(l), this.setState({ asyncStatus: "succeeded" });
    }).catch((a) => {
      a && a.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", a), this.setState({ asyncStatus: "failed" }));
    });
  }
  updateProgress() {
    const { current: t } = this.videoRef;
    t && this.setState({
      time: t.currentTime,
      duration: t.duration
    });
  }
  updateBuffer() {
    const { current: t } = this.videoRef, { time: e, duration: n } = this.state;
    if (t) {
      let o = null;
      const r = t.buffered;
      for (let a = 0; a < r.length; a += 1) {
        const l = r.start(a), c = r.end(a);
        l <= e && e <= c && (o = [l / n, c / n]);
      }
      this.setState({
        buffer: o
      });
    }
  }
  handleWaiting() {
    this.setState({
      isWaiting: !0
    });
  }
  handlePlaying() {
    this.setState({
      isWaiting: !1
    });
  }
  handleTogglePlayClick() {
    const { playing: t, actuallyPlaying: e } = this.state, { current: n } = this.videoRef;
    n && (t && e ? (n.pause(), this.setState({
      isWaiting: !1,
      playing: !1,
      actuallyPlaying: !1
    })) : t || (this.setState({
      isWaiting: !0,
      playing: !0,
      actuallyPlaying: !1
    }), n.play().then(() => {
      this.setState({ actuallyPlaying: !0 });
    })));
  }
  startHideControlCountdown() {
    this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({
      hideControls: !1
    }), this.hideControlsTimeout = setTimeout(() => {
      this.setState({
        hideControls: !0
      });
    }, 2e3);
  }
  handleFullscreenChange() {
    const { current: t } = this.playerRef, e = US(t);
    this.setState({
      isFullScreen: e
    }), e ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
  }
  handleFullscreenToggle() {
    const { current: t } = this.playerRef, { isFullScreen: e } = this.state;
    t && (e ? VS() : KS(t));
  }
  handleEnded() {
    this.setState({
      playing: !1
    });
  }
  handleError() {
    this.props.onError && this.props.onError();
  }
  seek(t) {
    const { current: e } = this.videoRef, { duration: n } = this.state;
    e && t && !Number.isNaN(t) && (e.currentTime = n * t);
  }
  handleVolume = (t) => {
    const { current: e } = this.videoRef;
    !e || typeof t > "u" || !Number.isFinite(t) || this.setState({ volume: t }, () => {
      this.setPlayerVolume(t);
    });
  };
  handleMute() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    const { volume: e, prevVolume: n } = this.state, o = e === 0, r = o ? n : 0;
    this.setState(
      {
        volume: r,
        prevVolume: o ? n : e
      },
      () => {
        this.setPlayerVolume(r);
      }
    );
  }
  setPlayerVolume(t) {
    const { current: e } = this.videoRef;
    e && (e.volume = t / 100);
  }
  render() {
    const {
      className: t,
      mediaFile: { type: e },
      headers: n,
      isPrivateFile: o,
      width: r,
      controls: a,
      noControlsStyle: l,
      ...c
    } = this.props, {
      src: d,
      playing: h,
      duration: u,
      time: p,
      volume: m,
      hideControls: g,
      isFullScreen: b,
      isWaiting: x,
      buffer: v,
      asyncStatus: y
    } = this.state, C = a?.play ?? !0, _ = a?.download ?? !0, w = a?.progress ?? !0, I = a?.volume ?? !0, S = a?.maximize ?? !0, T = C || _ || w || I || S, P = typeof e == "string" && e.startsWith("audio"), A = !d || y === "loading", k = b ? "primary" : "secondary", R = f(
      Z.root,
      {
        [Z.rootFullScreen]: b,
        [Z.rootHideControls]: g,
        [Z.rootWaiting]: h && x,
        [Z.rootAudio]: P
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...c,
        className: R,
        ref: this.playerRef,
        style: { width: r },
        children: [
          /* @__PURE__ */ s.jsx("div", { className: Z.videoWrapper, children: !!d && /* @__PURE__ */ s.jsx(
            "video",
            {
              className: Z.video,
              ref: this.videoRef,
              onDurationChange: this.updateProgress,
              onTimeUpdate: this.updateProgress,
              onWaiting: this.handleWaiting,
              onPlaying: this.handlePlaying,
              onProgress: this.updateBuffer,
              onEnded: this.handleEnded,
              onError: this.handleError,
              children: /* @__PURE__ */ s.jsx("source", { src: d })
            }
          ) }),
          T && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: f(Z.controls, {
                [Z.unstyled]: l
              }),
              children: [
                C && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    onClick: this.handleTogglePlayClick,
                    className: Z.control,
                    disabled: A,
                    icon: h ? "pause" : "play",
                    variant: k
                  }
                ),
                _ && (o ? /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: k,
                    className: Z.control,
                    disabled: A,
                    children: /* @__PURE__ */ s.jsx(
                      "a",
                      {
                        href: d,
                        download: !0,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: Z.downloadLink,
                        children: /* @__PURE__ */ s.jsx(N, { name: "download" })
                      }
                    )
                  }
                ) : /* @__PURE__ */ s.jsx(
                  K,
                  {
                    icon: "download",
                    variant: k,
                    className: Z.control,
                    disabled: A,
                    onClick: () => this.fetchFile(!0)
                  }
                )),
                w && /* @__PURE__ */ s.jsxs("div", { className: Z.progress, children: [
                  /* @__PURE__ */ s.jsx(
                    As,
                    {
                      hideAnnotations: !0,
                      className: Z.progressSlider,
                      min: 0,
                      max: u,
                      value: p,
                      onChange: (W) => !Array.isArray(W) && this.seek(W / u),
                      dark: b,
                      highlightRange: v?.map((W) => W * u)
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: Z.timestamp, children: uI(u) })
                ] }),
                I && /* @__PURE__ */ s.jsxs("div", { className: Z.volume, children: [
                  /* @__PURE__ */ s.jsx(
                    N,
                    {
                      className: Z.volumeMuteControl,
                      name: m === 0 ? "volume-off" : "volume-up",
                      onClick: this.handleMute
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    As,
                    {
                      hideAnnotations: !0,
                      className: Z.volumeSlider,
                      value: m,
                      onChange: (W) => !Array.isArray(W) && this.handleVolume(W),
                      dark: b
                    }
                  )
                ] }),
                S && !P && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    variant: k,
                    onClick: this.handleFullscreenToggle,
                    className: Z.control,
                    icon: "expand"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
}
const pI = "h-modalBody--modalBody__root", mI = {
  root: pI
};
class Qk extends D {
  render() {
    const { className: t, children: e, ...n } = this.props, o = f(
      {
        [mI.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: e });
  }
}
const gI = "h-modalFoot--modalFoot__root", fI = "h-modalFoot--modalFoot__confirm", bI = "h-modalFoot--modalFoot__confirmSecondary", xI = "h-modalFoot--modalFoot__cancel", Tn = {
  root: gI,
  confirm: fI,
  confirmSecondary: bI,
  cancel: xI
};
class yI extends D {
  static defaultProps;
  render() {
    const {
      className: t,
      confirmOnClick: e,
      confirmSecondaryOnClick: n,
      cancelOnClick: o,
      confirmName: r,
      confirmSecondaryName: a,
      cancelName: l,
      confirmProps: c,
      confirmSecondaryProps: d,
      cancelProps: h,
      children: u,
      ...p
    } = this.props, m = f(
      {
        [Tn.root]: !0
      },
      t
    ), g = f(
      {
        [Tn.cancel]: !0
      },
      h?.className
    ), b = f(
      {
        [Tn.confirm]: !0
      },
      c?.className
    ), x = f(
      {
        [Tn.confirmSecondary]: !0
      },
      d?.className
    );
    return /* @__PURE__ */ s.jsxs("div", { ...p, className: m, children: [
      u,
      n && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "secondary",
          ...d,
          className: x,
          onClick: n,
          children: a
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "tertiary",
          ...h,
          className: g,
          onClick: o,
          children: l
        }
      ),
      e && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "primary",
          ...c,
          className: b,
          onClick: e,
          children: r
        }
      )
    ] });
  }
}
yI.defaultProps = {
  confirmName: "Save",
  cancelName: "Cancel",
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};
const _I = "h-modalHead--modalHead__root", CI = "h-modalHead--modalHead__top", wI = "h-modalHead--modalHead__title", vI = "h-modalHead--modalHead__buttons", SI = "h-modalHead--modalHead__caption", Ye = {
  root: _I,
  top: CI,
  title: wI,
  buttons: vI,
  caption: SI
}, Zk = ({
  className: i,
  title: t,
  children: e,
  onClose: n,
  secondaryButton: o,
  buttonsClassName: r,
  ...a
}) => {
  const l = f(
    {
      [Ye.root]: !0
    },
    i
  );
  return /* @__PURE__ */ s.jsxs("div", { ...a, className: l, children: [
    /* @__PURE__ */ s.jsxs("div", { className: Ye.top, children: [
      /* @__PURE__ */ s.jsx(L.Heading, { className: Ye.title, children: t }),
      /* @__PURE__ */ s.jsxs("div", { className: f(Ye.buttons, r), children: [
        typeof o?.onClick == "function" && /* @__PURE__ */ s.jsx(gt, { content: o?.tooltipContent, children: /* @__PURE__ */ s.jsx(
          K,
          {
            icon: o?.icon,
            variant: "tertiary",
            onClick: o?.onClick
          }
        ) }),
        typeof n == "function" && /* @__PURE__ */ s.jsx(
          K,
          {
            icon: "close",
            iconSize: 24,
            variant: "tertiary",
            onClick: n
          }
        )
      ] })
    ] }),
    !!e && /* @__PURE__ */ s.jsx(
      L.Paragraph,
      {
        variant: "2",
        color: "secondary",
        className: Ye.caption,
        children: e
      }
    )
  ] });
}, II = "h-page-body--pageBody__root", DI = {
  root: II
}, kI = $(function({ children: t, className: e, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    pt.Row,
    {
      ...n,
      ref: o,
      className: f(DI.root, e),
      scrollable: !0,
      noMinHeight: !0,
      noHorizontalPadding: !0,
      noVerticalPadding: !0,
      children: t
    }
  );
}), TI = "h-page-head--pageHead__root", jI = {
  root: TI
}, NI = $(function({ className: t, title: e, controls: n, ...o }, r) {
  return /* @__PURE__ */ s.jsxs(
    pt.Row,
    {
      ...o,
      ref: r,
      as: "header",
      className: f(jI.root, t),
      slottable: !0,
      borderBottom: !0,
      children: [
        /* @__PURE__ */ s.jsx(pt.Slot, { placement: "start", children: /* @__PURE__ */ s.jsx(L.Heading, { variant: "heading-2", as: "h1", children: e }) }),
        n && /* @__PURE__ */ s.jsx(pt.Slot, { placement: "end", children: /* @__PURE__ */ s.jsx(O, { alignItems: "center", gap: "200", children: n }) })
      ]
    }
  );
}), FI = "h-page-section--pageSection__root", PI = "h-page-section--pageSection__head", RI = "h-page-section--pageSection__callout", EI = "h-page-section--pageSection__content", jn = {
  root: FI,
  head: PI,
  callout: RI,
  content: EI
}, LI = $(function({
  children: t,
  className: e,
  title: n,
  titleMeta: o,
  controls: r,
  callout: a,
  ...l
}, c) {
  const d = !!(n || o || r);
  return /* @__PURE__ */ s.jsxs(
    pt.Row,
    {
      ...l,
      ref: c,
      as: "section",
      className: f(jn.root, e),
      noMinHeight: !0,
      children: [
        d && /* @__PURE__ */ s.jsxs(
          pt.Row,
          {
            className: jn.head,
            slottable: !0,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: [
              (n || o) && /* @__PURE__ */ s.jsx(pt.Slot, { placement: "start", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsxs(O, { alignItems: "center", gap: "200", children: [
                n && /* @__PURE__ */ s.jsx(L.Heading, { variant: "heading-3", as: "h2", children: n }),
                o && /* @__PURE__ */ s.jsx(O, { alignItems: "center", gap: "200", children: o })
              ] }) }),
              r && /* @__PURE__ */ s.jsx(pt.Slot, { placement: "end", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsx(O, { alignItems: "center", gap: "200", children: r }) })
            ]
          }
        ),
        a && /* @__PURE__ */ s.jsx(
          pt.Row,
          {
            className: jn.callout,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: a
          }
        ),
        /* @__PURE__ */ s.jsx(
          pt.Row,
          {
            className: jn.content,
            size: 1,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: t
          }
        )
      ]
    }
  );
}), AI = $(function({ children: t, className: e, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    pt.Row,
    {
      ...n,
      ref: o,
      className: e,
      borderBottom: !0,
      noVerticalPadding: !0,
      noMinHeight: !0,
      children: t
    }
  );
}), ar = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(sd, { ...e, ref: n, as: "article", className: t, children: /* @__PURE__ */ s.jsx(pt, { children: i }) }), Jk = Object.assign($(ar), {
  name: ar.name,
  Head: NI,
  Body: kI,
  Section: LI,
  Tabs: AI
}), $I = "h-radio--radio__radio", BI = "h-radio--radio__radioDisabled", OI = "h-radio--radio__radioChecked", HI = "h-radio--radio__input", Nn = {
  radio: $I,
  radioDisabled: BI,
  radioChecked: OI,
  input: HI
}, tT = $(function(t, e) {
  const { id: n, checked: o, disabled: r, className: a, labelProps: l, ...c } = t, d = f(
    Nn.radio,
    { [Nn.radioChecked]: o },
    { [Nn.radioDisabled]: r },
    a
  ), h = n || `radio_${Math.random()}`;
  return /* @__PURE__ */ s.jsx(
    "label",
    {
      ...l,
      className: d,
      htmlFor: h,
      "data-testid": "radio",
      children: /* @__PURE__ */ s.jsx(
        "input",
        {
          ...c,
          ref: e,
          id: h,
          onChange: c.onChange || E,
          checked: o,
          disabled: r,
          type: "radio",
          className: Nn.input,
          "data-testid": "input"
        }
      )
    }
  );
}), WI = "h-reverseScroll--reverseScroll__root", MI = "h-reverseScroll--reverseScroll__column", zI = "h-reverseScroll--reverseScroll__row", VI = "h-reverseScroll--reverseScroll__scrollHandle", Xe = {
  root: WI,
  column: MI,
  row: zI,
  scrollHandle: VI
}, KI = "reverse-scroll", eT = $(function({
  children: t,
  className: e,
  direction: n = "column",
  ...o
}, r) {
  const a = Y(null), l = Y(null), c = Y(null), d = Jn(t), h = U(
    () => d.reverse(),
    [d]
  ), u = (b) => c.current?.scrollIntoView(b), p = (b) => l.current?.scrollIntoView(b), m = (b) => a.current?.children[1]?.scrollIntoView(b), g = (b) => a.current?.children[a.current.children.length - 2]?.scrollIntoView(b);
  return je(r, () => ({
    rootElem: a.current,
    scrollToEnd: u,
    scrollToStart: p,
    scrollToFirstChild: g,
    scrollToLastChild: m
  })), /* @__PURE__ */ s.jsxs(
    "div",
    {
      ...o,
      "data-testid": KI,
      ref: a,
      className: f(e, Xe.root, {
        [Xe.row]: n === "row",
        [Xe.column]: n === "column"
      }),
      children: [
        /* @__PURE__ */ s.jsx("div", { ref: c, className: Xe.scrollHandle }),
        h,
        /* @__PURE__ */ s.jsx("div", { ref: l, className: Xe.scrollHandle })
      ]
    }
  );
}), UI = "h-removableCard--removableCard__root", qI = "h-removableCard--removableCard__close", GI = "h-removableCard--removableCard__title", YI = "h-removableCard--removableCard__titleIcon", Qe = {
  root: UI,
  close: qI,
  title: GI,
  titleIcon: YI
};
class nT extends D {
  render() {
    const { icon: t, title: e, children: n, onRemove: o, className: r, ...a } = this.props, l = f(
      {
        [Qe.root]: Qe.root
      },
      r
    );
    return /* @__PURE__ */ s.jsxs(
      it,
      {
        padding: "300",
        background: "neutral.100",
        borderRadius: !0,
        ...a,
        className: l,
        children: [
          /* @__PURE__ */ s.jsx(
            it,
            {
              as: "button",
              "aria-label": "Remove",
              className: Qe.close,
              onClick: o,
              children: /* @__PURE__ */ s.jsx(N, { name: "close" })
            }
          ),
          /* @__PURE__ */ s.jsxs(
            O,
            {
              alignItems: "flex-start",
              justifyContent: "flex-start",
              className: Qe.title,
              children: [
                t && /* @__PURE__ */ s.jsx(N, { name: t, className: Qe.titleIcon }),
                e
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(it, { margin: "300 0 0 0" }),
          n
        ]
      }
    );
  }
}
const lr = ({
  colorMode: i = "light"
}) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${i}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${i};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, XI = "h-sandboxIframe--sandboxIframe__frame", QI = {
  frame: XI
};
class Xr extends D {
  frameRef;
  static defaultProps;
  constructor(t) {
    super(t), this.state = {
      iframeHeight: 0
    }, this.frameRef = B(), this.handlePostMessage = this.handlePostMessage.bind(this);
  }
  componentDidMount() {
    this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
  }
  componentDidUpdate(t) {
    const { content: e, headContent: n, colorMode: o } = this.props;
    (t.content !== e || t.headContent !== n || t.colorMode !== o) && this.buildSandbox();
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handlePostMessage);
  }
  static defaultSandboxParams = "allow-scripts allow-popups allow-forms";
  buildSandbox() {
    const { content: t, headContent: e = "", colorMode: n = "light" } = this.props, { current: o } = this.frameRef;
    if (o) {
      let r = "";
      t.indexOf("</body>") !== -1 ? r = t.replace(
        "</body>",
        `${lr({ colorMode: n })}</body>`
      ) : r = `<html><head><meta charset="utf-8" /><base target="_parent" />${e}</head><body>${t}${lr(
        { colorMode: n }
      )}</body></html>`, o.src = `data:text/html;base64,${window.btoa(
        unescape(encodeURIComponent(r))
      )}`;
    }
  }
  handlePostMessage(t) {
    const { current: e } = this.frameRef;
    if (e && t.source === e.contentWindow) {
      const { data: n } = t;
      typeof n == "object" && n !== null && n.event === "heightChange" && typeof n.value == "number" && this.setState({
        iframeHeight: n.value
      });
    }
  }
  render() {
    const {
      className: t,
      content: e,
      headContent: n,
      sandbox: o,
      colorMode: r,
      ...a
    } = this.props, { iframeHeight: l } = this.state, c = f({}, t);
    return /* @__PURE__ */ s.jsx("div", { ...a, className: c, children: /* @__PURE__ */ s.jsx(
      "iframe",
      {
        title: "message",
        sandbox: o ?? Xr.defaultSandboxParams,
        allowFullScreen: !0,
        scrolling: "no",
        frameBorder: "no",
        style: { height: `${l}px` },
        className: QI.frame,
        ref: this.frameRef
      }
    ) });
  }
}
const ZI = "h-scrollbar--scrollbar__track", JI = "h-scrollbar--scrollbar__handle", cr = {
  track: ZI,
  handle: JI
};
class sT extends D {
  constructor(t) {
    super(t), this.state = {
      size: 0,
      progress: 0,
      offset: 0
    }, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
  }
  componentDidMount() {
    const { container: t } = this.props;
    t.current && t.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
  }
  componentWillUnmount() {
    const { container: t } = this.props;
    t.current && t.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
  }
  updateSize = () => {
    const { container: t } = this.props;
    if (t.current) {
      const { current: e } = t;
      this.setState({
        size: e.offsetHeight / e.scrollHeight,
        progress: e.scrollTop / e.scrollHeight
      });
    }
  };
  handleTrackClick(t) {
    const { container: e } = this.props, { size: n } = this.state;
    if (this.setState({
      offset: n / 2
    }), e.current) {
      const o = e.current.getBoundingClientRect();
      let r = (t.clientY - o.top) / e.current.offsetHeight - n / 2;
      r < 0 && (r = 0), r + n > 1 && (r = 1 - n), e.current.scrollTop = r * e.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
    }
  }
  handleHandleClick(t) {
    const { size: e } = this.state;
    if (t.stopPropagation(), !(t.target instanceof Element)) return;
    const n = t.target.getBoundingClientRect();
    this.setState({
      offset: (t.clientY - n.top) / n.height * e
    }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
  }
  handleDrag(t) {
    t.preventDefault();
    const { container: e } = this.props, { size: n, offset: o } = this.state;
    if (e.current) {
      const r = e.current.getBoundingClientRect();
      let a = (t.clientY - r.top) / e.current.offsetHeight - o;
      a < 0 && (a = 0), a + n > 1 && (a = 1 - n), e.current.scrollTop = a * e.current.scrollHeight;
    }
  }
  handleDrop() {
    window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
  }
  render() {
    const { className: t, thumbClassName: e, trackClassName: n, ...o } = this.props, { size: r, progress: a } = this.state, l = f(t);
    return /* @__PURE__ */ s.jsx("div", { ...o, className: l, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(cr.track, n),
        onMouseDown: this.handleTrackClick,
        children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: f(cr.handle, e),
            onMouseDown: this.handleHandleClick,
            style: {
              height: `${r * 100}%`,
              top: `${a * 100}%`
            }
          }
        )
      }
    ) });
  }
}
const tD = "h-scrollShadow--scrollShadow__wrapper", eD = "h-scrollShadow--scrollShadow__content", dr = {
  wrapper: tD,
  content: eD
}, oT = ({
  className: i,
  children: t,
  ...e
}) => {
  const n = f(dr.wrapper, i);
  return /* @__PURE__ */ s.jsx("div", { className: n, ...e, children: /* @__PURE__ */ s.jsx("div", { className: dr.content, children: t }) });
}, nD = "h-searchInput--searchInput__root", sD = "h-searchInput--searchInput__input", oD = "h-searchInput--searchInput__inputButton", Fn = {
  root: nD,
  input: sD,
  inputButton: oD
}, rD = 275, hr = 300, rT = ({
  className: i,
  initialSearch: t,
  maxWidth: e = rD,
  placeholder: n,
  onChange: o,
  onSubmit: r,
  onToggle: a,
  ...l
}) => {
  const c = Y(null), [d, h] = V(!!t), [u, p] = V(!1), [m, g] = V(t ?? "");
  Oi(
    () => {
      u && (h(!1), p(!1), g(""));
    },
    hr,
    [u]
  ), Yt(() => {
    a?.(d), d && requestAnimationFrame(() => c.current?.focus());
  }, [d]);
  const b = F(() => {
    h(!0);
  }, []), x = F(() => {
    p(!0);
  }, []), v = F(
    (w) => {
      w.preventDefault(), r(m);
    },
    [r, m]
  ), y = F(
    (w) => {
      const {
        target: { value: I }
      } = w;
      g(I), o?.(I);
    },
    [o]
  ), C = F(
    ({ key: w }) => {
      w === "Enter" && b();
    },
    [b]
  ), _ = F(
    ({ key: w }) => {
      (w === "Esc" || w === "Escape") && x();
    },
    [x]
  );
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: f(Fn.root, i),
      style: {
        "--max-width": `${d && !u ? e : 32}px`,
        "--transition-delay": `${hr}ms`
      },
      ...l,
      children: d ? /* @__PURE__ */ s.jsx("form", { onSubmit: v, children: /* @__PURE__ */ s.jsx(
        qt,
        {
          className: Fn.input,
          ref: c,
          onChange: y,
          placeholder: n ?? "Search...",
          type: "search",
          value: m,
          prefix: {
            type: "button",
            button: {
              icon: "search",
              onClick: v,
              className: Fn.inputButton
            }
          },
          suffix: {
            type: "button",
            button: {
              icon: "close",
              onClick: x,
              className: Fn.inputButton
            }
          },
          onKeyDown: _
        }
      ) }) : /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "search",
          variant: "secondary",
          onClick: b,
          onKeyDown: C,
          "data-testid": "search-input-button"
        }
      )
    }
  );
}, iD = "h-selectOption--selectOption__root", aD = "h-selectOption--selectOption__checkbox", lD = "h-selectOption--selectOption__content", Is = {
  root: iD,
  checkbox: aD,
  content: lD
}, iT = (i) => {
  const t = f(Is.root);
  return /* @__PURE__ */ s.jsxs("label", { className: t, children: [
    /* @__PURE__ */ s.jsx(
      cn,
      {
        ...i,
        className: f(Is.checkbox, i.className)
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: Is.content, children: i.name })
  ] });
}, cD = "h-simpleProgressBar--simpleProgressBar__container", dD = "h-simpleProgressBar--simpleProgressBar__progressBar", hD = "h-simpleProgressBar--simpleProgressBar__progressBarFill", Ds = {
  container: cD,
  progressBar: dD,
  progressBarFill: hD
}, uD = "simpleProgressBarId";
function aT({
  progress: i,
  base: t = 100,
  progressColor: e = "purple.500",
  backgroundColor: n = "neutral.200",
  tooltipContent: o,
  tooltipProps: r,
  ...a
}) {
  const [l, c] = V(0), d = 4;
  et(() => c(i), [i]);
  const h = t >= l ? l / t : 1, u = () => d / h, p = {
    backgroundColor: tn(n)
  }, m = {
    transform: `scaleX(${h})`,
    borderTopRightRadius: `${u()}px ${d}px`,
    borderBottomRightRadius: `${u()}px ${d}px`,
    backgroundColor: tn(e)
  };
  return /* @__PURE__ */ s.jsx(
    O,
    {
      "test-id": uD,
      "align-items": "center",
      "justify-content": "center",
      className: Ds.container,
      ...a,
      children: /* @__PURE__ */ s.jsx(
        gt,
        {
          disabled: !o,
          content: o,
          wrap: "none",
          ...r,
          children: /* @__PURE__ */ s.jsx("div", { className: Ds.progressBar, style: p, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: Ds.progressBarFill,
              style: m
            }
          ) })
        }
      )
    }
  );
}
const pD = "h-tabsWithContent--tabsWithContent__container", mD = "h-tabsWithContent--tabsWithContent__containerTop", gD = "h-tabsWithContent--tabsWithContent__containerLeft", fD = "h-tabsWithContent--tabsWithContent__containerRight", bD = "h-tabsWithContent--tabsWithContent__containerBottom", xD = "h-tabsWithContent--tabsWithContent__childrenContainer", we = {
  container: pD,
  containerTop: mD,
  containerLeft: gD,
  containerRight: fD,
  containerBottom: bD,
  childrenContainer: xD
};
class $s extends _t {
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(t) {
    super(t), this.state = { activeTab: t.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
  }
  handleTabChange(t) {
    this.ensureTabIsValid(t) && (this.setState({ activeTab: t }), this.props.onChange?.(t));
  }
  ensureTabIsValid(t) {
    return this.props.tabs.some((e) => e.id === t);
  }
  getActiveChildIndex() {
    return this.props.tabs.findIndex(({ id: t }) => t === this.state.activeTab);
  }
  render() {
    const {
      className: t,
      tabsClassName: e,
      tabClassName: n,
      tabSelectedClassName: o,
      childrenWrapperClassName: r,
      tabs: a,
      children: l,
      tabsPlacement: c
    } = this.props, { activeTab: d } = this.state, h = Rt.toArray(l);
    if (h.length !== a.length) {
      const g = `${$s.name}: Number of tabs don't match the number of children.`;
      console.warn(g);
    }
    const u = this.getActiveChildIndex();
    if (u === -1) {
      const g = `${$s.name}: The selected tab does not exist in tabs array!`;
      console.warn(g);
    }
    const p = f(t, we.container, {
      [we.containerTop]: c === "top",
      [we.containerLeft]: c === "left",
      [we.containerBottom]: c === "bottom",
      [we.containerRight]: c === "right"
    }), m = f(
      r,
      we.childrenContainer
    );
    return /* @__PURE__ */ s.jsxs("section", { className: p, children: [
      /* @__PURE__ */ s.jsx(
        ob,
        {
          className: e,
          tabClassName: n,
          tabSelectedClassName: o,
          tabs: a,
          onChange: this.handleTabChange,
          selectedId: d,
          tabsPlacement: c
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: m, children: h[u] })
    ] });
  }
}
const yD = "h-tagsInput--tagsInput__root", _D = "h-tagsInput--tagsInput__wrapper", CD = "h-tagsInput--tagsInput__input", wD = "h-tagsInput--tagsInput__inputIsHidden", vD = "h-tagsInput--tagsInput__placeholder", SD = "h-tagsInput--tagsInput__placeholderText", ID = "h-tagsInput--tagsInput__iconBox", DD = "h-tagsInput--tagsInput__iconText", kD = "h-tagsInput--tagsInput__tag", TD = "h-tagsInput--tagsInput__tagIsActive", jD = "h-tagsInput--tagsInput__tagButton", ND = "h-tagsInput--tagsInput__divider", ut = {
  root: yD,
  wrapper: _D,
  input: CD,
  inputIsHidden: wD,
  placeholder: vD,
  placeholderText: SD,
  iconBox: ID,
  iconText: DD,
  tag: kD,
  tagIsActive: TD,
  tagButton: jD,
  divider: ND
};
function ur(i = [], t) {
  switch (t) {
    case "asc":
      return i.sort();
    case "desc":
      return i.sort().reverse();
    default:
      return i;
  }
}
const FD = 255, lT = ({
  className: i,
  disabled: t,
  limit: e,
  placeholder: n,
  selectedTags: o,
  sortDirection: r,
  onChange: a
}) => {
  const l = Y(null), c = Y(null), [d, h] = V(""), [u, p] = V(
    ur(o, r)
  ), [m, g] = V(""), [b, x] = V(!1);
  _r(l, () => x(!1)), Yt(() => a(u), [u, a]), Yt(() => {
    c.current && b && c.current.focus();
  }, [c.current, b]);
  const v = (S) => {
    h(S.target.value ?? "");
  }, y = (S) => {
    const T = u.indexOf(m);
    switch (S.key) {
      // Creates a new tag from the given input text.
      case "Enter":
        !m && d && p((P) => {
          const A = Array.from(/* @__PURE__ */ new Set([...P, d]));
          return h(""), ur(A, r);
        });
        break;
      // If there is no input text left, it will select the last tag.
      // If there is already a tag selected, it will remove that from the list.
      case "Backspace":
        !m && d.length === 0 && g(u[u.length - 1]), m && (C(m), g(""));
        break;
      // If there is a tag selected, it will select the previous one.
      case "ArrowLeft":
        m && T > 0 && g(u[T - 1]);
        break;
      // If there is a tag selected, it will select the next one.
      case "ArrowRight":
        m && T < u.length - 1 && g(u[T + 1]);
        break;
      default:
        m && g("");
    }
  }, C = (S) => {
    p((T) => {
      const P = [...T];
      return P.splice(P.indexOf(S), 1), P;
    });
  }, _ = b ? u.length : e || u.length, w = _ < u.length, I = u.slice(0, _);
  return /* @__PURE__ */ s.jsx(
    Et,
    {
      ref: l,
      className: f(ut.root, i),
      onClick: () => x(!0),
      disabled: t,
      children: /* @__PURE__ */ s.jsxs("div", { className: ut.wrapper, "data-testid": "tags-wrapper", children: [
        I.map((S, T, P) => {
          const A = !b && P.length > 1 && T === P.length - 1;
          return /* @__PURE__ */ s.jsxs(Xt, { children: [
            A && /* @__PURE__ */ s.jsx(
              L.Paragraph,
              {
                variant: "3",
                color: "secondary",
                className: ut.divider,
                children: "or"
              }
            ),
            /* @__PURE__ */ s.jsx(
              ke,
              {
                className: f(ut.tag, {
                  [ut.tagIsActive]: S === m
                }),
                onDelete: () => C(S),
                "data-testid": "tag",
                children: S
              },
              S
            )
          ] }, S);
        }),
        !b && w && /* @__PURE__ */ s.jsxs(
          ke,
          {
            className: f(ut.tag, ut.tagButton),
            "data-testid": "tag",
            children: [
              "+",
              u.length - _
            ]
          }
        ),
        !b && !u.length && !d && /* @__PURE__ */ s.jsx(O, { className: ut.placeholder, alignItems: "center", gap: "200", children: n ? /* @__PURE__ */ s.jsx(L.Paragraph, { className: ut.placeholderText, variant: "2", children: n }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(L.Paragraph, { className: ut.placeholderText, variant: "2", children: "Type words or phrases and add with" }),
          /* @__PURE__ */ s.jsxs("div", { className: ut.iconBox, children: [
            /* @__PURE__ */ s.jsx(N, { name: "enter", color: "neutral.500" }),
            /* @__PURE__ */ s.jsx(L.Paragraph, { className: ut.iconText, children: "enter" })
          ] })
        ] }) }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            className: f(ut.input, {
              [ut.inputIsHidden]: !b
            }),
            onChange: v,
            onKeyDown: y,
            maxLength: FD,
            ref: c,
            type: "text",
            value: d,
            "data-testid": "tag-input"
          }
        )
      ] })
    }
  );
}, PD = "h-textWithHighlight--textWithHighlight__highlight", RD = {
  highlight: PD
}, ED = ({
  text: i,
  highlight: t,
  className: e,
  highlightClassName: n,
  ignoreCase: o = !0
}) => {
  if (!t?.trim())
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const r = new RegExp(
    Ws(t.trim()),
    o ? "ig" : "g"
  ), a = i.match(r), l = i.split(r);
  return /* @__PURE__ */ s.jsx("span", { className: e, children: l.map((c, d) => /* @__PURE__ */ s.jsxs("span", { children: [
    c,
    a?.[d] && /* @__PURE__ */ s.jsx("em", { className: f(RD.highlight, n), children: a[d] })
  ] }, d)) });
}, LD = Kn(ED);
LD.name = "TextWithHighlight";
const AD = "h-timestamp--timestamp__timestamp", $D = {
  timestamp: AD
}, BD = 1e4;
class cT extends _t {
  interval;
  static defaultProps = {
    refreshRate: BD
  };
  constructor(t) {
    super(t);
    const { relative: e, counter: n, initialFormat: o } = t;
    let r = o ?? "absolute";
    e ? r = "ago" : n && (r = "counter"), this.state = {
      format: r,
      pristine: !0
    }, this.handleClick = this.handleClick.bind(this), this.interval = null;
  }
  componentDidMount() {
    const { format: t } = this.state;
    (t === "ago" || t === "counter") && this.startTicker();
  }
  componentDidUpdate(t) {
    const { relative: e, initialFormat: n } = this.props, { pristine: o } = this.state;
    e !== t.relative && o && this.setState({
      format: e ? "ago" : "absolute"
    }), n && n !== t.initialFormat && this.setState({ format: n });
  }
  componentWillUnmount() {
    this.stopTicker();
  }
  startTicker() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, this.props.refreshRate ?? 0);
  }
  stopTicker() {
    this.interval && clearInterval(this.interval);
  }
  handleClick(t) {
    const { onClick: e } = this.props, { format: n } = this.state;
    let o = this.state.format;
    n === "ago" ? (o = "full", this.stopTicker()) : n === "full" ? o = "absolute" : n === "absolute" && (o = "ago", this.startTicker()), this.setState({
      pristine: !1,
      format: o
    }), e?.(o, t);
  }
  getTimeString() {
    let { time: t } = this.props;
    const { isSecondsDisplayed: e, customFormatters: n } = this.props, { format: o } = this.state;
    let r = "";
    if (typeof t == "number") {
      const l = /* @__PURE__ */ new Date();
      l.setTime(t * 1e3), t = l;
    }
    const a = j(t).utc().local();
    if (o === "counter") {
      const l = j(t).utc(), d = j().utc().diff(l) / 1e3, h = Math.floor(d / (60 * 60)), u = Math.floor(h / 24), p = h % 24, m = h * 60 * 60, g = Math.floor((d - m) / 60), b = g * 60, x = Math.floor(
        d - m - b
      );
      r = [
        p.toString().padStart(2, "0"),
        g.toString().padStart(2, "0"),
        x.toString().padStart(2, "0")
      ].join(":"), u > 0 && (r = `${u} ${u === 1 ? "DAY" : "DAYS"} ${r}`);
    } else if (o === "full") {
      const l = n?.full ?? (e ? "MMM Do YYYY, hh:mm:ss A" : "lll");
      r = a.format(l);
    } else if (o === "absolute")
      if (j().diff(j(t), "hours") > 12) {
        const l = n?.absolute ?? `D MMMM LT${e ? "S" : ""}`;
        r = a.format(l);
      } else {
        const l = n?.absolute ?? `LT${e ? "S" : ""}`;
        r = a.format(l);
      }
    else
      r = Gh(a);
    return r;
  }
  render() {
    const {
      className: t,
      relative: e,
      time: n,
      refreshRate: o,
      counter: r,
      customFormatters: a,
      isSecondsDisplayed: l,
      initialFormat: c,
      onClick: d,
      ...h
    } = this.props, u = f(
      {
        [$D.timestamp]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "span",
      {
        ...h,
        ...Gn(this.handleClick),
        className: u,
        children: this.getTimeString()
      }
    );
  }
}
const OD = "h-token--token__root", HD = "h-token--token__select", WD = "h-token--token__label", MD = "h-token--token__rootReadonly", zD = "h-token--token__rootPrimary", VD = "h-token--token__rootWithError", KD = "h-token--token__value", UD = "h-token--token__icon", $t = {
  root: OD,
  select: HD,
  label: WD,
  rootReadonly: MD,
  rootPrimary: zD,
  rootWithError: VD,
  value: KD,
  icon: UD
};
class dT extends D {
  render() {
    const {
      onDelete: t,
      id: e,
      label: n,
      options: o,
      valueLabel: r,
      primary: a,
      input: l,
      meta: c,
      defaultOption: d,
      className: h,
      ...u
    } = this.props, p = f(
      {
        [$t.root]: !0,
        [$t.rootPrimary]: a,
        [$t.rootWithError]: c?.error,
        [$t.rootReadonly]: !o && !t
      },
      h
    );
    let m = r;
    if (!m && l && o && o.length) {
      const g = o.filter(({ value: b }) => l.value === b);
      g.length && (m = g[0].label);
    }
    return !m && d && (m = d), /* @__PURE__ */ s.jsxs("div", { ...u, className: p, children: [
      !!o && /* @__PURE__ */ s.jsxs("select", { ...l, className: $t.select, id: e, children: [
        !!d && /* @__PURE__ */ s.jsx("option", { disabled: !0, hidden: !0, value: "", children: d }),
        o.map((g) => /* @__PURE__ */ s.jsx("option", { value: g.value, children: g.label }, g.value?.toString()))
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: $t.label, htmlFor: e, children: [
        n,
        /* @__PURE__ */ s.jsx("span", { className: $t.value, children: m }),
        !!o && /* @__PURE__ */ s.jsx(N, { className: $t.icon, name: "angle-down" }),
        !!t && /* @__PURE__ */ s.jsx("span", { ...Gn(t), children: /* @__PURE__ */ s.jsx(N, { className: $t.icon, name: "close", onClick: t }) })
      ] })
    ] });
  }
}
const qD = "h-skeleton--skeleton__root", GD = "h-skeleton--skeleton__rootAnimationPulse", YD = "h-skeleton--skeleton__rootAnimationWave", ks = {
  root: qD,
  rootAnimationPulse: GD,
  rootAnimationWave: YD
};
function pr({ className: i, animation: t = "pulse", ...e }, n) {
  const o = f(
    {
      [ks.root]: !0,
      [ks.rootAnimationPulse]: t === "pulse",
      [ks.rootAnimationWave]: t === "wave"
    },
    i
  );
  return /* @__PURE__ */ s.jsx(it, { className: o, ...e, ref: n });
}
const hT = Object.assign($(pr), {
  name: pr.name
}), XD = "h-breadcrumbs--breadcrumbs__root", QD = "h-breadcrumbs--breadcrumbs__list", ZD = "h-breadcrumbs--breadcrumbs__item", JD = "h-breadcrumbs--breadcrumbs__separator", Pn = {
  root: XD,
  list: QD,
  item: ZD,
  separator: JD
}, uT = $(function({
  className: t,
  children: e,
  as: n,
  separator: o = /* @__PURE__ */ s.jsx(N, { name: "angle-right" }),
  "aria-label": r = "breadcrumb",
  ...a
}, l) {
  const c = n ?? "nav", d = Rt.toArray(e).filter(Boolean);
  return /* @__PURE__ */ s.jsx(
    c,
    {
      ...a,
      ref: l,
      className: f(Pn.root, t),
      "aria-label": r,
      children: /* @__PURE__ */ s.jsx("ol", { className: Pn.list, children: d.map((h, u) => {
        const p = u === d.length - 1, m = typeof h == "string" || typeof h == "number" ? /* @__PURE__ */ s.jsx("span", { children: h }) : h;
        return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Pn.item,
              "aria-current": p ? "page" : void 0,
              children: m
            },
            u
          ),
          !p && /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Pn.separator,
              "data-testid": "breadcrumbs-separator",
              "aria-hidden": "true",
              children: o
            }
          )
        ] });
      }) })
    }
  );
});
export {
  Ug as AddonTriggerContext,
  qg as AddonTriggerEvents,
  dk as Attachment,
  Cr as Avatar,
  Ku as AvatarSelectItem,
  hk as Badge,
  uk as Banner,
  it as Box,
  uT as Breadcrumbs,
  X as Button,
  pk as ButtonGroup,
  ho as ButtonList,
  vk as CheckableAvatarSelectItem,
  Ys as CheckableBaseItem,
  _k as CheckableSelectItem,
  wk as CheckableTagSelectItem,
  cn as Checkbox,
  hp as Chip,
  gk as CollapseCard,
  fk as Collapsible,
  Xn as ColorPicker,
  pt as Column,
  sd as Columns,
  Cd as CopyToClipboard,
  bk as CopyToClipboardButton,
  Mk as CountryFlag,
  xk as DataTable,
  $m as DatePicker,
  Ze as DatePickerOld,
  jm as DateRangePicker,
  tp as DeselectItem,
  Dk as Dialer,
  qn as Divider,
  Zt as Dropdown,
  ae as DropdownButton,
  dn as DropdownButtonContext,
  Gs as DropdownInfinite,
  jo as DropdownItem,
  Zs as DropdownSelect,
  Br as DropdownSelectContainer,
  kk as DropdownSelectMultiple,
  Ai as EMOJIS,
  gT as EmojiPicker,
  hn as EmptySelectItem,
  Gd as EmptyState,
  Ms as ErrorBoundary,
  fT as ErrorBoundaryContext,
  Wk as FieldAddonDropdown,
  Zn as FieldAlert,
  Tk as FieldButton,
  Hk as FieldColorPicker,
  jk as FieldDatePicker,
  Nk as FieldDateRangePicker,
  qs as FieldLabel,
  Pk as FieldRichText,
  Rk as FieldSelect,
  Ek as FieldSelectionList,
  Lk as FieldSlider,
  Ak as FieldSwitch,
  Ps as FieldText,
  $k as FieldTextarea,
  Bk as FieldTimePicker,
  Ok as FieldTimeRangePicker,
  z as FieldWrapper,
  O as FlexBox,
  wr as FocusScope,
  Kk as FormField,
  Vk as FormGrid,
  Us as HelpIcon,
  Uk as HelperField,
  N as Icon,
  K as IconButton,
  zs as Image,
  gg as InputDatePicker,
  on as InputDateRangePicker,
  qk as InputDuration,
  oo as InputRichText,
  jx as InputSelectionList,
  qt as InputText,
  Et as InputWrapper,
  Gk as Lightbox,
  Yk as List,
  Yk as ListV2,
  Xk as MediaPlayer,
  uS as Modal,
  Qk as ModalBody,
  yI as ModalFoot,
  Zk as ModalHead,
  ck as NavigationButton,
  Jk as Page,
  Hd as Pagination,
  rS as Portal,
  Lr as Presets,
  tT as Radio,
  nT as RemovableCard,
  eT as ReverseScroll,
  Xr as SandboxIframe,
  oT as ScrollShadow,
  sT as Scrollbar,
  rT as SearchInput,
  Wp as Select,
  Ar as SelectItem,
  iT as SelectOption,
  hx as SelectionList,
  Sd as SimplePagination,
  aT as SimpleProgressBar,
  hT as Skeleton,
  As as Slider,
  Un as Spinner,
  Qx as Switch,
  mt as Table,
  Qn as TableContext,
  ob as Tabs,
  $s as TabsWithContent,
  ke as Tag,
  Ik as TagDeselectItem,
  Ck as TagSelectItem,
  Sk as TagSelectSuggestion,
  lT as TagsInput,
  L as Text,
  LD as TextWithHighlight,
  Ur as Textarea,
  sn as TimePicker,
  _m as TimeRangePicker,
  cT as Timestamp,
  dT as Token,
  gt as Tooltip,
  _T as addSvgIconsToDocument,
  qa as badgeTestId,
  Jc as colorPickerTestId,
  zk as countryCodes,
  yk as datepickerDisableWeekends,
  bT as defaultElementType,
  Fg as formattingOptions,
  Re as getSelectionListContext,
  xT as iconMeta,
  Ko as inputRichTextCommands,
  Tx as inputSelectionListTestId,
  KI as reverseScrollTestId,
  an as withErrorBoundary
};
//# sourceMappingURL=index.js.map
